/*!
* @alife/cn-uni-api v2.13.1
* (c) Alibaba Group Holding Limited.
*
* @license ISC
* @build at 2023/12/22 17:30:02
*/
(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports) :
    typeof define === 'function' && define.amd ? define(['exports'], factory) :
    (global = typeof globalThis !== 'undefined' ? globalThis : global || self, factory(global.cnUniApi = {}));
})(this, (function (exports) { 'use strict';

    /*! *****************************************************************************
    Copyright (c) Microsoft Corporation.

    Permission to use, copy, modify, and/or distribute this software for any
    purpose with or without fee is hereby granted.

    THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
    REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
    AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
    INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
    LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
    OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
    PERFORMANCE OF THIS SOFTWARE.
    ***************************************************************************** */

    var __assign$2 = function() {
        __assign$2 = Object.assign || function __assign(t) {
            for (var s, i = 1, n = arguments.length; i < n; i++) {
                s = arguments[i];
                for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
            }
            return t;
        };
        return __assign$2.apply(this, arguments);
    };

    function __read$1(o, n) {
        var m = typeof Symbol === "function" && o[Symbol.iterator];
        if (!m) return o;
        var i = m.call(o), r, ar = [], e;
        try {
            while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
        }
        catch (error) { e = { error: error }; }
        finally {
            try {
                if (r && !r.done && (m = i["return"])) m.call(i);
            }
            finally { if (e) throw e.error; }
        }
        return ar;
    }

    function __spread$1() {
        for (var ar = [], i = 0; i < arguments.length; i++)
            ar = ar.concat(__read$1(arguments[i]));
        return ar;
    }

    var _a$2;
    var isWeb$3 = typeof window !== 'undefined' && 'onload' in window;
    typeof dd !== 'undefined' && !!dd && typeof dd.showtoast === 'function';
    var isMiniAli$2 = typeof my !== 'undefined' && !!my && (typeof my.showToast === 'function' || typeof my.navigateTo === 'function');
    var isMiniTt$2 = typeof tt !== 'undefined' && !!tt && typeof tt.showtoast === 'function';
    var isMiniWx$2 = !isMiniTt$2 &&
        typeof wx !== 'undefined' &&
        !!wx &&
        (typeof wx.login !== 'undefined' || typeof wx.miniProgram !== 'undefined');
    var isMini$2 = isMiniAli$2 || isMiniWx$2 || isMiniTt$2;
    typeof WXEnvironment !== 'undefined' &&
        !!WXEnvironment &&
        WXEnvironment.platform !== 'Web';
    var aliUA$2 = '';
    try {
        aliUA$2 = navigator.userAgent || navigator.swuserAgent || '';
    }
    catch (error) {
        aliUA$2 = '';
    }
    var isMiniweb$2 = (isWeb$3 && aliUA$2.indexOf('Triver') > -1) || aliUA$2.indexOf('miniProgram') > -1;
    var aliAppMatches$2 = /.+AliApp\((\w+)\/((?:\d+\.)+\d+)\)/.exec(aliUA$2 || '') || [];
    var client$1 = (_a$2 = aliAppMatches$2[1]) === null || _a$2 === void 0 ? void 0 : _a$2.toLocaleLowerCase();
    var isWindvane$2 = /.+AliApp\((\w+)\/((?:\d+\.)+\d+)\).* .*(WindVane)(?:\/((?:\d+\.)+\d+))?.*/.test(aliUA$2 || '');
    var isNebula$2 = /.+AliApp\((\w+)\/((?:\d+\.)+\d+)\)/.test(aliUA$2 || '') &&
        /.*(Nebula)(?:\/((?:\d+\.)+\d+))?.*/.test(aliUA$2 || '');
    var isFliggy$2 = /.+AliApp\((\w+)\/((?:\d+\.)+\d+)\) .*(AliTrip)(?:\/((?:\d+\.)+\d+))?.*/.test(aliUA$2 || '');
    var isDingTalk$2 = /.+AliApp\((DingTalk)\/((?:\d+\.)+\d+)?.*/.test(aliUA$2 || '');
    var isWebTm$1 = isWeb$3 && client$1 === 'tm';
    var isWebFm$1 = isWeb$3 && client$1 === 'fm';
    var isWebLt$1 = isWeb$3 && client$1 === 'lt';
    var isWebTb$1 = isWeb$3 && client$1 === 'tb';
    var isWebElmc$1 = isWeb$3 && client$1 === 'elmc';
    var isWebIhome$1 = isWeb$3 && client$1 === 'ihome';
    var isWebTphome$1 = isWeb$3 && client$1 === 'tphome';
    var isWebQn$1 = isWeb$3 && client$1 === 'qn';
    var isWebYouku$1 = isWeb$3 && client$1 === 'youku';
    var isWebWdkhema$1 = isWeb$3 && client$1 === 'wdkhema';
    var isWebCunpartner$1 = isWeb$3 && client$1 === 'cunpartner';
    var isWebAh$1 = isWeb$3 && client$1 === 'ah';
    var isWebAlipm$1 = isWeb$3 && client$1 === 'alipm';
    var isDingTalkPC$2 = /\s+DingTalk\(/i.test(aliUA$2);
    var isAndroid$3 = aliUA$2.indexOf('Android') > -1 || aliUA$2.indexOf('Adr') > -1;
    var isIOS$3 = !!aliUA$2.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
    function isIphoneXSeries$1() {
        var deviceHeight = screen.height * window.devicePixelRatio;
        if (['2340', '2436', '2688', '1792', '1624', '2532', '2778'].indexOf(String(deviceHeight)) >= 0) {
            return true;
        }
    }

    function notSupport$2(_a) {
        var fail = _a.fail;
        fail({
            errCode: '1',
            errMsg: 'not support',
        });
    }
    function enhanceSuccess$2(success, _originalInput, formatOptions, formatErrorOptions) {
        if (success === void 0) { success = function (ret) { return ret; }; }
        if (formatOptions === void 0) { formatOptions = {}; }
        if (formatErrorOptions === void 0) { formatErrorOptions = {}; }
        var formatOutput = formatOptions.formatOutput, outputMap = formatOptions.outputMap;
        return function (ret) {
            var _a;
            if (ret && ret.error) {
                var onFail = enhanceFail$2(_originalInput && _originalInput.fail, formatErrorOptions);
                return onFail(ret);
            }
            var output = {};
            if (typeof formatOutput === 'function') {
                output = formatOutput(ret);
            }
            else if (outputMap) {
                (_a = Object.keys(outputMap)) === null || _a === void 0 ? void 0 : _a.forEach(function (key) {
                    output[key] = ret[outputMap[key]];
                });
            }
            output = __assign$2(__assign$2({}, ret), output);
            outputMap && delete outputMap.ret;
            outputMap && delete outputMap.status;
            success(__assign$2(__assign$2({}, output), { _original: {
                    input: _originalInput,
                    output: ret,
                } }));
        };
    }
    function enhanceFail$2(fail, formatOptions) {
        if (fail === void 0) { fail = function (e) { return e; }; }
        if (formatOptions === void 0) { formatOptions = {}; }
        return function (e) {
            var _a;
            var formatOutput = formatOptions.formatOutput, outputMap = formatOptions.outputMap;
            var output = {};
            if (typeof formatOutput === 'function') {
                output = formatOutput(e);
            }
            else if (outputMap) {
                (_a = Object.keys(outputMap)) === null || _a === void 0 ? void 0 : _a.forEach(function (key) {
                    output[key] = e[outputMap[key]];
                });
            }
            output = __assign$2(__assign$2({}, e), output);
            outputMap && delete outputMap.ret;
            outputMap && delete outputMap.status;
            return fail(__assign$2({ _originalErrInfo: e }, output));
        };
    }
    function apiCall$1(apiName, params, JSCall, formatOptions, errFormatOptions) {
        var _a;
        if (formatOptions === void 0) { formatOptions = {}; }
        if (errFormatOptions === void 0) { errFormatOptions = {}; }
        var success = params.success, fail = params.fail;
        var options = {};
        var formatInput = formatOptions.formatInput, inputMap = formatOptions.inputMap, formatOutput = formatOptions.formatOutput, outputMap = formatOptions.outputMap;
        if (typeof formatInput === 'function') {
            options = formatInput(params);
        }
        else if (inputMap) {
            (_a = Object.keys(inputMap)) === null || _a === void 0 ? void 0 : _a.forEach(function (key) {
                options[key] = params[inputMap[key]];
            });
        }
        options = __assign$2(__assign$2({}, params), options);
        var onSuccess = enhanceSuccess$2(success, options, {
            outputMap: outputMap,
            formatOutput: formatOutput,
        }, errFormatOptions);
        var onFail = enhanceFail$2(fail, errFormatOptions);
        apiName
            ? JSCall(apiName, options, onSuccess, onFail)
            : JSCall(__assign$2(__assign$2({}, options), { onSuccess: onSuccess, onFail: onFail }));
    }
    function promisifyApi$2(apiFn, plugins) {
        var promisify = function (apiFn) { return function (params) {
            if (params === void 0) { params = {}; }
            return new Promise(function (resolve, reject) {
                var success = function (e) {
                    if (typeof params.success === 'function') {
                        params.success(e);
                    }
                    else {
                        resolve(e);
                    }
                };
                var fail = function (e) {
                    typeof params.fail === 'function' && params.fail(e);
                    reject(e);
                };
                if (!params.onSuccess) {
                    params.onSuccess = success;
                }
                if (!params.onFail) {
                    params.onFail = fail;
                }
                apiFn(__assign$2(__assign$2({}, params), { success: success, fail: fail }));
            });
        }; };
        var api = promisify(apiFn);
        return api;
    }
    function search2JSON(search) {
        if (search === void 0) { search = ''; }
        var queryArr = search.replace(/^\?/, '').split(/&+/);
        var params;
        queryArr.forEach(function (item) {
            var index = item.indexOf('=');
            var key = item.substr(0, index);
            var value = item.substring(index + 1);
            if (key) {
                if (!params) {
                    params = {};
                }
                params[key] = decodeURIComponent(value);
            }
        });
        return params;
    }
    function parse(url) {
        if (url === void 0) { url = ''; }
        var REG = /^((https?:)?(?:\/{2})?(([^:/]+?\.[^:/?]+)(?::(\d+))?)?)([^?#]*)([^#]*)(#.*)?/i;
        var matches = url.match(REG);
        var params = search2JSON((matches === null || matches === void 0 ? void 0 : matches[7]) || '');
        return {
            href: matches === null || matches === void 0 ? void 0 : matches[0],
            origin: matches === null || matches === void 0 ? void 0 : matches[1],
            protocol: matches === null || matches === void 0 ? void 0 : matches[2],
            host: matches === null || matches === void 0 ? void 0 : matches[3],
            hostname: matches === null || matches === void 0 ? void 0 : matches[4],
            port: matches === null || matches === void 0 ? void 0 : matches[5],
            pathname: matches === null || matches === void 0 ? void 0 : matches[6],
            search: matches === null || matches === void 0 ? void 0 : matches[7],
            hash: matches === null || matches === void 0 ? void 0 : matches[8],
            params: params,
        };
    }
    function object2search(obj) {
        var _obj = Object.assign({}, obj, { '//': '//' });
        var keys = ['protocol', '//', 'host', 'pathname', 'params', 'hash'];
        var result = '';
        keys.forEach(function (key) {
            if (key === 'params' && _obj.params) {
                var parArr = [];
                var _params = Object.assign({}, _obj.params);
                for (var k in _params) {
                    if (!_params.hasOwnProperty(k)) {
                        continue;
                    }
                    parArr.push(k + '=' + encodeURIComponent(_params[k]));
                }
                result += '?' + parArr.join('&');
            }
            else {
                if (!obj.hostname && key === '//') {
                    return false;
                }
                result += _obj[key] || '';
            }
        });
        return result;
    }
    function setSearch(url, params, newHash) {
        if (newHash === void 0) { newHash = ''; }
        if (!url) {
            return '';
        }
        var result = parse(url);
        result.params = Object.assign(result.params || {}, params);
        if (newHash) {
            result.hash = (/^#/.test(newHash) ? '' : '#') + newHash;
        }
        return object2search(result);
    }

    var ERR_SCAN_USER_CANCEL = '10';
    var ERR_USER_CANCEL$1 = '11';
    var ERROR_AUDIO_CONFIG = '12';
    var ERR_COMMON$1 = '11';
    var ERR_MSG_CANCEL$1 = 'cancel';
    var ERR_MSG_COMMON$1 = 'call failed';
    var ERR_MSG_AUDIO_CONFIG = 'audio config not found';

    var JSCall$1$1 = function (api, options, success, failure) {
        if (success === void 0) { success = function (r) { }; }
        if (failure === void 0) { failure = function (e) { }; }
        if (typeof options === 'function') {
            failure = success;
            success = options;
            options = {};
        }
        if (!__windvane__.call) {
            new Function(__windvane__.windVaneCoreJs())();
        }
        __windvane__.call(api, options, success, failure);
    };
    function WVCall$2(apiName, params, formatOptions, errFormatOptions) {
        if (formatOptions === void 0) { formatOptions = {}; }
        if (errFormatOptions === void 0) { errFormatOptions = {}; }
        apiCall$1(apiName, params, JSCall$1$1, formatOptions, errFormatOptions);
    }
    function alert$a(params) {
        var api = 'WVUIDialog.alert';
        var title = params.title, content = params.content, _a = params.buttonText, buttonText = _a === void 0 ? '确定' : _a, _b = params.success, success = _b === void 0 ? function (r) { return r; } : _b, _c = params.fail, fail = _c === void 0 ? function (e) { return e; } : _c;
        var options = __assign$2(__assign$2({}, params), { title: title, message: content, okbutton: buttonText, identifier: Date.now() });
        var onSuccess = enhanceSuccess$2(success, options);
        var onFail = enhanceFail$2(fail);
        var handler = function (e) {
            if ((e.identifier || e.param.identifier) == options.identifier) {
                onSuccess(e);
                document.removeEventListener('WV.Event.Alert', handler);
            }
        };
        document.addEventListener('WV.Event.Alert', handler, false);
        JSCall$1$1(api, options, function () { }, onFail);
    }
    function chooseImage$8$1(params) {
        var formatInput = function (options) {
            var _a, _b;
            var mode = 'both';
            var sourceTypeInlcudeCamera = ((_a = options.sourceType) === null || _a === void 0 ? void 0 : _a.indexOf('camera')) > -1;
            var sourceTypeInlcudePhoto = ((_b = options.sourceType) === null || _b === void 0 ? void 0 : _b.indexOf('album')) > -1;
            if (sourceTypeInlcudeCamera || sourceTypeInlcudePhoto) {
                if (sourceTypeInlcudeCamera) {
                    mode = 'camera';
                }
                if (sourceTypeInlcudePhoto) {
                    mode = 'photo';
                }
            }
            return {
                type: '0',
                v: '2.0',
                mode: mode,
                mutipleSelection: options.multipleSelection || '0',
                bizCode: 'mtopupload',
                needLogin: false,
                maxSelect: options.count || 1,
            };
        };
        var formatOutput = function (ret) {
            var images = ret.images;
            return params.multipleSelection == '1'
                ? {
                    tempFilePaths: images.map(function (image) { return image.localPath; }),
                    tempFiles: images.map(function (image) {
                        return {
                            path: image.localPath,
                            previewURL: image.url,
                        };
                    }),
                }
                : {
                    tempFilePaths: [ret.localPath],
                    tempFiles: [
                        {
                            path: ret.localPath,
                            previewURL: ret.url,
                        },
                    ],
                };
        };
        var errFormatOutput = function (error) {
            var errorCode = error.status === 'RET_PHOTO_CANCEL' ? ERR_USER_CANCEL$1 : ERR_COMMON$1;
            var errorMsg = error.msg === 'RET_PHOTO_CANCEL' ? ERR_MSG_CANCEL$1 : ERR_MSG_COMMON$1;
            return {
                error: errorCode,
                errorMsg: errorMsg,
            };
        };
        return WVCall$2('WVCamera.takePhoto', params, {
            formatInput: formatInput,
            formatOutput: formatOutput,
        }, { formatOutput: errFormatOutput });
    }
    function uploadImage$3(params) {
        var files = params.tempFiles || params.files;
        if (files && files.length && files[0].path) {
            var urlList_1 = [];
            var originalRes_1 = [];
            files
                .reduce(function (promise, file) {
                return promise.then(function () {
                    return new Promise(function (resolve1, reject1) {
                        var options = {
                            path: file.path,
                            v: '2.0',
                            bizCode: params.bizCode || 'mtopupload',
                            needLogin: false,
                        };
                        var onSuccess = function (ret) {
                            urlList_1.push(ret.resourceURL);
                            originalRes_1.push(ret);
                            resolve1();
                        };
                        var onFail = function (e) {
                            reject1(e);
                        };
                        JSCall$1$1('WVCamera.confirmUploadPhoto', options, onSuccess, onFail);
                    });
                });
            }, Promise.resolve())
                .then(function () {
                var success = params.success;
                var onSuccess = enhanceSuccess$2(success, {});
                onSuccess({
                    urlList: urlList_1,
                    _original: { output: originalRes_1 },
                });
            })
                .catch(function (error) {
                var onFail = enhanceFail$2(params.fail);
                return onFail(error);
            });
        }
    }
    function showLoading$a(params) {
        WVCall$2('WVUI.showLoadingBox', params);
    }
    function choosePhoneContact$9(params) {
        var formatOutput = function (ret) {
            return {
                name: ret.name,
                phone: ret.phone.replace(/(\s|-)+/g, ''),
            };
        };
        var errFormatOutput = function (error) {
            var errorCode = error.msg === 'User abort' ? ERR_USER_CANCEL$1 : ERR_COMMON$1;
            var errorMsg = error.msg === 'User abort' ? ERR_MSG_CANCEL$1 : ERR_MSG_COMMON$1;
            return {
                error: errorCode,
                errorMsg: errorMsg,
            };
        };
        WVCall$2('WVContacts.choose', params, { formatOutput: formatOutput }, { formatOutput: errFormatOutput });
    }
    function confirm$8(params) {
        var api = 'WVUIDialog.confirm';
        var title = params.title, content = params.content, _a = params.confirmButtonText, confirmButtonText = _a === void 0 ? '确定' : _a, _b = params.cancelButtonText, cancelButtonText = _b === void 0 ? '取消' : _b, _c = params.success, success = _c === void 0 ? function (ret) { return ret; } : _c, _d = params.fail, fail = _d === void 0 ? function (err) { return err; } : _d;
        var options = __assign$2(__assign$2({}, params), { title: title, message: content, okbutton: confirmButtonText, canclebutton: cancelButtonText, _index: Date.now() });
        var formatOutput = function (ret) {
            var r = ret.param;
            if (r._index == options._index) {
                return {
                    confirm: r.type === options.okbutton,
                };
            }
        };
        var onSuccess = enhanceSuccess$2(success, options, { formatOutput: formatOutput });
        var handler = function (e) {
            var r = e.param;
            if (r._index == options._index) {
                onSuccess(e);
                document.removeEventListener('wv.dialog', handler);
            }
        };
        document.addEventListener('wv.dialog', handler, false);
        JSCall$1$1(api, options, function () { }, fail);
    }
    function getLocation$a$1(params) {
        var options = {
            address: true,
        };
        var onFail = enhanceFail$2(params.fail);
        var formatOutput = function (res) {
            var coords = res.coords, address = res.address;
            return __assign$2(__assign$2({}, coords), address);
        };
        var onSuccess = function (ret) {
            var _success = enhanceSuccess$2(params === null || params === void 0 ? void 0 : params.success, options, { formatOutput: formatOutput });
            try {
                _success(ret);
            }
            catch (e) {
                onFail(e);
            }
        };
        JSCall$1$1('WVLocation.getLocation', params, onSuccess, onFail);
    }
    function getNetworkType$a(params) {
        var formatOutput = function (ret) {
            var type = "" + ret.type;
            switch (type) {
                case 'WIFI':
                case '4G':
                case '3G':
                case '2G':
                    break;
                case 'CELL':
                case 'UNKNOWN':
                default:
                    type = 'UNKNOWN';
                    break;
            }
            return { networkType: type };
        };
        WVCall$2('WVNetwork.getNetworkType', params, { formatOutput: formatOutput });
    }
    function getOrientation$3(params) {
        var outputMap = {
            orientation: 'orientation',
        };
        WVCall$2('WVScreen.getOrientation', params, { outputMap: outputMap });
    }
    function hideLoading$9(params) {
        WVCall$2('WVUI.hideLoadingBox', params);
    }
    function isAppInstalled$5(params) {
        var formatInput = function (options) {
            return {
                installed: {
                    android: options.android,
                    ios: options.ios,
                },
            };
        };
        var formatOutput = function (res) {
            return {
                installed: isIOS$3 ? res.installed : res.installed === '0' ? false : true,
            };
        };
        WVCall$2('Base.isAppsInstalled', params, { formatInput: formatInput, formatOutput: formatOutput });
    }
    function openInBrowser$3(params) {
        WVCall$2('Base.openBrowser', params);
    }
    function setBackgroundColor$5(params) {
        var formatInput = function (options) {
            return {
                color: options.backgroundColor,
                alpha: options.alpha || 1,
            };
        };
        WVCall$2('Base.setBackgroundColor', params, { formatInput: formatInput });
    }
    function setClipboard$9$1(params) {
        WVCall$2('Base.copyToClipboard', params);
    }
    function setOrientation$1(params) {
        WVCall$2('WVScreen.setOrientation', params);
    }
    function showActionSheet$9(params) {
        var api = 'WVUIActionSheet.show';
        var _a = params.cancelButtonText, cancelButtonText = _a === void 0 ? '取消' : _a, items = params.items, success = params.success, fail = params.fail;
        var options = __assign$2(__assign$2({}, params), { cancelBtn: cancelButtonText, buttons: items });
        var formatOutput = function (ret) {
            var index = -1;
            items.some(function (btn, key) {
                if (ret.param.type === btn) {
                    index = key;
                    return false;
                }
            });
            return { index: index };
        };
        var _success = enhanceSuccess$2(success, options, { formatOutput: formatOutput });
        var onSuccess = function (e) {
            var onActionSheetClick = function (ret) {
                _success(ret);
                document.removeEventListener('wv.actionsheet', onActionSheetClick);
            };
            document.addEventListener('wv.actionsheet', onActionSheetClick, false);
        };
        var onFail = typeof fail === 'function' ? function (e) { return fail(e); } : function (e) { return e; };
        JSCall$1$1(api, options, onSuccess, onFail);
    }
    function snapshot$3(params) {
        var formatInput = function (options) {
            return { inAlbum: options.saveToGallery ? 'true' : 'false', type: false };
        };
        WVCall$2('WVScreen.capture', params, { formatInput: formatInput });
    }
    function vibrate$7(params) {
        WVCall$2('WVMotion.vibrate', params);
    }
    function redirectTo$8(params) {
        var formatInput = function (options) {
            return {
                url: options.url,
                popBeforeOpen: true,
            };
        };
        WVCall$2('WVNative.openWindow', params, { formatInput: formatInput });
    }
    function setNavigationBar$f(params) {
        var formatInput = function (options) {
            var title = options.title, subtitle = options.subtitle, image = options.image;
            var formattedOptions = {
                title: title,
                subtitle: '',
                icon: '',
                iconType: '',
            };
            if (subtitle) {
                formattedOptions.subtitle = subtitle;
            }
            if (image) {
                formattedOptions.icon = image;
                formattedOptions.iconType = 'URL';
            }
            return formattedOptions;
        };
        WVCall$2('WebAppInterface.setCustomPageTitle', params, {
            formatInput: formatInput,
        });
    }
    function showToast$9$1(params) {
        var formatInput = function (options) {
            var content = options.content, _a = options.type, type = _a === void 0 ? 'none' : _a, _b = options.duration, duration = _b === void 0 ? 1500 : _b;
            return {
                type: type,
                content: content,
                duration: Math.round(duration / 1000),
                message: content,
            };
        };
        WVCall$2('WVUIToast.toast', params, { formatInput: formatInput });
    }
    function saveImage$5$1(params) {
        WVCall$2('WVImage.saveImage', params);
    }
    function getStatusBarHeight$5(params) {
        if (isAndroid$3) {
            return notSupport$2(params === null || params === void 0 ? void 0 : params.fail);
        }
        return params === null || params === void 0 ? void 0 : params.success({ statusBarHeight: isIphoneXSeries$1 ? 88 : 40 });
    }

    var readyCall$2 = function (fn) {
        if (window.AlipayJSBridge) {
            fn();
        }
        else {
            var _once_1 = function () {
                fn();
                document.removeEventListener('AlipayJSBridgeReady', _once_1, false);
            };
            document.addEventListener('AlipayJSBridgeReady', _once_1, false);
        }
    };
    var call$2 = function (api, options, success, failure) {
        if (typeof options === 'function') {
            failure = success;
            success = options;
            options = {};
        }
        readyCall$2(function () {
            AlipayJSBridge.call(api, options, success, failure);
        });
    };

    function NBCall$2(apiName, params, formatOptions, errFormatOptions) {
        if (formatOptions === void 0) { formatOptions = {}; }
        if (errFormatOptions === void 0) { errFormatOptions = {}; }
        apiCall$1(apiName, params, call$2, formatOptions, errFormatOptions);
    }
    function showLoading$9(params) {
        NBCall$2('showLoading', params);
    }
    function chooseCity$4(params) {
        NBCall$2('getCities', params);
    }
    function choosePhoneContact$8(params) {
        var formatOutput = function (ret) {
            return {
                name: ret.name,
                phone: ret.mobile.replace(/(\s|-)+/g, ''),
            };
        };
        NBCall$2('contact', params, { formatOutput: formatOutput });
    }
    function getDeviceId$5(params) {
        var outputMap = {
            deviceId: 'device.id',
        };
        NBCall$2('getClientInfo', params, { outputMap: outputMap });
    }
    function clearNaviBarRightItem$6(params) {
        var formatOutput = function () {
            return { reset: true };
        };
        NBCall$2('setOptionMenu', params, { formatOutput: formatOutput });
        if (!params.show) {
            call$2('hideOptionMenu');
        }
        else {
            call$2('showOptionMenu');
        }
    }
    function getNetworkType$9(params) {
        var formatOutput = function (ret) {
            var type = "" + ret.type;
            switch (type) {
                case 'WIFI':
                case '4G':
                case '3G':
                case '2G':
                    break;
                case 'NOTREACHABLE':
                    type = 'NONE';
                    break;
                case 'UNKNOWN':
                case 'WWAN':
                default:
                    type = 'UNKNOWN';
                    break;
            }
            return { networkType: type };
        };
        NBCall$2('getNetworkType', params, { formatOutput: formatOutput });
    }
    function hideLoading$8(params) {
        NBCall$2('hideLoading', params);
    }
    function isAppInstalled$4(params) {
        var formatInput = function (input) {
            return {
                scheme: input.ios,
                packagename: input.android,
            };
        };
        NBCall$2('isInstalledApp', params, { formatInput: formatInput });
    }
    function navigateBack$e(params) {
        NBCall$2('popWindow', params);
    }
    function openInBrowser$2(params) {
        NBCall$2('openInBrowser', params);
    }
    function previewImage$9$1(params) {
        var api = 'imageViewer';
        var formatInput = function (options) {
            var _a = options.current, current = _a === void 0 ? 0 : _a, _b = options.urls, urls = _b === void 0 ? [] : _b;
            var formattedOptions = {
                images: [],
                init: +(current || 0),
            };
            urls.forEach(function (url) {
                formattedOptions.images.push({
                    u: url,
                    t: '',
                });
            });
            return formattedOptions;
        };
        NBCall$2(api, params, { formatInput: formatInput });
    }
    function scan$b(params) {
        var formatInput = function (_a) {
            var _b = _a.scanType, scanType = _b === void 0 ? ['qrCode', 'barCode'] : _b, _c = _a.hideAlbum, hideAlbum = _c === void 0 ? false : _c;
            return {
                scanType: scanType,
                hideAlbum: hideAlbum,
            };
        };
        var errFormatOutput = function (error) {
            var errorMsg = error.error === ERR_SCAN_USER_CANCEL ? ERR_MSG_CANCEL$1 : ERR_MSG_COMMON$1;
            return {
                errorMsg: errorMsg,
            };
        };
        NBCall$2('scan', params, { formatInput: formatInput }, { formatOutput: errFormatOutput });
    }
    function setClipboard$8$1(params) {
        NBCall$2('setClipboard', params);
    }
    function setNaviBarRightItem$6(params) {
        var formatInput = function (input) {
            var type = input.type, title = input.title, iconBase64 = input.iconBase64;
            var options = {
                redDot: '-1',
                reset: false,
                override: false,
            };
            if (type === 'text') {
                options.color = '#FF1478E3';
                options.title = title;
            }
            if (type === 'icon') {
                options.icon = iconBase64;
            }
            return options;
        };
        if (!window._uniapi_context) {
            window._uniapi_context = {};
        }
        if (!window._uniapi_context.events) {
            window._uniapi_context.events = {};
        }
        var lastHandler = window._uniapi_context.events.setNaviBarRightItem;
        if (typeof lastHandler === 'function') {
            document.removeEventListener('optionMenu', lastHandler);
        }
        var handler = params.onClick || function () { };
        document.addEventListener('optionMenu', handler, false);
        NBCall$2('setOptionMenu', params, { formatInput: formatInput });
        call$2('showOptionMenu');
    }
    function showActionSheet$8(params) {
        var formatInput = function (_a) {
            var _b = _a.cancelButtonText, cancelButtonText = _b === void 0 ? '取消' : _b, _c = _a.items, items = _c === void 0 ? [] : _c;
            return {
                cancelBtn: cancelButtonText,
                buttons: items,
                btns: items,
            };
        };
        NBCall$2('actionSheet', params, { formatInput: formatInput });
    }
    function showSharePanel$e(params) {
        NBCall$2('startShare', params);
    }
    function snapshot$2$1(params) {
        var formatInput = function (_a) {
            var _b = _a.saveToGallery, saveToGallery = _b === void 0 ? true : _b;
            return {
                dataType: 'fileURL',
                saveToGallery: saveToGallery,
            };
        };
        NBCall$2('snapshot', params, { formatInput: formatInput });
    }
    function vibrate$6(params) {
        NBCall$2('vibrate', params);
    }
    function alert$9(params) {
        var inputMap = {
            message: 'content',
            button: 'buttonText',
        };
        NBCall$2('alert', params, { inputMap: inputMap });
    }
    function confirm$7(params) {
        params.confirmButtonText = params.confirmButtonText || '确定';
        params.cancelButtonText = params.cancelButtonText || '取消';
        var inputMap = {
            message: 'content',
            okButton: 'confirmButtonText',
            cancelButton: 'cancelButtonText',
        };
        var outputMap = {
            confirm: 'ok',
        };
        NBCall$2('confirm', params, { inputMap: inputMap, outputMap: outputMap });
    }
    function getLocation$9$1(params) {
        var api = 'getLocation';
        var options = {
            requestType: true,
        };
        var _a = params.success, success = _a === void 0 ? function (r) { return r; } : _a, _b = params.fail, fail = _b === void 0 ? function (e) { return e; } : _b;
        var formatOutput = function (ret) {
            return {
                longitude: ret.longitude,
                latitude: ret.latitude,
                country: ret.country,
                countryCode: ret.countryCode,
                province: ret.province,
                city: ret.city.replace(/市$/i, ''),
                cityAdCode: ret.citycode,
            };
        };
        var onFail = enhanceFail$2(fail);
        var _success = enhanceSuccess$2(success, options, { formatOutput: formatOutput });
        var onSuccess = function (ret) {
            try {
                _success(ret);
            }
            catch (e) {
                onFail(e);
            }
        };
        call$2(api, options, onSuccess, onFail);
    }
    function navigateTo$f(params) {
        if (params === null || params === void 0 ? void 0 : params.useMiniCall) {
            var isMiniAli = typeof my !== 'undefined' &&
                !!my &&
                (typeof my.showToast === 'function' ||
                    typeof my.navigateTo === 'function');
            if (isMiniAli) {
                return my === null || my === void 0 ? void 0 : my.navigateTo(params);
            }
        }
        NBCall$2('pushWindow', params);
    }
    function redirectTo$7(params) {
        var api = 'startApp';
        var formatInput = function (_a) {
            var url = _a.url;
            var options = {
                appId: '20000067',
                param: {
                    url: url,
                },
                closeCurrentApp: true,
            };
            var matches = url.match(/\/\/([0-9]+).h5app/i);
            if (matches) {
                options = __assign$2(__assign$2({}, options), { appId: matches[1] });
            }
            return options;
        };
        NBCall$2(api, params, { formatInput: formatInput });
    }
    function setNavigationBar$e(params) {
        var api = 'setTitle';
        var formatInput = function (_a) {
            var title = _a.title, subtitle = _a.subtitle, image = _a.image, backgroundColor = _a.backgroundColor, reset = _a.reset;
            var options = {
                title: title,
            };
            if (subtitle) {
                options = __assign$2(__assign$2({}, options), { subtitle: subtitle });
            }
            options = __assign$2(__assign$2({}, options), { image: image });
            if (backgroundColor) {
                call$2('setTitleColor', {
                    color: parseInt(backgroundColor, 16),
                });
            }
            if (reset) {
                call$2('setTitleColor', {
                    reset: reset,
                });
            }
            return options;
        };
        NBCall$2(api, params, { formatInput: formatInput });
    }
    function showToast$8$1(_a) {
        var content = _a.content, _b = _a.type, type = _b === void 0 ? 'none' : _b, _c = _a.duration, duration = _c === void 0 ? 1500 : _c, _d = _a.success, success = _d === void 0 ? function (_) { return _; } : _d, _e = _a.fail, fail = _e === void 0 ? function () { } : _e;
        var api = 'toast';
        var options = {
            type: type,
            content: content,
            duration: duration,
        };
        var onSuccess = enhanceSuccess$2(success, options);
        var onFail = enhanceFail$2(fail);
        call$2(api, options, onSuccess, onFail);
        if (!/Android/i.test(navigator.userAgent)) {
            onSuccess(1);
        }
    }
    function chooseImage$7$1(params) {
        var formatInput = function () {
            return {
                publicDomain: true,
            };
        };
        var formatOutput = function (ret) {
            var formattedData = {
                tempFilePaths: [],
                tempFiles: [],
            };
            var previewURLList = ret.apFilePathsV2 || ret.apFilePaths;
            previewURLList.forEach(function (previewURL, index) {
                if (ret.localIds) {
                    formattedData.tempFiles.push({
                        localId: ret.localIds[index],
                        previewURL: previewURL,
                    });
                    formattedData.tempFilePaths.push(previewURL);
                }
                if (ret.tempFilePaths) {
                    var tempFilePaths = ret.tempFilePaths;
                    if (typeof tempFilePaths === 'string') {
                        tempFilePaths = JSON.parse(tempFilePaths);
                    }
                    formattedData.tempFiles.push({
                        path: tempFilePaths[index],
                        previewURL: previewURL,
                    });
                    formattedData.tempFilePaths.push(tempFilePaths[index]);
                }
            });
            return formattedData;
        };
        NBCall$2('chooseImage', params, { formatInput: formatInput, formatOutput: formatOutput });
    }
    function uploadImage$2(params) {
        try {
            delete params.ex;
        }
        catch (error) { }
        var promises = [];
        var files = params.tempFiles || params.files;
        files.forEach(function (file) {
            promises.push(new Promise(function (resolve, reject) {
                var options = {
                    compress: 4,
                    business: params.business || 'NebulaBiz',
                    publicDomain: true,
                    dataType: '',
                    data: '',
                };
                if (file.path) {
                    options.dataType = 'fileURL';
                    options.data = file.path;
                }
                else if (file.dataURL) {
                    options.dataType = 'dataURL';
                    options.data = file.dataURL;
                }
                else if (file.localId) {
                    options.dataType = 'localID';
                    options.data = file.localId;
                }
                else ;
                var onSuccess = function (ret) {
                    if (ret.errorMessage) {
                        reject(ret);
                    }
                    else {
                        resolve(__assign$2(__assign$2(__assign$2({}, ret), ret.result), { _originalOutput: ret, _originalInput: options }));
                    }
                };
                var onFail = function (e) { return reject(e); };
                call$2('uploadImage', options, onSuccess, onFail);
            }));
        });
        var success = params.success, fail = params.fail;
        var onSuccess = typeof success === 'function' ? function (ret) { return success(ret); } : function (ret) { return ret; };
        Promise.all(promises)
            .then(function (results) {
            var res = [];
            var originalRes = [];
            results.forEach(function (item) {
                res.push(item.publicUrl);
                originalRes.push(item);
            });
            onSuccess(__assign$2(__assign$2({}, params), { urlList: res, originalRes: originalRes, _originalOutput: originalRes }));
        })
            .catch(function (error) {
            fail(error);
        });
    }
    function playAudio$2(params) {
        var audioConfig = {
            audioDataUrl: params.urlMP3,
            audioName: 'audio-' + params.identifier,
            business: 'apm-h5',
        };
        if (!window._uniapi_context) {
            window._uniapi_context = {};
        }
        window._uniapi_context.audioConfig = audioConfig;
        var formatInput = function () {
            return audioConfig;
        };
        return stopAudio$2({
            identifier: params.identifier,
            success: function (res) {
                NBCall$2('playBackgroundAudio', params, { formatInput: formatInput });
            },
            fail: function () {
                NBCall$2('playBackgroundAudio', params, { formatInput: formatInput });
            },
        });
    }
    function pauseAudio$1(params) {
        return NBCall$2('pauseBackgroundAudio', params, {});
    }
    function stopAudio$2(params) {
        if (window._uniapi_context) {
            window._uniapi_context.audioConfig = null;
        }
        return NBCall$2('stopBackgroundAudio', params, {});
    }
    function resumeAudio$1(params) {
        if (window._uniapi_context) {
            var audioConfig = window._uniapi_context.audioConfig;
            if (!audioConfig) {
                return NBCall$2('playBackgroundAudio', audioConfig);
            }
        }
        var onFail = enhanceFail$2(params.fail);
        onFail({
            error: ERROR_AUDIO_CONFIG,
            errMsg: ERR_MSG_AUDIO_CONFIG,
        });
    }
    function getStatusBarHeight$4(params) {
        NBCall$2('getTitleAndStatusbarHeight', params);
    }

    var platform$1 = '';
    try {
        platform$1 = /\(i[^;]+;( U;)? CPU.+Mac OS X/i.test(navigator.userAgent)
            ? 'iOS'
            : 'Android';
    }
    catch (error) { }
    var JSCall$5 = function () {
        var _a;
        var _b;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (typeof window !== 'undefined' &&
            !!window &&
            typeof ((_b = window === null || window === void 0 ? void 0 : window.FYBridge) === null || _b === void 0 ? void 0 : _b.call) === 'function') {
            return (_a = window.FYBridge).call.apply(_a, __spread$1(args));
        }
        function genID() {
            return ~~(Math.random() * 1000);
        }
        var cMap = {
            successCallback: 'suc_',
            callbackCommand: 'cmd_',
            failCallback: 'fail_',
        };
        function genCallback(api, type, fn, isKeep) {
            var cname = ("" + (isKeep ? 'e_handler_' : api + "_" + (cMap[type] || 'callback_')) + genID()).replace(/\//gi, '_');
            window[cname] = (function (cb, _cname) {
                return function () {
                    var rest = [];
                    for (var _i = 0; _i < arguments.length; _i++) {
                        rest[_i] = arguments[_i];
                    }
                    cb.apply(void 0, __spread$1(rest));
                    if (!isKeep) {
                        delete window[_cname];
                    }
                };
            })(fn, cname);
            return cname;
        }
        var FYBridge = window.FYBridge;
        if (!FYBridge) {
            var pushBack_1 = function (api, params, isKeep) {
                if (params === void 0) { params = {}; }
                var name = 'bridge';
                var action = "bridge://" + api;
                var isAbnormal = /:\/\//.test(api);
                if (isAbnormal) {
                    action = api;
                    var _arr = api.split('://');
                    name = _arr[0];
                    api = _arr[1];
                }
                for (var i in params) {
                    if (Object.prototype.hasOwnProperty.call(params, i)) {
                        if (typeof params[i] === 'function') {
                            params[i] = genCallback(api, i, params[i], isKeep);
                        }
                        var formattedKey = params.ignore2LowerCase
                            ? i
                            : i.replace(/([A-Z])/g, '_$1').toLowerCase();
                        if (i !== formattedKey) {
                            params[formattedKey] = params[i];
                            delete params[i];
                        }
                    }
                }
                if (platform$1 === 'iOS') {
                    if (/\bWK\b/i.test(navigator.userAgent)) {
                        params._action_ = api;
                        webkit.messageHandlers[name].postMessage(params);
                    }
                    else {
                        alitripNativeCall(action, params);
                    }
                }
                else {
                    __JSContext__.alitripNativeCall(action, JSON.stringify(params));
                }
            };
            var call = function (api, options, success, failure) {
                if (typeof options === 'function') {
                    failure = success;
                    success = options;
                    options = {};
                }
                if (success) {
                    options.callbackCommand = options.successCallback = success;
                }
                if (failure) {
                    options.failCallback = failure;
                }
                if (options.clickHandler || options.clickCallback) {
                    pushBack_1(api, options, true);
                }
                else {
                    pushBack_1(api, options);
                }
            };
            FYBridge = { version: '1', call: call };
            Object.defineProperty(window, 'FYBridge', {
                enumerable: true,
                value: FYBridge,
            });
        }
        return FYBridge.call.apply(FYBridge, __spread$1(args));
    };
    function LXCall$1(apiName, params, formatOptions, errFormatOptions) {
        if (formatOptions === void 0) { formatOptions = {}; }
        if (errFormatOptions === void 0) { errFormatOptions = {}; }
        apiCall$1(apiName, params, JSCall$5, formatOptions, errFormatOptions);
    }
    function showLoading$8(params) {
        LXCall$1('open_loading_view', params);
    }
    function choosePhoneContact$7(params) {
        var formatOutput = function (ret) {
            return {
                name: ret.name,
                phone: ret.phone,
            };
        };
        LXCall$1('select_contacts', params, { formatOutput: formatOutput });
    }
    function getDeviceId$4(params) {
        var outputMap = {
            deviceId: 'device_id',
        };
        LXCall$1('client_info', params, { outputMap: outputMap });
    }
    function getNetworkType$8(params) {
        var formatOutput = function (ret) {
            var type = "" + ret.state;
            switch (type) {
                case '2':
                    type = 'WIFI';
                    break;
                case '5':
                    type = '4G';
                    break;
                case '4':
                    type = '3G';
                    break;
                case '3':
                    type = '2G';
                    break;
                case '6':
                    type = '5G';
                    break;
                case '7':
                    type = 'NONE';
                    break;
                case '0':
                case '1':
                default:
                    type = 'UNKNOWN';
                    break;
            }
            return { networkType: type };
        };
        LXCall$1('networktype', params, { formatOutput: formatOutput });
    }
    function openInBrowser$1(params) {
        LXCall$1('open_system_browser', params);
    }
    function setNaviBarRightItem$5(params) {
        var formatInput = function (_a) {
            var type = _a.type, title = _a.title, iconBase64 = _a.iconBase64, onClick = _a.onClick;
            var options = __assign$2(__assign$2({}, params), { redDot: '-1', reset: false, override: false });
            if (type === 'text') {
                options.title = title;
                options.clickCallback = onClick;
            }
            if (type === 'icon') {
                options.title = 'ICON';
                options.img = iconBase64;
            }
            return options;
        };
        LXCall$1('set_webview_right_button', params, { formatInput: formatInput });
        JSCall$5('showOptionMenu');
    }
    function clearNaviBarRightItem$5(params) {
        return setNaviBarRightItem$5({
            title: ' ',
            iconBase64: '',
            onClick: function () { },
        });
    }
    function showSharePanel$d(params) {
        var formatInput = function (_a) {
            var image = _a.image, url = _a.url, title = _a.title, content = _a.content;
            return {
                data: {
                    img_url: image,
                    h5_url: url,
                    title: title,
                    content: content,
                },
            };
        };
        LXCall$1('share', params, { formatInput: formatInput });
    }
    function snapshot$1$1(params) {
        var formatInput = function () {
            var docElement = document.documentElement;
            return {
                origin_x: 0,
                origin_y: 0,
                width: docElement.offsetWidth,
                height: docElement.offsetHeight,
            };
        };
        LXCall$1('screenCapture_share', params, { formatInput: formatInput });
    }
    function vibrate$5(params) {
        LXCall$1('vibrate', params);
    }
    function alert$8(params) {
        var formatInput = function (_a) {
            var title = _a.title, content = _a.content, _b = _a.buttonText, buttonText = _b === void 0 ? '确定' : _b;
            return {
                title: title,
                message: content,
                buttonNames: [buttonText],
            };
        };
        LXCall$1('alert', params, { formatInput: formatInput });
    }
    function confirm$6(params) {
        var formatInput = function (_a) {
            var title = _a.title, content = _a.content, _b = _a.confirmButtonText, confirmButtonText = _b === void 0 ? '确定' : _b, _c = _a.cancelButtonText, cancelButtonText = _c === void 0 ? '取消' : _c;
            return {
                title: title,
                message: content,
                buttonNames: [cancelButtonText, confirmButtonText],
            };
        };
        var formatOutput = function (ret) {
            return {
                confirm: ret.button_index === 1,
            };
        };
        LXCall$1('confirm', params, { formatInput: formatInput, formatOutput: formatOutput });
    }
    function navigateTo$e(params) {
        var formatInput = function (_a) {
            var url = _a.url;
            return {
                pageName: 'webview',
                animeType: 2,
                data: {
                    url: url,
                },
            };
        };
        LXCall$1('goto', params, { formatInput: formatInput });
    }
    function getLocation$8$1(params) {
        var formatOutput = function (ret) {
            return {
                longitude: ret.longitude,
                latitude: ret.latitude,
                country: ret.country,
                countryCode: ret.countryCode,
                province: ret.province,
                city: ret.city.replace(/市$/i, ''),
                cityAdCode: ret.citycode,
            };
        };
        var onFail = enhanceFail$2(params === null || params === void 0 ? void 0 : params.fail);
        var _success = enhanceSuccess$2(params === null || params === void 0 ? void 0 : params.success, params, { formatOutput: formatOutput });
        var onSuccess = function (ret) {
            try {
                _success(ret);
            }
            catch (e) {
                onFail(e);
            }
        };
        JSCall$5('native://lbs/locate', params, onSuccess, onFail);
    }
    function redirectTo$6(params) {
        var formatInput = function (_a) {
            var url = _a.url;
            return {
                pageName: 'webview',
                animeType: -1,
                data: {
                    url: setSearch(url, { _fli_popBeforeOpen: true }),
                },
            };
        };
        LXCall$1('goto', params, { formatInput: formatInput });
    }
    function setNavigationBar$d(params) {
        var formatInput = function (_a) {
            var subtitle = _a.subtitle, image = _a.image;
            var options = {};
            if (subtitle) {
                options = __assign$2(__assign$2({}, options), { subtitle: subtitle });
            }
            options = __assign$2(__assign$2({}, options), { image: image });
            return options;
        };
        LXCall$1('set_webview_title', params, { formatInput: formatInput });
    }
    function showToast$7$1(params) {
        var formatInput = function (_a) {
            var content = _a.content, _b = _a.type, type = _b === void 0 ? 'none' : _b, _c = _a.duration, duration = _c === void 0 ? 1500 : _c;
            return {
                message: content,
                type: type,
                duration: duration,
            };
        };
        LXCall$1('toast', params, { formatInput: formatInput });
    }
    function scan$a(params) {
        var formatInput = function () {
            return {
                action: 'RETURN',
            };
        };
        LXCall$1('scan_code', params, { formatInput: formatInput });
    }
    function navigateBack$d(params) {
        methodChannel.call('close', params, function () { }, function () { });
    }
    function isAppInstalled$3(params) {
        var inputMap = {
            package_name: 'android',
            scheme: 'ios',
        };
        LXCall$1('is_installed_app', params, { inputMap: inputMap });
    }
    function hideTitle$5(params) {
        var formatInput = function () {
            return {
                titlebarDisplay: 'hide',
            };
        };
        LXCall$1('set_ui', params, { formatInput: formatInput });
    }
    function showTitle$3(params) {
        var formatInput = function () {
            return {
                titlebarDisplay: 'show',
            };
        };
        LXCall$1('set_ui', params, { formatInput: formatInput });
    }
    function saveImage$4$1(params) {
        LXCall$1('save_image_to_album', params, {});
    }
    function chooseImage$6$1(params) {
        var formatInput = function (options) {
            return {
                pickType: 0,
                maxSelect: options.count || 1,
            };
        };
        LXCall$1('take_photo', params, { formatInput: formatInput });
    }
    function getStatusBarHeight$3(params) {
        var success = enhanceSuccess$2(params.success, params);
        success === null || success === void 0 ? void 0 : success({
            statusBarHeight: isIOS$3
                ? isIphoneXSeries$1
                    ? 88
                    : 40
                : window.__STATUS_BAR_HEIGHT__,
        });
    }

    function getScriptFromCDN$1(url, retryTimes, maxRetryTimes, resolveCB, rejectCB) {
        var doc = document;
        var head = doc.head || doc.getElementsByTagName('head')[0] || doc.documentElement;
        var node = doc.createElement('script');
        node.setAttribute('charset', 'utf-8');
        if ('onload' in node) {
            node.onload = function () {
                resolveCB && resolveCB();
            };
            node.onerror = function (e) {
                if (retryTimes < maxRetryTimes) {
                    retryTimes++;
                    getScriptFromCDN$1(url, retryTimes, maxRetryTimes, resolveCB, rejectCB);
                }
                else {
                    rejectCB && rejectCB();
                }
            };
        }
        else {
            node.onreadystatechange = function () {
                if (/loaded|complete/.test(node.readyState)) {
                    resolveCB && resolveCB();
                }
            };
        }
        node.async = true;
        node.src = url;
        head.appendChild(node);
    }
    function loadScripts$1(libs, maxRetryTimes) {
        var promiseList = [];
        var _loop_1 = function (i) {
            var promise = new Promise(function (resolve, reject) {
                getScriptFromCDN$1(libs[i], 0, maxRetryTimes, resolve, reject);
            });
            promiseList.push(promise);
        };
        for (var i = 0; i < libs.length; i++) {
            _loop_1(i);
        }
        return Promise.all(promiseList);
    }

    var MAX_CDN_RESOURCE_RETRY_TIMES$1 = 1;

    function DDCall$1(api, params, formatOptions, errFormatOptions) {
        if (formatOptions === void 0) { formatOptions = {}; }
        if (errFormatOptions === void 0) { errFormatOptions = {}; }
        apiCall$1(null, params, api, formatOptions, errFormatOptions);
    }
    function showToast$6$1(params) {
        var api = dd.device.notification.toast;
        var formatInput = function (input) {
            return {
                icon: '',
                text: input.content,
                duration: input.duration
                    ? input.duration > 100
                        ? input.duration / 1000
                        : input.duration
                    : 2,
                delay: 0,
            };
        };
        return DDCall$1(api, params, { formatInput: formatInput });
    }
    function alert$7(params) {
        var api = dd.device.notification.alert;
        var inputMap = {
            title: 'title',
            message: 'content',
            buttonName: 'buttonText',
        };
        return DDCall$1(api, params, { inputMap: inputMap });
    }
    function confirm$5(params) {
        var api = dd.device.notification.confirm;
        var formatOutput = function (ret) {
            return {
                confirm: ret.buttonIndex === 0,
            };
        };
        var formatInput = function (input) {
            return {
                message: input.content,
                buttonLabels: [input.confirmButtonText, input.cancelButtonText],
            };
        };
        return DDCall$1(api, params, { formatInput: formatInput, formatOutput: formatOutput });
    }
    function showActionSheet$7(params) {
        var api = dd.device.notification.actionSheet;
        var outputMap = {
            index: 'buttonIndex',
        };
        var formatInput = function (input) {
            return {
                cancelButton: input.cancelButtonText || '取消',
                otherButtons: input.items,
            };
        };
        return DDCall$1(api, params, { outputMap: outputMap, formatInput: formatInput });
    }
    function showLoading$7(params) {
        var api = dd.device.notification.showPreloader;
        var formatInput = function () {
            return { text: '', showIcon: true };
        };
        return DDCall$1(api, params, { formatInput: formatInput });
    }
    function hideLoading$7(params) {
        var api = dd.device.notification.hidePreloader;
        return DDCall$1(api, params);
    }
    function setNavigationBar$c(params) {
        var api = dd.biz.navigation.setTitle;
        return DDCall$1(api, params);
    }
    function setNaviBarRightItem$4(params) {
        if (params.type === 'text') {
            var api = dd.biz.navigation.setRight;
            var formatInput = function (input) {
                return {
                    show: true,
                    control: true,
                    text: input.title,
                    onSuccess: function (e) {
                        var onClick = (params === null || params === void 0 ? void 0 : params.onClick) || function () { };
                        onClick(e);
                    },
                };
            };
            DDCall$1(api, params, { formatInput: formatInput });
        }
        else {
            var onFail = enhanceFail$2(params.fail);
            return onFail({ error: '1', errMsg: 'not support options icon' });
        }
    }
    function clearNaviBarRightItem$4(params) {
        return new Promise(function (resolve, reject) {
            var api = dd.biz.navigation.setRight;
            var formatInput = function (input) {
                return {
                    control: false,
                    text: '分享',
                };
            };
            return DDCall$1(api, params, { formatInput: formatInput });
        });
    }
    function choosePhoneContact$6(params) {
        var api = dd.biz.contact.chooseMobileContacts;
        var formatOutput = function (ret) {
            return {
                name: ret[0].name,
                phone: ret[0].mobile.replace(/(\s|-)+/g, ''),
                multiple: false,
            };
        };
        return DDCall$1(api, params, { formatOutput: formatOutput });
    }
    function showSharePanel$c(params) {
        var api = dd.biz.util.share;
        var formatInput = function (input) {
            return {
                type: 0,
                url: input.url,
                title: input.title,
                content: input.content,
                image: input.image,
            };
        };
        return DDCall$1(api, params, { formatInput: formatInput });
    }
    function navigateTo$d(params) {
        var api = dd.biz.util.openLink;
        return DDCall$1(api, params);
    }
    function navigateBack$c(params) {
        var api = dd.biz.navigation.close;
        return DDCall$1(api, params);
    }
    function previewImage$8$1(params) {
        var formatInput = function (options) {
            var _a, _b;
            var current = (_a = options === null || options === void 0 ? void 0 : options.urls) === null || _a === void 0 ? void 0 : _a[0];
            if (options.current !== undefined) {
                current = (_b = options === null || options === void 0 ? void 0 : options.urls) === null || _b === void 0 ? void 0 : _b[+options.current];
            }
            return { current: current };
        };
        if (typeof dd === 'undefined') {
            var urls = [
                'https://g.alicdn.com/dingding/dingtalk-jsapi/2.10.3/dingtalk.open.js',
            ];
            loadScripts$1(urls, MAX_CDN_RESOURCE_RETRY_TIMES$1).then(function () {
                var api = dd.biz.util.previewImage;
                return DDCall$1(api, params, { formatInput: formatInput });
            });
        }
        else {
            var api = dd.biz.util.previewImage;
            return DDCall$1(api, params, { formatInput: formatInput });
        }
    }
    function getNetworkType$7(params) {
        var api = dd.device.connection.getNetworkType;
        var formatOutput = function (ret) {
            return {
                networkType: (ret.result || '').toUpperCase(),
            };
        };
        return DDCall$1(api, params, { formatOutput: formatOutput });
    }
    function getLocation$7$1(params) {
        var formatOutput = function (ret) {
            return {
                longitude: ret.longitude.toString(),
                latitude: ret.latitude.toString(),
            };
        };
        var formatInput = function (input) {
            var targetAccuracy = input.highAccuracy ? 50 : 200;
            return {
                targetAccuracy: targetAccuracy,
                coordinate: 0,
                withReGeocode: false,
                useCache: true,
            };
        };
        return DDCall$1(dd.device.geolocation.get, params, {
            formatInput: formatInput,
            formatOutput: formatOutput,
        });
    }
    function isAppInstalled$2(params) {
        var api = dd.device.launcher.checkInstalledApps;
        var formatInput = function (input) {
            return { apps: [input.ios, input.ios] };
        };
        var formatOutput = function (ret) {
            return {
                installed: ret.installed.some(function (schema) {
                    return params.ios === schema || params.android === schema;
                }),
            };
        };
        return DDCall$1(api, params, { formatInput: formatInput, formatOutput: formatOutput });
    }
    function setClipboard$7$1(params) {
        var api = dd.biz.clipboardData.setData;
        return DDCall$1(api, params);
    }
    function scan$9(params) {
        var api = dd.biz.util.scan;
        var type = 'all';
        var resultType = 'QR';
        if (params.type === 'qr') {
            type = 'qrCode';
            resultType = 'QR';
        }
        if (params.type === 'bar') {
            type = 'barCode';
            resultType = 'BAR';
        }
        var formatOutput = function (ret) {
            return {
                type: resultType,
                code: ret.text,
            };
        };
        var formatInput = function () {
            return { type: type };
        };
        return DDCall$1(api, params, { formatInput: formatInput, formatOutput: formatOutput });
    }
    function vibrate$4(params) {
        var api = dd.device.notification.vibrate;
        var formatInput = function () {
            return { duration: 300 };
        };
        DDCall$1(api, params, { formatInput: formatInput });
    }

    function DDCall$2(api, params, formatOptions, errFormatOptions) {
        if (formatOptions === void 0) { formatOptions = {}; }
        if (errFormatOptions === void 0) { errFormatOptions = {}; }
        apiCall$1(null, params, api, formatOptions, errFormatOptions);
    }
    function showToast$5$1(params) {
        var api = dd.device.notification.toast;
        var formatInput = function (input) {
            return {
                icon: '',
                text: input.content,
                duration: input.duration
                    ? input.duration > 100
                        ? input.duration / 1000
                        : input.duration
                    : 2,
                delay: 0,
            };
        };
        return DDCall$2(api, params, { formatInput: formatInput });
    }
    function alert$6(params) {
        var api = dd.device.notification.alert;
        var inputMap = {
            title: 'title',
            message: 'content',
            buttonName: 'buttonText',
        };
        return DDCall$2(api, params, { inputMap: inputMap });
    }
    function confirm$4(params) {
        var api = dd.device.notification.confirm;
        var formatOutput = function (ret) {
            return {
                confirm: ret.buttonIndex === 0,
            };
        };
        var formatInput = function (input) {
            return {
                message: input.content,
                buttonLabels: [input.confirmButtonText, input.cancelButtonText],
            };
        };
        return DDCall$2(api, params, { formatInput: formatInput, formatOutput: formatOutput });
    }
    function showActionSheet$6(params) {
        var api = dd.device.notification.actionSheet;
        var outputMap = {
            index: 'buttonIndex',
        };
        var formatInput = function (input) {
            return {
                cancelButton: input.cancelButtonText || '取消',
                otherButtons: input.items,
            };
        };
        return DDCall$2(api, params, { outputMap: outputMap, formatInput: formatInput });
    }
    function showLoading$6(params) {
        var api = dd.device.notification.showPreloader;
        var formatInput = function () {
            return { text: '', showIcon: true };
        };
        return DDCall$2(api, params, { formatInput: formatInput });
    }
    function hideLoading$6(params) {
        var api = dd.device.notification.hidePreloader;
        return DDCall$2(api, params);
    }
    function setNavigationBar$b(params) {
        var api = dd.biz.navigation.setTitle;
        return DDCall$2(api, params);
    }
    function setNaviBarRightItem$3$1(params) {
        if (params.type === 'text') {
            var api = dd.biz.navigation.setRight;
            var formatInput = function (input) {
                return {
                    show: true,
                    control: true,
                    text: input.title,
                    onSuccess: function (e) {
                        var onClick = (params === null || params === void 0 ? void 0 : params.onClick) || function () { };
                        onClick(e);
                    },
                };
            };
            DDCall$2(api, params, { formatInput: formatInput });
        }
        else {
            var onFail = enhanceFail$2(params.fail);
            return onFail({ error: '1', errMsg: 'not support options icon' });
        }
    }
    function clearNaviBarRightItem$3$1(params) {
        return new Promise(function (resolve, reject) {
            var api = dd.biz.navigation.setRight;
            var formatInput = function (input) {
                return {
                    control: false,
                    text: '分享',
                };
            };
            return DDCall$2(api, params, { formatInput: formatInput });
        });
    }
    function choosePhoneContact$5(params) {
        var api = dd.biz.contact.chooseMobileContacts;
        var formatOutput = function (ret) {
            return {
                name: ret[0].name,
                phone: ret[0].mobile.replace(/(\s|-)+/g, ''),
                multiple: false,
            };
        };
        return DDCall$2(api, params, { formatOutput: formatOutput });
    }
    function showSharePanel$b(params) {
        var api = dd.biz.util.share;
        var formatInput = function (input) {
            return {
                type: 0,
                url: input.url,
                title: input.title,
                content: input.content,
                image: input.image,
            };
        };
        return DDCall$2(api, params, { formatInput: formatInput });
    }
    function navigateTo$c(params) {
        var api = dd.biz.util.openLink;
        return DDCall$2(api, params);
    }
    function previewImage$7$1(params) {
        var formatInput = function (options) {
            var _a, _b;
            var current = (_a = options === null || options === void 0 ? void 0 : options.urls) === null || _a === void 0 ? void 0 : _a[0];
            if (options.current !== undefined) {
                current = (_b = options === null || options === void 0 ? void 0 : options.urls) === null || _b === void 0 ? void 0 : _b[+options.current];
            }
            return { current: current };
        };
        if (typeof dd === 'undefined') {
            var urls = [
                'https://g.alicdn.com/dingding/dingtalk-jsapi/2.10.3/dingtalk.open.js',
            ];
            loadScripts$1(urls, MAX_CDN_RESOURCE_RETRY_TIMES$1).then(function () {
                var api = dd.biz.util.previewImage;
                return DDCall$2(api, params, { formatInput: formatInput });
            });
        }
        else {
            var api = dd.biz.util.previewImage;
            return DDCall$2(api, params, { formatInput: formatInput });
        }
    }
    function getNetworkType$6(params) {
        var api = dd.device.connection.getNetworkType;
        var formatOutput = function (ret) {
            return {
                networkType: (ret.result || '').toUpperCase(),
            };
        };
        return DDCall$2(api, params, { formatOutput: formatOutput });
    }
    function getLocation$6$1(params) {
        var formatOutput = function (ret) {
            return {
                longitude: ret.longitude.toString(),
                latitude: ret.latitude.toString(),
            };
        };
        var formatInput = function (input) {
            var targetAccuracy = input.highAccuracy ? 50 : 200;
            return {
                targetAccuracy: targetAccuracy,
                coordinate: 0,
                withReGeocode: false,
                useCache: true,
            };
        };
        return DDCall$2(dd.device.geolocation.get, params, {
            formatInput: formatInput,
            formatOutput: formatOutput,
        });
    }
    function isAppInstalled$1$1(params) {
        var api = dd.device.launcher.checkInstalledApps;
        var formatInput = function (input) {
            return { apps: [input.ios, input.ios] };
        };
        var formatOutput = function (ret) {
            return {
                installed: ret.installed.some(function (schema) {
                    return params.ios === schema || params.android === schema;
                }),
            };
        };
        return DDCall$2(api, params, { formatInput: formatInput, formatOutput: formatOutput });
    }
    function setClipboard$6$1(params) {
        var api = dd.biz.clipboardData.setData;
        return DDCall$2(api, params);
    }
    function scan$8(params) {
        var api = dd.biz.util.scan;
        var type = 'all';
        var resultType = 'QR';
        if (params.type === 'qr') {
            type = 'qrCode';
            resultType = 'QR';
        }
        if (params.type === 'bar') {
            type = 'barCode';
            resultType = 'BAR';
        }
        var formatOutput = function (ret) {
            return {
                type: resultType,
                code: ret.text,
            };
        };
        var formatInput = function () {
            return { type: type };
        };
        return DDCall$2(api, params, { formatInput: formatInput, formatOutput: formatOutput });
    }
    function vibrate$3(params) {
        var api = dd.device.notification.vibrate;
        var formatInput = function () {
            return { duration: 300 };
        };
        DDCall$2(api, params, { formatInput: formatInput });
    }

    function navigateBack$b(params) {
        var api = dd.biz.navigation.close(params);
        DDCall$2(api, params);
    }

    function alert$5() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return my.alert.apply(my, __spread$1(args));
    }
    function chooseCity$3() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return my.chooseCity.apply(my, __spread$1(args));
    }
    function chooseImage$5$1() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (args[0] && typeof args[0] === 'object') {
            return my.chooseImage.apply(my, __spread$1([
                __assign$2(__assign$2({}, args[0]), { fail: function (err) {
                        var _a, _b, _c;
                        var systemInfo = (_a = my === null || my === void 0 ? void 0 : my.getSystemInfoSync) === null || _a === void 0 ? void 0 : _a.call(my);
                        if ((systemInfo === null || systemInfo === void 0 ? void 0 : systemInfo.app) === 'TB' && (systemInfo === null || systemInfo === void 0 ? void 0 : systemInfo.platform) === 'iOS') {
                            if (err.error === 1) {
                                alert$5({
                                    title: '开启相册权限',
                                    content: '开启后才能访问你的照片',
                                    buttonText: '我知道了',
                                });
                            }
                        }
                        (_c = (_b = args[0]) === null || _b === void 0 ? void 0 : _b.fail) === null || _c === void 0 ? void 0 : _c.call(_b, err);
                    }, success: function (res) {
                        var _a, _b;
                        var formattedRes = {
                            dataList: res === null || res === void 0 ? void 0 : res.apFilePaths.map(function (path, i) {
                                return {
                                    previewURL: path,
                                    fileURL: res === null || res === void 0 ? void 0 : res.tempFiles[i],
                                };
                            }),
                            _orignal: {
                                input: args[0],
                                output: res,
                            },
                        } || [];
                        (_b = (_a = args[0]) === null || _a === void 0 ? void 0 : _a.success) === null || _b === void 0 ? void 0 : _b.call(_a, formattedRes);
                    } })
            ], args.slice(1)));
        }
        return my.chooseImage.apply(my, __spread$1(args));
    }
    function choosePhoneContact$4() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return my.choosePhoneContact.apply(my, __spread$1(args));
    }
    function confirm$3() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return my.confirm.apply(my, __spread$1(args));
    }
    function getLocation$5$1() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return my.getLocation.apply(my, __spread$1(args));
    }
    function getNetworkType$5() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return my.getNetworkType.apply(my, __spread$1(args));
    }
    function hideLoading$5() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return my.hideLoading.apply(my, __spread$1(args));
    }
    function hideNavigationBarLoading$2() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return my.hideNavigationBarLoading.apply(my, __spread$1(args));
    }
    function hideToast$4$1() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return my.hideToast.apply(my, __spread$1(args));
    }
    function navigateBack$a$1() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return my.navigateBack.apply(my, __spread$1(args));
    }
    function navigateTo$b() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return my.navigateTo.apply(my, __spread$1(args));
    }
    function previewImage$6$1() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return my.previewImage.apply(my, __spread$1(args));
    }
    function redirectTo$5() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return my.redirectTo.apply(my, __spread$1(args));
    }
    function saveImage$3$1(params) {
        return my.saveImage(params);
    }
    function scan$7() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return my.scan.apply(my, __spread$1(args));
    }
    function setBackgroundColor$4() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return my.setBackgroundColor.apply(my, __spread$1(args));
    }
    function setClipboard$5$1() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return my.setClipboard.apply(my, __spread$1(args));
    }
    function setNavigationBar$a() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return my.setNavigationBar.apply(my, __spread$1(args));
    }
    function showActionSheet$5() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return my.showActionSheet.apply(my, __spread$1(args));
    }
    function showLoading$5() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return my.showLoading.apply(my, __spread$1(args));
    }
    function showNavigationBarLoading$2() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return my.showNavigationBarLoading.apply(my, __spread$1(args));
    }
    function showSharePanel$a() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return my.showSharePanel.apply(my, __spread$1(args));
    }
    function showToast$4$1() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return my.showToast.apply(my, __spread$1(args));
    }
    function vibrate$2() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return my.vibrate.apply(my, __spread$1(args));
    }
    function vibrateLong$4() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return my.vibrateLong.apply(my, __spread$1(args));
    }
    function vibrateShort$4() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return my.vibrateShort.apply(my, __spread$1(args));
    }
    function getStorage$4() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return my.getStorage.apply(my, __spread$1(args));
    }
    function getStorageSync$5() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return my.getStorageSync.apply(my, __spread$1(args));
    }
    function setStorage$4() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return my.setStorage.apply(my, __spread$1(args));
    }
    function setStorageSync$5() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return my.setStorageSync.apply(my, __spread$1(args));
    }
    function removeStorage$4() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return my.removeStorage.apply(my, __spread$1(args));
    }
    function removeStorageSync$5() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return my.removeStorageSync.apply(my, __spread$1(args));
    }
    function clearStorage$3() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return my.clearStorage.apply(my, __spread$1(args));
    }
    function clearStorageSync$4() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return my.clearStorageSync.apply(my, __spread$1(args));
    }
    function optionsSelect() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return my.optionsSelect.apply(my, __spread$1(args));
    }
    function datePicker$1() {
        var _a, _b, _c, _d;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var systemInfo = (_a = my === null || my === void 0 ? void 0 : my.getSystemInfoSync) === null || _a === void 0 ? void 0 : _a.call(my);
        if (args[0] &&
            typeof args[0] === 'object' &&
            args[0].format === 'yyyy' &&
            (systemInfo === null || systemInfo === void 0 ? void 0 : systemInfo.app) === 'TB' &&
            (systemInfo === null || systemInfo === void 0 ? void 0 : systemInfo.platform) === 'Android') {
            var fullYear = new Date().getFullYear();
            var yearNameList = [];
            var yearList_1 = [];
            var startYear = parseInt((_b = args[0]) === null || _b === void 0 ? void 0 : _b.startDate) || fullYear;
            var endYear = parseInt((_c = args[0]) === null || _c === void 0 ? void 0 : _c.endDate) || fullYear;
            var selectedOneIndex = 0;
            for (var year = startYear; year <= endYear; year++) {
                if (year === parseInt((_d = args[0]) === null || _d === void 0 ? void 0 : _d.currentDate)) {
                    selectedOneIndex = yearList_1.length;
                }
                yearNameList.push(year + " \u5E74");
                yearList_1.push(year);
            }
            return optionsSelect({
                title: '',
                optionsOne: yearNameList,
                selectedOneIndex: selectedOneIndex,
                success: function (res) { var _a, _b; return (_b = (_a = args[0]) === null || _a === void 0 ? void 0 : _a.success) === null || _b === void 0 ? void 0 : _b.call(_a, {
                    date: yearList_1[res === null || res === void 0 ? void 0 : res.selectedOneIndex],
                }); },
            });
        }
        return my.datePicker.apply(my, __spread$1(args));
    }

    function genParams(params, formatOptions) {
        var _a;
        if (formatOptions === void 0) { formatOptions = {}; }
        var success = params.success, fail = params.fail;
        var options = {};
        var formatInput = formatOptions.formatInput, inputMap = formatOptions.inputMap, formatOutput = formatOptions.formatOutput, outputMap = formatOptions.outputMap;
        if (typeof formatInput === 'function') {
            options = formatInput(params);
        }
        else if (inputMap) {
            (_a = Object.keys(inputMap)) === null || _a === void 0 ? void 0 : _a.forEach(function (key) {
                options[key] = params[inputMap[key]];
            });
        }
        var _success = enhanceSuccess$2(success, options, {
            outputMap: outputMap,
            formatOutput: formatOutput,
        });
        var _fail = enhanceFail$2(fail);
        return __assign$2(__assign$2(__assign$2({}, params), options), { success: _success, fail: _fail });
    }

    function alert$4(params) {
        var formatInput = function (options) {
            return {
                confirmText: options.buttonText || '',
                showCancel: false,
            };
        };
        var options = genParams(params, { formatInput: formatInput });
        wx.showModal(options);
    }
    function setNavigationBar$9(params) {
        var backgroundColor = params.backgroundColor, title = params.title;
        var options = genParams(params);
        if (backgroundColor) {
            wx.setNavigationBarColor(options);
        }
        if (title) {
            wx.setNavigationBarTitle(options);
        }
    }
    function hideToast$3$1(params) {
        var options = genParams(params);
        wx.hideToast(options);
    }
    function showActionSheet$4(params) {
        var inputMap = {
            alerText: 'hideTitle',
            itemList: 'items',
        };
        var options = genParams(params, { inputMap: inputMap });
        return wx.showActionSheet(options);
    }
    function choosePhoneContact$3(params) {
        var outputMap = {
            phoneNumber: 'mobile',
            displayName: 'name',
        };
        var options = genParams(params, { outputMap: outputMap });
        return wx.chooseContact(options);
    }
    function navigateBack$9$1(params) {
        var options = genParams(params);
        return wx.navigateBack(options);
    }
    function showLoading$4(params) {
        var inputMap = {
            title: 'content',
        };
        var options = genParams(params, { inputMap: inputMap });
        return wx.showLoading(options);
    }
    function navigateTo$a(params) {
        var options = genParams(params);
        wx.navigateTo(options);
    }
    function showToast$3$1(params) {
        var formatInput = function (options) {
            return {
                title: 'content',
                icon: options.type === 'fail' ? 'error' : options.type,
            };
        };
        var options = genParams(params, { formatInput: formatInput });
        return wx.showToast(options);
    }
    function previewImage$5$1(params) {
        var options = genParams(params);
        return wx.previewImage(options);
    }
    function redirectTo$4(params) {
        var options = genParams(params);
        return wx.redirectTo(options);
    }
    function showSharePanel$9(params) {
        var options = genParams(params);
        return wx.showShareMenu(options);
    }
    function chooseImage$4$1(params) {
        var options = genParams(params);
        return wx.chooseImage(options);
    }
    function getLocation$4$1(params) {
        var options = genParams(params);
        return wx.getLocation(options);
    }
    function scan$6(params) {
        var options = genParams(params);
        return wx.scanCode(options);
    }
    function vibrateLong$3(params) {
        var options = genParams(params);
        return wx.vibrateLong(options);
    }
    function getNetworkType$4$1(params) {
        var options = genParams(params);
        return wx.getNetworkType(options);
    }
    function setBackgroundColor$3(params) {
        var options = genParams(params);
        return wx.setBackgroundColor(options);
    }
    function vibrateShort$3(params) {
        var options = genParams(params);
        return wx.vibrateShort(options);
    }
    function getOrientation$2(params) {
        var options = genParams(params);
        return wx.getOrientation(options);
    }
    function setClipboard$4$1(params) {
        var inputMap = {
            data: 'text',
        };
        var options = genParams(params, { inputMap: inputMap });
        return wx.setClipboardData(options);
    }
    function hideLoading$4(params) {
        var options = genParams(params);
        return wx.hideLoading(options);
    }
    function getStorage$3() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return wx.getStorage.apply(wx, __spread$1(args));
    }
    function setStorage$3() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return wx.setStorage.apply(wx, __spread$1(args));
    }
    function removeStorage$3() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return wx.removeStorage.apply(wx, __spread$1(args));
    }
    function clearStorage$2() {
        return wx.clearStorage();
    }
    function getStorageSync$4(params) {
        var key = params.key;
        var data = params.data;
        return wx.getStorageSync(key, data);
    }
    function setStorageSync$4(params) {
        var key = params.key;
        var data = params.data;
        return wx.setStorageSync(key, data);
    }
    function removeStorageSync$4(params) {
        var key = params.key;
        return wx.removeStorageSync(key);
    }
    function clearStorageSync$3() {
        return wx.clearStorageSync();
    }
    function saveImage$2$1(params) {
        genParams(params, {
            inputMap: {
                filePath: 'url',
            },
        });
        wx.saveImageToPhotosAlbum(params);
    }

    function alert$3(params) {
        var formatInput = function (options) {
            return {
                confirmText: options.buttonText || '',
                showCancel: false,
            };
        };
        var options = genParams(params, { formatInput: formatInput });
        tt.showModal(options);
    }
    function setNavigationBar$8(params) {
        var backgroundColor = params.backgroundColor, title = params.title;
        var options = genParams(params);
        if (backgroundColor) {
            tt.setNavigationBarColor(options);
        }
        if (title) {
            tt.setNavigationBarTitle(options);
        }
    }
    function hideToast$2$1(params) {
        var options = genParams(params);
        tt.hideToast(options);
    }
    function showActionSheet$3(params) {
        var inputMap = {
            alerText: 'hideTitle',
            itemList: 'items',
        };
        var options = genParams(params, { inputMap: inputMap });
        return tt.showActionSheet(options);
    }
    function choosePhoneContact$2(params) {
        var outputMap = {
            phoneNumber: 'mobile',
            displayName: 'name',
        };
        var options = genParams(params, { outputMap: outputMap });
        return tt.chooseContact(options);
    }
    function navigateBack$8$1(params) {
        var options = genParams(params);
        return tt.navigateBack(options);
    }
    function showLoading$3$1(params) {
        var inputMap = {
            title: 'content',
        };
        var options = genParams(params, { inputMap: inputMap });
        return tt.showLoading(options);
    }
    function navigateTo$9$1(params) {
        var options = genParams(params);
        tt.navigateTo(options);
    }
    function showToast$2$1(params) {
        var formatInput = function (options) {
            return {
                title: 'content',
                icon: options.type === 'fail' ? 'error' : options.type,
            };
        };
        var options = genParams(params, { formatInput: formatInput });
        return tt.showToast(options);
    }
    function previewImage$4$1(params) {
        var options = genParams(params);
        return tt.previewImage(options);
    }
    function redirectTo$3$1(params) {
        var options = genParams(params);
        return tt.redirectTo(options);
    }
    function showSharePanel$8(params) {
        var options = genParams(params);
        return tt.showShareMenu(options);
    }
    function chooseImage$3$1(params) {
        var options = genParams(params);
        return tt.chooseImage(options);
    }
    function getLocation$3$1(params) {
        var options = genParams(params);
        return tt.getLocation(options);
    }
    function scan$5$1(params) {
        var options = genParams(params);
        return tt.scanCode(options);
    }
    function vibrateLong$2(params) {
        var options = genParams(params);
        return tt.vibrateLong(options);
    }
    function getNetworkType$3$1(params) {
        var options = genParams(params);
        return tt.getNetworkType(options);
    }
    function setBackgroundColor$2(params) {
        var options = genParams(params);
        return tt.setBackgroundColor(options);
    }
    function vibrateShort$2(params) {
        var options = genParams(params);
        return tt.vibrateShort(options);
    }
    function getOrientation$1(params) {
        var options = genParams(params);
        return tt.getOrientation(options);
    }
    function setClipboard$3$1(params) {
        var inputMap = {
            data: 'text',
        };
        var options = genParams(params, { inputMap: inputMap });
        return tt.setClipboardData(options);
    }
    function hideLoading$3$1(params) {
        var options = genParams(params);
        return tt.hideLoading(options);
    }
    function getStorage$2() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return tt.getStorage.apply(tt, __spread$1(args));
    }
    function setStorage$2$1() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return tt.setStorage.apply(tt, __spread$1(args));
    }
    function removeStorage$2() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return tt.removeStorage.apply(tt, __spread$1(args));
    }
    function clearStorage$1() {
        return tt.clearStorage();
    }
    function getStorageSync$3(params) {
        var key = params.key;
        var data = params.data;
        return tt.getStorageSync(key, data);
    }
    function setStorageSync$3(params) {
        var key = params.key;
        var data = params.data;
        return tt.setStorageSync(key, data);
    }
    function removeStorageSync$3(params) {
        var key = params.key;
        return tt.removeStorageSync(key);
    }
    function clearStorageSync$2() {
        return tt.clearStorageSync();
    }
    function saveImage$1$1(params) {
        genParams(params, {
            inputMap: {
                filePath: 'url',
            },
        });
        tt.saveImageToPhotosAlbum(params);
    }

    function alert$2$1() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return my.alert.apply(my, __spread$1(args));
    }
    function chooseCity$2() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return my.chooseCity.apply(my, __spread$1(args));
    }
    function chooseImage$2$1() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return my.chooseImage.apply(my, __spread$1(args));
    }
    function choosePhoneContact$1$1() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return my.choosePhoneContact.apply(my, __spread$1(args));
    }
    function confirm$2$1() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return my.confirm.apply(my, __spread$1(args));
    }
    function getLocation$2$1() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return my.getLocation.apply(my, __spread$1(args));
    }
    function getNetworkType$2$1() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return my.getNetworkType.apply(my, __spread$1(args));
    }
    function hideLoading$2$1() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return my.hideLoading.apply(my, __spread$1(args));
    }
    function hideNavigationBarLoading$1() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return my.hideNavigationBarLoading.apply(my, __spread$1(args));
    }
    function hideToast$1$1() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return my.hideToast.apply(my, __spread$1(args));
    }
    function navigateBack$7$1() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return my.navigateBack.apply(my, __spread$1(args));
    }
    function navigateTo$8$1() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return my.navigateTo.apply(my, __spread$1(args));
    }
    function previewImage$3$1() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return my.previewImage.apply(my, __spread$1(args));
    }
    function redirectTo$2$1() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return my.redirectTo.apply(my, __spread$1(args));
    }
    function scan$4$1() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return my.scan.apply(my, __spread$1(args));
    }
    function setBackgroundColor$1() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return my.setBackgroundColor.apply(my, __spread$1(args));
    }
    function setClipboard$2$1() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return my.setClipboard.apply(my, __spread$1(args));
    }
    function setNavigationBar$7() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return my.setNavigationBar.apply(my, __spread$1(args));
    }
    function showActionSheet$2() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return my.showActionSheet.apply(my, __spread$1(args));
    }
    function showLoading$2$1() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return my.showLoading.apply(my, __spread$1(args));
    }
    function showNavigationBarLoading$1() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return my.showNavigationBarLoading.apply(my, __spread$1(args));
    }
    function showSharePanel$7() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return my.showSharePanel.apply(my, __spread$1(args));
    }
    function showToast$1$1() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return my.showToast.apply(my, __spread$1(args));
    }
    function vibrate$1$1() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return my.vibrate.apply(my, __spread$1(args));
    }
    function vibrateLong$1() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return my.vibrateLong.apply(my, __spread$1(args));
    }
    function vibrateShort$1() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return my.vibrateShort.apply(my, __spread$1(args));
    }
    function uploadImage$1$1() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return my.uploadFile.apply(my, __spread$1(args));
    }

    var setBackgroundColor$6;
    if (isWeb$3) {
        if (isWindvane$2) {
            setBackgroundColor$6 = setBackgroundColor$5;
        }
        else if (isNebula$2) {
            setBackgroundColor$6 = notSupport$2;
        }
        else if (isFliggy$2) {
            setBackgroundColor$6 = notSupport$2;
        }
        else if (isDingTalk$2) {
            setBackgroundColor$6 = notSupport$2;
        }
        else if (isDingTalkPC$2) {
            setBackgroundColor$6 = notSupport$2;
        }
    }
    else if (isMini$2) {
        if (isMiniAli$2) {
            setBackgroundColor$6 = setBackgroundColor$4;
        }
        else if (isMiniWx$2) {
            setBackgroundColor$6 = setBackgroundColor$3;
        }
        else if (isMiniTt$2) {
            setBackgroundColor$6 = setBackgroundColor$2;
        }
    }
    else if (isMiniweb$2) {
        setBackgroundColor$6 = setBackgroundColor$1;
    }
    if (!setBackgroundColor$6) {
        setBackgroundColor$6 = notSupport$2;
    }
    var index$M = promisifyApi$2(setBackgroundColor$6);

    var queue = [];
    var isProcessing = false;
    var toastWin;
    var toastContent;
    var toastIcon;
    var styles$2 = {
        container: {
            backgroundColor: 'rgba(0, 0, 0, 0.6)',
            boxSizing: 'border-box',
            maxWidth: '80%',
            color: '#ffffff',
            padding: '8px 16px',
            position: 'fixed',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            left: '50%',
            bottom: '50%',
            fontSize: '16px',
            lineHeight: '32px',
            fontWeight: '600',
            borderRadius: '4px',
            textAlign: 'center',
            transition: 'all 0.4s ease-in-out',
            webkitTransition: 'all 0.4s ease-in-out',
            transform: 'translateX(-50%)',
            webkitTransform: 'translateX(-50%)',
            zIndex: 9999,
        },
        icon: {
            marginBottom: '5px',
            width: '45px',
            height: '45px',
        },
    };
    function showToastWindow$1(message, iconUrl) {
        if (!toastWin) {
            toastIcon = null;
            toastWin = document.createElement('div');
            toastWin.setAttribute('role', 'alert');
            toastWin.setAttribute('tabindex', '-1');
            for (var key in styles$2.container) {
                toastWin.style[key] = styles$2.container[key];
            }
            toastContent = document.createElement('div');
            toastWin.appendChild(toastContent);
            document.body.appendChild(toastWin);
        }
        if (toastIcon && !iconUrl) {
            toastWin.removeChild(toastIcon);
            toastIcon = null;
        }
        else if (toastIcon && iconUrl) {
            toastIcon.setAttribute('src', iconUrl);
        }
        else if (!toastIcon && iconUrl) {
            toastIcon = document.createElement('img');
            toastIcon.setAttribute('src', iconUrl);
            for (var key in styles$2.icon) {
                toastIcon.style[key] = styles$2.icon[key];
            }
            toastWin.insertBefore(toastIcon, toastContent);
        }
        toastContent.textContent = message;
        toastWin.style.transform = 'translateX(-50%)';
        toastWin.style.webkitTransform = 'translateX(-50%)';
    }
    function hideToastWindow$1() {
        setTimeout(function () {
            if (toastWin && toastWin.style) {
                toastWin.style.transform = 'translateX(-50%) scale(0.8)';
                toastWin.style.webkitTransform = 'translateX(-50%) scale(0.8)';
            }
        }, 0);
    }
    var initHideTimer = null;
    var innerToast$1 = {
        hideTimer: initHideTimer,
        show: function () {
            if (!queue.length) {
                if (toastWin) {
                    toastWin.parentNode.removeChild(toastWin);
                }
                toastWin = null;
                return;
            }
            if (isProcessing)
                return;
            isProcessing = true;
            var toastInfo = queue.shift();
            try {
                showToastWindow$1(toastInfo.content, toastInfo.icon);
            }
            catch (e) {
                toastInfo.fail && toastInfo.fail(e);
                toastInfo.complete && toastInfo.complete(e);
            }
            innerToast$1.hideTimer = setTimeout(function () {
                toastInfo.success && toastInfo.success();
                toastInfo.complete && toastInfo.complete();
                innerToast$1.switchToNext();
            }, toastInfo.duration);
        },
        push: function (options) {
            queue.push(options);
            innerToast$1.show();
        },
        switchToNext: function () {
            hideToastWindow$1();
            isProcessing = false;
            setTimeout(function () { return innerToast$1.show(); }, 500);
            if (innerToast$1.hideTimer) {
                clearTimeout(innerToast$1.hideTimer);
                innerToast$1.hideTimer = null;
            }
        },
    };
    var show$7 = function (options) {
        var _a = options.type, type = _a === void 0 ? 'none' : _a, content = options.content, duration = options.duration, success = options.success, fail = options.fail, complete = options.complete;
        var iconMap = {
            success: 'https://gw.alicdn.com/imgextra/i1/O1CN01h684sE1Td4mwYyChK_!!6000000002404-2-tps-200-200.png',
            fail: 'https://gw.alicdn.com/imgextra/i1/O1CN01yOywus1et4ORJzafk_!!6000000003928-2-tps-200-200.png',
            none: '',
        };
        innerToast$1.push({
            content: content,
            duration: duration,
            icon: iconMap[type] || '',
            success: function () {
                success && success();
            },
            fail: function (res) {
                fail && fail(res);
            },
            complete: function (res) {
                complete && complete(res);
            },
        });
    };
    var hide$6 = function (options) {
        var success = options.success, fail = options.fail, complete = options.complete;
        try {
            queue = [];
            innerToast$1.switchToNext();
            success && success({ success: true });
            complete && complete({ success: true });
        }
        catch (e) {
            fail && fail(e);
            complete && complete(e);
        }
    };

    var navigateTo$7$1 = function (params) {
        var url = params.url, _a = params.isHash, isHash = _a === void 0 ? false : _a, _b = params.refresh, refresh = _b === void 0 ? true : _b, success = params.success, fail = params.fail, complete = params.complete;
        var _url = isHash ? "/#" + url : url;
        setTimeout(function () {
            try {
                if (refresh) {
                    location.href = _url;
                }
                else {
                    var state = { page_id: 1 };
                    var title = '';
                    history.pushState(state, title, _url);
                }
                success && success(params);
                complete && complete(params);
            }
            catch (e) {
                fail && fail(e);
                complete && complete(e);
            }
        });
    };

    var getLocation$1$1 = function (params) {
        var _a = params.success, success = _a === void 0 ? function () { } : _a, _b = params.fail, fail = _b === void 0 ? function () { } : _b, _c = params.complete, complete = _c === void 0 ? function () { } : _c;
        if ('geolocation' in navigator) {
            navigator.geolocation.getCurrentPosition(function (position) {
                var formatOutput = function (options) {
                    var coords = position.coords || {};
                    return {
                        longitude: coords.longitude,
                        latitude: coords.latitude,
                    };
                };
                var onSuccess = enhanceSuccess$2(success, params, { formatOutput: formatOutput });
                onSuccess(position);
                complete(position);
            }, function (err) {
                if (err.code === 1) {
                    err.errCode = 11;
                    err.errMsg = 'permission deny';
                }
                fail(err);
                complete(err);
            });
        }
        else {
            var err = { code: -1, message: '地理位置服务不可用' };
            fail(err);
            complete(err);
        }
    };

    var clsPrefix$1 = '__uni_confirm';
    var styles$1$1 = ("." + clsPrefix$1 + " {\n  position: fixed;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  -webkit-transform: translate(-50%, -50%);\n  background: #fff;\n  color: #000;\n  box-sizing: border-box;\n  border-radius: 12px;\n  z-index: 9999;\n  outline: none;\n  text-align: center;\n  width: 280px;\n  opacity: 0;\n  animation-duration: .3s;\n  animation-fill-mode: both;\n}\n." + clsPrefix$1 + "_mask {\n  content: \"\";\n  position: fixed;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  top: 0;\n  margin: auto;\n  display: block;\n  z-index: 9999;\n  background: #000;\n  opacity: 0;\n  animation-duration: .3s;\n  animation-fill-mode: both;\n}\n." + clsPrefix$1 + "_title {\n  padding: 28px 16px 16px;\n  font-weight: bold;\n}\n." + clsPrefix$1 + "_content {\n  color: #666;\n  padding: 0 16px;\n  margin-bottom: 28px;\n  word-break: break-all;\n  max-height: 200px;\n  overflow: scroll;\n}\n." + clsPrefix$1 + "_cancel {\n  display: inline-block;\n  font-weight: bold;\n  padding: 14px 0;\n  width: 50%;\n  box-sizing: border-box;\n  border-top: 1px solid #eee;\n  border-right: 1px solid #eee;\n}\n." + clsPrefix$1 + "_confirm {\n  display: inline-block;\n  font-weight: bold;\n  color: #576B95;\n  padding: 14px 0;\n  width: 50%;\n  box-sizing: border-box;\n  border-top: 1px solid #eee;\n}\n@keyframes " + clsPrefix$1 + "_in {\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n@keyframes " + clsPrefix$1 + "_out {\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n@keyframes " + clsPrefix$1 + "_fadeIn {\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: .6;\n  }\n}\n@keyframes " + clsPrefix$1 + "_fadeOut {\n  0% {\n    opacity: .6;\n  }\n  100% {\n    opacity: 0;\n  }\n}").replace(/\n/g, '');
    var styleElement$1 = null;
    var confirmElement = null;
    var hideFn$1 = function () { };
    var confirm$1$1 = function (params) {
        var _a, _b;
        if (params === void 0) { params = {}; }
        try {
            if (!styleElement$1) {
                styleElement$1 = document.createElement('style');
                styleElement$1.innerHTML = styles$1$1;
                document.body.appendChild(styleElement$1);
            }
            if (!confirmElement) {
                confirmElement = document.createElement('div');
                var maskEle_1 = document.createElement('div');
                maskEle_1.className = clsPrefix$1 + "_mask";
                confirmElement.appendChild(maskEle_1);
                var containerEle_1 = document.createElement('div');
                containerEle_1.className = clsPrefix$1;
                var titleEle = document.createElement('div');
                titleEle.className = clsPrefix$1 + "_title";
                titleEle.innerText = params.title || '';
                containerEle_1.appendChild(titleEle);
                var contentEle = document.createElement('div');
                contentEle.className = clsPrefix$1 + "_content";
                contentEle.innerText = params.content || '';
                containerEle_1.appendChild(contentEle);
                var operateEle = document.createElement('div');
                var cancelButton = document.createElement('div');
                cancelButton.className = clsPrefix$1 + "_cancel";
                cancelButton.innerText = params.cancelButtonText || '';
                cancelButton.setAttribute('tabindex', '-1');
                cancelButton.addEventListener('click', function () {
                    hideFn$1(function () {
                        var _a, _b;
                        (_a = params.success) === null || _a === void 0 ? void 0 : _a.call(params, { confirm: false });
                        (_b = params.complete) === null || _b === void 0 ? void 0 : _b.call(params, { confirm: false });
                    });
                });
                operateEle.appendChild(cancelButton);
                var confirmButton = document.createElement('div');
                confirmButton.className = clsPrefix$1 + "_confirm";
                confirmButton.innerText = params.confirmButtonText || '';
                confirmButton.setAttribute('tabindex', '-1');
                confirmButton.addEventListener('click', function () {
                    hideFn$1(function () {
                        var _a, _b;
                        (_a = params.success) === null || _a === void 0 ? void 0 : _a.call(params, { confirm: true });
                        (_b = params.complete) === null || _b === void 0 ? void 0 : _b.call(params, { confirm: true });
                    });
                });
                operateEle.appendChild(confirmButton);
                containerEle_1.appendChild(operateEle);
                confirmElement.appendChild(containerEle_1);
                document.body.appendChild(confirmElement);
                maskEle_1.style.animationName = clsPrefix$1 + "_fadeIn";
                containerEle_1.style.animationName = clsPrefix$1 + "_in";
                hideFn$1 = function (callback) {
                    maskEle_1.style.animationName = clsPrefix$1 + "_fadeOut";
                    confirmElement === null || confirmElement === void 0 ? void 0 : confirmElement.removeChild(containerEle_1);
                    setTimeout(function () {
                        var _a;
                        confirmElement && ((_a = document.body) === null || _a === void 0 ? void 0 : _a.removeChild(confirmElement));
                        confirmElement = null;
                        callback();
                    }, 300);
                };
            }
        }
        catch (err) {
            (_a = params.fail) === null || _a === void 0 ? void 0 : _a.call(params, err);
            (_b = params.complete) === null || _b === void 0 ? void 0 : _b.call(params, err);
        }
    };

    function alert$1$1(params) {
        var content = params.content;
        window.alert(content);
    }

    var showLoading$1$1 = function (_a) {
        var _b = _a.content, content = _b === void 0 ? '' : _b; _a.delay; var _d = _a.success, success = _d === void 0 ? function () { } : _d, _e = _a.fail, fail = _e === void 0 ? function () { } : _e, _f = _a.complete, complete = _f === void 0 ? function () { } : _f;
        window.__uni_loadingWin = null;
        var clsPrefix = '__uni_loading';
        var styles = ("." + clsPrefix + " {\n    background-color: rgba(0, 0, 0, 0.6);\n    box-sizing: border-box;\n    max-width: 80%;\n    color: #ffffff;\n    padding: 15px;\n    position: fixed;\n    left: 50%;\n    bottom: 50%;\n    border-radius: 4px;\n    text-align: center;\n    transform: translateX(-50%);\n    -webkit-transform: translateX(-50%);\n    z-index: 9999;\n    outline: none;\n  }\n  ." + clsPrefix + "_circle {\n    border: 2px solid rgba(200, 200, 200, 0.5);\n    border-radius: 50%;\n    position: relative;\n    height: 40px;\n    width: 40px;\n    margin: auto;\n  }\n  ." + clsPrefix + "_circle:after {\n    content: \"\";\n    display: block;\n    border-radius: 50%;\n    width: 100%;\n    height: 100%;\n    position: absolute;\n    top: -2px;\n    left: -2px;\n    border: 2px solid;\n    border-color: transparent;\n    border-left-color: #fff;\n    box-sizing: content-box;\n    animation: " + clsPrefix + "_roller 1s infinite linear;\n  }\n  ." + clsPrefix + "_text {\n    margin-top: 6px;\n    color: #fff;\n    line-height: 1.5;\n    font-size: 14px;\n    text-align: center;\n    font-weight: normal;\n  }\n  @keyframes " + clsPrefix + "_roller {\n    0% {\n      transform: rotateZ(0);\n    }\n    100% {\n      transform: rotateZ(360deg);\n    }\n  }").replace(/\n/g, '');
        var styleElement = null;
        try {
            if (!styleElement) {
                styleElement = document.createElement('style');
                styleElement.innerHTML = styles;
                document.body.appendChild(styleElement);
            }
            if (!window.__uni_loadingWin) {
                window.__uni_loadingWin = document.createElement('div');
                window.__uni_loadingWin.className = clsPrefix;
                window.__uni_loadingWin.setAttribute('role', 'alert');
                window.__uni_loadingWin.setAttribute('tabindex', '-1');
                var circle = document.createElement('div');
                circle.className = clsPrefix + "_circle";
                window.__uni_loadingWin.appendChild(circle);
                var text_1 = document.createElement('div');
                text_1.className = clsPrefix + "_text";
                window.__uni_loadingWin.appendChild(text_1);
                document.body.appendChild(window.__uni_loadingWin);
            }
            var text = window.__uni_loadingWin.querySelector("." + clsPrefix + "_text");
            if (content) {
                text.style.display = 'block';
                text.innerText = content;
            }
            else {
                text.style.display = 'none';
                text.innerText = '';
            }
            success();
            complete();
        }
        catch (error) {
            fail();
            complete();
        }
    };

    var hideLoading$1$1 = function (_a) {
        var _b = _a.success, success = _b === void 0 ? function () { } : _b, _c = _a.fail, fail = _c === void 0 ? function () { } : _c, _d = _a.complete, complete = _d === void 0 ? function () { } : _d;
        try {
            setTimeout(function () {
                if (window.__uni_loadingWin && window.__uni_loadingWin.parentNode) {
                    window.__uni_loadingWin.parentNode.removeChild(window.__uni_loadingWin);
                }
                window.__uni_loadingWin = null;
                success();
                complete();
            }, 0);
        }
        catch (error) {
            fail();
            complete();
        }
    };

    var clsPrefix$2 = '__uni_actionsheet';
    var styles$3 = ("." + clsPrefix$2 + " {\n  position: fixed;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: #fff;\n  color: #000;\n  box-sizing: border-box;\n  border-radius: 12px 12px 0 0;\n  transform: translateY(100%);\n  -webkit-transform: translateY(100%);\n  z-index: 9999;\n  outline: none;\n  text-align: center;\n  animation-duration: .3s;\n  animation-fill-mode: both;\n}\n." + clsPrefix$2 + "_mask {\n  content: \"\";\n  position: fixed;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  top: 0;\n  margin: auto;\n  display: block;\n  z-index: 9999;\n  background: #000;\n  opacity: 0;\n  animation-duration: .3s;\n  animation-fill-mode: both;\n}\n." + clsPrefix$2 + "_item {\n  padding: 16px 0;\n  border-bottom: 1px solid #eee;\n}\n." + clsPrefix$2 + "_cancel {\n  padding: 16px 0;\n  border-top: 10px solid #eee;\n}\n@keyframes " + clsPrefix$2 + "_slideIn {\n  0% {\n    transform: translateY(100%);\n    -webkit-transform: translateY(100%);\n  }\n  100% {\n    transform: translateY(0);\n    -webkit-transform: translateY(0);\n  }\n}\n@keyframes " + clsPrefix$2 + "_slideOut {\n  0% {\n    transform: translateY(0);\n    -webkit-transform: translateY(0);\n  }\n  100% {\n    transform: translateY(100%);\n    -webkit-transform: translateY(100%);\n  }\n}\n@keyframes " + clsPrefix$2 + "_fadeIn {\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: .6;\n  }\n}\n@keyframes " + clsPrefix$2 + "_fadeOut {\n  0% {\n    opacity: .6;\n  }\n  100% {\n    opacity: 0;\n  }\n}").replace(/\n/g, '');
    var styleElement$2 = null;
    var actionSheetElement = null;
    var hideFn = function () { };
    var hideCallback = function () { };
    var showActionSheet$1$1 = function (params) {
        var _a, _b;
        try {
            if (!styleElement$2) {
                styleElement$2 = document.createElement('style');
                styleElement$2.innerHTML = styles$3;
                document.body.appendChild(styleElement$2);
            }
            if (!actionSheetElement) {
                actionSheetElement = document.createElement('div');
                var maskEle_1 = document.createElement('div');
                maskEle_1.className = clsPrefix$2 + "_mask";
                maskEle_1.addEventListener('click', function () {
                    hideCallback(-1);
                });
                actionSheetElement.appendChild(maskEle_1);
                var containerEle_1 = document.createElement('div');
                containerEle_1.className = clsPrefix$2;
                var itemList = params.items || [];
                var _loop_1 = function (index) {
                    var itemEle = document.createElement('div');
                    itemEle.className = clsPrefix$2 + "_item";
                    itemEle.innerText = itemList[index];
                    itemEle.setAttribute('tabindex', "" + index);
                    itemEle.addEventListener('click', function () {
                        hideCallback(index);
                    });
                    containerEle_1.appendChild(itemEle);
                };
                for (var index = 0; index < itemList.length; index++) {
                    _loop_1(index);
                }
                var cancelEle = document.createElement('div');
                cancelEle.className = clsPrefix$2 + "_cancel";
                cancelEle.innerText = params.cancelButtonText || '取消';
                cancelEle.setAttribute('tabindex', '-1');
                cancelEle.addEventListener('click', function () {
                    hideCallback(-1);
                });
                containerEle_1.appendChild(cancelEle);
                actionSheetElement.appendChild(containerEle_1);
                document.body.appendChild(actionSheetElement);
                maskEle_1.style.animationName = clsPrefix$2 + "_fadeIn";
                containerEle_1.style.animationName = clsPrefix$2 + "_slideIn";
                hideFn = function (callback) {
                    maskEle_1.style.animationName = clsPrefix$2 + "_fadeOut";
                    containerEle_1.style.animationName = clsPrefix$2 + "_slideOut";
                    setTimeout(function () {
                        actionSheetElement && document.body.removeChild(actionSheetElement);
                        actionSheetElement = null;
                        callback();
                    }, 300);
                };
                hideCallback = function (index) {
                    hideFn(function () {
                        var _a, _b;
                        (_a = params.success) === null || _a === void 0 ? void 0 : _a.call(params, { index: index });
                        (_b = params.complete) === null || _b === void 0 ? void 0 : _b.call(params, { index: index });
                    });
                };
            }
        }
        catch (err) {
            (_a = params.fail) === null || _a === void 0 ? void 0 : _a.call(params, err);
            (_b = params.complete) === null || _b === void 0 ? void 0 : _b.call(params, err);
        }
    };

    var redirectTo$1$1 = function (params) {
        var _a = params || {}, url = _a.url, _b = _a.isHash, isHash = _b === void 0 ? false : _b, _c = _a.refresh, refresh = _c === void 0 ? true : _c, success = _a.success, fail = _a.fail, complete = _a.complete;
        var _url = isHash ? "/#" + url : url;
        setTimeout(function () {
            try {
                history.replaceState('', '', _url);
                refresh && history.go(0);
                success && success(params);
                complete && complete(params);
            }
            catch (e) {
                fail && fail(e);
                complete && complete(e);
            }
        });
    };

    var getStorage$1$1 = function (params) {
        var _a, _b, _c, _d;
        try {
            if (Object.prototype.toString.call(params) !== '[object Object]') {
                throw new Error('the Function need a param of Object type');
            }
            if (!params.hasOwnProperty('key')) {
                throw new Error('the first param of this Function must contain a property named "key"');
            }
            if (typeof params.key !== 'string') {
                throw new Error('the first param of this Function must contain a property named "key" of string type');
            }
            var res = {
                data: JSON.parse(window.localStorage.getItem(params.key || '') || '{}'),
            };
            (_a = params.success) === null || _a === void 0 ? void 0 : _a.call(params, res);
            (_b = params.complete) === null || _b === void 0 ? void 0 : _b.call(params, res);
            return res;
        }
        catch (e) {
            (_c = params.fail) === null || _c === void 0 ? void 0 : _c.call(params, e);
            (_d = params.complete) === null || _d === void 0 ? void 0 : _d.call(params, e);
        }
    };

    var removeStorageSync$2 = function (params) {
        var _a = params || {}; _a.success; _a.fail; _a.complete;
        try {
            if (Object.prototype.toString.call(params) !== '[object Object]') {
                throw new Error('the Function need a param of Object type');
            }
            if (!params.hasOwnProperty('key')) {
                throw new Error('the first param of this Function must contain a property named "key"');
            }
            if (typeof params.key !== 'string') {
                throw new Error('the first param of this Function must contain a property named "key" of string type');
            }
            return window.localStorage.removeItem(params.key);
        }
        catch (e) {
            throw new Error(JSON.stringify(e || ''));
        }
    };

    var setStorage$1$1 = function (params) {
        var _a = params || {}, _b = _a.success, success = _b === void 0 ? function () { } : _b, _c = _a.fail, fail = _c === void 0 ? function () { } : _c, _d = _a.complete, complete = _d === void 0 ? function () { } : _d;
        try {
            if (Object.prototype.toString.call(params) !== '[object Object]') {
                throw new Error('the Function need a param of Object type');
            }
            if (!params.hasOwnProperty('key')) {
                throw new Error('the first param of this Function must contain a property named "key"');
            }
            if (typeof params.key !== 'string') {
                throw new Error('the first param of this Function must contain a property named "key" of string type');
            }
            if (!params.hasOwnProperty('data')) {
                throw new Error('the first param of this Function must contain a property named "data"');
            }
            window.localStorage.setItem(params.key, JSON.stringify(params.data || {}));
            success({ success: true });
            complete({ success: true });
        }
        catch (e) {
            fail(e);
            complete(e);
        }
    };

    function inputCreateAndAppend(multiple) {
        var inputElement = document.createElement('INPUT');
        inputElement.name = 'file';
        inputElement.id = "input-" + Math.random() * 1e8;
        inputElement.type = 'file';
        multiple && inputElement.setAttribute('multiple', 'multiple');
        inputElement.style.display = 'none';
        inputElement.setAttribute('accept', 'image/*');
        document.body.appendChild(inputElement);
        return inputElement;
    }
    function transformBase64(files) {
        return new Promise(function (resolve, reject) {
            !files.length && reject();
            var base64Array = [];
            var count = 0;
            files.forEach(function (file) {
                var reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = function (e) {
                    base64Array.push(e.target.result);
                };
                reader.onloadend = function () {
                    count++;
                    if (count === files.length) {
                        resolve(base64Array);
                    }
                };
            });
        });
    }
    var chooseImage$1$1 = function (params) {
        var _a = params.count, count = _a === void 0 ? 1 : _a; params.sourceType; var _c = params.success, success = _c === void 0 ? function () { } : _c, _d = params.fail, fail = _d === void 0 ? function () { } : _d, _e = params.complete, complete = _e === void 0 ? function () { } : _e;
        try {
            var inputElement_1 = inputCreateAndAppend(count > 1);
            var files_1 = [];
            inputElement_1.addEventListener('change', function (e) {
                files_1 = e.target.files && Array.from(e.target.files).slice(0, count);
                transformBase64(files_1)
                    .then(function (base64Array) {
                    var res = {
                        tempFilePaths: base64Array,
                        tempFiles: base64Array.map(function (filePath) { return ({
                            path: filePath,
                            size: filePath.length,
                        }); }),
                    };
                    success(res);
                    complete(res);
                })
                    .finally(function () { return inputElement_1.remove && inputElement_1.remove(); });
            }, false);
            var MouseEvents = document.createEvent('MouseEvents');
            MouseEvents.initEvent('click', true, true);
            inputElement_1.dispatchEvent(MouseEvents);
        }
        catch (e) {
            fail(e);
            complete(e);
        }
    };

    var getStorageSync$2 = function (params) {
        try {
            if (Object.prototype.toString.call(params) !== '[object Object]') {
                throw new Error('the Function need a param of Object type');
            }
            if (!params.hasOwnProperty('key')) {
                throw new Error('the first param of this Function must contain a property named "key"');
            }
            if (typeof params.key !== 'string') {
                throw new Error('the first param of this Function must contain a property named "key" of string type');
            }
            var res = {
                data: JSON.parse(window.localStorage.getItem(params.key || '') || '{}'),
            };
            return res;
            return res;
        }
        catch (e) {
            throw new Error(JSON.stringify(e || ''));
        }
    };

    var removeStorage$1 = function (params) {
        var _a = params || {}, _b = _a.success, success = _b === void 0 ? function () { } : _b, _c = _a.fail, fail = _c === void 0 ? function () { } : _c, _d = _a.complete, complete = _d === void 0 ? function () { } : _d;
        try {
            if (Object.prototype.toString.call(params) !== '[object Object]') {
                throw new Error('the Function need a param of Object type');
            }
            if (!params.hasOwnProperty('key')) {
                throw new Error('the first param of this Function must contain a property named "key"');
            }
            if (typeof params.key !== 'string') {
                throw new Error('the first param of this Function must contain a property named "key" of string type');
            }
            window.localStorage.removeItem(params.key);
            success({ success: true });
            complete({ success: true });
        }
        catch (e) {
            fail(e);
            complete(e);
        }
    };

    var setClipboard$1$1 = function (args) {
        var _a = args || {}, _b = _a.text, text = _b === void 0 ? '' : _b, _c = _a.success, success = _c === void 0 ? function () { } : _c, _d = _a.fail, fail = _d === void 0 ? function () { } : _d, _e = _a.complete, complete = _e === void 0 ? function () { } : _e;
        var input = document.createElement('input');
        input.setAttribute('readonly', 'readonly');
        input.setAttribute('value', text);
        input.style.position = 'fixed';
        input.style.height = '0px';
        document.body.appendChild(input);
        input.focus();
        input.setSelectionRange(0, -1);
        var removeInput = function () {
            document.body.removeChild(input);
        };
        try {
            if (document.execCommand('copy')) {
                removeInput();
                success({ success: true });
                complete({ success: true });
                return text;
            }
            else {
                removeInput();
                fail({
                    errCode: 1,
                    errMsg: 'not support'
                });
            }
        }
        catch (error) {
            removeInput();
            fail(false);
        }
    };

    var setStorageSync$2 = function (params) {
        var _a = params || {}; _a.success; var _c = _a.fail, fail = _c === void 0 ? function () { } : _c, _d = _a.complete, complete = _d === void 0 ? function () { } : _d;
        try {
            if (Object.prototype.toString.call(params) !== '[object Object]') {
                throw new Error('the Function need a param of Object type');
            }
            if (!params.hasOwnProperty('key')) {
                throw new Error('the first param of this Function must contain a property named "key"');
            }
            if (typeof params.key !== 'string') {
                throw new Error('the first param of this Function must contain a property named "key" of string type');
            }
            if (!params.hasOwnProperty('data')) {
                throw new Error('the first param of this Function must contain a property named "data"');
            }
            return window.localStorage.setItem(params.key, JSON.stringify(params.data || {}));
        }
        catch (e) {
            fail(e);
            complete(e);
        }
    };

    function getNetworkType$1$1(params) {
        var _a;
        var type = navigator.connection.effectiveType;
        if (type) {
            if (type === 'slow-2g') {
                type = '2g';
            }
        }
        else {
            type = navigator.connection.type || 'none';
            if (!['wifi', 'none'].includes(type)) {
                type = 'unknown';
            }
        }
        type = type.toUpperCase();
        (_a = params === null || params === void 0 ? void 0 : params.success) === null || _a === void 0 ? void 0 : _a.call(params, { networkType: type });
    }

    var showActionSheet$a;
    if (isWeb$3) {
        if (isWindvane$2) {
            showActionSheet$a = showActionSheet$9;
        }
        else if (isNebula$2) {
            showActionSheet$a = showActionSheet$8;
        }
        else if (isFliggy$2) {
            showActionSheet$a = notSupport$2;
        }
        else if (isDingTalk$2) {
            showActionSheet$a = showActionSheet$7;
        }
        else if (isDingTalkPC$2) {
            showActionSheet$a = showActionSheet$6;
        }
        else {
            showActionSheet$a = showActionSheet$1$1;
        }
    }
    else if (isMini$2) {
        if (isMiniAli$2) {
            showActionSheet$a = showActionSheet$5;
        }
        else if (isMiniWx$2) {
            showActionSheet$a = showActionSheet$4;
        }
        else if (isMiniTt$2) {
            showActionSheet$a = showActionSheet$3;
        }
    }
    else if (isMiniweb$2) {
        showActionSheet$a = showActionSheet$2;
    }
    if (!showActionSheet$a) {
        showActionSheet$a = notSupport$2;
    }
    var index$L = promisifyApi$2(showActionSheet$a);

    function getStatusBarHeight$2(params) {
        if (!isIOS$3) {
            var success = enhanceSuccess$2(params.success, params);
            success({ statusBarHeight: 0 });
        }
        else {
            return getStatusBarHeight$5(params);
        }
    }
    function previewImage$2$1(params) {
        var formatInput = function (_a) {
            var urls = _a.urls, current = _a.current;
            return {
                images: urls,
                index: +(current || 0),
            };
        };
        WVCall$2('WVUIImagepreview.showImagepreview', params, { formatInput: formatInput });
    }
    function scan$3$1(params) {
        var formatInput = function (_a) {
            var _b = _a.scanType, scanType = _b === void 0 ? ['qrCode', 'barCode'] : _b, _c = _a.hideAlbum, hideAlbum = _c === void 0 ? false : _c;
            return {
                type: scanType,
                hideAlbum: hideAlbum,
            };
        };
        var formatErrInfo = function (error) {
            var errorCode = error.msg === 'user abort' ? ERR_SCAN_USER_CANCEL : ERR_COMMON$1;
            var errorMsg = error.msg === 'user abort' ? ERR_MSG_CANCEL$1 : ERR_MSG_COMMON$1;
            return {
                error: errorCode,
                errorMsg: errorMsg,
            };
        };
        WVCall$2('Scancode.scan', params, { formatInput: formatInput }, { formatOutput: formatErrInfo });
    }
    function setNaviBarRightItem$2$1(params) {
        var formatInput = function (_a) {
            var type = _a.type, iconBase64 = _a.iconBase64, title = _a.title;
            if (type === 'text') {
                return {
                    title: type === 'text' && title,
                };
            }
            else {
                return {
                    icon: type === 'icon' && iconBase64,
                };
            }
        };
        if (!window._uniapi_context) {
            window._uniapi_context = {};
        }
        if (!window._uniapi_context.events) {
            window._uniapi_context.events = {};
        }
        var lastHandler = window._uniapi_context.events.setNaviBarRightItem;
        if (typeof lastHandler === 'function') {
            document.removeEventListener('navbar-right-item-click', lastHandler);
        }
        var handler = params.onClick || function () { };
        document.addEventListener('TBNaviBar.rightItem.clicked', handler, false);
        return WVCall$2('WebAppInterface.setNaviBarRightItem', params, {
            formatInput: formatInput,
        });
    }
    function clearNaviBarRightItem$2$1(params) {
        WVCall$2('WebAppInterface.clearNaviBarRightItem', params);
    }
    function showTitle$2$1(params) {
        var formatInput = function () {
            return {
                hidden: '0',
                animated: '1',
            };
        };
        WVCall$2('WebAppInterface.setNaviBarHidden', params, { formatInput: formatInput });
    }
    function hideTitle$4(params) {
        var formatInput = function () {
            return {
                hidden: '1',
                animated: '1',
                statusBarHidden: '1',
            };
        };
        WVCall$2('WebAppInterface.setNaviBarHidden', params, { formatInput: formatInput });
    }
    function setNavigationBar$6(params) {
        WVCall$2('WebAppInterface.setCustomPageTitle', params);
    }
    function chooseCity$1(params) {
        var formatOutput = function (ret) {
            return {
                adCode: ret.cityCode,
                city: ret.cityName,
            };
        };
        WVCall$2('WVUICityList.showCityList', params, { formatOutput: formatOutput });
    }
    function showSharePanel$6$1(params) {
        WVCall$2('TBSharedModule.showSharedMenu', params);
    }
    function navigateTo$6$1(params) {
        WVCall$2('WVNative.openWindow', params);
    }
    function navigateBack$6$1(params) {
        WVCall$2('WVNative.nativeBack', params);
    }
    function getDeviceId$3(params) {
        var outputMap = { deviceId: 'deviceID' };
        WVCall$2('TBDeviceInfo.getInfo', params, {
            outputMap: outputMap,
        });
    }
    function playAudio$1(params) {
        var inputMap = {
            playIdentifier: ['identifier'],
        };
        return WVCall$2('H5AudioPlayer.play', params, { inputMap: inputMap });
    }
    function stopAudio$1(params) {
        var inputMap = {
            playIdentifier: ['identifier'],
        };
        return WVCall$2('H5AudioPlayer.stop', params, { inputMap: inputMap });
    }

    var stopAudio;
    if (isWeb$3) {
        if (isWindvane$2) {
            if (isWebTb$1) {
                stopAudio = stopAudio$1;
            }
            else if (isWebLt$1) {
                stopAudio = stopAudio$1;
            }
            else {
                stopAudio = notSupport$2;
            }
        }
        else if (isNebula$2) {
            stopAudio = stopAudio$2;
        }
        else if (isFliggy$2) {
            stopAudio = notSupport$2;
        }
        else if (isDingTalk$2) {
            stopAudio = notSupport$2;
        }
        else if (isDingTalkPC$2) {
            stopAudio = notSupport$2;
        }
    }
    else if (isMini$2) {
        if (isMiniAli$2) {
            stopAudio = notSupport$2;
        }
        else if (isMiniWx$2) {
            stopAudio = notSupport$2;
        }
        else if (isMiniTt$2) {
            stopAudio = notSupport$2;
        }
    }
    if (!stopAudio) {
        stopAudio = notSupport$2;
    }
    var index$K = promisifyApi$2(stopAudio);
    function hideTitle$3(params) {
        var formatInput = function () {
            return { visible: false };
        };
        return WVCall$2('WVIdleFishApi.setNavigationBarVisible', params, {
            formatInput: formatInput,
        });
    }
    function navigateBack$5$1(params) {
        return WVCall$2('WVIdleFishApi.finish', params);
    }
    function navigateTo$5$1(params) {
        return WVCall$2('Base.openWindow', params);
    }
    function setNavigationBar$5(params) {
        WVCall$2('WVIdleFishApi.setTitle', params);
    }
    function setNaviBarRightItem$1$1(params) {
        var formatInput = function (_a) {
            var type = _a.type; _a.iconBase64; var title = _a.title;
            return {
                title: type === 'text' && title,
                func: '_uniapi_context_onNaviRightItemClick',
            };
        };
        var handler = params.onClick || function () { };
        window._uniapi_context_onNaviRightItemClick = handler;
        return WVCall$2('WVIdleFishApi.setNavigatorRightItem', params, {
            formatInput: formatInput,
        });
    }
    function clearNaviBarRightItem$1$1(params) {
        WVCall$2('WVIdleFishApi.setHideNavigatorRightItem', params);
    }
    function showSharePanel$5$1(params) {
        var inputMap = {
            content: 'text',
        };
        WVCall$2('TBSharedModule.showSharedMenu', params, { inputMap: inputMap });
    }
    function getStatusBarHeight$1(params) {
        if (isIOS$3) {
            return getStatusBarHeight$5(params);
        }
        else {
            var outputMap = {
                statusBarHeight: 'height',
            };
            WVCall$2('WVIdleFishApi.getImmerseStatusBarHeight', params, { outputMap: outputMap });
        }
    }

    function navigateTo$4$1(params) {
        var url = params.url;
        if (!url) {
            return {
                errCode: '11',
                errMsg: '参数缺少 url',
            };
        }
        location.href = "eleme://web?url=" + encodeURIComponent(url);
        return {
            success: 1,
        };
    }
    function navigateBack$4$1(params) {
        WVCall$2('EleWVHybridAPI.popWindow', params, {});
    }

    var confirm$9;
    if (isWeb$3) {
        if (isWindvane$2) {
            confirm$9 = confirm$8;
        }
        else if (isNebula$2) {
            confirm$9 = confirm$7;
        }
        else if (isFliggy$2) {
            confirm$9 = confirm$6;
        }
        else if (isDingTalk$2) {
            confirm$9 = confirm$5;
        }
        else if (isDingTalkPC$2) {
            confirm$9 = confirm$4;
        }
        else {
            confirm$9 = confirm$1$1;
        }
    }
    else if (isMini$2) {
        if (isMiniAli$2) {
            confirm$9 = confirm$3;
        }
        else if (isMiniWx$2) {
            confirm$9 = notSupport$2;
        }
        else if (isMiniTt$2) {
            confirm$9 = notSupport$2;
        }
    }
    else if (isMiniweb$2) {
        confirm$9 = confirm$2$1;
    }
    if (!confirm$9) {
        confirm$9 = notSupport$2;
    }
    var index$I = promisifyApi$2(confirm$9);

    var getStorage$5;
    if (isWeb$3) {
        getStorage$5 = getStorage$1$1;
    }
    else if (isMini$2) {
        if (isMiniAli$2) {
            getStorage$5 = getStorage$4;
        }
        else if (isMiniWx$2) {
            getStorage$5 = getStorage$3;
        }
        else if (isMiniTt$2) {
            getStorage$5 = getStorage$2;
        }
    }
    if (!getStorage$5) {
        getStorage$5 = notSupport$2;
    }
    var index$H = promisifyApi$2(getStorage$5);

    var isAppInstalled$6;
    if (isWeb$3) {
        if (isWindvane$2) {
            isAppInstalled$6 = isAppInstalled$5;
        }
        else if (isNebula$2) {
            isAppInstalled$6 = isAppInstalled$4;
        }
        else if (isFliggy$2) {
            isAppInstalled$6 = isAppInstalled$3;
        }
        else if (isDingTalk$2) {
            isAppInstalled$6 = isAppInstalled$2;
        }
        else if (isDingTalkPC$2) {
            isAppInstalled$6 = isAppInstalled$1$1;
        }
    }
    else if (isMini$2) {
        if (isMiniAli$2) {
            isAppInstalled$6 = notSupport$2;
        }
        else if (isMiniWx$2) {
            isAppInstalled$6 = notSupport$2;
        }
        else if (isMiniTt$2) {
            isAppInstalled$6 = notSupport$2;
        }
    }
    else if (isMiniweb$2) {
        isAppInstalled$6 = notSupport$2;
    }
    if (!isAppInstalled$6) {
        isAppInstalled$6 = notSupport$2;
    }
    var index$G = promisifyApi$2(isAppInstalled$6);

    var redirectTo$9;
    if (isWeb$3) {
        if (isWindvane$2) {
            redirectTo$9 = redirectTo$8;
        }
        else if (isNebula$2) {
            redirectTo$9 = redirectTo$7;
        }
        else if (isFliggy$2) {
            redirectTo$9 = redirectTo$6;
        }
        else if (isDingTalk$2) {
            redirectTo$9 = notSupport$2;
        }
        else if (isDingTalkPC$2) {
            redirectTo$9 = notSupport$2;
        }
        else {
            redirectTo$9 = redirectTo$1$1;
        }
    }
    else if (isMini$2) {
        if (isMiniAli$2) {
            redirectTo$9 = redirectTo$5;
        }
        else if (isMiniWx$2) {
            redirectTo$9 = redirectTo$4;
        }
        else if (isMiniTt$2) {
            redirectTo$9 = redirectTo$3$1;
        }
    }
    else if (isMiniweb$2) {
        redirectTo$9 = redirectTo$2$1;
    }
    if (!redirectTo$9) {
        redirectTo$9 = notSupport$2;
    }
    var index$F = promisifyApi$2(redirectTo$9);

    var setClipboard$h;
    if (isWeb$3) {
        if (isWindvane$2) {
            setClipboard$h = setClipboard$9$1;
        }
        else if (isNebula$2) {
            setClipboard$h = setClipboard$8$1;
        }
        else if (isFliggy$2) {
            setClipboard$h = notSupport$2;
        }
        else if (isDingTalk$2) {
            setClipboard$h = setClipboard$7$1;
        }
        else if (isDingTalkPC$2) {
            setClipboard$h = setClipboard$6$1;
        }
        else {
            setClipboard$h = setClipboard$1$1;
        }
    }
    else if (isMini$2) {
        if (isMiniAli$2) {
            setClipboard$h = setClipboard$5$1;
        }
        else if (isMiniWx$2) {
            setClipboard$h = setClipboard$4$1;
        }
        else if (isMiniTt$2) {
            setClipboard$h = setClipboard$3$1;
        }
    }
    else if (isMiniweb$2) {
        setClipboard$h = setClipboard$2$1;
    }
    if (!setClipboard$h) {
        setClipboard$h = notSupport$2;
    }
    var index$E = promisifyApi$2(setClipboard$h);

    var showLoading$b;
    if (isWeb$3) {
        if (isWindvane$2) {
            showLoading$b = showLoading$a;
        }
        else if (isNebula$2) {
            showLoading$b = showLoading$9;
        }
        else if (isFliggy$2) {
            showLoading$b = showLoading$8;
        }
        else if (isDingTalk$2) {
            showLoading$b = showLoading$7;
        }
        else if (isDingTalkPC$2) {
            showLoading$b = showLoading$6;
        }
        else {
            showLoading$b = showLoading$1$1;
        }
    }
    else if (isMini$2) {
        if (isMiniAli$2) {
            showLoading$b = showLoading$5;
        }
        else if (isMiniWx$2) {
            showLoading$b = showLoading$4;
        }
        else if (isMiniTt$2) {
            showLoading$b = showLoading$3$1;
        }
    }
    else if (isMiniweb$2) {
        showLoading$b = showLoading$2$1;
    }
    if (!showLoading$b) {
        showLoading$b = notSupport$2;
    }
    var index$D = promisifyApi$2(showLoading$b);

    var uploadImage$4;
    if (isWeb$3) {
        if (isWindvane$2) {
            uploadImage$4 = uploadImage$3;
        }
        else if (isNebula$2) {
            uploadImage$4 = uploadImage$2;
        }
        else if (isFliggy$2) {
            uploadImage$4 = notSupport$2;
        }
        else if (isDingTalk$2) {
            uploadImage$4 = notSupport$2;
        }
        else if (isDingTalkPC$2) {
            uploadImage$4 = notSupport$2;
        }
    }
    else if (isMini$2) {
        if (isMiniAli$2) {
            uploadImage$4 = notSupport$2;
        }
        else if (isMiniWx$2) {
            uploadImage$4 = notSupport$2;
        }
        else if (isMiniTt$2) {
            uploadImage$4 = notSupport$2;
        }
    }
    else if (isMiniweb$2) {
        uploadImage$4 = uploadImage$1$1;
    }
    if (!uploadImage$4) {
        uploadImage$4 = notSupport$2;
    }
    var index$C = promisifyApi$2(uploadImage$4);

    var chooseCity;
    if (isWeb$3) {
        if (isWindvane$2) {
            if (isWebTb$1) {
                chooseCity = chooseCity$1;
            }
            else if (isWebAlipm$1) {
                chooseCity = chooseCity$1;
            }
            else {
                chooseCity = notSupport$2;
            }
        }
        else if (isNebula$2) {
            chooseCity = chooseCity$4;
        }
        else if (isFliggy$2) {
            chooseCity = notSupport$2;
        }
        else if (isDingTalk$2) {
            chooseCity = notSupport$2;
        }
        else if (isDingTalkPC$2) {
            chooseCity = notSupport$2;
        }
    }
    else if (isMini$2) {
        if (isMiniAli$2) {
            chooseCity = chooseCity$3;
        }
        else if (isMiniWx$2) {
            chooseCity = notSupport$2;
        }
        else if (isMiniTt$2) {
            chooseCity = notSupport$2;
        }
    }
    else if (isMiniweb$2) {
        chooseCity = chooseCity$2;
    }
    if (!chooseCity) {
        chooseCity = notSupport$2;
    }
    var index$B = promisifyApi$2(chooseCity);

    var datePicker;
    if (isMini$2) {
        if (isMiniAli$2) {
            datePicker = datePicker$1;
        }
    }
    if (!datePicker) {
        datePicker = notSupport$2;
    }
    var index$A = promisifyApi$2(datePicker);

    var getStorageSync;
    if (isWeb$3) {
        getStorageSync = getStorageSync$2;
    }
    else if (isMini$2) {
        if (isMiniAli$2) {
            getStorageSync = getStorageSync$5;
        }
        else if (isMiniWx$2) {
            getStorageSync = getStorageSync$4;
        }
        else if (isMiniTt$2) {
            getStorageSync = getStorageSync$3;
        }
    }
    if (!getStorageSync) {
        getStorageSync = notSupport$2;
    }
    var getStorageSync$1 = getStorageSync;

    function setNavigationBar$4(params) {
        return WVCall$2('TMWVWindow.setTitle', params);
    }
    function hideTitle$2$1(params) {
        WVCall$2('TMWVWindow.hideTitle', params);
    }
    function showSharePanel$4$1(params) {
        var inputMap = {
            'all-link': 'url',
            'mobile-image': 'image',
            'share-title': 'title',
            'share-intro': 'content',
        };
        WVCall$2('TMShare.doShare', params, { inputMap: inputMap });
    }
    function navigateBack$3$1(params) {
        return WVCall$2('TMWVWindow.back', params);
    }
    function navigateTo$3$1(params) {
        return WVCall$2('Base.openWindow', params);
    }

    function setNavigationBar$3(params) {
        var formatInput = function (input) {
            return {
                type: 'text',
                content: input.title,
            };
        };
        WVCall$2('WVWDKHemaApi.setTitle', params, { formatInput: formatInput });
    }
    function showSharePanel$3$1(params) {
        var formatInput = function (_a) {
            var title = _a.title, content = _a.content, image = _a.image, url = _a.url;
            return {
                shareType: 'url',
                showShareButton: false,
                shareTitle: title,
                shareContent: content,
                sharePicUrl: image,
                shareString: url,
            };
        };
        WVCall$2('WVWDKHemaApi.WDKShareComponent', params, { formatInput: formatInput });
    }
    function navigateTo$2$1(params) {
        var formatInput = function (_a) {
            _a.url;
            return {
                url: params.url,
                popBeforeOpen: false,
            };
        };
        WVCall$2('WVWDKHemaApi.openWindow', params, { formatInput: formatInput });
    }
    function navigateBack$2$1(params) {
        WVCall$2('WVWDKHemaApi.finish', params);
    }
    function previewImage$1$1(params) {
        var inputMap = { index: 'init', images: ' urls' };
        WVCall$2('HMWVUIImagePreview.previewImage', params, { inputMap: inputMap });
    }
    function getDeviceId$2(params) {
        var outputMap = {
            deviceId: ['deviceID'],
        };
        return WVCall$2('WVWDKHemaApi.WDKDeviceInfo', params, { outputMap: outputMap });
    }
    function scan$2$1(params) {
        var formatInput = function () {
            return {
                needResult: true,
            };
        };
        var outputMap = {
            code: 'scanResult',
        };
        return WVCall$2('HMWVScan.scan', params, { formatInput: formatInput, outputMap: outputMap });
    }

    function setNavigationBar$2(params) {
        var inputMap = { setText: 'title' };
        return WVCall$2('YKWebAppInterface.setTitleBar', params, { inputMap: inputMap });
    }
    function showTitle$1$1(params) {
        var formatInput = function () {
            return {
                showTitle: true,
            };
        };
        return WVCall$2('YKWebAppInterface.setTitleBar', params, { formatInput: formatInput });
    }
    function hideTitle$1$1(params) {
        var formatInput = function () {
            return { showTitle: false };
        };
        var formatOutput = function () {
            return {
                isStatusBarHidden: false,
            };
        };
        return WVCall$2('YKWebAppInterface.setTitleBar', params, {
            formatInput: formatInput,
            formatOutput: formatOutput,
        });
    }
    function showSharePanel$2$1(params) {
        var formatInput = function (_a) {
            var title = _a.title, content = _a.content, image = _a.image, url = _a.url;
            return {
                titleText: title,
                descText: content,
                thumbnailUrl: image,
                url: url,
                sourceId: 10,
            };
        };
        return WVCall$2('WVBehavioursBridge.showShareView', params, { formatInput: formatInput });
    }
    function navigateTo$1$1(params) {
        var api = 'DYKBaseJSBridge.nativeOpen';
        var formatInput = function (options) {
            return {
                url: isAndroid$3 ? options.url : "youku://http?url=" + options.url,
            };
        };
        if (isAndroid$3) {
            api = 'AliPayTransferJSBridge.openNewH5Page';
        }
        return WVCall$2(api, params, { formatInput: formatInput });
    }
    function navigateBack$1$1(params) {
        return WVCall$2('WVActionJSBridge.close', params);
    }
    function getDeviceId$1(params) {
        var outputMap = {
            deviceId: 'deviceID',
        };
        WVCall$2('DYKBaseJSBridge.getDeviceInfo', params, { outputMap: outputMap });
    }

    var navigateBack$f;
    if (isWeb$3) {
        if (isWindvane$2) {
            if (isWebTb$1) {
                navigateBack$f = navigateBack$6$1;
            }
            else if (isWebTm$1) {
                navigateBack$f = navigateBack$3$1;
            }
            else if (isWebWdkhema$1) {
                navigateBack$f = navigateBack$2$1;
            }
            else if (isWebYouku$1) {
                navigateBack$f = navigateBack$1$1;
            }
            else if (isWebFm$1) {
                navigateBack$f = navigateBack$5$1;
            }
            else if (isWebLt$1) {
                navigateBack$f = navigateBack$6$1;
            }
            else if (isWebElmc$1) {
                navigateBack$f = navigateBack$4$1;
            }
            else if (isWebIhome$1) {
                navigateBack$f = navigateBack$6$1;
            }
            else if (isWebTphome$1) {
                navigateBack$f = navigateBack$6$1;
            }
            else if (isWebAh$1) {
                navigateBack$f = navigateBack$6$1;
            }
            else if (isWebAlipm$1) {
                navigateBack$f = navigateBack$6$1;
            }
            else {
                navigateBack$f = notSupport$2;
            }
        }
        else if (isNebula$2) {
            navigateBack$f = navigateBack$e;
        }
        else if (isFliggy$2) {
            navigateBack$f = navigateBack$d;
        }
        else if (isDingTalk$2) {
            navigateBack$f = navigateBack$c;
        }
        else if (isDingTalkPC$2) {
            navigateBack$f = navigateBack$b;
        }
    }
    else if (isMini$2) {
        if (isMiniAli$2) {
            navigateBack$f = navigateBack$a$1;
        }
        else if (isMiniWx$2) {
            navigateBack$f = navigateBack$9$1;
        }
        else if (isMiniTt$2) {
            navigateBack$f = navigateBack$8$1;
        }
    }
    else if (isMiniweb$2) {
        navigateBack$f = navigateBack$7$1;
    }
    if (!navigateBack$f) {
        navigateBack$f = notSupport$2;
    }
    var index$z = promisifyApi$2(navigateBack$f);

    var removeStorage$5;
    if (isWeb$3) {
        removeStorage$5 = removeStorage$1;
    }
    else if (isMini$2) {
        if (isMiniAli$2) {
            removeStorage$5 = removeStorage$4;
        }
        else if (isMiniWx$2) {
            removeStorage$5 = removeStorage$3;
        }
        else if (isMiniTt$2) {
            removeStorage$5 = removeStorage$2;
        }
    }
    if (!removeStorage$5) {
        removeStorage$5 = notSupport$2;
    }
    var index$y = promisifyApi$2(removeStorage$5);

    function scan$1$1(params) {
        var formatInput = function (_a) {
            var _b = _a.scanType, scanType = _b === void 0 ? 'qr' : _b, _c = _a.hideAlbum, hideAlbum = _c === void 0 ? false : _c;
            return {
                type: scanType === 'qr' ? '512' : scanType === 'bar' ? '255' : '767',
                hideAlbum: hideAlbum,
            };
        };
        WVCall$2('CUNScan.scan', params, { formatInput: formatInput });
    }
    function setNavigationBar$1(params) {
        var formatInput = function (_a) {
            var _b = _a.iconType, iconType = _b === void 0 ? 'Base 64' : _b;
            return { iconType: iconType };
        };
        return WVCall$2('WebAppInterface.setCustomPageTitle', params, { formatInput: formatInput });
    }
    function showSharePanel$1$1(params) {
        var inputMap = {
            imageUrl: 'image',
            pageUrl: 'url',
            taopasswordPicUrl: 'image',
        };
        return WVCall$2('CunpartnerShare.startShare', params, {
            inputMap: inputMap,
        });
    }

    var setNaviBarRightItem$7;
    if (isWeb$3) {
        if (isWindvane$2) {
            if (isWebTb$1) {
                setNaviBarRightItem$7 = setNaviBarRightItem$2$1;
            }
            else if (isWebCunpartner$1) {
                setNaviBarRightItem$7 = setNaviBarRightItem$2$1;
            }
            else if (isWebFm$1) {
                setNaviBarRightItem$7 = setNaviBarRightItem$1$1;
            }
            else if (isWebLt$1) {
                setNaviBarRightItem$7 = setNaviBarRightItem$2$1;
            }
            else if (isWebElmc$1) {
                setNaviBarRightItem$7 = setNaviBarRightItem$2$1;
            }
            else if (isWebIhome$1) {
                setNaviBarRightItem$7 = setNaviBarRightItem$2$1;
            }
            else if (isWebTphome$1) {
                setNaviBarRightItem$7 = setNaviBarRightItem$2$1;
            }
            else if (isWebAh$1) {
                setNaviBarRightItem$7 = setNaviBarRightItem$2$1;
            }
            else if (isWebAlipm$1) {
                setNaviBarRightItem$7 = setNaviBarRightItem$2$1;
            }
            else {
                setNaviBarRightItem$7 = notSupport$2;
            }
        }
        else if (isNebula$2) {
            setNaviBarRightItem$7 = setNaviBarRightItem$6;
        }
        else if (isFliggy$2) {
            setNaviBarRightItem$7 = setNaviBarRightItem$5;
        }
        else if (isDingTalk$2) {
            setNaviBarRightItem$7 = setNaviBarRightItem$4;
        }
        else if (isDingTalkPC$2) {
            setNaviBarRightItem$7 = setNaviBarRightItem$3$1;
        }
    }
    else if (isMini$2) {
        if (isMiniAli$2) {
            setNaviBarRightItem$7 = notSupport$2;
        }
        else if (isMiniWx$2) {
            setNaviBarRightItem$7 = notSupport$2;
        }
        else if (isMiniTt$2) {
            setNaviBarRightItem$7 = notSupport$2;
        }
    }
    else if (isMiniweb$2) {
        setNaviBarRightItem$7 = notSupport$2;
    }
    if (!setNaviBarRightItem$7) {
        setNaviBarRightItem$7 = notSupport$2;
    }
    var index$x = promisifyApi$2(setNaviBarRightItem$7);

    var showNavigationBarLoading;
    if (isWeb$3) {
        if (isWindvane$2) {
            showNavigationBarLoading = notSupport$2;
        }
        else if (isNebula$2) {
            showNavigationBarLoading = notSupport$2;
        }
        else if (isFliggy$2) {
            showNavigationBarLoading = notSupport$2;
        }
        else if (isDingTalk$2) {
            showNavigationBarLoading = notSupport$2;
        }
        else if (isDingTalkPC$2) {
            showNavigationBarLoading = notSupport$2;
        }
    }
    else if (isMini$2) {
        if (isMiniAli$2) {
            showNavigationBarLoading = showNavigationBarLoading$2;
        }
        else if (isMiniWx$2) {
            showNavigationBarLoading = notSupport$2;
        }
        else if (isMiniTt$2) {
            showNavigationBarLoading = notSupport$2;
        }
    }
    else if (isMiniweb$2) {
        showNavigationBarLoading = showNavigationBarLoading$1;
    }
    if (!showNavigationBarLoading) {
        showNavigationBarLoading = notSupport$2;
    }
    var index$w = promisifyApi$2(showNavigationBarLoading);

    var vibrate$8;
    if (isWeb$3) {
        if (isWindvane$2) {
            vibrate$8 = vibrate$7;
        }
        else if (isNebula$2) {
            vibrate$8 = vibrate$6;
        }
        else if (isFliggy$2) {
            vibrate$8 = vibrate$5;
        }
        else if (isDingTalk$2) {
            vibrate$8 = vibrate$4;
        }
        else if (isDingTalkPC$2) {
            vibrate$8 = vibrate$3;
        }
    }
    else if (isMini$2) {
        if (isMiniAli$2) {
            vibrate$8 = vibrate$2;
        }
        else if (isMiniWx$2) {
            vibrate$8 = notSupport$2;
        }
        else if (isMiniTt$2) {
            vibrate$8 = notSupport$2;
        }
    }
    else if (isMiniweb$2) {
        vibrate$8 = vibrate$1$1;
    }
    if (!vibrate$8) {
        vibrate$8 = notSupport$2;
    }
    var index$v = promisifyApi$2(vibrate$8);

    var chooseImage$i;
    if (isWeb$3) {
        if (isWindvane$2) {
            chooseImage$i = chooseImage$8$1;
        }
        else if (isNebula$2) {
            chooseImage$i = chooseImage$7$1;
        }
        else if (isFliggy$2) {
            chooseImage$i = chooseImage$6$1;
        }
        else if (isDingTalk$2) {
            chooseImage$i = notSupport$2;
        }
        else if (isDingTalkPC$2) {
            chooseImage$i = notSupport$2;
        }
        else {
            chooseImage$i = chooseImage$1$1;
        }
    }
    else if (isMini$2) {
        if (isMiniAli$2) {
            chooseImage$i = chooseImage$5$1;
        }
        else if (isMiniWx$2) {
            chooseImage$i = chooseImage$4$1;
        }
        else if (isMiniTt$2) {
            chooseImage$i = chooseImage$3$1;
        }
    }
    else if (isMiniweb$2) {
        chooseImage$i = chooseImage$2$1;
    }
    if (!chooseImage$i) {
        chooseImage$i = notSupport$2;
    }
    var index$u = promisifyApi$2(chooseImage$i);

    var hideLoading$a;
    if (isWeb$3) {
        if (isWindvane$2) {
            hideLoading$a = hideLoading$9;
        }
        else if (isNebula$2) {
            hideLoading$a = hideLoading$8;
        }
        else if (isFliggy$2) {
            hideLoading$a = notSupport$2;
        }
        else if (isDingTalk$2) {
            hideLoading$a = hideLoading$7;
        }
        else if (isDingTalkPC$2) {
            hideLoading$a = hideLoading$6;
        }
        else {
            hideLoading$a = hideLoading$1$1;
        }
    }
    else if (isMini$2) {
        if (isMiniAli$2) {
            hideLoading$a = hideLoading$5;
        }
        else if (isMiniWx$2) {
            hideLoading$a = hideLoading$4;
        }
        else if (isMiniTt$2) {
            hideLoading$a = hideLoading$3$1;
        }
    }
    else if (isMiniweb$2) {
        hideLoading$a = hideLoading$2$1;
    }
    if (!hideLoading$a) {
        hideLoading$a = notSupport$2;
    }
    var index$t = promisifyApi$2(hideLoading$a);

    var navigateTo$g;
    if (isWeb$3) {
        if (isWindvane$2) {
            if (isWebTb$1) {
                navigateTo$g = navigateTo$6$1;
            }
            else if (isWebWdkhema$1) {
                navigateTo$g = navigateTo$2$1;
            }
            else if (isWebYouku$1) {
                navigateTo$g = navigateTo$1$1;
            }
            else if (isWebFm$1) {
                navigateTo$g = navigateTo$5$1;
            }
            else if (isWebCunpartner$1) {
                navigateTo$g = navigateTo$6$1;
            }
            else if (isWebLt$1) {
                navigateTo$g = navigateTo$6$1;
            }
            else if (isWebElmc$1) {
                navigateTo$g = navigateTo$4$1;
            }
            else if (isWebIhome$1) {
                navigateTo$g = navigateTo$6$1;
            }
            else if (isWebTphome$1) {
                navigateTo$g = navigateTo$6$1;
            }
            else if (isWebAh$1) {
                navigateTo$g = navigateTo$6$1;
            }
            else if (isWebTm$1) {
                navigateTo$g = navigateTo$3$1;
            }
            else if (isWebAlipm$1) {
                navigateTo$g = navigateTo$6$1;
            }
            else {
                navigateTo$g = notSupport$2;
            }
        }
        else if (isNebula$2) {
            navigateTo$g = navigateTo$f;
        }
        else if (isFliggy$2) {
            navigateTo$g = navigateTo$e;
        }
        else if (isDingTalk$2) {
            navigateTo$g = navigateTo$d;
        }
        else if (isDingTalkPC$2) {
            navigateTo$g = navigateTo$c;
        }
        else {
            navigateTo$g = navigateTo$7$1;
        }
    }
    else if (isMini$2) {
        if (isMiniAli$2) {
            navigateTo$g = navigateTo$b;
        }
        else if (isMiniWx$2) {
            navigateTo$g = navigateTo$a;
        }
        else if (isMiniTt$2) {
            navigateTo$g = navigateTo$9$1;
        }
    }
    else if (isMiniweb$2) {
        navigateTo$g = navigateTo$8$1;
    }
    if (!navigateTo$g) {
        navigateTo$g = notSupport$2;
    }
    var index$s = promisifyApi$2(navigateTo$g);

    var removeStorageSync;
    if (isWeb$3) {
        removeStorageSync = removeStorageSync$2;
    }
    else if (isMini$2) {
        if (isMiniAli$2) {
            removeStorageSync = removeStorageSync$5;
        }
        else if (isMiniWx$2) {
            removeStorageSync = removeStorageSync$4;
        }
        else if (isMiniTt$2) {
            removeStorageSync = removeStorageSync$3;
        }
    }
    if (!removeStorageSync) {
        removeStorageSync = notSupport$2;
    }
    var removeStorageSync$1 = removeStorageSync;

    var setNavigationBar;
    if (isWeb$3) {
        if (isWindvane$2) {
            if (isWebTb$1) {
                setNavigationBar = setNavigationBar$6;
            }
            else if (isWebTm$1) {
                setNavigationBar = setNavigationBar$4;
            }
            else if (isWebWdkhema$1) {
                setNavigationBar = setNavigationBar$3;
            }
            else if (isWebYouku$1) {
                setNavigationBar = setNavigationBar$2;
            }
            else if (isWebCunpartner$1) {
                setNavigationBar = setNavigationBar$1;
            }
            else if (isWebFm$1) {
                setNavigationBar = setNavigationBar$5;
            }
            else if (isWebLt$1) {
                setNavigationBar = setNavigationBar$6;
            }
            else if (isWebElmc$1) {
                setNavigationBar = setNavigationBar$6;
            }
            else if (isWebIhome$1) {
                setNavigationBar = setNavigationBar$6;
            }
            else if (isWebTphome$1) {
                setNavigationBar = setNavigationBar$6;
            }
            else if (isWebAh$1) {
                setNavigationBar = setNavigationBar$6;
            }
            else {
                setNavigationBar = setNavigationBar$f;
            }
        }
        else if (isNebula$2) {
            setNavigationBar = setNavigationBar$e;
        }
        else if (isFliggy$2) {
            setNavigationBar = setNavigationBar$d;
        }
        else if (isDingTalk$2) {
            setNavigationBar = setNavigationBar$c;
        }
        else if (isDingTalkPC$2) {
            setNavigationBar = setNavigationBar$b;
        }
    }
    else if (isMini$2) {
        if (isMiniAli$2) {
            setNavigationBar = setNavigationBar$a;
        }
        else if (isMiniWx$2) {
            setNavigationBar = setNavigationBar$9;
        }
        else if (isMiniTt$2) {
            setNavigationBar = setNavigationBar$8;
        }
    }
    else if (isMiniweb$2) {
        setNavigationBar = setNavigationBar$7;
    }
    if (!setNavigationBar) {
        setNavigationBar = notSupport$2;
    }
    var index$r = promisifyApi$2(setNavigationBar);

    var showSharePanel$f;
    if (isWeb$3) {
        if (isWindvane$2) {
            if (isWebTb$1) {
                showSharePanel$f = showSharePanel$6$1;
            }
            else if (isWebTm$1) {
                showSharePanel$f = showSharePanel$4$1;
            }
            else if (isWebWdkhema$1) {
                showSharePanel$f = showSharePanel$3$1;
            }
            else if (isWebYouku$1) {
                showSharePanel$f = showSharePanel$2$1;
            }
            else if (isWebCunpartner$1) {
                showSharePanel$f = showSharePanel$1$1;
            }
            else if (isWebLt$1) {
                showSharePanel$f = showSharePanel$6$1;
            }
            else if (isWebElmc$1) {
                showSharePanel$f = showSharePanel$6$1;
            }
            else if (isWebIhome$1) {
                showSharePanel$f = showSharePanel$6$1;
            }
            else if (isWebTphome$1) {
                showSharePanel$f = showSharePanel$6$1;
            }
            else if (isWebFm$1) {
                showSharePanel$f = showSharePanel$5$1;
            }
            else if (isWebAlipm$1) {
                showSharePanel$f = showSharePanel$6$1;
            }
            else if (isWebQn$1) {
                showSharePanel$f = showSharePanel$6$1;
            }
            else {
                showSharePanel$f = notSupport$2;
            }
        }
        else if (isNebula$2) {
            showSharePanel$f = showSharePanel$e;
        }
        else if (isFliggy$2) {
            showSharePanel$f = showSharePanel$d;
        }
        else if (isDingTalk$2) {
            showSharePanel$f = showSharePanel$c;
        }
        else if (isDingTalkPC$2) {
            showSharePanel$f = showSharePanel$b;
        }
    }
    else if (isMini$2) {
        if (isMiniAli$2) {
            showSharePanel$f = showSharePanel$a;
        }
        else if (isMiniWx$2) {
            showSharePanel$f = showSharePanel$9;
        }
        else if (isMiniTt$2) {
            showSharePanel$f = showSharePanel$8;
        }
    }
    else if (isMiniweb$2) {
        showSharePanel$f = showSharePanel$7;
    }
    if (!showSharePanel$f) {
        showSharePanel$f = notSupport$2;
    }
    var index$q = promisifyApi$2(showSharePanel$f);

    var vibrateLong;
    if (isWeb$3) {
        if (isWindvane$2) {
            vibrateLong = notSupport$2;
        }
        else if (isNebula$2) {
            vibrateLong = notSupport$2;
        }
        else if (isFliggy$2) {
            vibrateLong = notSupport$2;
        }
        else if (isDingTalk$2) {
            vibrateLong = notSupport$2;
        }
        else if (isDingTalkPC$2) {
            vibrateLong = notSupport$2;
        }
    }
    else if (isMini$2) {
        if (isMiniAli$2) {
            vibrateLong = vibrateLong$4;
        }
        else if (isMiniWx$2) {
            vibrateLong = vibrateLong$3;
        }
        else if (isMiniTt$2) {
            vibrateLong = vibrateLong$2;
        }
    }
    else if (isMiniweb$2) {
        vibrateLong = vibrateLong$1;
    }
    if (!vibrateLong) {
        vibrateLong = notSupport$2;
    }
    var index$p = promisifyApi$2(vibrateLong);

    var choosePhoneContact$a;
    if (isWeb$3) {
        if (isWindvane$2) {
            if (isWebFm$1) {
                choosePhoneContact$a = notSupport$2;
            }
            else {
                choosePhoneContact$a = choosePhoneContact$9;
            }
        }
        else if (isNebula$2) {
            choosePhoneContact$a = choosePhoneContact$8;
        }
        else if (isFliggy$2) {
            choosePhoneContact$a = choosePhoneContact$7;
        }
        else if (isDingTalk$2) {
            choosePhoneContact$a = choosePhoneContact$6;
        }
        else if (isDingTalkPC$2) {
            choosePhoneContact$a = choosePhoneContact$5;
        }
    }
    else if (isMini$2) {
        if (isMiniAli$2) {
            choosePhoneContact$a = choosePhoneContact$4;
        }
        else if (isMiniWx$2) {
            choosePhoneContact$a = choosePhoneContact$3;
        }
        else if (isMiniTt$2) {
            choosePhoneContact$a = choosePhoneContact$2;
        }
    }
    else if (isMiniweb$2) {
        choosePhoneContact$a = choosePhoneContact$1$1;
    }
    if (!choosePhoneContact$a) {
        choosePhoneContact$a = notSupport$2;
    }
    var index$o = promisifyApi$2(choosePhoneContact$a);

    var getDeviceId;
    if (isWeb$3) {
        if (isWindvane$2) {
            if (isWebTb$1) {
                getDeviceId = getDeviceId$3;
            }
            else if (isWebWdkhema$1) {
                getDeviceId = getDeviceId$2;
            }
            else if (isWebYouku$1) {
                getDeviceId = getDeviceId$1;
            }
            else if (isWebFm$1) {
                getDeviceId = getDeviceId$3;
            }
            else if (isWebLt$1) {
                getDeviceId = getDeviceId$3;
            }
            else if (isWebElmc$1) {
                getDeviceId = getDeviceId$3;
            }
            else if (isWebIhome$1) {
                getDeviceId = getDeviceId$3;
            }
            else if (isWebTphome$1) {
                getDeviceId = getDeviceId$3;
            }
            else if (isWebCunpartner$1) {
                getDeviceId = notSupport$2;
            }
            else if (isWebAh$1) {
                getDeviceId = getDeviceId$3;
            }
            else {
                getDeviceId = notSupport$2;
            }
        }
        else if (isNebula$2) {
            getDeviceId = getDeviceId$5;
        }
        else if (isFliggy$2) {
            getDeviceId = getDeviceId$4;
        }
        else if (isDingTalk$2) {
            getDeviceId = notSupport$2;
        }
        else if (isDingTalkPC$2) {
            getDeviceId = notSupport$2;
        }
    }
    else if (isMini$2) {
        if (isMiniAli$2) {
            getDeviceId = notSupport$2;
        }
        else if (isMiniWx$2) {
            getDeviceId = notSupport$2;
        }
        else if (isMiniTt$2) {
            getDeviceId = notSupport$2;
        }
    }
    else if (isMiniweb$2) {
        getDeviceId = notSupport$2;
    }
    if (!getDeviceId) {
        getDeviceId = notSupport$2;
    }
    var index$n = promisifyApi$2(getDeviceId);

    var hideNavigationBarLoading;
    if (isWeb$3) {
        if (isWindvane$2) {
            hideNavigationBarLoading = notSupport$2;
        }
        else if (isNebula$2) {
            hideNavigationBarLoading = notSupport$2;
        }
        else if (isFliggy$2) {
            hideNavigationBarLoading = notSupport$2;
        }
        else if (isDingTalk$2) {
            hideNavigationBarLoading = notSupport$2;
        }
        else if (isDingTalkPC$2) {
            hideNavigationBarLoading = notSupport$2;
        }
    }
    else if (isMini$2) {
        if (isMiniAli$2) {
            hideNavigationBarLoading = hideNavigationBarLoading$2;
        }
        else if (isMiniWx$2) {
            hideNavigationBarLoading = notSupport$2;
        }
        else if (isMiniTt$2) {
            hideNavigationBarLoading = notSupport$2;
        }
    }
    else if (isMiniweb$2) {
        hideNavigationBarLoading = hideNavigationBarLoading$1;
    }
    if (!hideNavigationBarLoading) {
        hideNavigationBarLoading = notSupport$2;
    }
    var index$m = promisifyApi$2(hideNavigationBarLoading);

    var openInBrowser$4;
    if (isWeb$3) {
        if (isWindvane$2) {
            openInBrowser$4 = openInBrowser$3;
        }
        else if (isNebula$2) {
            openInBrowser$4 = openInBrowser$2;
        }
        else if (isFliggy$2) {
            openInBrowser$4 = openInBrowser$1;
        }
        else if (isDingTalk$2) {
            openInBrowser$4 = notSupport$2;
        }
        else if (isDingTalkPC$2) {
            openInBrowser$4 = notSupport$2;
        }
    }
    else if (isMini$2) {
        if (isMiniAli$2) {
            openInBrowser$4 = notSupport$2;
        }
        else if (isMiniWx$2) {
            openInBrowser$4 = notSupport$2;
        }
        else if (isMiniTt$2) {
            openInBrowser$4 = notSupport$2;
        }
    }
    else if (isMiniweb$2) {
        openInBrowser$4 = notSupport$2;
    }
    if (!openInBrowser$4) {
        openInBrowser$4 = notSupport$2;
    }
    var index$l = promisifyApi$2(openInBrowser$4);

    var resumeAudio;
    if (isWeb$3) {
        if (isWindvane$2) {
            if (isWebTb$1) {
                resumeAudio = notSupport$2;
            }
            else {
                resumeAudio = notSupport$2;
            }
        }
        else if (isNebula$2) {
            resumeAudio = resumeAudio$1;
        }
        else if (isFliggy$2) {
            resumeAudio = notSupport$2;
        }
        else if (isDingTalk$2) {
            resumeAudio = notSupport$2;
        }
        else if (isDingTalkPC$2) {
            resumeAudio = notSupport$2;
        }
    }
    else if (isMini$2) {
        if (isMiniAli$2) {
            resumeAudio = notSupport$2;
        }
        else if (isMiniWx$2) {
            resumeAudio = notSupport$2;
        }
        else if (isMiniTt$2) {
            resumeAudio = notSupport$2;
        }
    }
    if (!resumeAudio) {
        resumeAudio = notSupport$2;
    }
    var index$k = promisifyApi$2(resumeAudio);

    var setOrientation;
    if (isWeb$3) {
        if (isWindvane$2) {
            setOrientation = setOrientation$1;
        }
        else if (isNebula$2) {
            setOrientation = notSupport$2;
        }
        else if (isFliggy$2) {
            setOrientation = notSupport$2;
        }
        else if (isDingTalk$2) {
            setOrientation = notSupport$2;
        }
        else if (isDingTalkPC$2) {
            setOrientation = notSupport$2;
        }
    }
    else if (isMini$2) {
        if (isMiniAli$2) {
            setOrientation = notSupport$2;
        }
        else if (isMiniWx$2) {
            setOrientation = notSupport$2;
        }
        else if (isMiniTt$2) {
            setOrientation = notSupport$2;
        }
    }
    else if (isMiniweb$2) {
        setOrientation = notSupport$2;
    }
    if (!setOrientation) {
        setOrientation = notSupport$2;
    }
    var index$j = promisifyApi$2(setOrientation);

    var showTitle$4;
    if (isWeb$3) {
        if (isWindvane$2) {
            if (isWebTb$1) {
                showTitle$4 = showTitle$2$1;
            }
            else if (isWebTm$1) {
                showTitle$4 = notSupport$2;
            }
            else if (isWebYouku$1) {
                showTitle$4 = showTitle$1$1;
            }
            else if (isWebFm$1) {
                showTitle$4 = notSupport$2;
            }
            else if (isWebCunpartner$1) {
                showTitle$4 = showTitle$2$1;
            }
            else if (isWebElmc$1) {
                showTitle$4 = showTitle$2$1;
            }
            else if (isWebIhome$1) {
                showTitle$4 = showTitle$2$1;
            }
            else if (isWebTphome$1) {
                showTitle$4 = showTitle$2$1;
            }
            else if (isWebAh$1) {
                showTitle$4 = showTitle$2$1;
            }
            else if (isWebAlipm$1) {
                showTitle$4 = showTitle$2$1;
            }
            else {
                showTitle$4 = notSupport$2;
            }
        }
        else if (isNebula$2) {
            showTitle$4 = notSupport$2;
        }
        else if (isFliggy$2) {
            showTitle$4 = showTitle$3;
        }
        else if (isDingTalk$2) {
            showTitle$4 = notSupport$2;
        }
        else if (isDingTalkPC$2) {
            showTitle$4 = notSupport$2;
        }
    }
    else if (isMini$2) {
        if (isMiniAli$2) {
            showTitle$4 = notSupport$2;
        }
        else if (isMiniWx$2) {
            showTitle$4 = notSupport$2;
        }
        else if (isMiniTt$2) {
            showTitle$4 = notSupport$2;
        }
    }
    else if (isMiniweb$2) {
        showTitle$4 = notSupport$2;
    }
    if (!showTitle$4) {
        showTitle$4 = notSupport$2;
    }
    var index$i = promisifyApi$2(showTitle$4);

    var vibrateShort;
    if (isWeb$3) {
        if (isWindvane$2) {
            vibrateShort = notSupport$2;
        }
        else if (isNebula$2) {
            vibrateShort = notSupport$2;
        }
        else if (isFliggy$2) {
            vibrateShort = notSupport$2;
        }
        else if (isDingTalk$2) {
            vibrateShort = notSupport$2;
        }
        else if (isDingTalkPC$2) {
            vibrateShort = notSupport$2;
        }
    }
    else if (isMini$2) {
        if (isMiniAli$2) {
            vibrateShort = vibrateShort$4;
        }
        else if (isMiniWx$2) {
            vibrateShort = vibrateShort$3;
        }
        else if (isMiniTt$2) {
            vibrateShort = vibrateShort$2;
        }
    }
    else if (isMiniweb$2) {
        vibrateShort = vibrateShort$1;
    }
    if (!vibrateShort) {
        vibrateShort = notSupport$2;
    }
    var index$h = promisifyApi$2(vibrateShort);

    var clearNaviBarRightItem$7;
    if (isWeb$3) {
        if (isWindvane$2) {
            if (isWebTb$1) {
                clearNaviBarRightItem$7 = clearNaviBarRightItem$2$1;
            }
            else if (isWebFm$1) {
                clearNaviBarRightItem$7 = clearNaviBarRightItem$1$1;
            }
            else if (isWebLt$1) {
                clearNaviBarRightItem$7 = clearNaviBarRightItem$2$1;
            }
            else if (isWebElmc$1) {
                clearNaviBarRightItem$7 = clearNaviBarRightItem$2$1;
            }
            else if (isWebIhome$1) {
                clearNaviBarRightItem$7 = clearNaviBarRightItem$2$1;
            }
            else if (isWebTphome$1) {
                clearNaviBarRightItem$7 = clearNaviBarRightItem$2$1;
            }
            else if (isWebCunpartner$1) {
                clearNaviBarRightItem$7 = clearNaviBarRightItem$2$1;
            }
            else if (isWebAh$1) {
                clearNaviBarRightItem$7 = clearNaviBarRightItem$2$1;
            }
            else if (isWebAlipm$1) {
                clearNaviBarRightItem$7 = clearNaviBarRightItem$2$1;
            }
            else {
                clearNaviBarRightItem$7 = notSupport$2;
            }
        }
        else if (isNebula$2) {
            clearNaviBarRightItem$7 = clearNaviBarRightItem$6;
        }
        else if (isFliggy$2) {
            clearNaviBarRightItem$7 = clearNaviBarRightItem$5;
        }
        else if (isDingTalk$2) {
            clearNaviBarRightItem$7 = clearNaviBarRightItem$4;
        }
        else if (isDingTalkPC$2) {
            clearNaviBarRightItem$7 = clearNaviBarRightItem$3$1;
        }
    }
    else if (isMini$2) {
        if (isMiniAli$2) {
            clearNaviBarRightItem$7 = notSupport$2;
        }
        else if (isMiniWx$2) {
            clearNaviBarRightItem$7 = notSupport$2;
        }
        else if (isMiniTt$2) {
            clearNaviBarRightItem$7 = notSupport$2;
        }
    }
    else if (isMiniweb$2) {
        clearNaviBarRightItem$7 = notSupport$2;
    }
    if (!clearNaviBarRightItem$7) {
        clearNaviBarRightItem$7 = notSupport$2;
    }
    var index$g = promisifyApi$2(clearNaviBarRightItem$7);

    var getLocation$i;
    if (isWeb$3) {
        if (isWindvane$2) {
            getLocation$i = getLocation$a$1;
        }
        else if (isNebula$2) {
            getLocation$i = getLocation$9$1;
        }
        else if (isFliggy$2) {
            getLocation$i = getLocation$8$1;
        }
        else if (isDingTalk$2) {
            getLocation$i = getLocation$7$1;
        }
        else if (isDingTalkPC$2) {
            getLocation$i = getLocation$6$1;
        }
        else {
            getLocation$i = getLocation$1$1;
        }
    }
    else if (isMini$2) {
        if (isMiniAli$2) {
            getLocation$i = getLocation$5$1;
        }
        else if (isMiniWx$2) {
            getLocation$i = getLocation$4$1;
        }
        else if (isMiniTt$2) {
            getLocation$i = getLocation$3$1;
        }
    }
    else if (isMiniweb$2) {
        getLocation$i = getLocation$2$1;
    }
    if (!getLocation$i) {
        getLocation$i = notSupport$2;
    }
    var index$f = promisifyApi$2(getLocation$i);

    var hideTitle$6;
    if (isWeb$3) {
        if (isWindvane$2) {
            if (isWebTb$1) {
                hideTitle$6 = hideTitle$4;
            }
            else if (isWebTm$1) {
                hideTitle$6 = hideTitle$2$1;
            }
            else if (isWebYouku$1) {
                hideTitle$6 = hideTitle$1$1;
            }
            else if (isWebFm$1) {
                hideTitle$6 = hideTitle$3;
            }
            else if (isWebCunpartner$1) {
                hideTitle$6 = hideTitle$4;
            }
            else if (isWebElmc$1) {
                hideTitle$6 = hideTitle$4;
            }
            else if (isWebIhome$1) {
                hideTitle$6 = hideTitle$4;
            }
            else if (isWebTphome$1) {
                hideTitle$6 = hideTitle$4;
            }
            else if (isWebAh$1) {
                hideTitle$6 = hideTitle$4;
            }
            else if (isWebAlipm$1) {
                hideTitle$6 = hideTitle$4;
            }
            else {
                hideTitle$6 = notSupport$2;
            }
        }
        else if (isNebula$2) {
            hideTitle$6 = notSupport$2;
        }
        else if (isFliggy$2) {
            hideTitle$6 = hideTitle$5;
        }
        else if (isDingTalk$2) {
            hideTitle$6 = notSupport$2;
        }
        else if (isDingTalkPC$2) {
            hideTitle$6 = notSupport$2;
        }
    }
    else if (isMini$2) {
        if (isMiniAli$2) {
            hideTitle$6 = notSupport$2;
        }
        else if (isMiniWx$2) {
            hideTitle$6 = notSupport$2;
        }
        else if (isMiniTt$2) {
            hideTitle$6 = notSupport$2;
        }
    }
    else if (isMiniweb$2) {
        hideTitle$6 = notSupport$2;
    }
    if (!hideTitle$6) {
        hideTitle$6 = notSupport$2;
    }
    var index$e = promisifyApi$2(hideTitle$6);

    var pauseAudio;
    if (isWeb$3) {
        if (isWindvane$2) {
            if (isWebTb$1) {
                pauseAudio = notSupport$2;
            }
            else {
                pauseAudio = notSupport$2;
            }
        }
        else if (isNebula$2) {
            pauseAudio = pauseAudio$1;
        }
        else if (isFliggy$2) {
            pauseAudio = notSupport$2;
        }
        else if (isDingTalk$2) {
            pauseAudio = notSupport$2;
        }
        else if (isDingTalkPC$2) {
            pauseAudio = notSupport$2;
        }
    }
    else if (isMini$2) {
        if (isMiniAli$2) {
            pauseAudio = notSupport$2;
        }
        else if (isMiniWx$2) {
            pauseAudio = notSupport$2;
        }
        else if (isMiniTt$2) {
            pauseAudio = notSupport$2;
        }
    }
    if (!pauseAudio) {
        pauseAudio = notSupport$2;
    }
    var index$d = promisifyApi$2(pauseAudio);

    var saveImage$j;
    if (isWeb$3) {
        if (isWindvane$2) {
            saveImage$j = saveImage$5$1;
        }
        else if (isNebula$2) {
            saveImage$j = notSupport$2;
        }
        else if (isFliggy$2) {
            saveImage$j = saveImage$4$1;
        }
        else if (isDingTalk$2) {
            saveImage$j = notSupport$2;
        }
        else if (isDingTalkPC$2) {
            saveImage$j = notSupport$2;
        }
    }
    else if (isMini$2) {
        if (isMiniAli$2) {
            saveImage$j = saveImage$3$1;
        }
        else if (isMiniWx$2) {
            saveImage$j = saveImage$2$1;
        }
        else if (isMiniTt$2) {
            saveImage$j = saveImage$1$1;
        }
    }
    if (!saveImage$j) {
        saveImage$j = notSupport$2;
    }
    var index$c = promisifyApi$2(saveImage$j);

    var setStorage$5;
    if (isWeb$3) {
        setStorage$5 = setStorage$1$1;
    }
    else if (isMini$2) {
        if (isMiniAli$2) {
            setStorage$5 = setStorage$4;
        }
        else if (isMiniWx$2) {
            setStorage$5 = setStorage$3;
        }
        else if (isMiniTt$2) {
            setStorage$5 = setStorage$2$1;
        }
    }
    if (!setStorage$5) {
        setStorage$5 = notSupport$2;
    }
    var index$b = promisifyApi$2(setStorage$5);

    var showToast$a;
    if (isWeb$3) {
        if (isWindvane$2) {
            showToast$a = showToast$9$1;
        }
        else if (isNebula$2) {
            showToast$a = showToast$8$1;
        }
        else if (isFliggy$2) {
            showToast$a = showToast$7$1;
        }
        else if (isDingTalk$2) {
            showToast$a = showToast$6$1;
        }
        else if (isDingTalkPC$2) {
            showToast$a = showToast$5$1;
        }
        else {
            showToast$a = show$7;
        }
    }
    else if (isMini$2) {
        if (isMiniAli$2) {
            showToast$a = showToast$4$1;
        }
        else if (isMiniWx$2) {
            showToast$a = showToast$3$1;
        }
        else if (isMiniTt$2) {
            showToast$a = showToast$2$1;
        }
    }
    else if (isMiniweb$2) {
        showToast$a = showToast$1$1;
    }
    if (!showToast$a) {
        showToast$a = notSupport$2;
    }
    var index$a = promisifyApi$2(showToast$a);

    var clearStorage;
    if (isWeb$3) {
        if (isWindvane$2) {
            clearStorage = notSupport$2;
        }
        else if (isNebula$2) {
            clearStorage = notSupport$2;
        }
        else if (isFliggy$2) {
            clearStorage = notSupport$2;
        }
        else if (isDingTalk$2) {
            clearStorage = notSupport$2;
        }
        else if (isDingTalkPC$2) {
            clearStorage = notSupport$2;
        }
    }
    else if (isMini$2) {
        if (isMiniAli$2) {
            clearStorage = clearStorage$3;
        }
        else if (isMiniWx$2) {
            clearStorage = clearStorage$2;
        }
        else if (isMiniTt$2) {
            clearStorage = clearStorage$1;
        }
    }
    if (!clearStorage) {
        clearStorage = notSupport$2;
    }
    var index$9 = promisifyApi$2(clearStorage);

    var clearStorageSync;
    if (isWeb$3) {
        if (isWindvane$2) {
            clearStorageSync = notSupport$2;
        }
        else if (isNebula$2) {
            clearStorageSync = notSupport$2;
        }
        else if (isFliggy$2) {
            clearStorageSync = notSupport$2;
        }
        else if (isDingTalk$2) {
            clearStorageSync = notSupport$2;
        }
        else if (isDingTalkPC$2) {
            clearStorageSync = notSupport$2;
        }
    }
    else if (isMini$2) {
        if (isMiniAli$2) {
            clearStorageSync = clearStorageSync$4;
        }
        else if (isMiniWx$2) {
            clearStorageSync = clearStorageSync$3;
        }
        else if (isMiniTt$2) {
            clearStorageSync = clearStorageSync$2;
        }
    }
    if (!clearStorageSync) {
        clearStorageSync = notSupport$2;
    }
    var clearStorageSync$1 = clearStorageSync;

    var getNetworkType$b;
    if (isWeb$3) {
        if (isWindvane$2) {
            getNetworkType$b = getNetworkType$a;
        }
        else if (isNebula$2) {
            getNetworkType$b = getNetworkType$9;
        }
        else if (isFliggy$2) {
            getNetworkType$b = getNetworkType$8;
        }
        else if (isDingTalk$2) {
            getNetworkType$b = getNetworkType$7;
        }
        else if (isDingTalkPC$2) {
            getNetworkType$b = getNetworkType$6;
        }
        else {
            getNetworkType$b = getNetworkType$1$1;
        }
    }
    else if (isMini$2) {
        if (isMiniAli$2) {
            getNetworkType$b = getNetworkType$5;
        }
        else if (isMiniWx$2) {
            getNetworkType$b = getNetworkType$4$1;
        }
        else if (isMiniTt$2) {
            getNetworkType$b = getNetworkType$3$1;
        }
    }
    else if (isMiniweb$2) {
        getNetworkType$b = getNetworkType$2$1;
    }
    if (!getNetworkType$b) {
        getNetworkType$b = notSupport$2;
    }
    var index$8 = promisifyApi$2(getNetworkType$b);

    var hideToast$8;
    if (isWeb$3) {
        if (isWindvane$2) {
            hideToast$8 = notSupport$2;
        }
        else if (isNebula$2) {
            hideToast$8 = notSupport$2;
        }
        else if (isFliggy$2) {
            hideToast$8 = notSupport$2;
        }
        else if (isDingTalk$2) {
            hideToast$8 = notSupport$2;
        }
        else if (isDingTalkPC$2) {
            hideToast$8 = notSupport$2;
        }
        else {
            hideToast$8 = hide$6;
        }
    }
    else if (isMini$2) {
        if (isMiniAli$2) {
            hideToast$8 = hideToast$4$1;
        }
        else if (isMiniWx$2) {
            hideToast$8 = hideToast$3$1;
        }
        else if (isMiniTt$2) {
            hideToast$8 = hideToast$2$1;
        }
    }
    else if (isMiniweb$2) {
        hideToast$8 = hideToast$1$1;
    }
    if (!hideToast$8) {
        hideToast$8 = notSupport$2;
    }
    var index$7 = promisifyApi$2(hideToast$8);

    var playAudio;
    if (isWeb$3) {
        if (isWindvane$2) {
            if (isWebTb$1) {
                playAudio = playAudio$1;
            }
            else if (isWebLt$1) {
                playAudio = playAudio$1;
            }
            else {
                playAudio = notSupport$2;
            }
        }
        else if (isNebula$2) {
            playAudio = playAudio$2;
        }
        else if (isFliggy$2) {
            playAudio = notSupport$2;
        }
        else if (isDingTalk$2) {
            playAudio = notSupport$2;
        }
        else if (isDingTalkPC$2) {
            playAudio = notSupport$2;
        }
    }
    else if (isMini$2) {
        if (isMiniAli$2) {
            playAudio = notSupport$2;
        }
        else if (isMiniWx$2) {
            playAudio = notSupport$2;
        }
        else if (isMiniTt$2) {
            playAudio = notSupport$2;
        }
    }
    if (!playAudio) {
        playAudio = notSupport$2;
    }
    var index$6 = promisifyApi$2(playAudio);

    var scan$c;
    if (isWeb$3) {
        if (isWindvane$2) {
            if (isWebTb$1) {
                scan$c = scan$3$1;
            }
            else if (isWebFm$1) {
                scan$c = scan$3$1;
            }
            else if (isWebWdkhema$1) {
                scan$c = scan$2$1;
            }
            else if (isWebCunpartner$1) {
                scan$c = scan$1$1;
            }
            else if (isWebLt$1) {
                scan$c = scan$3$1;
            }
            else if (isWebElmc$1) {
                scan$c = scan$3$1;
            }
            else if (isWebIhome$1) {
                scan$c = scan$3$1;
            }
            else if (isWebTphome$1) {
                scan$c = scan$3$1;
            }
            else if (isWebTm$1) {
                scan$c = scan$3$1;
            }
            else if (isWebAlipm$1) {
                scan$c = scan$3$1;
            }
            else {
                scan$c = notSupport$2;
            }
        }
        else if (isNebula$2) {
            scan$c = scan$b;
        }
        else if (isFliggy$2) {
            scan$c = scan$a;
        }
        else if (isDingTalk$2) {
            scan$c = scan$9;
        }
        else if (isDingTalkPC$2) {
            scan$c = scan$8;
        }
    }
    else if (isMini$2) {
        if (isMiniAli$2) {
            scan$c = scan$7;
        }
        else if (isMiniWx$2) {
            scan$c = scan$6;
        }
        else if (isMiniTt$2) {
            scan$c = scan$5$1;
        }
    }
    else if (isMiniweb$2) {
        scan$c = scan$4$1;
    }
    if (!scan$c) {
        scan$c = notSupport$2;
    }
    var index$5 = promisifyApi$2(scan$c);

    var setStorageSync;
    if (isWeb$3) {
        setStorageSync = setStorageSync$2;
    }
    else if (isMini$2) {
        if (isMiniAli$2) {
            setStorageSync = setStorageSync$5;
        }
        else if (isMiniWx$2) {
            setStorageSync = setStorageSync$4;
        }
        else if (isMiniTt$2) {
            setStorageSync = setStorageSync$3;
        }
    }
    if (!setStorageSync) {
        setStorageSync = notSupport$2;
    }
    var setStorageSync$1 = setStorageSync;

    var snapshot$4;
    if (isWeb$3) {
        if (isWindvane$2) {
            snapshot$4 = snapshot$3;
        }
        else if (isNebula$2) {
            snapshot$4 = snapshot$2$1;
        }
        else if (isFliggy$2) {
            snapshot$4 = snapshot$1$1;
        }
        else if (isDingTalk$2) {
            snapshot$4 = notSupport$2;
        }
        else if (isDingTalkPC$2) {
            snapshot$4 = notSupport$2;
        }
    }
    else if (isMini$2) {
        if (isMiniAli$2) {
            snapshot$4 = notSupport$2;
        }
        else if (isMiniWx$2) {
            snapshot$4 = notSupport$2;
        }
        else if (isMiniTt$2) {
            snapshot$4 = notSupport$2;
        }
    }
    else if (isMiniweb$2) {
        snapshot$4 = notSupport$2;
    }
    if (!snapshot$4) {
        snapshot$4 = notSupport$2;
    }
    var index$4 = promisifyApi$2(snapshot$4);

    var alert$b;
    if (isWeb$3) {
        if (isWindvane$2) {
            alert$b = alert$a;
        }
        else if (isNebula$2) {
            alert$b = alert$9;
        }
        else if (isFliggy$2) {
            alert$b = alert$8;
        }
        else if (isDingTalk$2) {
            alert$b = alert$7;
        }
        else if (isDingTalkPC$2) {
            alert$b = alert$6;
        }
        else {
            alert$b = alert$1$1;
        }
    }
    else if (isMini$2) {
        if (isMiniAli$2) {
            alert$b = alert$5;
        }
        else if (isMiniWx$2) {
            alert$b = alert$4;
        }
        else if (isMiniTt$2) {
            alert$b = alert$3;
        }
    }
    else if (isMiniweb$2) {
        alert$b = alert$2$1;
    }
    if (!alert$b) {
        alert$b = notSupport$2;
    }
    var index$3 = promisifyApi$2(alert$b);

    var getOrientation;
    if (isWeb$3) {
        if (isWindvane$2) {
            getOrientation = getOrientation$3;
        }
        else if (isNebula$2) {
            getOrientation = notSupport$2;
        }
        else if (isFliggy$2) {
            getOrientation = notSupport$2;
        }
        else if (isDingTalk$2) {
            getOrientation = notSupport$2;
        }
        else if (isDingTalkPC$2) {
            getOrientation = notSupport$2;
        }
    }
    else if (isMini$2) {
        if (isMiniAli$2) {
            getOrientation = notSupport$2;
        }
        else if (isMiniWx$2) {
            getOrientation = getOrientation$2;
        }
        else if (isMiniTt$2) {
            getOrientation = getOrientation$1;
        }
    }
    else if (isMiniweb$2) {
        getOrientation = notSupport$2;
    }
    if (!getOrientation) {
        getOrientation = notSupport$2;
    }
    var index$2 = promisifyApi$2(getOrientation);

    var previewImage$g;
    if (isWeb$3) {
        if (isWindvane$2) {
            if (isWebTb$1) {
                previewImage$g = previewImage$2$1;
            }
            else if (isWebFm$1) {
                previewImage$g = previewImage$2$1;
            }
            else if (isWebWdkhema$1) {
                previewImage$g = previewImage$1$1;
            }
            else if (isWebCunpartner$1) {
                previewImage$g = previewImage$2$1;
            }
            else if (isWebLt$1) {
                previewImage$g = previewImage$2$1;
            }
            else if (isWebElmc$1) {
                previewImage$g = previewImage$2$1;
            }
            else if (isWebIhome$1) {
                previewImage$g = previewImage$2$1;
            }
            else if (isWebTphome$1) {
                previewImage$g = previewImage$2$1;
            }
            else if (isWebAh$1) {
                previewImage$g = previewImage$2$1;
            }
            else if (isWebAlipm$1) {
                previewImage$g = previewImage$2$1;
            }
            else {
                previewImage$g = notSupport$2;
            }
        }
        else if (isNebula$2) {
            previewImage$g = previewImage$9$1;
        }
        else if (isFliggy$2) {
            previewImage$g = notSupport$2;
        }
        else if (isDingTalk$2) {
            previewImage$g = previewImage$8$1;
        }
        else if (isDingTalkPC$2) {
            previewImage$g = previewImage$7$1;
        }
    }
    else if (isMini$2) {
        if (isMiniAli$2) {
            previewImage$g = previewImage$6$1;
        }
        else if (isMiniWx$2) {
            previewImage$g = previewImage$5$1;
        }
        else if (isMiniTt$2) {
            previewImage$g = previewImage$4$1;
        }
    }
    else if (isMiniweb$2) {
        previewImage$g = previewImage$3$1;
    }
    if (!previewImage$g) {
        previewImage$g = notSupport$2;
    }
    var index$1$1 = promisifyApi$2(previewImage$g);

    var getStatusBarHeight;
    if (isWeb$3) {
        if (isWindvane$2) {
            if (isWebTb$1) {
                getStatusBarHeight = getStatusBarHeight$2;
            }
            else if (isWebFm$1) {
                getStatusBarHeight = getStatusBarHeight$1;
            }
            else {
                getStatusBarHeight = getStatusBarHeight$5;
            }
        }
        else if (isNebula$2) {
            getStatusBarHeight = getStatusBarHeight$4;
        }
        else if (isFliggy$2) {
            getStatusBarHeight = getStatusBarHeight$3;
        }
        else if (isDingTalk$2) {
            getStatusBarHeight = notSupport$2;
        }
        else if (isDingTalkPC$2) {
            getStatusBarHeight = notSupport$2;
        }
    }
    else if (isMini$2) {
        if (isMiniAli$2) {
            getStatusBarHeight = notSupport$2;
        }
        else if (isMiniWx$2) {
            getStatusBarHeight = notSupport$2;
        }
        else if (isMiniTt$2) {
            getStatusBarHeight = notSupport$2;
        }
    }
    if (!getStatusBarHeight) {
        getStatusBarHeight = notSupport$2;
    }
    var index$J = promisifyApi$2(getStatusBarHeight);

    /******************************************************************************
    Copyright (c) Microsoft Corporation.

    Permission to use, copy, modify, and/or distribute this software for any
    purpose with or without fee is hereby granted.

    THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
    REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
    AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
    INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
    LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
    OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
    PERFORMANCE OF THIS SOFTWARE.
    ***************************************************************************** */

    var __assign$1 = function() {
        __assign$1 = Object.assign || function __assign(t) {
            for (var s, i = 1, n = arguments.length; i < n; i++) {
                s = arguments[i];
                for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
            }
            return t;
        };
        return __assign$1.apply(this, arguments);
    };

    function __rest(s, e) {
        var t = {};
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
            t[p] = s[p];
        if (s != null && typeof Object.getOwnPropertySymbols === "function")
            for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
                if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                    t[p[i]] = s[p[i]];
            }
        return t;
    }

    function __awaiter(thisArg, _arguments, P, generator) {
        function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
        return new (P || (P = Promise))(function (resolve, reject) {
            function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
            function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
            function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
            step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
    }

    function __generator(thisArg, body) {
        var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
        return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
        function verb(n) { return function (v) { return step([n, v]); }; }
        function step(op) {
            if (f) throw new TypeError("Generator is already executing.");
            while (g && (g = 0, op[0] && (_ = 0)), _) try {
                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                if (y = 0, t) op = [op[0] & 2, t.value];
                switch (op[0]) {
                    case 0: case 1: t = op; break;
                    case 4: _.label++; return { value: op[1], done: false };
                    case 5: _.label++; y = op[1]; op = [0]; continue;
                    case 7: op = _.ops.pop(); _.trys.pop(); continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                        if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                        if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                        if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                        if (t[2]) _.ops.pop();
                        _.trys.pop(); continue;
                }
                op = body.call(thisArg, _);
            } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
            if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
        }
    }

    function __spreadArray(to, from, pack) {
        if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
            if (ar || !(i in from)) {
                if (!ar) ar = Array.prototype.slice.call(from, 0, i);
                ar[i] = from[i];
            }
        }
        return to.concat(ar || Array.prototype.slice.call(from));
    }

    var _a$1;
    var isWeb$2 = typeof window !== 'undefined' && 'onload' in window;
    var isMiniDingTalk = typeof dd !== 'undefined' && !!dd && typeof dd.showtoast === 'function';
    var isMiniAli$1 = typeof my !== 'undefined' &&
        !!my &&
        (typeof my.showToast === 'function' || typeof my.navigateTo === 'function');
    var isMiniTt$1 = typeof tt !== 'undefined' && !!tt && typeof tt.showtoast === 'function';
    var isMiniWx$1 = !isMiniTt$1 &&
        typeof wx !== 'undefined' &&
        !!wx &&
        (typeof wx.login !== 'undefined' || typeof wx.miniProgram !== 'undefined');
    var isMini$1 = isMiniAli$1 || isMiniWx$1 || isMiniTt$1;
    var isWeex$1 = typeof WXEnvironment !== 'undefined' &&
        !!WXEnvironment &&
        WXEnvironment.platform !== 'Web';
    var isQuickApp$1 = typeof global !== 'undefined' &&
        !!global &&
        typeof global.callNative !== 'function' &&
        !isWeex$1;
    var aliUA$1 = '';
    try {
        aliUA$1 = navigator.userAgent || navigator.swuserAgent || '';
    }
    catch (error) {
        aliUA$1 = '';
    }
    var isMiniweb$1 = (isWeb$2 && aliUA$1.indexOf('Triver') > -1) || aliUA$1.indexOf('miniProgram') > -1;
    var aliAppMatches$1 = /.+AliApp\((\w+)\/((?:\d+\.)+\d+)\)/.exec(aliUA$1 || '') || [];
    var client = (_a$1 = aliAppMatches$1[1]) === null || _a$1 === void 0 ? void 0 : _a$1.toLocaleLowerCase();
    var isWindvane$1 = /.+AliApp\((\w+)\/((?:\d+\.)+\d+)\).* .*(WindVane)(?:\/((?:\d+\.)+\d+))?.*/.test(aliUA$1 || '');
    var isNebula$1 = /.+AliApp\((\w+)\/((?:\d+\.)+\d+)\)/.test(aliUA$1 || '') &&
        /.*(Nebula)(?:\/((?:\d+\.)+\d+))?.*/.test(aliUA$1 || '');
    var isFliggy$1 = /.+AliApp\((\w+)\/((?:\d+\.)+\d+)\) .*(AliTrip)(?:\/((?:\d+\.)+\d+))?.*/.test(aliUA$1 || '');
    var isDingTalk$1 = /.+AliApp\((DingTalk)\/((?:\d+\.)+\d+)?.*/.test(aliUA$1 || '');
    var isMiniAp = isMiniAli$1 && 'ap' === client;
    var isMiniTb = isMiniAli$1 && 'tb' === client;
    var isMiniTm = isMiniAli$1 && 'tm' === client;
    var isMiniFm = isMiniAli$1 && 'fm' === client;
    var isMiniLx = isMiniAli$1 && 'lx' === client;
    var isWebTm = isWeb$2 && client === 'tm';
    var isWebAliyun = isWeb$2 && client === 'aliyun';
    var isWebCn = isWeb$2 && client === 'cn';
    var isWebFm = isWeb$2 && client === 'fm';
    var isWebRetail = isWeb$2 && client === 'retail';
    var isWebXionganapp = isWeb$2 && client === 'xionganapp';
    var isWebAfw = isWeb$2 && client === 'afw';
    var isWebAp = isWeb$2 && client === 'ap';
    var isWebKb = isWeb$2 && client === 'kb';
    var isWebRetailtrader = isWeb$2 && client === 'retailtrader';
    var isWebXm = isWeb$2 && client === 'xm';
    var isWebAk = isWeb$2 && client === 'ak';
    var isWebAt = isWeb$2 && client === 'at';
    var isWebLt = isWeb$2 && client === 'lt';
    var isWebNj = isWeb$2 && client === 'nj';
    var isWebTb = isWeb$2 && client === 'tb';
    var isWebElmc = isWeb$2 && client === 'elmc';
    var isWebIhome = isWeb$2 && client === 'ihome';
    var isWebTphome = isWeb$2 && client === 'tphome';
    var isWebAliwork = isWeb$2 && client === 'aliwork';
    var isWebBk = isWeb$2 && client === 'bk';
    var isWebEt = isWeb$2 && client === 'et';
    var isWebLx = isWeb$2 && client === 'lx';
    var isWebQn = isWeb$2 && client === 'qn';
    var isWebYouku = isWeb$2 && client === 'youku';
    var isWebWdkhema = isWeb$2 && client === 'wdkhema';
    var isWebCunpartner = isWeb$2 && /cunpartner/i.test(aliUA$1);
    var isWebDingTalk = isWeb$2 && client === 'dingtalk';
    var isWebAh = isWeb$2 && client === 'ah';
    var isWebAlipm = isWeb$2 && client === 'alipm';
    var isDingTalkPC$1 = /\s+DingTalk\(/i.test(aliUA$1);
    var isWebDingTalkPC = isDingTalkPC$1;
    var appName = client;
    function getUA() {
        return (navigator === null || navigator === void 0 ? void 0 : navigator.userAgent) || (navigator === null || navigator === void 0 ? void 0 : navigator.swuserAgent) || '';
    }
    function isDingTalkMiniApp() {
        return (typeof dd !== 'undefined' && !!dd && typeof dd.showtoast === 'function');
    }
    function isAliMiniApp() {
        return (typeof my !== 'undefined' &&
            !!my &&
            (typeof my.showToast === 'function' || typeof my.navigateTo === 'function'));
    }
    function isByteDanceMicroApp$1() {
        return (typeof tt !== 'undefined' && !!tt && typeof tt.showtoast === 'function');
    }
    function isWeChatMiniProgram$1() {
        return (!isByteDanceMicroApp$1 &&
            typeof wx !== 'undefined' &&
            !!wx &&
            (typeof wx.login !== 'undefined' || typeof wx.miniProgram !== 'undefined'));
    }
    function getAliAppName() {
        var _a;
        var aliUA = getUA();
        var aliAppMatches = /.+AliApp\((\w+)\/((?:\d+\.)+\d+)\)/.exec(aliUA || '') || [];
        var app = (_a = aliAppMatches[1]) === null || _a === void 0 ? void 0 : _a.toLocaleLowerCase();
        return app || '';
    }
    function isTm$1() {
        var app = getAliAppName();
        return app === 'tm';
    }
    function isTb$1() {
        var app = getAliAppName();
        return app === 'tb';
    }
    function isAp$1() {
        var app = getAliAppName();
        return app === 'ap';
    }
    function isCn$1() {
        var app = getAliAppName();
        return app === 'cn';
    }
    function isAliYun$1() {
        var app = getAliAppName();
        return app === 'aliyun';
    }
    function isFm$1() {
        var app = getAliAppName();
        return app === 'fm';
    }
    function isRetail$1() {
        var app = getAliAppName();
        return app === 'retail';
    }
    function isRetailtrader$1() {
        var app = getAliAppName();
        return app === 'retailtrader';
    }
    function isXiongan$1() {
        var app = getAliAppName();
        return app === 'xiongan';
    }
    function isAwf$1() {
        var app = getAliAppName();
        return app === 'afw';
    }
    function isKb$1() {
        var app = getAliAppName();
        return app === 'kb';
    }
    function isAk$1() {
        var app = getAliAppName();
        return app === 'ak';
    }
    function isLt$1() {
        var app = getAliAppName();
        return app === 'lt';
    }
    function isNj$1() {
        var app = getAliAppName();
        return app === 'nj';
    }
    function isElmc$1() {
        var app = getAliAppName();
        return app === 'elmc';
    }
    function isIhome$1() {
        var app = getAliAppName();
        return app === 'ihome';
    }
    function isTphome$1() {
        var app = getAliAppName();
        return app === 'tphome';
    }
    function isAliwork$1() {
        var app = getAliAppName();
        return app === 'aliwork';
    }
    function isEt$1() {
        var app = getAliAppName();
        return app === 'et';
    }
    function isBk$1() {
        var app = getAliAppName();
        return app === 'bk';
    }
    function isLx$1() {
        var app = getAliAppName();
        return app === 'lx';
    }
    function isQn$1() {
        var app = getAliAppName();
        return app === 'qn';
    }
    function isCunpartner$1() {
        var app = getAliAppName();
        return app === 'cunpartner';
    }
    function isDingtalk() {
        var app = getAliAppName();
        return app === 'dingtalk';
    }
    function isWdkhema$1() {
        var app = getAliAppName();
        return app === 'wdkhema';
    }
    function isAh$1() {
        var app = getAliAppName();
        return app === 'ah';
    }
    function is1688() {
        var app = getAliAppName();
        return app === '1688';
    }
    function isMro$1() {
        var app = getAliAppName();
        return app === 'mro';
    }
    function isMicrosupply$1() {
        var app = getAliAppName();
        return app === 'microsupply';
    }
    var isAndroid$2 = aliUA$1.indexOf('Android') > -1 || aliUA$1.indexOf('Adr') > -1;
    var isIOS$2 = !!aliUA$1.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
    function isIphoneXSeries() {
        var deviceHeight = screen.height * window.devicePixelRatio;
        if (['2340', '2436', '2688', '1792', '1624', '2532', '2778'].indexOf(String(deviceHeight)) >= 0) {
            return true;
        }
    }

    var env$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        appName: appName,
        getAliAppName: getAliAppName,
        getUA: getUA,
        is1688: is1688,
        isAh: isAh$1,
        isAk: isAk$1,
        isAliMiniApp: isAliMiniApp,
        isAliYun: isAliYun$1,
        isAliwork: isAliwork$1,
        isAndroid: isAndroid$2,
        isAp: isAp$1,
        isAwf: isAwf$1,
        isBk: isBk$1,
        isByteDanceMicroApp: isByteDanceMicroApp$1,
        isCn: isCn$1,
        isCunpartner: isCunpartner$1,
        isDingTalk: isDingTalk$1,
        isDingTalkMiniApp: isDingTalkMiniApp,
        isDingTalkPC: isDingTalkPC$1,
        isDingtalk: isDingtalk,
        isElmc: isElmc$1,
        isEt: isEt$1,
        isFliggy: isFliggy$1,
        isFm: isFm$1,
        isIOS: isIOS$2,
        isIhome: isIhome$1,
        isIphoneXSeries: isIphoneXSeries,
        isKb: isKb$1,
        isLt: isLt$1,
        isLx: isLx$1,
        isMicrosupply: isMicrosupply$1,
        isMini: isMini$1,
        isMiniAli: isMiniAli$1,
        isMiniAp: isMiniAp,
        isMiniDingTalk: isMiniDingTalk,
        isMiniFm: isMiniFm,
        isMiniLx: isMiniLx,
        isMiniTb: isMiniTb,
        isMiniTm: isMiniTm,
        isMiniTt: isMiniTt$1,
        isMiniWx: isMiniWx$1,
        isMiniweb: isMiniweb$1,
        isMro: isMro$1,
        isNebula: isNebula$1,
        isNj: isNj$1,
        isQn: isQn$1,
        isQuickApp: isQuickApp$1,
        isRetail: isRetail$1,
        isRetailtrader: isRetailtrader$1,
        isTb: isTb$1,
        isTm: isTm$1,
        isTphome: isTphome$1,
        isWdkhema: isWdkhema$1,
        isWeChatMiniProgram: isWeChatMiniProgram$1,
        isWeb: isWeb$2,
        isWebAfw: isWebAfw,
        isWebAh: isWebAh,
        isWebAk: isWebAk,
        isWebAlipm: isWebAlipm,
        isWebAliwork: isWebAliwork,
        isWebAliyun: isWebAliyun,
        isWebAp: isWebAp,
        isWebAt: isWebAt,
        isWebBk: isWebBk,
        isWebCn: isWebCn,
        isWebCunpartner: isWebCunpartner,
        isWebDingTalk: isWebDingTalk,
        isWebDingTalkPC: isWebDingTalkPC,
        isWebElmc: isWebElmc,
        isWebEt: isWebEt,
        isWebFm: isWebFm,
        isWebIhome: isWebIhome,
        isWebKb: isWebKb,
        isWebLt: isWebLt,
        isWebLx: isWebLx,
        isWebNj: isWebNj,
        isWebQn: isWebQn,
        isWebRetail: isWebRetail,
        isWebRetailtrader: isWebRetailtrader,
        isWebTb: isWebTb,
        isWebTm: isWebTm,
        isWebTphome: isWebTphome,
        isWebWdkhema: isWebWdkhema,
        isWebXionganapp: isWebXionganapp,
        isWebXm: isWebXm,
        isWebYouku: isWebYouku,
        isWeex: isWeex$1,
        isWindvane: isWindvane$1,
        isXiongan: isXiongan$1
    });

    // @ali/uni-env再加工。菜鸟扩展的env放到config中
    // 方法转变量，调用者不迷惑：getXXX为方法，isXXX为变量
    var isTm = isTm$1();
    var isTb = isTb$1();
    var isAp = isAp$1();
    var isCn = isCn$1();
    var isAliYun = isAliYun$1();
    var isFm = isFm$1();
    var isRetail = isRetail$1();
    var isRetailtrader = isRetailtrader$1();
    var isXiongan = isXiongan$1();
    var isAwf = isAwf$1();
    var isKb = isKb$1();
    var isAk = isAk$1();
    var isLt = isLt$1();
    var isNj = isNj$1();
    var isElmc = isElmc$1();
    var isIhome = isIhome$1();
    var isTphome = isTphome$1();
    var isAliwork = isAliwork$1();
    var isEt = isEt$1();
    var isBk = isBk$1();
    var isLx = isLx$1();
    var isQn = isQn$1();
    var isCunpartner = isCunpartner$1();
    var isWdkhema = isWdkhema$1();
    var isAh = isAh$1();
    var isMro = isMro$1();
    var isMicrosupply = isMicrosupply$1();

    var uniEnv = /*#__PURE__*/Object.freeze({
        __proto__: null,
        getAliAppName: getAliAppName,
        appName: appName,
        getUA: getUA,
        isAndroid: isAndroid$2,
        isIOS: isIOS$2,
        isWeb: isWeb$2,
        isWindvane: isWindvane$1,
        isNebula: isNebula$1,
        isFliggy: isFliggy$1,
        isDingTalk: isDingTalk$1,
        isDingTalkPC: isDingTalkPC$1,
        isWeex: isWeex$1,
        isQuickApp: isQuickApp$1,
        isMiniDingTalk: isMiniDingTalk,
        isMiniAli: isMiniAli$1,
        isMiniTt: isMiniTt$1,
        isMiniWx: isMiniWx$1,
        isMiniAp: isMiniAp,
        isMiniTb: isMiniTb,
        isMiniTm: isMiniTm,
        isMiniFm: isMiniFm,
        isMiniLx: isMiniLx,
        isTm: isTm,
        isTb: isTb,
        isAp: isAp,
        isCn: isCn,
        isAliYun: isAliYun,
        isFm: isFm,
        isRetail: isRetail,
        isRetailtrader: isRetailtrader,
        isXiongan: isXiongan,
        isAwf: isAwf,
        isKb: isKb,
        isAk: isAk,
        isLt: isLt,
        isNj: isNj,
        isElmc: isElmc,
        isIhome: isIhome,
        isTphome: isTphome,
        isAliwork: isAliwork,
        isEt: isEt,
        isBk: isBk,
        isLx: isLx,
        isQn: isQn,
        isCunpartner: isCunpartner,
        isWdkhema: isWdkhema,
        isAh: isAh,
        isMro: isMro,
        isMicrosupply: isMicrosupply,
        isWebTm: isWebTm,
        isWebAliyun: isWebAliyun,
        isWebCn: isWebCn,
        isWebFm: isWebFm,
        isWebRetail: isWebRetail,
        isWebXionganapp: isWebXionganapp,
        isWebAfw: isWebAfw,
        isWebAp: isWebAp,
        isWebKb: isWebKb,
        isWebRetailtrader: isWebRetailtrader,
        isWebXm: isWebXm,
        isWebAk: isWebAk,
        isWebAt: isWebAt,
        isWebLt: isWebLt,
        isWebNj: isWebNj,
        isWebTb: isWebTb,
        isWebElmc: isWebElmc,
        isWebIhome: isWebIhome,
        isWebTphome: isWebTphome,
        isWebAliwork: isWebAliwork,
        isWebBk: isWebBk,
        isWebEt: isWebEt,
        isWebLx: isWebLx,
        isWebQn: isWebQn,
        isWebYouku: isWebYouku,
        isWebWdkhema: isWebWdkhema,
        isWebCunpartner: isWebCunpartner,
        isWebDingTalk: isWebDingTalk,
        isWebAh: isWebAh,
        isWebAlipm: isWebAlipm,
        isWebDingTalkPC: isWebDingTalkPC
    });

    var isWeb$1 = typeof window !== 'undefined' && 'onload' in window;
    var isNode = typeof process !== 'undefined' && !!(process.versions && process.versions.node);
    var isWeex = typeof WXEnvironment !== 'undefined' && WXEnvironment.platform !== 'Web';
    var isKraken = typeof __kraken__ !== 'undefined';
    var isMiniApp = typeof my !== 'undefined' && my !== null && typeof my.alert !== 'undefined';
    var isByteDanceMicroApp = typeof tt !== 'undefined' && tt !== null && typeof tt.showToast !== 'undefined';
    var isBaiduSmartProgram = typeof swan !== 'undefined' && swan !== null && typeof swan.showToast !== 'undefined';
    var isKuaiShouMiniProgram = typeof ks !== 'undefined' && ks !== null && typeof ks.showToast !== 'undefined'; // In wechat mini program, wx.login is a function
    // In wechat mini propgram webview, there is no wx.login, but exist wx.miniProgram
    // In bytedance maicro app, there is wx variable.
    // In kuaishou mini program, there is wx variable.

    var isWeChatMiniProgram = !isByteDanceMicroApp && typeof wx !== 'undefined' && wx !== null && (typeof wx.request !== 'undefined' || typeof wx.miniProgram !== 'undefined');
    var isQuickApp = typeof global !== 'undefined' && global !== null && typeof global.callNative !== 'undefined' && !isWeex;
    var isPHA = isWeb$1 && typeof pha === 'object';
    var isFRM = isMiniApp && isWeb$1 && my.isFRM; // WindVane.call is a function while page importing windvane.js

    var ua$1 = typeof navigator === 'object' ? navigator.userAgent || navigator.swuserAgent : '';
    var isWindVane = /.+AliApp\((\w+)\/((?:\d+\.)+\d+)\).* .*(WindVane)(?:\/((?:\d+\.)+\d+))?.*/.test(ua$1) && isWeb$1 && typeof WindVane !== 'undefined' && typeof WindVane.call !== 'undefined';
    var index$1 = {
      isWeb: isWeb$1,
      isNode: isNode,
      isWeex: isWeex,
      isKraken: isKraken,
      isMiniApp: isMiniApp,
      isByteDanceMicroApp: isByteDanceMicroApp,
      isBaiduSmartProgram: isBaiduSmartProgram,
      isKuaiShouMiniProgram: isKuaiShouMiniProgram,
      isWeChatMiniProgram: isWeChatMiniProgram,
      isQuickApp: isQuickApp,
      isPHA: isPHA,
      isWindVane: isWindVane,
      isFRM: isFRM
    };

    var es = /*#__PURE__*/Object.freeze({
        __proto__: null,
        isWeb: isWeb$1,
        isNode: isNode,
        isWeex: isWeex,
        isKraken: isKraken,
        isMiniApp: isMiniApp,
        isByteDanceMicroApp: isByteDanceMicroApp,
        isBaiduSmartProgram: isBaiduSmartProgram,
        isKuaiShouMiniProgram: isKuaiShouMiniProgram,
        isWeChatMiniProgram: isWeChatMiniProgram,
        isQuickApp: isQuickApp,
        isPHA: isPHA,
        isFRM: isFRM,
        isWindVane: isWindVane,
        'default': index$1
    });

    /**
     * ua 方便使用。
     * 1. web环境，ua=window.navigator.userAgent;
     * 2. mini环境，ua=window.navigator.swuserAgent;
     */
    var ua = getUA();
    /**
     * 1. App判断。（使用场景：web和小程序内都可用）
     */
    var isWechat = ua.includes('MicroMessenger');
    var isTbLive = appName === 'taobaoliveapp';
    var isAli1688 = appName === '1688';
    // 在Android端，唯一的ua叫cnstation；在Ios端，唯一的ua叫postoffice
    var isCnStation = ['postoffice', 'cnstation'].includes(appName);
    // 驿站通，跟驿站掌柜JSBridge对齐
    var isCnNetCom = appName === 'netcom';
    var isCnBgx = appName === 'bgx';
    /**
     * 2. Mini小程序（使用场景：axml原生小程序或类tora小程序框架内用）
     */
    // IDE（原则：先严格，再有新的再扩展）
    var isMiniTbIDE = isMiniAli$1 && ua.includes('Taobao') && ua.includes('AlipayIDE');
    var isMiniApIDE = isMiniAli$1 && ua.includes('AlipayClient') && ua.includes('AlipayIDE');
    var isMiniDingTalkIDE = isMiniAli$1 && ua.includes('DingTalkIDE') && ua.includes('AlipayIDE');
    /**
     * 3. miniweb：小程序内嵌webview（使用场景：web中用）
     */
    var isMiniwebDingTalk = isWeb$2 && // TODO: isMiniweb有bug，暂时换为isWeb。需要多真机看下UA是否都是MiniProgram
        isDingTalk$1 &&
        // 钉钉小程序web-view组件，ios端注入dd-web，需要特殊处理,所以ua判断使用MiniPrograme。https://yuque.antfin-inc.com/dingtalk-miniprogram/faq/cwva6h?view=
        ((isIOS$2 && ua.indexOf('dd-web') > -1) || ua.indexOf('MiniProgram') > -1);
    /**
     * 真机ua示例：
     * Mozilla/5.0 (iPhone; CPU iPhone os 16_3_1 like Mac OS X) AppleWebKit/605.1.15
     *  (KHTML, like Gecko) Mobile/15E148 MicroMessenger/8.0.32(0x18002035) NetType/WIFI
     *  Language/zh_CN miniProgram/wx795bd500b21f8fee
     */
    var isMiniwebWechat = isMiniweb$1 && isWechat;
    var isMiniwebAli = isMiniweb$1 && !isMiniwebWechat;
    // 若官方 env(https://yuque.antfin-inc.com/multix/api/rgp412) 未实现 isWindvane,
    // 则需扩展时进行补充, 补充格式: is + 环境首字母大写(如：Windvane)
    /**
     * 扩展的env环境
     * 自定义环境变量，区分“包裹侠” & '驿站掌柜'等
     * isWeb: 只是判断是否在window环境中,而不管是在App内的浏览器还是App外的浏览器。主要是针对原生小程序这种没有window onload环境的情况做区别。
     *
     * 当前已识别的匹配关系：
     * tb 淘宝
     * tbLive 点淘(即淘宝直播独立App)
     * nubula 支付宝
     * cn 菜鸟
     * fm 闲鱼
     * cnStation 菜鸟驿站掌柜
     * browser 浏览器（无容器），比如电脑端的浏览器环境, 手机中原生 safari chrome 等。
     */
    var extendEnv = {
        /**
         * 驿站掌柜App
         */
        isCnStation: isCnStation,
        /**
         * 菜鸟驿站通App
         */
        isCnNetCom: isCnNetCom,
        /** 菜鸟包裹侠App */
        isCnBgx: isCnBgx,
        /** 1688 App */
        isAli1688: isAli1688,
        /** 点淘App，是淘宝直播团队新做的App,基于Windvane容器 */
        isTbLive: isTbLive,
        /** 微信App */
        isWechat: isWechat,
        /**
         * 纯浏览器，无任何容器
         * 除webview外的浏览器，比如电脑端的浏览器环境, 手机中原生 safari chrome 等
         */
        isBrowser: isWeb$2 && !appName,
        /** 小程序环境。isMini支持了阿里系、微信、头条小程序、【新】百度小程序、快手小程序。【待支持】钉钉小程序 */
        isMini: isMini$1 || isBaiduSmartProgram || isKuaiShouMiniProgram,
        /** 百度小程序 */
        isMiniBd: isBaiduSmartProgram,
        /** 快手小程序 */
        isMiniKs: isKuaiShouMiniProgram,
        /** 是否是小程序IDE环境。包含：O2 IDE、支付宝-小程序开发者工具IDE */
        isMiniIDE: isMiniTbIDE || isMiniApIDE || isMiniDingTalkIDE,
        /**
         * 是否淘宝的IDE - O2 环境
         * 请验证后使用，O2经常更新
         */
        isMiniTbIDE: isMiniTbIDE,
        // 扩展小程序内webview。
        /**
         * 小程序内嵌 Webview 环境。
         * isMiniweb支持了阿里小程序、微信小程序，【新】钉钉小程序
         */
        isMiniweb: isMiniweb$1 || isMiniwebDingTalk,
        /**
         * 扩展钉钉小程序内嵌web-view。
         * by 钉钉jssdk源码：git@gitlab.alibaba-inc.com:dingding/dingtalk-jsapi.git
         */
        isMiniwebDingTalk: isMiniwebDingTalk,
        /** 微信小程序内嵌web-view */
        isMiniwebWechat: isMiniwebWechat,
        /** 阿里小程序内嵌web-view */
        isMiniwebAli: isMiniwebAli,
    };

    var Version = /** @class */ (function () {
        function Version(v) {
            this.val = v.toString();
            if (!this.val.match(/^([^.]+\.)*[^.]+$/) ||
                this.val.match(/^[^\d\w]|\.[^\d\w]|[^\d\w]$/i)) {
                console.error('invalid version');
            }
        }
        Version.compare = function (v1, v2) {
            var val1 = v1.toString().split('.');
            var val2 = v2.toString().split('.');
            for (var i = 0; i < val1.length || i < val2.length; i += 1) {
                var n1 = parseInt(val1[i], 10);
                var n2 = parseInt(val2[i], 10);
                if (Number.isNaN(n1)) {
                    n1 = 0;
                }
                if (Number.isNaN(n2)) {
                    n2 = 0;
                }
                if (n1 < n2) {
                    return -1;
                }
                if (n1 > n2) {
                    return 1;
                }
            }
            return 0;
        };
        /**
         * 当前app版本是否大于（>）传入的版本号
         *
         * @param  {string | number} v 传入的对比
         * @returns {boolean}
         */
        Version.prototype.gt = function (v) {
            return Version.compare(this.val, v) > 0;
        };
        /**
         * 当前app版本是否大于等于（>=）传入的版本号
         *
         * @param  {string | number} v 传入的对比
         * @returns {boolean}
         */
        Version.prototype.gte = function (v) {
            return Version.compare(this.val, v) >= 0;
        };
        /**
         * 当前app版本是否小于（<）传入的版本号
         *
         * @param  {string | number} v 传入的对比
         * @returns {boolean}
         */
        Version.prototype.lt = function (v) {
            return Version.compare(this.val, v) < 0;
        };
        /**
         * 当前app版本是否小于等于（<=）传入的版本号
         *
         * @param  {string | number} v 传入的对比
         * @returns {boolean}
         */
        Version.prototype.lte = function (v) {
            return Version.compare(this.val, v) <= 0;
        };
        /**
         * 当前app版本是否等于（=）传入的版本号
         *
         * @param  {string | number} v 传入的对比
         * @returns {boolean}
         */
        Version.prototype.eq = function (v) {
            return Version.compare(this.val, v) === 0;
        };
        /**
         * 当前app版本号
         */
        Version.prototype.toString = function () {
            return this.val;
        };
        return Version;
    }());
    var getVersion = function () {
        var ua = getUA();
        var execResult = /aliapp\([\w-]+\/([\d.]+)\)/i.exec(ua);
        if (!execResult) {
            return null;
        }
        var version = execResult && execResult[1] ? execResult[1] : '';
        return new Version(version);
    };
    /**
     * version 实例，只在阿里系 App 中才能获取到
     *
     * @example
     * ```js
     * version.toString() // 获取当前版本
     * version.gt('1.0.0') // 当前环境app版本大于1.0版本
     * version.lt('1.0.0') // 当前环境app版本小于1.0版本
     * version.gte('1.0.0') // 当前环境app版本大于等于1.0版本
     * ```
     */
    var version$2 = getVersion();

    /**
     * 判端环境
     * 主要原理是根据ua和注入的参数可确定。
     * @example 使用案例：
     * import { env } from '@alife/cn-uni-api'; // h5、小程序通用包
     *
     * // 淘系
     * env.isTb // 淘宝
     * env.isTbLive // 点淘App
     * env.isFm // 咸鱼
     * env.isAli1688 // 1688
     *
     * // 支付宝系
     * env.isAp
     *
     * // 菜鸟系
     * env.isCn // 菜鸟
     * env.isCnStation // 菜鸟驿站掌柜App
     * env.isMiniwebDingTalk // 钉钉小程序内嵌webview（如驿站盘古）
     *
     * // 小程序容器。包含阿里系、头条、微信、快手、百度小程序。
     * env.isMini
     *
     * // 小程序内嵌webview容器
     * env.isMiniweb
     *
     * // 纯浏览器
     * env.isBrowser
     *
     * @author 敬文
     */
    var env = __assign$1(__assign$1(__assign$1({}, uniEnv), extendEnv), { // 扩展菜鸟
        /** app版本（根据ua获得） */
        version: version$2 });

    var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

    function getDefaultExportFromCjs (x) {
    	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
    }

    function getAugmentedNamespace(n) {
    	if (n.__esModule) return n;
    	var a = Object.defineProperty({}, '__esModule', {value: true});
    	Object.keys(n).forEach(function (k) {
    		var d = Object.getOwnPropertyDescriptor(n, k);
    		Object.defineProperty(a, k, d.get ? d : {
    			enumerable: true,
    			get: function () {
    				return n[k];
    			}
    		});
    	});
    	return a;
    }

    function createCommonjsModule(fn) {
      var module = { exports: {} };
    	return fn(module, module.exports), module.exports;
    }

    /**
     * lodash (Custom Build) <https://lodash.com/>
     * Build: `lodash modularize exports="npm" -o ./`
     * Copyright jQuery Foundation and other contributors <https://jquery.org/>
     * Released under MIT license <https://lodash.com/license>
     * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
     * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
     */

    /** Used as the `TypeError` message for "Functions" methods. */
    var FUNC_ERROR_TEXT = 'Expected a function';

    /** Used to stand-in for `undefined` hash values. */
    var HASH_UNDEFINED = '__lodash_hash_undefined__';

    /** Used as references for various `Number` constants. */
    var INFINITY = 1 / 0;

    /** `Object#toString` result references. */
    var funcTag = '[object Function]',
        genTag = '[object GeneratorFunction]',
        symbolTag = '[object Symbol]';

    /** Used to match property names within property paths. */
    var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
        reIsPlainProp = /^\w*$/,
        reLeadingDot = /^\./,
        rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

    /**
     * Used to match `RegExp`
     * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
     */
    var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

    /** Used to match backslashes in property paths. */
    var reEscapeChar = /\\(\\)?/g;

    /** Used to detect host constructors (Safari). */
    var reIsHostCtor = /^\[object .+?Constructor\]$/;

    /** Detect free variable `global` from Node.js. */
    var freeGlobal = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;

    /** Detect free variable `self`. */
    var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

    /** Used as a reference to the global object. */
    var root = freeGlobal || freeSelf || Function('return this')();

    /**
     * Gets the value at `key` of `object`.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */
    function getValue(object, key) {
      return object == null ? undefined : object[key];
    }

    /**
     * Checks if `value` is a host object in IE < 9.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
     */
    function isHostObject(value) {
      // Many host objects are `Object` objects that can coerce to strings
      // despite having improperly defined `toString` methods.
      var result = false;
      if (value != null && typeof value.toString != 'function') {
        try {
          result = !!(value + '');
        } catch (e) {}
      }
      return result;
    }

    /** Used for built-in method references. */
    var arrayProto = Array.prototype,
        funcProto = Function.prototype,
        objectProto = Object.prototype;

    /** Used to detect overreaching core-js shims. */
    var coreJsData = root['__core-js_shared__'];

    /** Used to detect methods masquerading as native. */
    var maskSrcKey = (function() {
      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
      return uid ? ('Symbol(src)_1.' + uid) : '';
    }());

    /** Used to resolve the decompiled source of functions. */
    var funcToString = funcProto.toString;

    /** Used to check objects for own properties. */
    var hasOwnProperty = objectProto.hasOwnProperty;

    /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */
    var objectToString = objectProto.toString;

    /** Used to detect if a method is native. */
    var reIsNative = RegExp('^' +
      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
    );

    /** Built-in value references. */
    var Symbol$1 = root.Symbol,
        splice = arrayProto.splice;

    /* Built-in method references that are verified to be native. */
    var Map = getNative(root, 'Map'),
        nativeCreate = getNative(Object, 'create');

    /** Used to convert symbols to primitives and strings. */
    var symbolProto = Symbol$1 ? Symbol$1.prototype : undefined,
        symbolToString = symbolProto ? symbolProto.toString : undefined;

    /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Hash(entries) {
      var index = -1,
          length = entries ? entries.length : 0;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */
    function hashClear() {
      this.__data__ = nativeCreate ? nativeCreate(null) : {};
    }

    /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function hashDelete(key) {
      return this.has(key) && delete this.__data__[key];
    }

    /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function hashGet(key) {
      var data = this.__data__;
      if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
      }
      return hasOwnProperty.call(data, key) ? data[key] : undefined;
    }

    /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function hashHas(key) {
      var data = this.__data__;
      return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
    }

    /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */
    function hashSet(key, value) {
      var data = this.__data__;
      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
      return this;
    }

    // Add methods to `Hash`.
    Hash.prototype.clear = hashClear;
    Hash.prototype['delete'] = hashDelete;
    Hash.prototype.get = hashGet;
    Hash.prototype.has = hashHas;
    Hash.prototype.set = hashSet;

    /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function ListCache(entries) {
      var index = -1,
          length = entries ? entries.length : 0;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */
    function listCacheClear() {
      this.__data__ = [];
    }

    /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function listCacheDelete(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        return false;
      }
      var lastIndex = data.length - 1;
      if (index == lastIndex) {
        data.pop();
      } else {
        splice.call(data, index, 1);
      }
      return true;
    }

    /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function listCacheGet(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      return index < 0 ? undefined : data[index][1];
    }

    /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function listCacheHas(key) {
      return assocIndexOf(this.__data__, key) > -1;
    }

    /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */
    function listCacheSet(key, value) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        data.push([key, value]);
      } else {
        data[index][1] = value;
      }
      return this;
    }

    // Add methods to `ListCache`.
    ListCache.prototype.clear = listCacheClear;
    ListCache.prototype['delete'] = listCacheDelete;
    ListCache.prototype.get = listCacheGet;
    ListCache.prototype.has = listCacheHas;
    ListCache.prototype.set = listCacheSet;

    /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function MapCache(entries) {
      var index = -1,
          length = entries ? entries.length : 0;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */
    function mapCacheClear() {
      this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
      };
    }

    /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function mapCacheDelete(key) {
      return getMapData(this, key)['delete'](key);
    }

    /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function mapCacheGet(key) {
      return getMapData(this, key).get(key);
    }

    /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function mapCacheHas(key) {
      return getMapData(this, key).has(key);
    }

    /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */
    function mapCacheSet(key, value) {
      getMapData(this, key).set(key, value);
      return this;
    }

    // Add methods to `MapCache`.
    MapCache.prototype.clear = mapCacheClear;
    MapCache.prototype['delete'] = mapCacheDelete;
    MapCache.prototype.get = mapCacheGet;
    MapCache.prototype.has = mapCacheHas;
    MapCache.prototype.set = mapCacheSet;

    /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */
    function assocIndexOf(array, key) {
      var length = array.length;
      while (length--) {
        if (eq(array[length][0], key)) {
          return length;
        }
      }
      return -1;
    }

    /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */
    function baseGet(object, path) {
      path = isKey(path, object) ? [path] : castPath(path);

      var index = 0,
          length = path.length;

      while (object != null && index < length) {
        object = object[toKey(path[index++])];
      }
      return (index && index == length) ? object : undefined;
    }

    /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */
    function baseIsNative(value) {
      if (!isObject$1(value) || isMasked(value)) {
        return false;
      }
      var pattern = (isFunction$1(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
      return pattern.test(toSource(value));
    }

    /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */
    function baseToString(value) {
      // Exit early for strings to avoid a performance hit in some environments.
      if (typeof value == 'string') {
        return value;
      }
      if (isSymbol(value)) {
        return symbolToString ? symbolToString.call(value) : '';
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast property path array.
     */
    function castPath(value) {
      return isArray$1(value) ? value : stringToPath(value);
    }

    /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */
    function getMapData(map, key) {
      var data = map.__data__;
      return isKeyable(key)
        ? data[typeof key == 'string' ? 'string' : 'hash']
        : data.map;
    }

    /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */
    function getNative(object, key) {
      var value = getValue(object, key);
      return baseIsNative(value) ? value : undefined;
    }

    /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */
    function isKey(value, object) {
      if (isArray$1(value)) {
        return false;
      }
      var type = typeof value;
      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
          value == null || isSymbol(value)) {
        return true;
      }
      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
        (object != null && value in Object(object));
    }

    /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */
    function isKeyable(value) {
      var type = typeof value;
      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
        ? (value !== '__proto__')
        : (value === null);
    }

    /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */
    function isMasked(func) {
      return !!maskSrcKey && (maskSrcKey in func);
    }

    /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */
    var stringToPath = memoize(function(string) {
      string = toString(string);

      var result = [];
      if (reLeadingDot.test(string)) {
        result.push('');
      }
      string.replace(rePropName, function(match, number, quote, string) {
        result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
      });
      return result;
    });

    /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */
    function toKey(value) {
      if (typeof value == 'string' || isSymbol(value)) {
        return value;
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to process.
     * @returns {string} Returns the source code.
     */
    function toSource(func) {
      if (func != null) {
        try {
          return funcToString.call(func);
        } catch (e) {}
        try {
          return (func + '');
        } catch (e) {}
      }
      return '';
    }

    /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */
    function memoize(func, resolver) {
      if (typeof func != 'function' || (resolver && typeof resolver != 'function')) {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var memoized = function() {
        var args = arguments,
            key = resolver ? resolver.apply(this, args) : args[0],
            cache = memoized.cache;

        if (cache.has(key)) {
          return cache.get(key);
        }
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result);
        return result;
      };
      memoized.cache = new (memoize.Cache || MapCache);
      return memoized;
    }

    // Assign cache to `_.memoize`.
    memoize.Cache = MapCache;

    /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */
    function eq(value, other) {
      return value === other || (value !== value && other !== other);
    }

    /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */
    var isArray$1 = Array.isArray;

    /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */
    function isFunction$1(value) {
      // The use of `Object#toString` avoids issues with the `typeof` operator
      // in Safari 8-9 which returns 'object' for typed array and other constructors.
      var tag = isObject$1(value) ? objectToString.call(value) : '';
      return tag == funcTag || tag == genTag;
    }

    /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */
    function isObject$1(value) {
      var type = typeof value;
      return !!value && (type == 'object' || type == 'function');
    }

    /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */
    function isObjectLike(value) {
      return !!value && typeof value == 'object';
    }

    /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */
    function isSymbol(value) {
      return typeof value == 'symbol' ||
        (isObjectLike(value) && objectToString.call(value) == symbolTag);
    }

    /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */
    function toString(value) {
      return value == null ? '' : baseToString(value);
    }

    /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */
    function get(object, path, defaultValue) {
      var result = object == null ? undefined : baseGet(object, path);
      return result === undefined ? defaultValue : result;
    }

    var lodash_get = get;

    /**
     * 安全 JSON.parse
     *
     * @param {string} str 需要 JSON.parse 的字符串
     * @returns {object|null} JSON.parse 返回的值
     */
    var safeJSONParse = function (str) {
        try {
            return JSON.parse(str);
        }
        catch (error) {
            return null;
        }
    };

    /**
     * 从 CDN 加载 script
     * @param {string} url 资源路径
     * @param {number} retryTimes 重连次数
     * @param {number} maxRetryTimes 最大重连次数
     * @param {function} resolveCB 成功回调
     * @param {function} rejectCB 失败回调
     */
    function getScriptFromCDN(url, retryTimes, maxRetryTimes, resolveCB, rejectCB) {
        var doc = document;
        var head = doc.head || doc.getElementsByTagName('head')[0] || doc.documentElement;
        var node = doc.createElement('script');
        node.setAttribute('charset', 'utf-8');
        if ('onload' in node) {
            node.onload = function () {
                resolveCB === null || resolveCB === void 0 ? void 0 : resolveCB();
            };
            node.onerror = function () {
                if (retryTimes < maxRetryTimes) {
                    // 失败重连
                    // eslint-disable-next-line no-plusplus, no-param-reassign
                    retryTimes++;
                    getScriptFromCDN(url, retryTimes, maxRetryTimes, resolveCB, rejectCB);
                }
                else {
                    // 超过最大重连次数
                    rejectCB === null || rejectCB === void 0 ? void 0 : rejectCB();
                }
            };
        }
        else {
            // IE 浏览器
            // @ts-ignore
            node.onreadystatechange = function () {
                // @ts-ignore
                if (/loaded|complete/.test(node.readyState)) {
                    resolveCB === null || resolveCB === void 0 ? void 0 : resolveCB();
                }
            };
        }
        node.async = true;
        node.src = url;
        head.appendChild(node);
    }
    /** 重试次数 */
    var MAX_CDN_RESOURCE_RETRY_TIMES = 1;
    /**
     * 加载 scripts
     * @param {Array} libs 资源列表
     * @param {number} maxRetryTimes 最大重连次数
     * @returns {Promise}
     */
    function loadScripts(libs, maxRetryTimes) {
        if (maxRetryTimes === void 0) { maxRetryTimes = MAX_CDN_RESOURCE_RETRY_TIMES; }
        var promiseList = [];
        var _loop_1 = function (i) {
            var promise = new Promise(function (resolve, reject) {
                getScriptFromCDN(libs[i], 0, maxRetryTimes, resolve, reject);
            });
            promiseList.push(promise);
        };
        // eslint-disable-next-line no-plusplus
        for (var i = 0; i < libs.length; i++) {
            _loop_1(i);
        }
        return Promise.all(promiseList);
    }
    /**
     * 依次加载 scripts
     * @param {Array} libs 资源列表
     * @param {number} maxRetryTimes 最大重连次数
     * @returns {Promise}
     */
    function loadScriptsByOrder(libs, maxRetryTimes) {
        if (maxRetryTimes === void 0) { maxRetryTimes = MAX_CDN_RESOURCE_RETRY_TIMES; }
        return __awaiter(this, void 0, void 0, function () {
            var promiseList, _loop_2, i;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        promiseList = [];
                        _loop_2 = function (i) {
                            var p;
                            return __generator(this, function (_b) {
                                switch (_b.label) {
                                    case 0: return [4 /*yield*/, new Promise(function (resolve, reject) {
                                            getScriptFromCDN(libs[i], 0, maxRetryTimes, resolve, reject);
                                        })];
                                    case 1:
                                        p = _b.sent();
                                        promiseList.push(p);
                                        return [2 /*return*/];
                                }
                            });
                        };
                        i = 0;
                        _a.label = 1;
                    case 1:
                        if (!(i < libs.length)) return [3 /*break*/, 4];
                        return [5 /*yield**/, _loop_2(i)];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3:
                        i++;
                        return [3 /*break*/, 1];
                    case 4: return [2 /*return*/, Promise.resolve(promiseList)];
                }
            });
        });
    }

    // TODO:上报错误机制
    var logError = console.trace;

    /**
     * Determines if a reference is a `String`.
     *
     * @param value Reference to check.
     */
    // 入参无法明确知道类型，此处使用any代替。下同
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function isString(value) {
        return typeof value === 'string';
    }
    /**
     * Determines if a reference is an `Array`.
     *
     * @param value Reference to check.
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function isArray(value) {
        return Array.isArray(value);
    }
    /**
     * Determines if a reference is a `Function`.
     *
     * @param value Reference to check.
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/ban-types
    function isFunction(value) {
        return typeof value === 'function';
    }

    /**
     * @description 延时
     * @param duration 毫秒 ms
     * @example
     * ```typescript
     *  await delay(2000);
     * ```
     */
    var delay = function (duration) {
        return new Promise(function (resolved) {
            setTimeout(function () {
                resolved('done');
            }, duration);
        });
    };

    /**
     * follow alipay mini program https://opendocs.alipay.com/mini/00nmrr
     * 错误码规范：https://alidocs.dingtalk.com/i/nodes/jQPRqwxd3NLWjlRdOAOzJYK6lrGM4795# 「错误码定义」
     */
    var ErrorCodes;
    (function (ErrorCodes) {
        ErrorCodes["ErrScanUserCancel"] = "10";
        /**
         * 暂不支持的端调用。
         * 命名6位数，防止与其他环境（一般5位数）的errorCode冲突
         */
        ErrorCodes["NotSupport"] = "100099";
        /** 按需加载失败 */
        ErrorCodes["DependError"] = "100098";
    })(ErrorCodes || (ErrorCodes = {}));
    /** 错误文案信息 */
    var ErrorMsgs;
    (function (ErrorMsgs) {
        ErrorMsgs["ErrMsgCommon"] = "call failed";
        ErrorMsgs["ErrMsgCancel"] = "user cancel";
    })(ErrorMsgs || (ErrorMsgs = {}));
    // 按需加载
    var AppxWebviewURL = 'https://appx/web-view.min.js';
    var PanguMiniAppTpPlusURL = 'https://g.alicdn.com/cn-yz/tp-plus/1.0.12/tp-plus-web.js';
    /** 容器依赖的jssdk */
    var BRIDGE_DEPEND_LIBS = {
        dingTalk: [
            'https://g.alicdn.com/dingding/dingtalk-jsapi/2.15.5/dingtalk.internal.js',
        ],
        miniWeb: [AppxWebviewURL],
        panguMiniApp: [AppxWebviewURL, PanguMiniAppTpPlusURL],
    };

    /** 增强fail，具备errSuccessFormatOptions能力 */
    function enhanceFail$1(fail, errFormatOptions) {
        if (fail === void 0) { fail = function (err) { return err; }; }
        if (errFormatOptions === void 0) { errFormatOptions = {}; }
        return function (e) {
            var formatOutput = errFormatOptions.formatOutput;
            var output = {};
            if (typeof formatOutput === 'function') {
                output = formatOutput(e);
            }
            output = __assign$1(__assign$1({}, e), output);
            fail === null || fail === void 0 ? void 0 : fail(__assign$1({ _originalErrInfo: e }, output));
        };
    }
    /** 增强success，具备formatOptions能力 */
    function enhanceSuccess$1(success, enhanceInputParams, successFormatOptions, errFormatOptions) {
        if (success === void 0) { success = function (res) { return res; }; }
        if (enhanceInputParams === void 0) { enhanceInputParams = {
            success: noop,
            fail: noop,
        }; }
        if (successFormatOptions === void 0) { successFormatOptions = {}; }
        if (errFormatOptions === void 0) { errFormatOptions = {}; }
        var formatOutput = successFormatOptions.formatOutput;
        return function (ret) {
            // 容器成功调用，但错误码失败: 依然作为错误处理
            if (ret && ret.error) {
                var onFail = enhanceFail$1(enhanceInputParams && (enhanceInputParams === null || enhanceInputParams === void 0 ? void 0 : enhanceInputParams.fail), errFormatOptions);
                onFail(ret);
                return;
            }
            // 成功调用
            var output = {};
            if (typeof formatOutput === 'function') {
                output = formatOutput(ret);
            }
            output = __assign$1(__assign$1({}, ret), output);
            success === null || success === void 0 ? void 0 : success(__assign$1(__assign$1({}, output), { _original: {
                    input: enhanceInputParams,
                    output: ret,
                } }));
        };
    }
    /**
     * 容器适配层。抹平差异，使得输入和输出参数统一化。
     * 同时配合cn-uni-api的extend机制，call调用统一返回promise
     */
    var adapterApiCall = function (args) {
        var apiName = args.apiName, params = args.params, JSCall = args.JSCall, _a = args.successFormatOptions, successFormatOptions = _a === void 0 ? {} : _a, _b = args.errFormatOptions, errFormatOptions = _b === void 0 ? {} : _b;
        var success = params.success, fail = params.fail;
        var formatInput = successFormatOptions.formatInput;
        // 入参format
        var extraParams = typeof formatInput === 'function' ? formatInput(params) : {};
        var enhanceInputParams = __assign$1(__assign$1({}, params), extraParams);
        // 出参format
        var onSuccess = enhanceSuccess$1(success, enhanceInputParams, successFormatOptions, errFormatOptions);
        var onFail = enhanceFail$1(fail, errFormatOptions);
        // 真正执行容器
        JSCall(apiName, enhanceInputParams, onSuccess, onFail);
    };
    // 空函数
    var noop = function (opts) { return opts; };

    var JSCall$4 = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var apiName = args[0], params = args[1], _a = args[2], success = _a === void 0 ? noop : _a, _b = args[3], failure = _b === void 0 ? noop : _b;
        var apiFunc = lodash_get(window, apiName);
        // 钉钉jssdk底层，传入对象方式
        apiFunc(__assign$1(__assign$1({}, params), { onSuccess: success, onFail: failure }));
    };
    /**
     * 钉钉端容器桥接
     * 钉钉SDK：https://open.dingtalk.com/document/orgapp-client/jsapi-overview
     * @param api
     * @param params
     * @param formatOptions
     * @param errFormatOptions
     */
    function DDCall() {
        /** 钉钉方法名 */
        var args = [];
        for (
        /** 钉钉方法名 */
        var _i = 0; 
        /** 钉钉方法名 */
        _i < arguments.length; 
        /** 钉钉方法名 */
        _i++) {
            /** 钉钉方法名 */
            args[_i] = arguments[_i];
        }
        var apiName = args[0], params = args[1], successFormatOptions = args[2], errFormatOptions = args[3];
        var callJsbridge = function () {
            adapterApiCall({
                apiName: apiName,
                params: params,
                JSCall: JSCall$4,
                successFormatOptions: successFormatOptions,
                errFormatOptions: errFormatOptions,
            });
        };
        // 按需加载
        if (typeof dd === 'undefined') {
            loadScripts(BRIDGE_DEPEND_LIBS.dingTalk)
                .then(function () {
                callJsbridge();
            })
                .catch(function () {
                var _a;
                (_a = params === null || params === void 0 ? void 0 : params.fail) === null || _a === void 0 ? void 0 : _a.call(params, {
                    errCode: ErrorCodes.DependError,
                    errMsg: 'dd lib script not download',
                });
            });
        }
        else {
            callJsbridge();
        }
    }

    /**
     * Windvane最底层执行，真正去调用容器能力
     */
    var JSCall$3 = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var apiName = args[0], params = args[1], _a = args[2], success = _a === void 0 ? noop : _a, _b = args[3], failure = _b === void 0 ? noop : _b;
        if (!__windvane__.call) {
            // TODO new Function 有风险，但未有好用的替代方案。此段代码copy自uni-api，风险可控。
            // eslint-disable-next-line @typescript-eslint/no-implied-eval,no-new-func
            new Function(__windvane__.windVaneCoreJs())();
        }
        __windvane__.call(apiName, params, success, failure);
    };
    /**
     * Windvane容器调用。
     * 跟promiseWindvane的区别，WVCall配合uni-api的extend机制，自动添加了success和fail的能力。
     * Windvane SDK：https://h5.alibaba-inc.com/api/WindVane-API.html
     */
    var WVCall$1 = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var apiName = args[0], params = args[1], successFormatOptions = args[2], errFormatOptions = args[3];
        adapterApiCall({
            apiName: apiName,
            params: params,
            JSCall: JSCall$3,
            successFormatOptions: successFormatOptions,
            errFormatOptions: errFormatOptions,
        });
    };

    var readyCall$1 = function (fn) {
        if (window['AlipayJSBridge']) {
            fn();
        }
        else {
            var _once_1 = function () {
                fn();
                document.removeEventListener('AlipayJSBridgeReady', _once_1, false);
            };
            document.addEventListener('AlipayJSBridgeReady', _once_1, false);
        }
    };
    var call$1 = function (api, options, success, failure) {
        if (typeof options === 'function') {
            failure = success;
            success = options;
            options = {};
        }
        readyCall$1(function () {
            AlipayJSBridge.call(api, options, success, failure);
        });
    };

    /**
     * Nebula容器调用。
     * 跟promiseNebula的区别，NBCall配合uni-api的extend机制，自动添加了success和fail的能力。
     * 支付宝SDK：https://smallfish.antfin-inc.com/jsapi/index.html
     */
    function NBCall$1() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var apiName = args[0], params = args[1], successFormatOptions = args[2], errFormatOptions = args[3];
        adapterApiCall({
            apiName: apiName,
            params: params,
            JSCall: call$1,
            successFormatOptions: successFormatOptions,
            errFormatOptions: errFormatOptions,
        });
    }

    var JSCall$2 = function () {
        var _a, _b;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var apiName = args[0], params = args[1], _c = args[2], success = _c === void 0 ? noop : _c, _d = args[3], failure = _d === void 0 ? noop : _d;
        var apiFunc = window.tpPlus.runBridgeFunction;
        try {
            (_b = (_a = apiFunc(apiName, params)) === null || _a === void 0 ? void 0 : _a.then(success)) === null || _b === void 0 ? void 0 : _b.catch(failure);
        }
        catch (e) {
            console.error(e);
            failure(e);
        }
    };
    /**
     * 老盘古端容器桥接
     * @param api
     * @param params
     * @param formatOptions
     * @param errFormatOptions
     */
    function PanguMiniAppCall() {
        /** 钉钉方法名 */
        var args = [];
        for (
        /** 钉钉方法名 */
        var _i = 0; 
        /** 钉钉方法名 */
        _i < arguments.length; 
        /** 钉钉方法名 */
        _i++) {
            /** 钉钉方法名 */
            args[_i] = arguments[_i];
        }
        var apiName = args[0], params = args[1], successFormatOptions = args[2], errFormatOptions = args[3];
        // 按需加载
        loadPanguMiniAppDependLibs()
            .then(function () {
            adapterApiCall({
                apiName: apiName,
                params: params,
                JSCall: JSCall$2,
                successFormatOptions: successFormatOptions,
                errFormatOptions: errFormatOptions,
            });
        })
            .catch(function () {
            var _a;
            (_a = params === null || params === void 0 ? void 0 : params.fail) === null || _a === void 0 ? void 0 : _a.call(params, {
                errCode: ErrorCodes.DependError,
                errMsg: 'pangu lib script not download',
            });
        });
    }
    /**
     * 依赖加载
     */
    var loadPanguMiniAppDependLibs = (function () {
        var cachePromise = null;
        return function () {
            if (cachePromise) {
                return cachePromise;
            }
            var promise = new Promise(function (resolve, reject) {
                if (typeof window.tpPlus === 'undefined') {
                    loadScriptsByOrder(BRIDGE_DEPEND_LIBS.panguMiniApp)
                        .then(function () {
                        resolve(window.tpPlus);
                        cachePromise = null;
                    })
                        .catch(function () {
                        reject();
                        cachePromise = null;
                    });
                }
                else {
                    resolve(window.tpPlus);
                }
            });
            cachePromise = promise;
            return promise;
        };
    })();

    var notSupport$1 = function (_a) {
        var fail = _a.fail;
        fail === null || fail === void 0 ? void 0 : fail({
            errCode: ErrorCodes.NotSupport,
            errMsg: 'not support',
        });
    };
    /**
     * 提供统一的promise规范能力。所有标准API，都返回promise
     * 能力扩展： promisify + context
     * TODO: context设计为插件，可供注入
     */
    function promisifyApi$1(apiFn, context) {
        // 这里嵌套深，为了代码可读性，先禁用这条eslint规则
        // eslint-disable-next-line arrow-body-style
        var promisify = function (fn) {
            return function (params) {
                return new Promise(function (resolve, reject) {
                    var success = function (e) {
                        // @ts-ignore 这里success是IOptions参数值，如果用户传入，则执行用户success
                        if (typeof (params === null || params === void 0 ? void 0 : params.success) === 'function') {
                            // @ts-ignore 同上
                            params === null || params === void 0 ? void 0 : params.success(e);
                        }
                        else {
                            resolve(e);
                        }
                    };
                    var fail = function (e) {
                        // @ts-ignore 这里fail是IOptions参数值，如果用户传入，则执行用户fail
                        if (typeof (params === null || params === void 0 ? void 0 : params.fail) === 'function') {
                            // @ts-ignore 同上
                            params.fail(e);
                        }
                        reject(e);
                        // 错误机制
                        logError(JSON.stringify(e));
                    };
                    // 增加fn能力，具备promise规范 + context能力
                    var promisifyApiParams = { success: success, fail: fail };
                    var enhanceParams = __assign$1(__assign$1({}, params), promisifyApiParams);
                    fn(enhanceParams, context);
                });
            };
        };
        var api = promisify(apiFn);
        return api;
    }

    // promisifyApi 扩展参数能力
    var injectPromisifyAndContextApi = function (api) {
        var context = {
            WVCall: WVCall$1,
            NBCall: NBCall$1,
            DDCall: DDCall,
            PanguMiniAppCall: PanguMiniAppCall,
        };
        return promisifyApi$1(api, context);
    };
    /**
     * 判端核心规则：使用对象{}方式，代替if else判端。
     * 原理是：使用递归对象 + 判端环境，优先匹配到环境后，执行对应环境的函数。如果都没匹配到，执行基础函数extendBaseFunction。
     * @param apiConfig 各端的对象{}，匹配上则执行。
     * @param extendBaseFunction 扩展的基础api，没匹配则执行该函数【可选】
     * @param envConfig 判端规则，代替if else
     * @returns
     */
    function register(apiConfig, extendBaseFunction, envConfig) {
        /**
         * 代码流程：
         * 1. 根据isXxx约定规则，找到端函数api。
         * 2. 把api，自动注入promisify和context能力。
         * 注意：api赋值是覆盖式。即当同时2个端符合env条件（一般不会发生），以最后1个端实现为准。
         */
        var api = null;
        Object.keys(apiConfig).forEach(function (client) {
            // @ts-ignore 同上TODO，apiConfig[client]定义合理类型？
            return traverseRecursively(client, apiConfig[client]);
        });
        //  优先级
        if (api) {
            return injectPromisifyAndContextApi(api);
        }
        if (extendBaseFunction) {
            return extendBaseFunction;
        }
        return injectPromisifyAndContextApi(notSupport$1);
        // @ts-ignore TODO envEntities定义合理类型？
        function traverseRecursively(key, envEntities) {
            var mergedEnv = __assign$1(__assign$1({}, env$1), envConfig);
            var envKey = key.replace(/^\S/, function (s) { return s.toUpperCase(); });
            // @ts-ignore 判端核心规则：根据is + 端名，将if 转为 apiConfig方式。TODO 找到好的方式解决TS类型
            var isEnv = mergedEnv["is".concat(envKey)];
            if (typeof isEnv === 'function' ? isEnv() : isEnv) {
                if (typeof envEntities === 'function') {
                    api = envEntities;
                    return;
                }
                if (envEntities) {
                    Object.keys(envEntities).forEach(function (nestKey) {
                        // first letter uppercase
                        var envNestKey = nestKey.replace(/^\S/, function (s) { return s.toUpperCase(); });
                        var entity = envEntities[nestKey];
                        // @ts-ignore 同上TODO
                        var isNestEnv = mergedEnv["is".concat(envNestKey)];
                        if (typeof isNestEnv === 'function' ? isNestEnv() : isNestEnv) {
                            traverseRecursively(nestKey, entity);
                        }
                    });
                }
            }
        }
    }

    var globalConfig = {
        isPanguMiniApp: false,
    };
    /**
     * 全局配置。
     * @deprecated 这个API可能将来去除，目前仅服务于盘古业务，用于区分标志。
     * @example 使用案例：
     * import { configuration } from '@alife/cn-uni-api'; // h5、小程序通用包
     *
     * configuration({ isPanguMiniApp: env.isMiniwebDingTalk })
     * @author 敬文
     */
    var configuration = function (config) {
        return Object.assign(globalConfig, config);
    };
    /**
     * 扩展设计：https://yuque.antfin.com/cn-xt/arch/vaa0vx#E1g4c
     * T 是统一的输入参数，R是内部统一的输出参数， K是用户自定义的输出参数
     * @example 使用案例：
     * import { extend } from '@alife/cn-uni-api'; // h5、小程序通用包
     *
     * // 定义跨端扩展函数
     * const loginBuc = extend<{name: string}>({
     *  web: {
     *      // 菜鸟App环境时，执行该方法
     *      cn: (options, context) => {},
     *
     *      // 淘宝App环境时，执行该方法
     *      tb: (options, context) => {},
     *  }
     * });
     *
     * // 使用跨端函数
     * loginBuc({ name: 'xxx' })
     *  .then(res => console.log(res))
     *  .catch(err => console.error(err));
     * @author 敬文
     */
    var extend = function (
    /** 扩展部分 */
    apiConfig, 
    /** 基础函数【可选】，一般是cn-uni-api里的API */
    extendUniAPI, 
    /** 判端环境【可选】，apiConfig参数执行依据 */
    extendEnv) {
        // 基础判端
        var clientEnv = __assign$1(__assign$1(__assign$1({}, env), { 
            /**
             * 老盘古。这里作为1个端去处理，业务上可能在2023年下半年（无定论）不再维护。
             * 满足条件（同时）1. 一定在钉钉小程序webview中（自动） 2. 用户手动设置isPanguMiniApp=true
             */
            isPanguMiniApp: env.isMiniwebDingTalk && (function () { return globalConfig.isPanguMiniApp === true; }) }), extendEnv);
        // 使用函数体，延迟执行判端
        return function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            // @ts-ignore TODO 没想到好的解法处理TS类型，暂时先忽略
            return register(apiConfig, extendUniAPI, clientEnv).apply(void 0, args);
        };
    };

    var getResumeCallBackData = function (e) {
        var _a;
        var data = lodash_get(e, 'param.backData') ||
            lodash_get(e, 'param.data.backData') ||
            lodash_get(e, 'param.data') ||
            lodash_get(e, 'data');
        return typeof data === 'string' ? (_a = safeJSONParse(data)) !== null && _a !== void 0 ? _a : data : data;
    };
    var getLocalStorage = function (key) {
        var _a, _b;
        var valueString = (_a = localStorage.getItem(key)) !== null && _a !== void 0 ? _a : '';
        var value = (_b = safeJSONParse(valueString)) !== null && _b !== void 0 ? _b : valueString;
        return value;
    };
    var setLocalStorage = function (key, value) {
        var stringValue = typeof value === 'string' ? value : JSON.stringify(value);
        localStorage.setItem(key, stringValue);
    };
    /**
     * 咸鱼端的onResume事件，由于端容器事件不带数据，所以需要使用localStorage进行数据传递
     */
    var RESUME_DATA_FOR_FM = '__RESUME_DATA_FOR_FM__';
    var getResumeDataForFm = function () { return getLocalStorage(RESUME_DATA_FOR_FM); };
    var saveResumeDataForFm = function (data) {
        setLocalStorage(RESUME_DATA_FOR_FM, data);
    };
    /**
     * 获取真正的url,发送给端jsbridge
     * 背景：https://alidocs.dingtalk.com/i/nodes/QjXmLRyz4G5VGkmnQ3ZzVZpaD19v6NK2# 「【navigateTo API】支持hash、history补全」
     * hash确定规则：1. isHash = true  或 2. url以 `#/`或`/#/`开头
     */
    var getRealWebUrl = function (options) {
        var _a;
        var _b = options !== null && options !== void 0 ? options : {}, _c = _b.url, url = _c === void 0 ? '' : _c, isHash = _b.isHash;
        var useHashUrl = typeof isHash === 'undefined' ? /^(\/)?#\//g.test(url) : isHash;
        if (useHashUrl) {
            var _d = (_a = window === null || window === void 0 ? void 0 : window.location) !== null && _a !== void 0 ? _a : {}, hash = _d.hash, href = _d.href;
            if (hash) {
                return href.replace(hash, url);
            }
            // 类似http://www.xx.xx 纯网址，此时hash值为''
            return href + url;
        }
        return url;
    };

    function navigateTo$9(params) {
        // 菜鸟APP Hybrid ref：https://alidocs.dingtalk.com/i/nodes/Mk5evdR04jBV59vnPj1dVQL3x2OlParn
        var handler = function (e) {
            var _a;
            (_a = params === null || params === void 0 ? void 0 : params.onResume) === null || _a === void 0 ? void 0 : _a.call(params, getResumeCallBackData(e));
            document.removeEventListener('pageResume', handler, false);
        };
        JSCall$3('CNHybridNavigator.registerComeBackHandler', {}, function () {
            document.addEventListener('pageResume', handler, false);
        });
        WVCall$1('CNHybridNavigator.openURL', params, {
            formatInput: function (input) {
                return {
                    // TODO: 考虑参数预处理机制，这样就不用在Web侧，每个端都相同处理一遍
                    url: getRealWebUrl(input),
                };
            },
        });
    }

    function navigateTo$8(params) {
        // 驿站掌柜：https://page.cainiao.com/cn-yz/cnyz-book/_book/api/navigation.html
        WVCall$1('WVNavUrls.openUrl', params, {
            formatInput: function (input) {
                return { url: getRealWebUrl(input) };
            },
        });
    }

    function navigateTo$7(params) {
        var handler = function (e) {
            var _a;
            (_a = params === null || params === void 0 ? void 0 : params.onResume) === null || _a === void 0 ? void 0 : _a.call(params, getResumeCallBackData(e));
            document.removeEventListener('WV.Event.APP.Active', handler, false);
        };
        document.addEventListener('WV.Event.APP.Active', handler, false);
        var formatInput = function (input) {
            var _a;
            return ({
                url: getRealWebUrl(input),
                popBeforeOpen: (_a = input.killSelf) !== null && _a !== void 0 ? _a : false,
            });
        };
        WVCall$1('WVNative.openWindow', params, { formatInput: formatInput });
    }

    function navigateTo$6(params) {
        var formatInput = function (input) {
            var _a;
            return ({
                url: getRealWebUrl(input),
                method: 'GET',
                closeAfterOpen: (_a = input.killSelf) !== null && _a !== void 0 ? _a : false,
            });
        };
        WVCall$1('AliWindow.open', params, { formatInput: formatInput });
    }

    function navigateTo$5(params) {
        var handler = function (e) {
            var _a, _b;
            (_a = params === null || params === void 0 ? void 0 : params.onResume) === null || _a === void 0 ? void 0 : _a.call(params, getResumeCallBackData((_b = getResumeDataForFm()) !== null && _b !== void 0 ? _b : e));
            document.removeEventListener('WV.Event.APP.Active', handler, false);
        };
        document.addEventListener('WV.Event.APP.Active', handler, false);
        var formatInput = function (input) {
            var _a;
            return ({
                url: getRealWebUrl(input),
                popBeforeOpen: (_a = input.killSelf) !== null && _a !== void 0 ? _a : false,
            });
        };
        WVCall$1('Base.openWindow', params, { formatInput: formatInput });
    }

    function navigateTo$4(params) {
        var handler = function (e) {
            var _a;
            (_a = params === null || params === void 0 ? void 0 : params.onResume) === null || _a === void 0 ? void 0 : _a.call(params, getResumeCallBackData(e));
            document.removeEventListener('resume', handler, false);
        };
        document.addEventListener('resume', handler, false);
        var formatInput = function (input) {
            var _a;
            return ({
                url: getRealWebUrl(input),
                param: {
                    closeCurrentWindow: (_a = input.killSelf) !== null && _a !== void 0 ? _a : false,
                },
            });
        };
        NBCall$1('pushWindow', params, { formatInput: formatInput });
    }

    function navigateTo$3(params, context) {
        var _a;
        var api = 'dd.biz.util.openLink';
        (_a = context.DDCall) === null || _a === void 0 ? void 0 : _a.call(context, api, params, {
            formatInput: function (input) {
                return { url: getRealWebUrl(input) };
            },
        });
    }

    function navigateTo$2(params, context) {
        var _a;
        var api = 'dd.biz.util.openSlidePanel';
        (_a = context.DDCall) === null || _a === void 0 ? void 0 : _a.call(context, api, params, {
            formatInput: function (input) {
                return { url: getRealWebUrl(input) };
            },
        });
    }

    function _extends$H() { _extends$H = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$H.apply(this, arguments); }

    function promisify$8(api) {
      return function (arg) {
        return new Promise(function (resolve, reject) {
          var promisifyArg = arg;
          api(_extends$H({}, promisifyArg, {
            success: function success(res) {
              if (promisifyArg && typeof promisifyArg.success === 'function') {
                promisifyArg.success(res);
              }

              resolve(res);
            },
            onSuccess: function onSuccess(res) {
              if (promisifyArg && typeof promisifyArg.onSuccess === 'function') {
                promisifyArg.onSuccess(res);
              }

              resolve(res);
            },
            fail: function fail(res) {
              if (promisifyArg && typeof promisifyArg.fail === 'function') {
                promisifyArg.fail(res);
              }

              reject(res);
            },
            onFail: function onFail(res) {
              if (promisifyArg && typeof promisifyArg.onFail === 'function') {
                promisifyArg.onFail(res);
              }

              reject(res);
            },
            complete: function complete(res) {
              if (promisifyArg && typeof promisifyArg.complete === 'function') {
                promisifyArg.complete(res);
              }
            },
            onComplete: function onComplete(res) {
              if (promisifyArg && typeof promisifyArg.onComplete === 'function') {
                promisifyArg.onComplete(res);
              }
            }
          }));
        });
      };
    }

    var _excluded$8 = ["_ext"];

    function _objectWithoutPropertiesLoose$8(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

    function _extends$G() { _extends$G = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$G.apply(this, arguments); }
    var styleIn$7 = function styleIn(options, baseName) {
      var _ref = options || {},
          _ref$_ext = _ref._ext,
          _ext = _ref$_ext === void 0 ? {} : _ref$_ext,
          rest = _objectWithoutPropertiesLoose$8(_ref, _excluded$8);

      return _extends$G({}, rest, _ext[baseName] || {});
    };

    var normalize$5 = {
      push: function push(api, containerName) {
        return function (options) {
          return promisify$8(api)(styleIn$7(options, containerName));
        };
      },
      back: function back(api, containerName) {
        return function (options) {
          return promisify$8(api)(styleIn$7(options, containerName));
        };
      },
      go: function go(api, containerName) {
        return function (options) {
          return promisify$8(api)(styleIn$7(options, containerName));
        };
      },
      replace: function replace(api, containerName) {
        return function (options) {
          return promisify$8(api)(styleIn$7(options, containerName));
        };
      },
      reLaunch: function reLaunch(api, containerName) {
        return function (options) {
          return promisify$8(api)(styleIn$7(options, containerName));
        };
      },
      switchTab: function switchTab(api, containerName) {
        return function (options) {
          return promisify$8(api)(styleIn$7(options, containerName));
        };
      }
    };

    var CONTAINER_NAME$7 = {
      WECHAT: 'wechatMiniProgram',
      ALIPAY: 'aliMiniApp',
      BYTE: 'bytedanceMicroApp',
      WEB: 'web',
      BAIDU: 'baiduSmartProgram',
      KWAI: 'kuaishouMiniProgram'
    };

    var go$6 = normalize$5.go(function (options) {
      var step = options.step,
          _success = options.success,
          _fail = options.fail,
          _complete = options.complete;

      if (step < 0) {
        my.navigateBack({
          delta: Math.abs(step),
          success: function success() {
            _success && _success();
          },
          fail: function fail(res) {
            _fail && _fail(res);
          },
          complete: function complete(res) {
            _complete && _complete(res);
          }
        });
      } else {
        _fail && _fail({
          errMsg: 'step不能大于或等于0'
        });
        _complete && _complete({
          errMsg: 'step不能大于或等于0'
        });
      }
    }, CONTAINER_NAME$7.ALIPAY);

    var back$f = normalize$5.back(function (options) {
      var _ref = options || {},
          _success = _ref.success,
          _fail = _ref.fail,
          _complete = _ref.complete;

      my.navigateBack({
        delta: 1,
        success: function success() {
          _success && _success();
        },
        fail: function fail(res) {
          _fail && _fail(res);
        },
        complete: function complete(res) {
          _complete && _complete(res);
        }
      });
    }, CONTAINER_NAME$7.ALIPAY);
    var back$g = back$f;

    var reLaunch$6 = normalize$5.reLaunch(function (options) {
      var url = options.url,
          _success = options.success,
          _fail = options.fail,
          _complete = options.complete;
      my.reLaunch({
        url: url,
        success: function success() {
          _success && _success();
        },
        fail: function fail(res) {
          _fail && _fail(res);
        },
        complete: function complete(res) {
          _complete && _complete(res);
        }
      });
    }, CONTAINER_NAME$7.ALIPAY);

    var replace$6 = normalize$5.replace(function (options) {
      var _ref = options || {},
          url = _ref.url,
          _success = _ref.success,
          _fail = _ref.fail,
          _complete = _ref.complete;

      my.redirectTo({
        url: url,
        success: function success() {
          _success && _success();
        },
        fail: function fail(res) {
          _fail && _fail(res);
        },
        complete: function complete(res) {
          _complete && _complete(res);
        }
      });
    }, CONTAINER_NAME$7.ALIPAY);

    var push$b = normalize$5.push(function (options) {
      var url = options.url,
          _success = options.success,
          _fail = options.fail,
          _complete = options.complete;
      my.navigateTo({
        url: url,
        success: function success() {
          _success && _success();
        },
        fail: function fail(res) {
          _fail && _fail(res);
        },
        complete: function complete(res) {
          _complete && _complete(res);
        }
      });
    }, CONTAINER_NAME$7.ALIPAY);
    var push$c = push$b;

    var switchTab$6 = normalize$5.switchTab(function (options) {
      my.switchTab(options);
    }, CONTAINER_NAME$7.ALIPAY);

    var aliMiniAppModule$b = {
      push: push$c,
      back: back$g,
      reLaunch: reLaunch$6,
      switchTab: switchTab$6,
      replace: replace$6,
      go: go$6
    };

    var go$5 = normalize$5.go(function (options) {
      var step = options.step,
          _success = options.success,
          _fail = options.fail,
          _complete = options.complete;

      if (step < 0) {
        wx.navigateBack({
          delta: Math.abs(step),
          success: function success() {
            _success && _success();
          },
          fail: function fail(res) {
            _fail && _fail(res);
          },
          complete: function complete(res) {
            _complete && _complete(res);
          }
        });
      } else {
        _fail && _fail({
          errMsg: 'step不能大于或等于0'
        });
        _complete && _complete({
          errMsg: 'step不能大于或等于0'
        });
      }
    }, CONTAINER_NAME$7.WECHAT);

    var back$d = normalize$5.back(function (options) {
      var _ref = options || {},
          _success = _ref.success,
          _fail = _ref.fail,
          _complete = _ref.complete;

      wx.navigateBack({
        delta: 1,
        success: function success() {
          _success && _success();
        },
        fail: function fail(res) {
          _fail && _fail(res);
        },
        complete: function complete(res) {
          _complete && _complete(res);
        }
      });
    }, CONTAINER_NAME$7.WECHAT);
    var back$e = back$d;

    var reLaunch$5 = normalize$5.reLaunch(function (options) {
      var url = options.url,
          _success = options.success,
          _fail = options.fail,
          _complete = options.complete;
      wx.reLaunch({
        url: url,
        success: function success() {
          _success && _success();
        },
        fail: function fail(res) {
          _fail && _fail(res);
        },
        complete: function complete(res) {
          _complete && _complete(res);
        }
      });
    }, CONTAINER_NAME$7.WECHAT);

    var replace$5 = normalize$5.replace(function (options) {
      var _ref = options || {},
          url = _ref.url,
          _success = _ref.success,
          _fail = _ref.fail,
          _complete = _ref.complete;

      wx.redirectTo({
        url: url,
        success: function success() {
          _success && _success();
        },
        fail: function fail(res) {
          _fail && _fail(res);
        },
        complete: function complete(res) {
          _complete && _complete(res);
        }
      });
    }, CONTAINER_NAME$7.WECHAT);

    var push$9 = normalize$5.push(function (options) {
      var url = options.url,
          _success = options.success,
          _fail = options.fail,
          _complete = options.complete;
      wx.navigateTo({
        url: url,
        success: function success() {
          _success && _success();
        },
        fail: function fail(res) {
          _fail && _fail(res);
        },
        complete: function complete(res) {
          _complete && _complete(res);
        }
      });
    }, CONTAINER_NAME$7.WECHAT);
    var push$a = push$9;

    var switchTab$5 = normalize$5.switchTab(function (options) {
      wx.switchTab(options);
    }, CONTAINER_NAME$7.WECHAT);

    var weChatModule$b = {
      push: push$a,
      back: back$e,
      reLaunch: reLaunch$5,
      switchTab: switchTab$5,
      replace: replace$5,
      go: go$5
    };

    var go$4 = normalize$5.go(function (options) {
      var step = options.step,
          _success = options.success,
          _fail = options.fail,
          _complete = options.complete;

      if (step < 0) {
        tt.navigateBack({
          delta: Math.abs(step),
          success: function success() {
            _success && _success();
          },
          fail: function fail(res) {
            _fail && _fail(res);
          },
          complete: function complete(res) {
            _complete && _complete(res);
          }
        });
      } else {
        _fail && _fail({
          errMsg: 'step不能大于或等于0'
        });
        _complete && _complete({
          errMsg: 'step不能大于或等于0'
        });
      }
    }, CONTAINER_NAME$7.BYTE);

    var back$b = normalize$5.back(function (options) {
      var _ref = options || {},
          _success = _ref.success,
          _fail = _ref.fail,
          _complete = _ref.complete;

      tt.navigateBack({
        delta: 1,
        success: function success() {
          _success && _success();
        },
        fail: function fail(res) {
          _fail && _fail(res);
        },
        complete: function complete(res) {
          _complete && _complete(res);
        }
      });
    }, CONTAINER_NAME$7.BYTE);
    var back$c = back$b;

    var reLaunch$4 = normalize$5.reLaunch(function (options) {
      var url = options.url,
          _success = options.success,
          _fail = options.fail,
          _complete = options.complete;
      tt.reLaunch({
        url: url,
        success: function success() {
          _success && _success();
        },
        fail: function fail(res) {
          _fail && _fail(res);
        },
        complete: function complete(res) {
          _complete && _complete(res);
        }
      });
    }, CONTAINER_NAME$7.BYTE);

    var replace$4 = normalize$5.replace(function (options) {
      var _ref = options || {},
          url = _ref.url,
          _success = _ref.success,
          _fail = _ref.fail,
          _complete = _ref.complete;

      tt.redirectTo({
        url: url,
        success: function success() {
          _success && _success();
        },
        fail: function fail(res) {
          _fail && _fail(res);
        },
        complete: function complete(res) {
          _complete && _complete(res);
        }
      });
    }, CONTAINER_NAME$7.BYTE);

    var push$7 = normalize$5.push(function (options) {
      var url = options.url,
          _success = options.success,
          _fail = options.fail,
          _complete = options.complete;
      tt.navigateTo({
        url: url,
        success: function success() {
          _success && _success();
        },
        fail: function fail(res) {
          _fail && _fail(res);
        },
        complete: function complete(res) {
          _complete && _complete(res);
        }
      });
    }, CONTAINER_NAME$7.BYTE);
    var push$8 = push$7;

    var switchTab$4 = normalize$5.switchTab(function (options) {
      tt.switchTab(options);
    }, CONTAINER_NAME$7.BYTE);

    var bytedanceModule$b = {
      push: push$8,
      back: back$c,
      reLaunch: reLaunch$4,
      switchTab: switchTab$4,
      replace: replace$4,
      go: go$4
    };

    var go$3 = normalize$5.go(function (options) {
      var step = options.step,
          success = options.success,
          fail = options.fail,
          complete = options.complete;

      if (step < 0) {
        setTimeout(function () {
          history.go(options.step);
          success && success();
          complete && complete();
        });
      } else {
        fail && fail({
          errMsg: 'step不能大于或等于0'
        });
        complete && complete({
          errMsg: 'step不能大于或等于0'
        });
      }
    }, CONTAINER_NAME$7.WEB);

    var back$9 = normalize$5.back(function (options) {
      var _ref = options || {},
          success = _ref.success,
          fail = _ref.fail,
          complete = _ref.complete;

      setTimeout(function () {
        try {
          history.go(-1);
          success && success();
          complete && complete();
        } catch (e) {
          fail && fail(e);
          complete && complete(e);
        }
      });
    }, CONTAINER_NAME$7.WEB);
    var back$a = back$9;

    var replace$3 = normalize$5.replace(function (options) {
      var _ref = options || {},
          url = _ref.url,
          _ref$isHash = _ref.isHash,
          isHash = _ref$isHash === void 0 ? false : _ref$isHash,
          _ref$refresh = _ref.refresh,
          refresh = _ref$refresh === void 0 ? true : _ref$refresh,
          success = _ref.success,
          fail = _ref.fail,
          complete = _ref.complete;

      var _url = isHash ? "/#" + url : url;

      setTimeout(function () {
        try {
          if ((url.indexOf('https://') !== -1 || url.indexOf('https://') !== -1) && url.indexOf(location.origin) === -1) {
            console.warn('Uni API: Replace does not support cross-domain');
            location.href = url;
            return;
          }

          if (isHash) {
            var _location = location,
                href = _location.href;
            var index = href.indexOf('#'); // 域名不变的情况下不会刷新页面

            window.location.replace(index > 0 ? href.slice(0, index) + "#" + url : href + "#" + url);
          } else {
            window.history.replaceState(null, null, _url);
            refresh && location.reload();
          }

          success && success();
          complete && complete();
        } catch (e) {
          fail && fail(e);
          complete && complete(e);
        }
      });
    }, CONTAINER_NAME$7.WEB);

    var reLaunch$3 = normalize$5.reLaunch(function (options) {
      var url = options.url,
          _options$isHash = options.isHash,
          isHash = _options$isHash === void 0 ? false : _options$isHash,
          _options$refresh = options.refresh,
          refresh = _options$refresh === void 0 ? true : _options$refresh,
          success = options.success,
          fail = options.fail,
          complete = options.complete;

      var _url = isHash ? "/#" + url : url;

      setTimeout(function () {
        try {
          history.go(-(history.length - 1));

          if ((url.indexOf('https://') !== -1 || url.indexOf('https://') !== -1) && url.indexOf(location.origin) === -1) {
            console.warn('Uni API: Relaunch does not support cross-domain');
            location.href = url;
            return;
          }

          if (isHash) {
            replace$3({
              url: url,
              isHash: true
            });
          } else {
            window.history.replaceState(null, null, _url);
            refresh && location.reload();
          }

          success && success();
          complete && complete();
        } catch (e) {
          fail && fail(e);
          complete && complete(e);
        }
      });
    }, CONTAINER_NAME$7.WEB);

    var push$5 = normalize$5.push(function (options) {
      var url = options.url,
          _options$isHash = options.isHash,
          isHash = _options$isHash === void 0 ? false : _options$isHash,
          _options$refresh = options.refresh,
          refresh = _options$refresh === void 0 ? true : _options$refresh,
          success = options.success,
          fail = options.fail,
          complete = options.complete;
      setTimeout(function () {
        try {
          if (isHash) {
            location.hash = "#" + url;
          } else if (refresh) {
            location.href = url;
          } else {
            var state = {
              page_id: 1
            };
            var title = '';
            history.pushState(state, title, url);
          }

          success && success();
          complete && complete();
        } catch (e) {
          fail && fail(e);
          complete && complete(e);
        }
      });
    }, CONTAINER_NAME$7.WEB);
    var push$6 = push$5;

    var switchTab$3 = normalize$5.switchTab(function () {
      throw new Error('@uni/apis: switchTab 不支持');
    }, CONTAINER_NAME$7.WEB);

    var webModule$b = {
      push: push$6,
      back: back$a,
      reLaunch: reLaunch$3,
      switchTab: switchTab$3,
      replace: replace$3,
      go: go$3
    };

    var go$2 = normalize$5.go(function (options) {
      var step = options.step,
          _success = options.success,
          _fail = options.fail,
          _complete = options.complete;

      if (step < 0) {
        ks.navigateBack({
          delta: Math.abs(step),
          success: function success() {
            _success && _success();
          },
          fail: function fail(res) {
            _fail && _fail(res);
          },
          complete: function complete(res) {
            _complete && _complete(res);
          }
        });
      } else {
        _fail && _fail({
          errMsg: 'step不能大于或等于0'
        });
        _complete && _complete({
          errMsg: 'step不能大于或等于0'
        });
      }
    }, CONTAINER_NAME$7.KWAI);

    var back$7 = normalize$5.back(function (options) {
      var _ref = options || {},
          _success = _ref.success,
          _fail = _ref.fail,
          _complete = _ref.complete;

      ks.navigateBack({
        delta: 1,
        success: function success() {
          _success && _success();
        },
        fail: function fail(res) {
          _fail && _fail(res);
        },
        complete: function complete(res) {
          _complete && _complete(res);
        }
      });
    }, CONTAINER_NAME$7.KWAI);
    var back$8 = back$7;

    var reLaunch$2 = normalize$5.reLaunch(function (options) {
      var url = options.url,
          _success = options.success,
          _fail = options.fail,
          _complete = options.complete;
      ks.reLaunch({
        url: url,
        success: function success() {
          _success && _success();
        },
        fail: function fail(res) {
          _fail && _fail(res);
        },
        complete: function complete(res) {
          _complete && _complete(res);
        }
      });
    }, CONTAINER_NAME$7.KWAI);

    var replace$2 = normalize$5.replace(function (options) {
      var _ref = options || {},
          url = _ref.url,
          _success = _ref.success,
          _fail = _ref.fail,
          _complete = _ref.complete;

      ks.redirectTo({
        url: url,
        success: function success() {
          _success && _success();
        },
        fail: function fail(res) {
          _fail && _fail(res);
        },
        complete: function complete(res) {
          _complete && _complete(res);
        }
      });
    }, CONTAINER_NAME$7.KWAI);

    var push$3 = normalize$5.push(function (options) {
      var url = options.url,
          _success = options.success,
          _fail = options.fail,
          _complete = options.complete;
      ks.navigateTo({
        url: url,
        success: function success() {
          _success && _success();
        },
        fail: function fail(res) {
          _fail && _fail(res);
        },
        complete: function complete(res) {
          _complete && _complete(res);
        }
      });
    }, CONTAINER_NAME$7.KWAI);
    var push$4 = push$3;

    var switchTab$2 = normalize$5.switchTab(function (options) {
      ks.switchTab(options);
    }, CONTAINER_NAME$7.KWAI);

    var kuaiShouModule$9 = {
      push: push$4,
      back: back$8,
      reLaunch: reLaunch$2,
      switchTab: switchTab$2,
      replace: replace$2,
      go: go$2
    };

    var go$1 = normalize$5.go(function (options) {
      var step = options.step,
          _success = options.success,
          _fail = options.fail,
          _complete = options.complete;

      if (step < 0) {
        swan.navigateBack({
          delta: Math.abs(step),
          success: function success() {
            _success && _success();
          },
          fail: function fail(res) {
            _fail && _fail(res);
          },
          complete: function complete(res) {
            _complete && _complete(res);
          }
        });
      } else {
        _fail && _fail({
          errMsg: 'step不能大于或等于0'
        });
        _complete && _complete({
          errMsg: 'step不能大于或等于0'
        });
      }
    }, CONTAINER_NAME$7.BAIDU);

    var back$5 = normalize$5.back(function (options) {
      var _ref = options || {},
          _success = _ref.success,
          _fail = _ref.fail,
          _complete = _ref.complete;

      swan.navigateBack({
        delta: 1,
        success: function success() {
          _success && _success();
        },
        fail: function fail(res) {
          _fail && _fail(res);
        },
        complete: function complete(res) {
          _complete && _complete(res);
        }
      });
    }, CONTAINER_NAME$7.BAIDU);
    var back$6 = back$5;

    var reLaunch$1 = normalize$5.reLaunch(function (options) {
      var url = options.url,
          _success = options.success,
          _fail = options.fail,
          _complete = options.complete;
      swan.reLaunch({
        url: url,
        success: function success() {
          _success && _success();
        },
        fail: function fail(res) {
          _fail && _fail(res);
        },
        complete: function complete(res) {
          _complete && _complete(res);
        }
      });
    }, CONTAINER_NAME$7.BAIDU);

    var replace$1 = normalize$5.replace(function (options) {
      var _ref = options || {},
          url = _ref.url,
          _success = _ref.success,
          _fail = _ref.fail,
          _complete = _ref.complete;

      swan.redirectTo({
        url: url,
        success: function success() {
          _success && _success();
        },
        fail: function fail(res) {
          _fail && _fail(res);
        },
        complete: function complete(res) {
          _complete && _complete(res);
        }
      });
    }, CONTAINER_NAME$7.BAIDU);

    var push$1 = normalize$5.push(function (options) {
      var url = options.url,
          _success = options.success,
          _fail = options.fail,
          _complete = options.complete;
      swan.navigateTo({
        url: url,
        success: function success() {
          _success && _success();
        },
        fail: function fail(res) {
          _fail && _fail(res);
        },
        complete: function complete(res) {
          _complete && _complete(res);
        }
      });
    }, CONTAINER_NAME$7.BAIDU);
    var push$2 = push$1;

    var switchTab$1 = normalize$5.switchTab(function (options) {
      swan.switchTab(options);
    }, CONTAINER_NAME$7.BAIDU);

    var baiDuModule$b = {
      push: push$2,
      back: back$6,
      reLaunch: reLaunch$1,
      switchTab: switchTab$1,
      replace: replace$1,
      go: go$1
    };

    var push = function push(options) {
      if (isWeb$1) {
        return webModule$b.push(options);
      } else if (isKuaiShouMiniProgram) {
        return kuaiShouModule$9.push(options);
      } else if (isWeChatMiniProgram) {
        return weChatModule$b.push(options);
      } else if (isByteDanceMicroApp) {
        return bytedanceModule$b.push(options);
      } else if (isMiniApp) {
        return aliMiniAppModule$b.push(options);
      } else if (isBaiduSmartProgram) {
        return baiDuModule$b.push(options);
      } else {
        throw new Error('Uni API：navigate.push 暂不支持');
      }
    };
    var go = function go(options) {
      if (isWeb$1) {
        return webModule$b.go(options);
      } else if (isKuaiShouMiniProgram) {
        return kuaiShouModule$9.go(options);
      } else if (isWeChatMiniProgram) {
        return weChatModule$b.go(options);
      } else if (isByteDanceMicroApp) {
        return bytedanceModule$b.go(options);
      } else if (isMiniApp) {
        return aliMiniAppModule$b.go(options);
      } else if (isBaiduSmartProgram) {
        return baiDuModule$b.go(options);
      } else {
        throw new Error('Uni API：navigate.go 暂不支持');
      }
    };
    var back$4 = function back(options) {
      if (isWeb$1) {
        return webModule$b.back(options);
      } else if (isKuaiShouMiniProgram) {
        return kuaiShouModule$9.back(options);
      } else if (isWeChatMiniProgram) {
        return weChatModule$b.back(options);
      } else if (isByteDanceMicroApp) {
        return bytedanceModule$b.back(options);
      } else if (isMiniApp) {
        return aliMiniAppModule$b.back(options);
      } else if (isBaiduSmartProgram) {
        return baiDuModule$b.back(options);
      } else {
        throw new Error('Uni API：navigate.back 暂不支持');
      }
    };
    var replace = function replace(options) {
      if (isWeb$1) {
        return webModule$b.replace(options);
      } else if (isKuaiShouMiniProgram) {
        return kuaiShouModule$9.replace(options);
      } else if (isWeChatMiniProgram) {
        return weChatModule$b.replace(options);
      } else if (isByteDanceMicroApp) {
        return bytedanceModule$b.replace(options);
      } else if (isMiniApp) {
        return aliMiniAppModule$b.replace(options);
      } else if (isBaiduSmartProgram) {
        return baiDuModule$b.replace(options);
      } else {
        throw new Error('Uni API：navigate.replace 暂不支持');
      }
    };
    var reLaunch = function reLaunch(options) {
      if (isWeb$1) {
        return webModule$b.reLaunch(options);
      } else if (isKuaiShouMiniProgram) {
        return kuaiShouModule$9.reLaunch(options);
      } else if (isWeChatMiniProgram) {
        return weChatModule$b.reLaunch(options);
      } else if (isByteDanceMicroApp) {
        return bytedanceModule$b.reLaunch(options);
      } else if (isMiniApp) {
        return aliMiniAppModule$b.reLaunch(options);
      } else if (isBaiduSmartProgram) {
        return baiDuModule$b.reLaunch(options);
      } else {
        throw new Error('Uni API：navigate.reLaunch 暂不支持');
      }
    };
    var switchTab = function switchTab(options) {
      if (isWeb$1) {
        return webModule$b.switchTab(options);
      } else if (isKuaiShouMiniProgram) {
        return kuaiShouModule$9.switchTab(options);
      } else if (isWeChatMiniProgram) {
        return weChatModule$b.switchTab(options);
      } else if (isByteDanceMicroApp) {
        return bytedanceModule$b.switchTab(options);
      } else if (isMiniApp) {
        return aliMiniAppModule$b.switchTab(options);
      } else if (isBaiduSmartProgram) {
        return baiDuModule$b.switchTab(options);
      } else {
        throw new Error('Uni API：navigate.switchTab 暂不支持');
      }
    };
    var navigate = {
      push: push,
      back: back$4,
      reLaunch: reLaunch,
      switchTab: switchTab,
      replace: replace,
      go: go
    };

    var mini$9 = push;

    function navigateTo$1(params) {
        var success = params.success, fail = params.fail, rest = __rest(params, ["success", "fail"]);
        // 该API特殊处理。因为传递是string字符串，不符合uni-api底层传递Object规范。
        loadPanguMiniAppDependLibs().then(function () {
            var targetUrl = getRealWebUrl(rest);
            JSCall$2('openUrl', targetUrl, success, fail);
        });
    }

    // api: https://uni-apis.alibaba-inc.com/doc/Navigation/navigateto
    var apiConfig$r = {
        web: {
            dingTalk: navigateTo$3,
            dingTalkPC: navigateTo$2,
            nebula: navigateTo$4,
            windvane: {
                // 菜鸟系
                cn: navigateTo$9,
                cnStation: navigateTo$8,
                cnNetCom: navigateTo$8,
                // 淘系
                tb: navigateTo$7,
                tbLive: navigateTo$7,
                fm: navigateTo$5,
                ali1688: navigateTo$6,
            },
        },
        mini: mini$9,
        panguMiniApp: navigateTo$1,
    };
    var extendNavigateTo = extend(apiConfig$r, index$s);
    /**
     * 打开新的WebView新窗口。API：https://yuque.antfin.com/cn-xt/arch/lwbvd0
     * 注意: 该API不是页面路由，而是App端新开1个webview实例。打个比方是：google浏览器新开tab，而不是更新当前页
     * @param  {!string|NavigateToIOptions} url 新窗口url或者NavigateToIOptions（详细见如下）对象（兼容2种传参方式）
     * @param  {?NavigateToParams} params 当第一个参数为string格式时，此参数有效。
     * @returns {Promise<unknown>} promise调用结果

     * NavigateToIOptions 全部参数
     * @property  {!string}            NavigateToIOptions.url 新窗口url，必填
     * @property  {?boolean}           [NavigateToIOptions.killSelf=false] 开启新窗口时，是否关闭当前webview
     * @property  {?Function}          [NavigateToIOptions.onResume] 回到当前页面时的回调，常用来刷新页面
     * @example 使用案例：
     * import { navigateTo } from '@alife/cn-uni-api';
     *  navigateTo({
     *    url: 'https://xx.xx/', // url 参数必填。如果是工程内hash参数，使用#/开头即可，如：'#/xxx'
     *    killSelf: false, // killSelf 参数暂时只支持 菜鸟 ｜ 淘宝 | 支付宝 | 闲鱼
     *    onResume: () => {} // onResume 参数暂时只支持 菜鸟 ｜ 淘宝 | 支付宝 | 闲鱼
     *  })
     *    .then(() => {
     *      console.log('success');
     *    })
     *    .catch((error) => {
     *      console.log(error);
     *    });
     * @author 敬文
     */
    var navigateTo = function (url, params) {
        if (typeof url === 'string') {
            return extendNavigateTo(__assign$1(__assign$1({}, params), { url: url }));
        }
        return extendNavigateTo(url);
    };

    function navigateBack$a(params, context) {
        // 菜鸟APP Hybrid ref：https://alidocs.dingtalk.com/i/nodes/Mk5evdR04jBV59vnPj1dVQL3x2OlParn
        var formatInput = function (options) {
            var _a;
            return ({
                backData: (_a = options === null || options === void 0 ? void 0 : options.data) !== null && _a !== void 0 ? _a : {},
            });
        };
        context.WVCall('CNHybridNavigator.goBack', params, { formatInput: formatInput });
    }

    function navigateBack$9(params, context) {
        // 驿站掌柜：https://page.cainiao.com/cn-yz/cnyz-book/_book/api/navigation.html
        context.WVCall('WVNavUrls.pop', params);
    }

    function navigateBack$8(params, context) {
        saveResumeDataForFm(params);
        context === null || context === void 0 ? void 0 : context.WVCall('WVIdleFishApi.finish', params);
    }

    function navigateBack$7(params, context) {
        context === null || context === void 0 ? void 0 : context.WVCall('TMWVWindow.back', params);
    }

    function navigateBack$6(params, context) {
        // 传递给上一个 WebViewController 的数据，数据会在 Active 事件中传递: https://h5.alibaba-inc.com/api/TaobaoClient-API.html#WebAppInterface-pop
        context === null || context === void 0 ? void 0 : context.WVCall('WebAppInterface.pop', params);
    }

    function navigateBack$5(params, context) {
        context.WVCall('AliWindow.close', params);
    }

    function navigateBack$4(params) {
        var _a, _b, _c;
        (_b = (_a = window === null || window === void 0 ? void 0 : window.history) === null || _a === void 0 ? void 0 : _a.back) === null || _b === void 0 ? void 0 : _b.call(_a);
        (_c = params === null || params === void 0 ? void 0 : params.success) === null || _c === void 0 ? void 0 : _c.call(params);
    }

    function navigateBack$3(params, context) {
        var api = 'dd.biz.navigation.close';
        context === null || context === void 0 ? void 0 : context.DDCall(api, params);
    }

    function navigateBack$2(params, context) {
        var api = 'dd.biz.navigation.quit';
        context === null || context === void 0 ? void 0 : context.DDCall(api, params);
    }

    function navigateBack$1(options, context) {
        context === null || context === void 0 ? void 0 : context.PanguMiniAppCall('navigateBack', options);
    }

    var mini$8 = back$4;

    // api: https://uni-apis.alibaba-inc.com/doc/Navigation/back
    var apiConfig$q = {
        web: {
            browser: navigateBack$4,
            dingTalk: navigateBack$3,
            dingTalkPC: navigateBack$2,
            windvane: {
                // 菜鸟系
                cn: navigateBack$a,
                cnStation: navigateBack$9,
                cnNetCom: navigateBack$9,
                // 淘系
                tb: navigateBack$6,
                tbLive: navigateBack$6,
                fm: navigateBack$8,
                tm: navigateBack$7,
                ali1688: navigateBack$5,
            },
        },
        // @ts-ignore TODO TS类型处理，mini容器暂时不改动之前的逻辑
        mini: mini$8,
        panguMiniApp: navigateBack$1,
    };
    var extendNavigateBack = extend(apiConfig$q, index$z);
    /**
     * 关闭WebView新窗口。一般跟navigateTo成对出现
     * @see API：https://yuque.antfin.com/cn-xt/arch/lwbvd0#4e081fc0
     * @param  {unknown} [data] 关闭时，发送给上个页面的数据
     * @returns {Promise<unknown>} promise调用结果
     * @example 使用案例：
     * import { navigateBack } from '@alife/cn-uni-api'; // h5、小程序通用包
     *
     * navigateBack()
     *   .then(() => {
     *     console.log('success');
     *   })
     *   .catch((error) => {
     *     console.log(error);
     *   });
     * @author 敬文
     */
    var navigateBack = function (data) {
        // 支持2种传参方式：小程序格式(必须有data方法)：{ data: xxxx }, webview格式： xxx
        if (data && Object.prototype.hasOwnProperty.call(data, 'data')) {
            return extendNavigateBack(data);
        }
        return extendNavigateBack({ data: data });
    };

    // 兜底
    function back$3(params) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, success, fail, delayNumber, rest, currentUrl, preUrl;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = params !== null && params !== void 0 ? params : {}, success = _a.success, fail = _a.fail, delayNumber = _a.delay, rest = __rest(_a, ["success", "fail", "delay"]);
                        currentUrl = window.location.href;
                        window.history.back();
                        return [4 /*yield*/, delay(delayNumber || 200)];
                    case 1:
                        _b.sent();
                        preUrl = window.location.href;
                        if (currentUrl !== preUrl || env.isBrowser) {
                            success === null || success === void 0 ? void 0 : success({
                                message: 'window history back',
                            });
                            return [2 /*return*/];
                        }
                        // 关闭浏览器
                        navigateBack(rest).then(success).catch(fail);
                        return [2 /*return*/];
                }
            });
        });
    }

    function back$2(params, context) {
        var api = 'dd.biz.navigation.goBack';
        context === null || context === void 0 ? void 0 : context.DDCall(api, params);
    }

    function back$1(params, context) {
        var api = 'WebAppInterface.pop';
        context === null || context === void 0 ? void 0 : context.WVCall(api, params);
    }

    var baseBack = extend({
        web: back$3,
    });
    // api: https://uni-apis.alibaba-inc.com/doc/Navigation/back
    // 原则：native原生有的，用原生能力；没有则用前端js hack兜底
    var apiConfig$p = {
        web: {
            dingTalk: back$2,
            windvane: {
                tb: back$1,
            },
            panguMiniApp: back$3,
        },
    };
    /**
     * 若当前 WebView 有 history，则后退，否则关闭当前 WebView。
     * 方案：淘宝、钉钉端有原生Native，则端支持；其他端使用js hack处理，优先history.back()，未变动路由则走navigateBack()。
     * 详见RFC: https://alidocs.dingtalk.com/i/nodes/qXomz1wAyjKVXoALob7lW3Y9pRBx5OrE# 「【新增back API】支持回退上个页面」
     * @see API：https://yuque.antfin.com/cn-xt/arch/lwbvd0#4e081fc0
     * @returns {Promise<unknown>} promise调用结果
     * @example 使用案例：
     * import { back } from '@alife/cn-uni-api'; // h5、小程序通用包
     *
     * back()
     *   .then(() => {
     *     console.log('success');
     *   })
     *   .catch((error) => {
     *     console.log(error);
     *   });
     * @author 敬文
     */
    var back = extend(apiConfig$p, baseBack);

    function redirectTo$3(params, context) {
        var _a;
        var api = 'dd.biz.navigation.replace';
        (_a = context.DDCall) === null || _a === void 0 ? void 0 : _a.call(context, api, params);
    }

    function redirectTo$2(params) {
        var formatInput = function (options) { return ({
            url: options.url,
            method: 'GET',
            closeAfterOpen: true,
        }); };
        WVCall$1('AliWindow.open', params, { formatInput: formatInput });
    }

    function redirectTo$1(params) {
        navigate.replace({
            url: params.url,
            isHash: params.isHash,
            refresh: params.refresh,
        });
    }

    var apiConfig$o = {
        web: {
            dingTalk: redirectTo$3,
            windvane: {
                ali1688: redirectTo$2,
            },
        },
        mini: redirectTo$1,
    };
    var extendRedirectTo = extend(apiConfig$o, 
    /** baseRedirectTo 支持windvane容器、nebula容器 */
    index$F);
    var redirectTo = function (url, params) {
        if (typeof url === 'string') {
            return extendRedirectTo(__assign$1(__assign$1({}, params), { url: url }));
        }
        return extendRedirectTo(url);
    };

    /**
     * 唤起外部原生浏览器上打开 URL。
     * 支持端：支付宝、淘宝IOS
     * API：https://yuque.antfin.com/cn-xt/htc47g/tzr9pt
     * @returns {Promise<unknown>} promise调用结果
     * @example 使用案例：
     * import { openInBrowser } from '@alife/cn-uni-api'; // h5、小程序通用包
     *
     * openInBrowser({ ios: 'scheme', android: 'packagename' })
     *   .then(() => {
     *     console.log('success');
     *   })
     *   .catch((error) => {
     *     console.log(error);
     *   });
     * @author 敬文
     */
    var openInBrowser = extend({
    // 待扩展
    }, 
    /** baseOpenInBrowser 支持windvane容器、nebula容器、小程序容器 */
    index$l);

    // 驿站JSBridge：https://page.cainiao.com/cn-yz/cnyz-book/_book/api/navigation.html?spm=a2d5h.23431112.0.0
    function openOtherApp$1(params, context) {
        context === null || context === void 0 ? void 0 : context.WVCall('WVNavUrls.openOtherApp', params);
    }

    var extendOpenOtherApp = extend({
        web: {
            windvane: {
                cnStation: openOtherApp$1,
                cnNetCom: openOtherApp$1,
            },
        },
    });
    /**
     * 打开其他应用。API：https://yuque.antfin.com/cn-xt/arch/lwbvd0
     * 目前支持：【驿站掌柜App】
     * @param {!string | OpenOtherAppIOptions} url scheme协议
     * @returns {Promise<unknown>} promise调用结果
     *
     * @example
     * import { openOtherApp } from '@alife/cn-uni-api';
     *
     * openOtherApp('dingtalk://dingtalkclient/page/myProfile').then(() => {
     *   console.log('success');
     * }).catch((error) => {
     *   console.log(error);
     * });
     * @author 敬文
     */
    var openOtherApp = function (url) {
        if (url && typeof url === 'object') {
            return extendOpenOtherApp(url);
        }
        return extendOpenOtherApp({ url: url });
    };

    // 驿站JSBridge：https://page.cainiao.com/cn-yz/cnyz-book/_book/api/navigation.html?spm=a2d5h.23431112.0.0
    function isAppInstalled$1(params, context) {
        context === null || context === void 0 ? void 0 : context.WVCall('WVNavUrls.isAppInstalled', params, {
            formatInput: function (input) {
                return { pkgName: input.android || input.ios };
            },
        });
    }

    /**
     * 是否安装某个客户端。
     * 如不确定 APP schema 或者包名，请咨询对应客户端同学
     * API：https://yuque.antfin.com/cn-xt/htc47g/tzr9pt
     * @returns {Promise<unknown>} promise调用结果
     * @example 使用案例：
     * import { isAppInstalled } from '@alife/cn-uni-api'; // h5、小程序通用包
     *
     * isAppInstalled({ ios: 'scheme', android: 'com.cainiao.station' })
     *   .then(() => {
     *     console.log('success');
     *   })
     *   .catch((error) => {
     *     console.log(error);
     *   });
     * @author 敬文
     */
    var isAppInstalled = extend({
        web: {
            windvane: {
                cnStation: isAppInstalled$1,
                cnNetCom: isAppInstalled$1,
            },
        },
    }, 
    /** baseIsAppInstalled 支持windvane容器、nebula容器、钉钉容器、小程序容器 */
    index$G);

    function scan$5(params) {
        // 菜鸟APP Hybrid ref：https://alidocs.dingtalk.com/i/nodes/Mk5evdR04jBV59vnPj1dVQL3x2OlParn
        var formatOutput = function (ret) {
            var _a;
            // 统一成uni官方淘宝一致的API字段输出：https://uni-apis.alibaba-inc.com/doc/Device/scan
            // 菜鸟容器只返回result字符串，无其他属性
            var qrCode = (_a = ret === null || ret === void 0 ? void 0 : ret.data) === null || _a === void 0 ? void 0 : _a.result;
            return {
                code: qrCode,
                qrCode: qrCode,
                barCode: qrCode,
            };
        };
        WVCall$1('CNHybridGGScanner.jumpScannerPage', params, {
            formatOutput: formatOutput,
        });
    }

    function scan$4(params) {
        // 驿站JSBridge：https://page.cainiao.com/cn-yz/cnyz-book/_book/api/scan_code.html?spm=a2d5h.23431112.0.0
        var formatOutput = function (ret) {
            // 统一成uni官方淘宝一致的API字段输出：https://uni-apis.alibaba-inc.com/doc/Device/scan
            // 菜鸟容器只返回result字符串，无其他属性
            var qrCode = ret === null || ret === void 0 ? void 0 : ret.result;
            return {
                code: qrCode,
                qrCode: qrCode,
                barCode: qrCode,
            };
        };
        WVCall$1('ScanCodeModule.scan', params, {
            formatOutput: formatOutput,
        });
    }

    function scan$3(params) {
        // 点淘App Hybrid：https://yuque.antfin-inc.com/ya8qsr/vzgrmn/gnivzc?#
        // JSBridge为TLCommonBridge.scan。 调用的是AliScanViewController。
        // 回调为 :{ @"type" : type,@"code" : code }
        var formatOutput = function (ret) {
            var qrCode = ret === null || ret === void 0 ? void 0 : ret.code;
            return {
                code: qrCode,
                qrCode: qrCode,
                barCode: qrCode,
            };
        };
        WVCall$1('TLCommonBridge.scan', params, {
            formatOutput: formatOutput,
        });
    }

    // https://open.dingtalk.com/document/orgapp-client/scan-barcodes-and-qr-codes?spm=ding_open_doc.document.0.0.c97f4399SeHacV#topic-2025276
    function scan$2(options, context) {
        var _a;
        var api = 'dd.biz.util.scan';
        var formatOutput = function (ret) { return ({
            code: ret === null || ret === void 0 ? void 0 : ret.text,
            qrCode: ret === null || ret === void 0 ? void 0 : ret.text,
            barCode: ret === null || ret === void 0 ? void 0 : ret.text,
        }); };
        var formatInput = function (input) {
            var _a;
            var _b = (input !== null && input !== void 0 ? input : {}).scanType, scanType = _b === void 0 ? ['qrCode', 'barCode'] : _b;
            // qrCode：二维码
            // barCode：条形码
            // all（默认）：全部
            if ((scanType === null || scanType === void 0 ? void 0 : scanType.length) === 1) {
                return { type: (_a = scanType[0]) !== null && _a !== void 0 ? _a : 'all' };
            }
            return { type: 'all' };
        };
        (_a = context === null || context === void 0 ? void 0 : context.DDCall) === null || _a === void 0 ? void 0 : _a.call(context, api, options, { formatInput: formatInput, formatOutput: formatOutput });
    }

    function scan$1(params) {
        var formatInput = function (_a) {
            var _b = _a.scanType, scanType = _b === void 0 ? ['qrCode', 'barCode'] : _b, _c = _a.hideAlbum, hideAlbum = _c === void 0 ? false : _c;
            return ({
                scanType: scanType,
                hideAlbum: hideAlbum,
            });
        };
        var errFormatOutput = function (err) {
            var errMsg = (err === null || err === void 0 ? void 0 : err.error) === ErrorCodes.ErrScanUserCancel
                ? ErrorMsgs.ErrMsgCancel
                : ErrorMsgs.ErrMsgCommon;
            return {
                errMsg: errMsg,
            };
        };
        // https://smallfish.antfin-inc.com/jsapi/scan.html
        NBCall$1('scan', params, {
            formatInput: formatInput,
            formatOutput: function (res) { return ({
                // code数据为统一值
                code: (res === null || res === void 0 ? void 0 : res.qrCode) || (res === null || res === void 0 ? void 0 : res.barCode) || '',
            }); },
        }, { formatOutput: errFormatOutput });
    }

    // api: https://uni-apis.alibaba-inc.com/doc/UI/scan
    var apiConfig$n = {
        web: {
            dingTalk: scan$2,
            nebula: scan$1,
            windvane: {
                cn: scan$5,
                cnStation: scan$4,
                cnNetCom: scan$4,
                tbLive: scan$3,
            },
        },
    };
    /**
     * 扫一扫。API：https://yuque.antfin.com/cn-xt/arch/lwbvd0
     * 支持淘宝、支付宝、菜鸟裹裹、驿站掌柜App等端。支持度一览表：https://yuque.antfin.com/cn-xt/arch/isxm98
     * @param  {ScanIOptions} config 扫一扫参数
     * @returns {Promise<{ code: string } & unknown>} promise调用结果
     * @example 使用案例：
     * import { scan } from '@alife/cn-uni-api';
     * try {
     *    const res = await scan();
     *    console.log('扫码结果', res.code ?? res.qrCode)
     * } catch(e) {
     *    console.log('扫一扫失败', e);
     * }
     * @author 敬文
     */
    var scan = extend(apiConfig$n, index$5);

    function callPhone$4(params) {
        // 菜鸟APP Hybrid ref：https://alidocs.dingtalk.com/i/nodes/Mk5evdR04jBV59vnPj1dVQL3x2OlParn
        WVCall$1('CNHybridPhoneService.dailPhoneNumberWithAlert', params);
    }

    function callPhone$3(params) {
        var phoneNumber = params.phoneNumber, success = params.success, fail = params.fail;
        try {
            window.location.href = "tel:".concat(phoneNumber);
            success === null || success === void 0 ? void 0 : success(); // set resolved。跟universal-api web端保持一致返回。https://github.com/raxjs/universal-api/blob/master/src/packages/device/makePhoneCall/src/web/index.ts
        }
        catch (error) {
            fail === null || fail === void 0 ? void 0 : fail();
        }
    }

    function callPhone$2(options, context) {
        context === null || context === void 0 ? void 0 : context.PanguMiniAppCall('showCallMenu', options, {
            formatInput: function (input) {
                return {
                    phoneNumber: input.phoneNumber,
                    code: '+86',
                    showDingCall: true, // 是否显示钉钉电话
                };
            },
        });
    }

    function _extends$F() { _extends$F = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$F.apply(this, arguments); }

    function promisify$7(api) {
      return function (arg) {
        return new Promise(function (resolve, reject) {
          var promisifyArg = arg;
          api(_extends$F({}, promisifyArg, {
            success: function success(res) {
              if (promisifyArg && typeof promisifyArg.success === 'function') {
                promisifyArg.success(res);
              }

              resolve(res);
            },
            onSuccess: function onSuccess(res) {
              if (promisifyArg && typeof promisifyArg.onSuccess === 'function') {
                promisifyArg.onSuccess(res);
              }

              resolve(res);
            },
            fail: function fail(res) {
              if (promisifyArg && typeof promisifyArg.fail === 'function') {
                promisifyArg.fail(res);
              }

              reject(res);
            },
            onFail: function onFail(res) {
              if (promisifyArg && typeof promisifyArg.onFail === 'function') {
                promisifyArg.onFail(res);
              }

              reject(res);
            },
            complete: function complete(res) {
              if (promisifyArg && typeof promisifyArg.complete === 'function') {
                promisifyArg.complete(res);
              }
            },
            onComplete: function onComplete(res) {
              if (promisifyArg && typeof promisifyArg.onComplete === 'function') {
                promisifyArg.onComplete(res);
              }
            }
          }));
        });
      };
    }

    var _excluded$7 = ["_ext"];

    function _objectWithoutPropertiesLoose$7(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

    function _extends$E() { _extends$E = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$E.apply(this, arguments); }
    var styleIn$6 = function styleIn(options, baseName) {
      var _ref = options || {},
          _ref$_ext = _ref._ext,
          _ext = _ref$_ext === void 0 ? {} : _ref$_ext,
          rest = _objectWithoutPropertiesLoose$7(_ref, _excluded$7);

      return _extends$E({}, rest, _ext[baseName] || {});
    };

    function normalize$4(api, containerName) {
      return function (args) {
        return promisify$7(api)(styleIn$6(args, containerName));
      };
    }

    var CONTAINER_NAME$6 = {
      WECHAT: 'wechatMiniProgram',
      ALIPAY: 'aliMiniApp',
      BYTE: 'bytedanceMicroApp',
      WEB: 'web',
      BAIDU: 'baiduSmartProgram',
      KWAI: 'kuaishouMiniProgram'
    };

    function isUndef$8(type) {
      return type === 'undefined';
    }

    var isDingdingMiniapp$8 = !isUndef$8(typeof dd) && dd !== null && !isUndef$8(typeof dd.alert);

    var _excluded$6 = ["phoneNumber"];

    function _extends$D() { _extends$D = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$D.apply(this, arguments); }

    function _objectWithoutPropertiesLoose$6(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

    var makePhoneCall$6 = function makePhoneCall(options) {
      if (isDingdingMiniapp$8) {
        dd.showCallMenu(options);
      } else {
        var phoneNumber = options.phoneNumber,
            ext = _objectWithoutPropertiesLoose$6(options, _excluded$6);

        my.makePhoneCall(_extends$D({}, ext, {
          number: phoneNumber
        }));
      }
    };

    var aliMiniAppModule$a = normalize$4(makePhoneCall$6, CONTAINER_NAME$6.ALIPAY);

    var makePhoneCall$5 = function makePhoneCall(options) {
      var phoneNumber = options == null ? void 0 : options.phoneNumber;
      var a = document.createElement('a');
      a.href = "tel:" + phoneNumber;
      a.innerHTML = "tel:" + phoneNumber;
      a.style.display = 'none';
      document.body.appendChild(a);
      setTimeout(function () {
        a.click(); // remove

        setTimeout(function () {
          try {
            document.body.removeChild(a);
          } catch (e) {// ignore
          } finally {
            // eslint-disable-next-line @typescript-eslint/dot-notation
            options == null ? void 0 : options['success'](); // set resolved
          }
        }, 0);
      }, 0);
    };

    var webModule$a = normalize$4(makePhoneCall$5, CONTAINER_NAME$6.WEB);

    var makePhoneCall$4 = function makePhoneCall(options) {
      wx.makePhoneCall(options);
    };

    var weChatModule$a = normalize$4(makePhoneCall$4, CONTAINER_NAME$6.WECHAT);

    var makePhoneCall$3 = function makePhoneCall(options) {
      tt.makePhoneCall(options);
    };

    var bytedanceModule$a = normalize$4(makePhoneCall$3, CONTAINER_NAME$6.BYTE);

    var makePhoneCall$2 = function makePhoneCall(options) {
      ks.makePhoneCall(options);
    };

    var kuaiShouModule$8 = normalize$4(makePhoneCall$2, CONTAINER_NAME$6.KWAI);

    var makePhoneCall$1 = function makePhoneCall(options) {
      swan.makePhoneCall(options);
    };

    var baiDuModule$a = normalize$4(makePhoneCall$1, CONTAINER_NAME$6.BAIDU);

    /**
     * call phone
     * @param options
     */
    function makePhoneCall(options) {
      if (isWeb$1) {
        return webModule$a(options);
      } else if (isKuaiShouMiniProgram) {
        return kuaiShouModule$8(options);
      } else if (isWeChatMiniProgram) {
        return weChatModule$a(options);
      } else if (isByteDanceMicroApp) {
        return bytedanceModule$a(options);
      } else if (isMiniApp) {
        return aliMiniAppModule$a(options);
      } else if (isBaiduSmartProgram) {
        return baiDuModule$a(options);
      } else {
        throw new Error('Uni API：makePhoneCall 暂不支持');
      }
    }

    function callPhone$1(params) {
        makePhoneCall(params);
    }

    var extendCallPhone = extend({
        // 兜底容器
        web: callPhone$3,
        mini: callPhone$1,
        // 特定端
        cn: callPhone$4,
        panguMiniApp: callPhone$2,
    });
    /**
     * 拨打电话。API：https://yuque.antfin.com/cn-xt/arch/lwbvd0
     * @param {!string | number | CallPhoneIOptions} phoneNumber 电话号码
     * @returns {Promise<unknown>} promise调用结果
     *
     * @example
     * import { callPhone } from '@alife/cn-uni-api';
     *
     * callPhone('18521566878').then(() => {
     *   console.log('success');
     * }).catch((error) => {
     *   console.log(error);
     * });
     * @author 敬文
     */
    var callPhone = function (phoneNumber) {
        if (phoneNumber && typeof phoneNumber === 'object') {
            return extendCallPhone(phoneNumber);
        }
        return extendCallPhone({ phoneNumber: "".concat(phoneNumber) });
    };

    /* 判断是否为base64字符串 */
    var isBase64 = function (str) {
        if (typeof str === 'string' && str.length > 0) {
            try {
                window.atob(str);
                return true;
            }
            catch (e) {
                return false;
            }
        }
        return false;
    };
    /* 判断是否支持直接分享（不唤起分享面板） */
    var isSupportDirect = function (type) {
        return type === 'Weixin' || type === 'WeixinMoments';
    };
    var getShareType = function (options) {
        var title = options.title, content = options.content, url = options.url, image = options.image, _a = options._ext, _b = _a === void 0 ? {} : _a, _c = _b.cn, cn = _c === void 0 ? {} : _c;
        var _d = cn !== null && cn !== void 0 ? cn : {}, cnType = _d.type, cnWxMiniAppData = _d.wxMiniAppData;
        if (cnWxMiniAppData) {
            return 'wxminiapp';
        }
        if ((cnType === 'image' && image) ||
            (cnType === 'multimedia' && url) ||
            (cnType === 'text' && (title || content || url))) {
            return cnType;
        }
        /* 默认值multimedia（最常用的类型） */
        return 'multimedia';
    };
    /** 微信 渠道数据 */
    var getWxMiniShareData = function (options, useImageBase64) {
        if (useImageBase64 === void 0) { useImageBase64 = false; }
        var title = options.title, content = options.content, image = options.image, _a = options._ext, _b = _a === void 0 ? {} : _a, _c = _b.cn, cn = _c === void 0 ? {} : _c;
        var cnWxMiniAppData = (cn !== null && cn !== void 0 ? cn : {}).wxMiniAppData;
        var _d = cnWxMiniAppData || {}, appId = _d.appId, path = _d.path, userName = _d.userName, wxEnv = _d.wxEnv;
        return [
            {
                name: 'Weixin',
                isDirect: true,
                param: {
                    type: 'wxminiapp',
                    text: title,
                    imageURL: image,
                    useImageBase64: useImageBase64,
                    multimedia: {
                        title: title,
                        subTitle: content,
                        thumbnail: image,
                        wxMiniAppURL: "https://page.cainiao.com/mcn/ggpromo/applet.html?appId=".concat(appId),
                        wxMiniAppPath: path,
                        wxMiniAppUserName: userName,
                        wxEnv: wxEnv,
                    },
                },
            },
        ];
    };
    /** web H5 渠道数据 */
    var getBasicShareData = function (type, options, useImageBase64) {
        if (useImageBase64 === void 0) { useImageBase64 = false; }
        var title = options.title, content = options.content, url = options.url, image = options.image;
        var plainText = "".concat(title || '').concat(content || '').concat(url || '');
        var shareData = {
            SMS: {
                name: 'SMS',
                param: {
                    text: plainText,
                },
            },
            Copy: {
                name: 'Copy',
                param: {
                    text: plainText,
                },
            },
            Qzone: {
                name: 'Qzone',
                param: {
                    type: 'multimedia',
                    text: title,
                    imageURL: image,
                    useImageBase64: useImageBase64,
                    multimedia: {
                        title: title,
                        subTitle: content,
                        thumbnail: image,
                        url: url,
                    },
                },
            },
            DingTalk: {
                name: 'DingTalk',
                param: {
                    type: 'multimedia',
                    text: title,
                    imageURL: image,
                    useImageBase64: useImageBase64,
                    multimedia: {
                        title: title,
                        subTitle: content,
                        thumbnail: image,
                        url: url,
                    },
                },
            },
            Weibo: {
                name: 'Weibo',
                param: {
                    type: 'image',
                    imageURL: image,
                    useImageBase64: useImageBase64,
                    textForImageShare: plainText, // 微博分享图片可以给用户预填文字
                },
            },
            QQ: {
                name: 'QQ',
                param: {
                    type: type,
                    text: title,
                    imageURL: image,
                    useImageBase64: useImageBase64,
                    multimedia: {
                        title: title,
                        subTitle: content,
                        thumbnail: image,
                        url: url,
                    },
                },
            },
            Weixin: {
                name: 'Weixin',
                param: {
                    useSquareThumbnail: true,
                    type: type,
                    text: title,
                    imageURL: image,
                    useImageBase64: useImageBase64,
                    multimedia: {
                        title: title,
                        subTitle: content,
                        thumbnail: image,
                        url: url,
                    },
                },
            },
            WeixinMoments: {
                name: 'WeixinMoments',
                param: {
                    type: type,
                    text: title,
                    imageURL: image,
                    useImageBase64: useImageBase64,
                    multimedia: {
                        title: title,
                        subTitle: content,
                        thumbnail: image,
                        url: url,
                    },
                },
            },
        };
        return shareData;
    };
    var getShareData = function (options, useImageBase64) {
        if (useImageBase64 === void 0) { useImageBase64 = false; }
        var title = options.title, content = options.content, url = options.url, image = options.image, _a = options._ext, _b = _a === void 0 ? {} : _a, _c = _b.cn, cn = _c === void 0 ? {} : _c;
        var _d = (cn !== null && cn !== void 0 ? cn : {}).channel, cnChannel = _d === void 0 ? [
            'SMS',
            'Copy',
            'Weixin',
            'WeixinMoments',
            'QQ',
            'Qzone',
            'DingTalk',
            'Weibo',
        ] : _d;
        var type = getShareType(options);
        /** 微信小程序分享 */
        if (type === 'wxminiapp') {
            return getWxMiniShareData(options, useImageBase64);
        }
        /* 检查参数，进行分享面板过滤 */
        var basicShareData = getBasicShareData(type, options, useImageBase64);
        var filterChannels = function (targetChannels) {
            return cnChannel
                .filter(function (channel) { return targetChannels.includes(channel); })
                .map(function (item) { return basicShareData[item]; });
        };
        var getPlainTextChannels = function () {
            if (!content && !url && !title) {
                return [];
            }
            return filterChannels(['Copy', 'SMS']);
        };
        var getPlainImageChannel = function () {
            if (!image) {
                return [];
            }
            return filterChannels(['Weibo']);
        };
        var getPlainMediaChannels = function () {
            if (!url) {
                return [];
            }
            return filterChannels(['Qzone', 'DingTalk']);
        };
        var getMixedChannel = function () {
            return filterChannels(['QQ', 'Weixin', 'WeixinMoments']);
        };
        var shareChannels = __spreadArray(__spreadArray(__spreadArray(__spreadArray([], getPlainMediaChannels(), true), getPlainTextChannels(), true), getPlainImageChannel(), true), getMixedChannel(), true);
        /* 处理单渠道分享 */
        if (shareChannels.length === 1 && isSupportDirect(shareChannels[0].name)) {
            shareChannels[0].isDirect = true;
            return [shareChannels[0]];
        }
        return shareChannels;
    };
    /** 最终发送的数据 shareData */
    var getShareParams = function (options) {
        var image = options.image;
        var useImageBase64 = isBase64(image);
        var shareData = getShareData(options, useImageBase64);
        var params = { shareData: shareData };
        // 处理base64格式图片
        if (useImageBase64) {
            params.imageBase64 = image === null || image === void 0 ? void 0 : image.split(',')[1];
        }
        return params;
    };
    // 菜鸟APP Hybrid ref：https://alidocs.dingtalk.com/i/nodes/Mk5evdR04jBV59vnPj1dVQL3x2OlParn
    var showSharePanel$6 = function (params, context) {
        var formatInput = function (options) {
            return getShareParams(options);
        };
        context.WVCall('CNHybridGGShareBoard.share', params, { formatInput: formatInput });
    };

    // https://page.cainiao.com/cn-yz/cnyz-book/_book/api/share.html?spm=a2d5h.23431112.0.0
    function showSharePanel$5(options, context) {
        var formatInput = function (input) {
            var _a;
            var cnStation = ((_a = input === null || input === void 0 ? void 0 : input._ext) !== null && _a !== void 0 ? _a : {}).cnStation;
            return __assign$1({ type: 'url' }, cnStation);
        };
        context.WVCall('TBSharedModule.showSharedMenu', options, {
            formatInput: formatInput,
        });
    }

    // 点淘App Hybrid：https://yuque.antfin-inc.com/ya8qsr/vzgrmn/gnivzc?#
    function showSharePanel$4(params, context) {
        context.WVCall('TBSharedModule.showSharedMenu', params);
    }

    // 支付宝 easyShare: https://smallfish.antfin-inc.com/jsapi/easyShare.html
    var showSharePanel$3 = function (params, context) {
        var getAPShareData = function (options) {
            var _a;
            var _b = options !== null && options !== void 0 ? options : {}, _c = _b.businessId, businessId = _c === void 0 ? '' : _c, content = _b.content, image = _b.image;
            var ap = ((_a = options === null || options === void 0 ? void 0 : options._ext) !== null && _a !== void 0 ? _a : {}).ap;
            return __assign$1({ bizType: businessId, desc: content, iconUrl: image, imageUrl: image }, ap);
        };
        context.NBCall('easyShare', params, {
            formatInput: function (options) { return (__assign$1({}, getAPShareData(options))); },
        });
    };

    function showSharePanel$2(options, context) {
        var _a;
        var api = 'dd.biz.util.share';
        var formatInput = function (input) {
            var _a = input !== null && input !== void 0 ? input : {}, url = _a.url, title = _a.title, content = _a.content, image = _a.image, _b = _a._ext, _c = _b === void 0 ? {} : _b, _d = _c.dingTalk, dingTalk = _d === void 0 ? {} : _d;
            return __assign$1({ url: url, title: title, content: content, image: image, type: (dingTalk === null || dingTalk === void 0 ? void 0 : dingTalk.type) || 0 }, dingTalk);
        };
        (_a = context === null || context === void 0 ? void 0 : context.DDCall) === null || _a === void 0 ? void 0 : _a.call(context, api, options, {
            formatInput: formatInput,
        });
    }

    function showSharePanel$1(options, context) {
        var _a;
        (_a = context === null || context === void 0 ? void 0 : context.PanguMiniAppCall) === null || _a === void 0 ? void 0 : _a.call(context, 'callShare', options);
    }

    /**
     * uni-apis: https://uni-apis.alibaba-inc.com/doc/UI/showsharepanel
     * AP easyShare: https://smallfish.antfin-inc.com/jsapi/easyShare.html
     */
    var apiConfig$m = {
        web: {
            dingTalk: showSharePanel$2,
            nebula: showSharePanel$3,
            windvane: {
                cn: showSharePanel$6,
                cnStation: showSharePanel$5,
                cnNetCom: showSharePanel$5,
                tbLive: showSharePanel$4,
            },
        },
        panguMiniApp: showSharePanel$1,
    };
    /**
     * 分享功能
     * API：https://yuque.antfin.com/cn-xt/htc47g/tzr9pt
     * @example 使用案例：
     * import { showSharePanel } from '@alife/cn-uni-api'; // h5、小程序通用包
     *
     * showSharePanel({
     *  title: '终于明白为什么大家都爱玩《绿色家园》'
     *  content: '天天领鸡蛋、赚能量，绿色减碳还能赢好礼！',
     *  image: 'https://gw.alicdn.com/imgextra/i4/O1CN010JQ88U1j2T4dMGh4o_!!6000000004490-2-tps-400-400.png',
     *  url: 'https://xxx',
     * })
     *   .then(() => {
     *     console.log('success');
     *   })
     *   .catch((error) => {
     *     console.log(error);
     *   });
     * @author 敬文
     */
    var showSharePanel = extend(apiConfig$m, index$q);

    // web方式兜底
    var setClipboard$g = function (args) {
        var _a = args || {}, _b = _a.text, text = _b === void 0 ? '' : _b, _c = _a.success, success = _c === void 0 ? function () { } : _c, _d = _a.fail, fail = _d === void 0 ? function () { } : _d, _e = _a.complete, complete = _e === void 0 ? function () { } : _e;
        var input = document.createElement('input');
        input.setAttribute('readonly', 'readonly');
        input.setAttribute('value', text);
        input.style.position = 'fixed';
        input.style.height = '0px';
        document.body.appendChild(input);
        input.focus();
        input.setSelectionRange(0, -1);
        var removeInput = function () {
            document.body.removeChild(input);
        };
        try {
            if (document.execCommand('copy')) {
                removeInput();
                success({ success: true });
                complete({ success: true });
            }
            else {
                removeInput();
                fail({
                    errCode: 1,
                    errMsg: 'not support',
                });
            }
        }
        catch (error) {
            removeInput();
            fail({
                errCode: 11,
                errMsg: JSON.stringify(error),
            });
        }
    };

    function setClipboard$f(options, context) {
        var _a;
        var api = 'dd.biz.clipboardData.setData';
        (_a = context === null || context === void 0 ? void 0 : context.DDCall) === null || _a === void 0 ? void 0 : _a.call(context, api, options);
    }

    function setClipboard$e(options, context) {
        var _a;
        (_a = context === null || context === void 0 ? void 0 : context.PanguMiniAppCall) === null || _a === void 0 ? void 0 : _a.call(context, 'setClipboard', options);
    }

    function isUndef$7(type) {
      return type === 'undefined';
    }

    var isDingdingMiniapp$7 = !isUndef$7(typeof dd) && dd !== null && !isUndef$7(typeof dd.alert);

    var CONTAINER_NAME$5 = {
      WECHAT: 'wechatMiniProgram',
      ALIPAY: 'aliMiniApp',
      BYTE: 'bytedanceMicroApp',
      WEB: 'web',
      BAIDU: 'baiduSmartProgram',
      KWAI: 'kuaishouMiniProgram'
    };

    function _extends$C() { _extends$C = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$C.apply(this, arguments); }

    function promisify$6(api) {
      return function (arg) {
        return new Promise(function (resolve, reject) {
          var promisifyArg = arg;
          api(_extends$C({}, promisifyArg, {
            success: function success(res) {
              if (promisifyArg && typeof promisifyArg.success === 'function') {
                promisifyArg.success(res);
              }

              resolve(res);
            },
            onSuccess: function onSuccess(res) {
              if (promisifyArg && typeof promisifyArg.onSuccess === 'function') {
                promisifyArg.onSuccess(res);
              }

              resolve(res);
            },
            fail: function fail(res) {
              if (promisifyArg && typeof promisifyArg.fail === 'function') {
                promisifyArg.fail(res);
              }

              reject(res);
            },
            onFail: function onFail(res) {
              if (promisifyArg && typeof promisifyArg.onFail === 'function') {
                promisifyArg.onFail(res);
              }

              reject(res);
            },
            complete: function complete(res) {
              if (promisifyArg && typeof promisifyArg.complete === 'function') {
                promisifyArg.complete(res);
              }
            },
            onComplete: function onComplete(res) {
              if (promisifyArg && typeof promisifyArg.onComplete === 'function') {
                promisifyArg.onComplete(res);
              }
            }
          }));
        });
      };
    }

    var _excluded$5 = ["_ext"];

    function _objectWithoutPropertiesLoose$5(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

    function _extends$B() { _extends$B = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$B.apply(this, arguments); }
    var styleIn$5 = function styleIn(options, baseName) {
      var _ref = options || {},
          _ref$_ext = _ref._ext,
          _ext = _ref$_ext === void 0 ? {} : _ref$_ext,
          rest = _objectWithoutPropertiesLoose$5(_ref, _excluded$5);

      return _extends$B({}, rest, _ext[baseName] || {});
    };

    function _extends$A() { _extends$A = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$A.apply(this, arguments); }

    /**
     * actionsheet返回值格式化
     * @param res
     */
    var formatResponse$1 = function formatResponse(res) {
      return {
        text: res.data != undefined ? res.data : res.text
      };
    };
    /**
     * actionsheet参数格式化
     * @param options
     */


    function styleOptions$6(options) {
      return options ? _extends$A({}, options, {
        success: function success(res) {
          options.success && options.success(formatResponse$1(res));
        }
      }) : {};
    }

    function normalizeGet(api, containerName) {
      return function (args) {
        return promisify$6(api)(styleOptions$6(styleIn$5(args, containerName))).then(formatResponse$1);
      };
    }
    function normalizeSet(api, containerName) {
      return function (args) {
        return promisify$6(api)(styleIn$5(args, containerName));
      };
    }

    var getClipboard$8 = normalizeGet(function (args) {
      return isDingdingMiniapp$7 ? dd.getClipboard(args) : my.getClipboard(args);
    }, CONTAINER_NAME$5.ALIPAY);

    var setClipboard$c = normalizeSet(function (args) {
      return isDingdingMiniapp$7 ? dd.setClipboard(args) : my.setClipboard(args);
    }, CONTAINER_NAME$5.ALIPAY);
    var setClipboard$d = setClipboard$c;

    var aliMiniAppModule$9 = {
      getClipboard: getClipboard$8,
      setClipboard: setClipboard$d
    };

    var getClipboard$7 = normalizeGet(function () {
      throw new Error('Uni API: getClipboard不支持');
    }, CONTAINER_NAME$5.WEB);

    var setClipboard$a = normalizeSet(function (args) {
      var _ref = args || {},
          _ref$text = _ref.text,
          text = _ref$text === void 0 ? '' : _ref$text,
          _ref$success = _ref.success,
          success = _ref$success === void 0 ? function () {} : _ref$success,
          _ref$fail = _ref.fail,
          fail = _ref$fail === void 0 ? function () {} : _ref$fail,
          _ref$complete = _ref.complete,
          complete = _ref$complete === void 0 ? function () {} : _ref$complete;

      var textArea;

      var createTextArea = function createTextArea() {
        textArea = document.createElement('textArea');
        textArea.style.position = 'absolute';
        textArea.style.top = 0;
        textArea.style.opacity = 0;
        textArea.style.zIndex = -1;
        textArea.value = text;
        document.body.appendChild(textArea);
      };

      var selectText = function selectText() {
        textArea.setAttribute('readonly', '');
        textArea.select();
        textArea.setSelectionRange(0, textArea.value.length);
      };

      var copyToClipboard = function copyToClipboard() {
        document.execCommand('copy');
        textArea.remove();
      };

      try {
        createTextArea();
        selectText();
        copyToClipboard();
        success(text);
        complete(text);
        return text;
      } catch (error) {
        fail(error);
        complete(text);
      }
    }, CONTAINER_NAME$5.WEB);
    var setClipboard$b = setClipboard$a;

    var webModule$9 = {
      getClipboard: getClipboard$7,
      setClipboard: setClipboard$b
    };

    var getClipboard$6 = normalizeGet(function (args) {
      return wx.getClipboardData(args);
    }, CONTAINER_NAME$5.WECHAT);

    var setClipboard$8 = normalizeSet(function (args) {
      args.data = args.text;
      delete args.text;
      return wx.setClipboardData(args);
    }, CONTAINER_NAME$5.WECHAT);
    var setClipboard$9 = setClipboard$8;

    var weChatModule$9 = {
      getClipboard: getClipboard$6,
      setClipboard: setClipboard$9
    };

    var getClipboard$5 = normalizeGet(function (args) {
      return tt.getClipboardData(args);
    }, CONTAINER_NAME$5.BYTE);

    var setClipboard$6 = normalizeSet(function (args) {
      args.data = args.text;
      delete args.text;
      return tt.setClipboardData(args);
    }, CONTAINER_NAME$5.BYTE);
    var setClipboard$7 = setClipboard$6;

    var bytedanceModule$9 = {
      getClipboard: getClipboard$5,
      setClipboard: setClipboard$7
    };

    var getClipboard$4 = normalizeGet(function (args) {
      return ks.getClipboardData(args);
    }, CONTAINER_NAME$5.KWAI);

    var setClipboard$4 = normalizeSet(function (args) {
      args.data = args.text;
      delete args.text;
      return ks.setClipboardData(args);
    }, CONTAINER_NAME$5.KWAI);
    var setClipboard$5 = setClipboard$4;

    var kuaiShouModule$7 = {
      getClipboard: getClipboard$4,
      setClipboard: setClipboard$5
    };

    var getClipboard$3 = normalizeGet(function (args) {
      return swan.getClipboardData(args);
    }, CONTAINER_NAME$5.BAIDU);

    var setClipboard$2 = normalizeSet(function (args) {
      args.data = args.text;
      delete args.text;
      return swan.setClipboardData(args);
    }, CONTAINER_NAME$5.BAIDU);
    var setClipboard$3 = setClipboard$2;

    var baiDuModule$9 = {
      getClipboard: getClipboard$3,
      setClipboard: setClipboard$3
    };

    var setClipboard$1 = function setClipboard(args) {
      if (isWeb$1) {
        return webModule$9.setClipboard(args);
      } else if (isKuaiShouMiniProgram) {
        return kuaiShouModule$7.setClipboard(args);
      } else if (isWeChatMiniProgram) {
        return weChatModule$9.setClipboard(args);
      } else if (isByteDanceMicroApp) {
        return bytedanceModule$9.setClipboard(args);
      } else if (isMiniApp) {
        return aliMiniAppModule$9.setClipboard(args);
      } else if (isBaiduSmartProgram) {
        return baiDuModule$9.setClipboard(args);
      } else {
        throw new Error('Uni API：setClipboard暂不支持');
      }
    };

    var mini$7 = setClipboard$1;

    var apiConfig$l = {
        web: {
            browser: setClipboard$g,
            dingTalk: setClipboard$f,
            dingTalkPC: setClipboard$g,
        },
        mini: mini$7,
        panguMiniApp: setClipboard$e,
    };
    var extendSetClipboard = extend(apiConfig$l, index$E);
    /**
     * 复制到剪切板。API：https://yuque.antfin.com/cn-xt/arch/lwbvd0
     * @param {!string|{text: string}} text 粘贴的文本
     * @returns {Promise<unknown>} promise调用结果
     *
     * @example
     * import { setClipboard } from '@alife/cn-uni-api';
     *
     * setClipboard('来复制我').then(() => {
     *   console.log('success');
     * }).catch((error) => {
     *   console.log(error);
     * });
     * @author 敬文
     */
    var setClipboard = function (text) {
        if (typeof text === 'string') {
            return extendSetClipboard({
                text: text,
            });
        }
        return extendSetClipboard(text);
    };

    // web方式兜底
    var getClipboard$2 = function (args) {
        var _a, _b, _c;
        var _d = args || {}, _e = _d.success, success = _e === void 0 ? function () { } : _e, _f = _d.fail, fail = _f === void 0 ? function () { } : _f, _g = _d.complete, complete = _g === void 0 ? function () { } : _g;
        try {
            // ios支持，androi部分支持（UC不支持）：https://caniuse.com/?search=navigator%3F.clipboard
            // 先这么在浏览器兜底。后续再优化，走兼容性最好的document.execCommand，逻辑会稍麻烦些
            (_c = (_b = (_a = navigator === null || navigator === void 0 ? void 0 : navigator.clipboard) === null || _a === void 0 ? void 0 : _a.readText()) === null || _b === void 0 ? void 0 : _b.then(function (text) {
                success({ content: text });
                complete({ content: text });
            })) === null || _c === void 0 ? void 0 : _c.catch(function (error) {
                fail({
                    errCode: 11,
                    errMsg: JSON.stringify(error),
                });
            });
        }
        catch (error) {
            fail({
                errCode: 11,
                errMsg: JSON.stringify(error),
            });
        }
    };

    function getClipboard$1(options, context) {
        // 菜鸟APP Hybrid ref：https://alidocs.dingtalk.com/i/nodes/Mk5evdR04jBV59vnPj1dVQL3x2OlParn
        var formatOutput = function (ret) {
            var _a;
            var content = (_a = ret === null || ret === void 0 ? void 0 : ret.data) === null || _a === void 0 ? void 0 : _a.content;
            return {
                content: content,
            };
        };
        context === null || context === void 0 ? void 0 : context.WVCall('CNHybridPasteBoard.getStringFromPasteboard', options, {
            formatOutput: formatOutput,
        });
    }

    var apiConfig$k = {
        web: {
            browser: getClipboard$2,
            windvane: {
                cn: getClipboard$1,
            },
        },
    };
    /**
     * 获取系统剪贴板的内容。API：https://yuque.antfin.com/cn-xt/arch/lwbvd0
     * @returns {Promise<unknown>} promise调用结果
     *
     * @example
     * import { getClipboard } from '@alife/cn-uni-api';
     *
     * getClipboard().then((res) => {
     *   console.log(res.content, 'success');
     * }).catch((error) => {
     *   console.log(error);
     * });
     * @author 敬文
     */
    var getClipboard = extend(apiConfig$k);

    function snapshot$2(options, context) {
        var _a;
        // https://yuque.alibaba-inc.com/dingtalk-miniprogram/api/bxvy5t
        var api = 'dd.biz.conference.screenshot';
        (_a = context === null || context === void 0 ? void 0 : context.DDCall) === null || _a === void 0 ? void 0 : _a.call(context, api, options);
    }

    function snapshot$1(options, context) {
        var _a;
        (_a = context === null || context === void 0 ? void 0 : context.PanguMiniAppCall) === null || _a === void 0 ? void 0 : _a.call(context, 'makeScreenshot', options);
    }

    /**
     * 截图
     * @example
     * import { snapshot } from '@alife/cn-uni-api';
     *
     * snapshot({
     *    // ...
     * })
     *  .then(console.log)
     *  .catch(console.log)
     *
     * @author 余国平
     */
    var snapshot = extend({
        web: {
            dingTalk: snapshot$2,
        },
        panguMiniApp: snapshot$1,
    }, index$4);

    function vibrate$1(options, context) {
        var _a;
        var api = 'dd.device.notification.vibrate';
        (_a = context === null || context === void 0 ? void 0 : context.DDCall) === null || _a === void 0 ? void 0 : _a.call(context, api, options, { formatInput: function () { return ({ duration: 300 }); } });
    }

    /**
     * vibrate 提示
     * API：https://yuque.antfin.com/cn-xt/htc47g/tzr9pt
     * @returns {Promise<unknown>} promise调用结果
     * @example 使用案例：
     * import { vibrate } from '@alife/cn-uni-api'; // h5、小程序通用包
     *
     * vibrate()
     *   .then(() => {
     *     console.log('success');
     *   })
     *   .catch((error) => {
     *     console.log(error);
     *   });
     * @author 敬文
     */
    var vibrate = extend({
        web: {
            dingTalk: vibrate$1,
        },
    }, 
    /** baseVibrate 支持windvane容器、nebula容器 */
    index$v);

    function choosePhoneContact$1(options, context) {
        var _a;
        var api = 'dd.biz.contact.chooseMobileContacts';
        var formatOutput = function (ret) {
            var selectItem = ret[0];
            return {
                name: selectItem.name,
                phone: selectItem.mobile.replace(/(\s|-)+/g, ''),
                multiple: false,
            };
        };
        (_a = context === null || context === void 0 ? void 0 : context.DDCall) === null || _a === void 0 ? void 0 : _a.call(context, api, options, { formatOutput: formatOutput });
    }

    /**
     * choosePhoneContact 提示
     * API：https://yuque.antfin.com/cn-xt/htc47g/tzr9pt
     * @returns {Promise<unknown>} promise调用结果
     * @example 使用案例：
     * import { choosePhoneContact } from '@alife/cn-uni-api'; // h5、小程序通用包
     *
     * choosePhoneContact()
     *   .then((res) => {
     *     console.log(res.name + res.mobile);
     *   })
     *   .catch((error) => {
     *     console.log(error);
     *   });
     * @author 敬文
     */
    var choosePhoneContact = extend({
        web: {
            dingTalk: choosePhoneContact$1,
        },
    }, index$o);

    function getLocation$h(params) {
        // https://yuque.antfin.com/docs/share/9f7861ac-8c8d-4226-9d46-794b951af427?# 《小二App API接口列表文档》
        WVCall$1('SensorModule.getLocation', params);
    }

    // 纯web方式兜底
    var getLocation$g = function (params) {
        var _a = params.success, success = _a === void 0 ? function () { } : _a, _b = params.fail, fail = _b === void 0 ? function () { } : _b, _c = params.complete, complete = _c === void 0 ? function () { } : _c;
        if ('geolocation' in navigator) {
            /* 地理位置服务可用 */
            navigator.geolocation.getCurrentPosition(function (position) {
                var coords = position === null || position === void 0 ? void 0 : position.coords;
                success(coords);
                complete(coords);
            }, function (err) {
                fail(err);
                complete(err);
            });
        }
        else {
            /* 地理位置服务不可用 */
            var err = { code: -1, message: '地理位置服务不可用' };
            fail(err);
            complete(err);
        }
    };

    // API: https://open.dingtalk.com/document/orgapp-client/obtain-current-geographic-location-information-single-positioning?spm=ding_open_doc.document.0.0.c97f4399SeHacV#topic-2025194
    function getLocation$f(options, context) {
        var _a;
        var api = 'dd.device.geolocation.get'; // 该api需要钉钉鉴权：https://open.dingtalk.com/document/orgapp-client/jsapi-overview
        var formatInput = function (input) {
            var _a;
            var dingTalk = ((_a = input === null || input === void 0 ? void 0 : input._ext) !== null && _a !== void 0 ? _a : {}).dingTalk;
            return __assign$1({ targetAccuracy: 200, coordinate: 0, withReGeocode: false, useCache: true }, dingTalk);
        };
        var formatOutput = function (ret) { return ({
            longitude: ret.longitude.toString(),
            latitude: ret.latitude.toString(),
        }); };
        (_a = context === null || context === void 0 ? void 0 : context.DDCall) === null || _a === void 0 ? void 0 : _a.call(context, api, options, { formatInput: formatInput, formatOutput: formatOutput });
    }

    function getLocation$e(options, context) {
        var _a;
        (_a = context === null || context === void 0 ? void 0 : context.PanguMiniAppCall) === null || _a === void 0 ? void 0 : _a.call(context, 'getLocation', options);
    }

    function isUndef$6(type) {
      return type === 'undefined';
    }

    var isDingdingMiniapp$6 = !isUndef$6(typeof dd) && dd !== null && !isUndef$6(typeof dd.alert);

    var CONTAINER_NAME$4 = {
      WECHAT: 'wechatMiniProgram',
      ALIPAY: 'aliMiniApp',
      BYTE: 'bytedanceMicroApp',
      WEB: 'web',
      BAIDU: 'baiduSmartProgram',
      KWAI: 'kuaishouMiniProgram'
    };

    function _extends$z() { _extends$z = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$z.apply(this, arguments); }

    function promisify$5(api) {
      return function (arg) {
        return new Promise(function (resolve, reject) {
          var promisifyArg = arg;
          api(_extends$z({}, promisifyArg, {
            success: function success(res) {
              if (promisifyArg && typeof promisifyArg.success === 'function') {
                promisifyArg.success(res);
              }

              resolve(res);
            },
            onSuccess: function onSuccess(res) {
              if (promisifyArg && typeof promisifyArg.onSuccess === 'function') {
                promisifyArg.onSuccess(res);
              }

              resolve(res);
            },
            fail: function fail(res) {
              if (promisifyArg && typeof promisifyArg.fail === 'function') {
                promisifyArg.fail(res);
              }

              reject(res);
            },
            onFail: function onFail(res) {
              if (promisifyArg && typeof promisifyArg.onFail === 'function') {
                promisifyArg.onFail(res);
              }

              reject(res);
            },
            complete: function complete(res) {
              if (promisifyArg && typeof promisifyArg.complete === 'function') {
                promisifyArg.complete(res);
              }
            },
            onComplete: function onComplete(res) {
              if (promisifyArg && typeof promisifyArg.onComplete === 'function') {
                promisifyArg.onComplete(res);
              }
            }
          }));
        });
      };
    }

    var _excluded$4 = ["_ext"];

    function _objectWithoutPropertiesLoose$4(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

    function _extends$y() { _extends$y = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$y.apply(this, arguments); }
    var styleIn$4 = function styleIn(options, baseName) {
      var _ref = options || {},
          _ref$_ext = _ref._ext,
          _ext = _ref$_ext === void 0 ? {} : _ref$_ext,
          rest = _objectWithoutPropertiesLoose$4(_ref, _excluded$4);

      return _extends$y({}, rest, _ext[baseName] || {});
    };

    function _extends$x() { _extends$x = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$x.apply(this, arguments); }

    /**
     * getLocation返回值格式化
     * @param res
     */
    var formatResponse = function formatResponse(res) {
      var result = _extends$x({}, res, {
        latitude: String(res.latitude),
        longitude: String(res.longitude),
        accuracy: String(res.accuracy),
        horizontalAccuracy: String(res.horizontalAccuracy)
      });

      return result;
    };

    function styleOptions$5(options) {
      if (options === void 0) {
        options = {};
      }

      return _extends$x({}, options, {
        success: function success(res) {
          options.success && options.success(formatResponse(res));
        },
        complete: function complete(res) {
          options.complete && options.complete(res);
        }
      });
    }

    function normalizeGetLocation(api, containerName) {
      return function (args) {
        return promisify$5(api)(styleOptions$5(styleIn$4(args, containerName))).then(formatResponse);
      };
    }
    /**
     * openLocation
     * @param api
     */

    function normalizeOpenLocation(api, containerName) {
      return function (args) {
        return promisify$5(api)(styleIn$4(args, containerName));
      };
    }
    /**
     * chooseLocation
     */

    function normalizeChooseLocation(api, containerName) {
      return function (args) {
        return promisify$5(api)(styleIn$4(args, containerName));
      };
    }

    var getLocation$c = normalizeGetLocation(function (args) {
      args.resultType = args.resultType || 0;

      if (args != null && args.type && typeof args.type === 'string') {
        args.type = 0;
      }

      if (args != null && args.resultType && typeof args.resultType === 'number' && !isNaN(args.resultType)) {
        args.type = args.resultType;
      }

      return isDingdingMiniapp$6 ? dd.getLocation(args) : my.getLocation(args);
    }, CONTAINER_NAME$4.ALIPAY);
    var getLocation$d = getLocation$c;

    function _extends$w() { _extends$w = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$w.apply(this, arguments); }
    var openLocation$5 = normalizeOpenLocation(function (args) {
      var params = _extends$w({}, args, {
        latitude: String(args.latitude),
        longitude: String(args.longitude)
      });

      isDingdingMiniapp$6 ? dd.openLocation(params) : my.openLocation(params);
    }, CONTAINER_NAME$4.ALIPAY);

    var chooseLocation$5 = normalizeChooseLocation(function (args) {
      return isDingdingMiniapp$6 ? dd.chooseLocation(args) : my.chooseLocation(args);
    }, CONTAINER_NAME$4.ALIPAY);

    var aliMiniAppModule$8 = {
      getLocation: getLocation$d,
      openLocation: openLocation$5,
      chooseLocation: chooseLocation$5
    };

    var getLocation$a = normalizeGetLocation(function (args) {
      var _args$success = args.success,
          success = _args$success === void 0 ? function () {} : _args$success,
          _args$fail = args.fail,
          fail = _args$fail === void 0 ? function () {} : _args$fail,
          _args$complete = args.complete,
          complete = _args$complete === void 0 ? function () {} : _args$complete;

      if ('geolocation' in navigator) {
        /* 地理位置服务可用 */
        navigator.geolocation.getCurrentPosition(function (position) {
          success(position.coords);
          complete(position.coords);
        }, function (err) {
          fail(err);
          complete(err);
        });
      } else {
        /* 地理位置服务不可用 */
        var err = {
          code: -1,
          message: '地理位置服务不可用'
        };
        fail(err);
        complete(err);
      }
    }, CONTAINER_NAME$4.WEB);
    var getLocation$b = getLocation$a;

    var openLocation$4 = normalizeOpenLocation(function () {
      throw new Error('Uni API: openLocation不支持');
    }, CONTAINER_NAME$4.WEB);

    var chooseLocation$4 = normalizeChooseLocation(function () {
      throw new Error('@uni/apis: chooseLocation不支持');
    }, CONTAINER_NAME$4.WEB);

    var webModule$8 = {
      getLocation: getLocation$b,
      openLocation: openLocation$4,
      chooseLocation: chooseLocation$4
    };

    var getLocation$8 = normalizeGetLocation(function (args) {
      return wx.getLocation(args);
    }, CONTAINER_NAME$4.WECHAT);
    var getLocation$9 = getLocation$8;

    function _extends$v() { _extends$v = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$v.apply(this, arguments); }
    var openLocation$3 = normalizeOpenLocation(function (args) {
      return wx.openLocation(_extends$v({}, args, {
        latitude: Number(args.latitude),
        longitude: Number(args.longitude)
      }));
    }, CONTAINER_NAME$4.WECHAT);

    var chooseLocation$3 = normalizeChooseLocation(function (args) {
      return wx.chooseLocation(args);
    }, CONTAINER_NAME$4.WECHAT);

    var weChatModule$8 = {
      getLocation: getLocation$9,
      openLocation: openLocation$3,
      chooseLocation: chooseLocation$3
    };

    var getLocation$6 = normalizeGetLocation(function (args) {
      return tt.getLocation(args);
    }, CONTAINER_NAME$4.BYTE);
    var getLocation$7 = getLocation$6;

    function _extends$u() { _extends$u = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$u.apply(this, arguments); }
    var openLocation$2 = normalizeOpenLocation(function (args) {
      return tt.openLocation(_extends$u({}, args, {
        latitude: Number(args.latitude),
        longitude: Number(args.longitude)
      }));
    }, CONTAINER_NAME$4.BYTE);

    var chooseLocation$2 = normalizeChooseLocation(function (args) {
      return tt.chooseLocation(args);
    }, CONTAINER_NAME$4.BYTE);

    var bytedanceModule$8 = {
      getLocation: getLocation$7,
      openLocation: openLocation$2,
      chooseLocation: chooseLocation$2
    };

    var getLocation$4 = normalizeGetLocation(function (args) {
      return swan.getLocation(args);
    }, CONTAINER_NAME$4.BAIDU);
    var getLocation$5 = getLocation$4;

    function _extends$t() { _extends$t = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$t.apply(this, arguments); }
    var openLocation$1 = normalizeOpenLocation(function (args) {
      return swan.openLocation(_extends$t({}, args, {
        latitude: Number(args.latitude),
        longitude: Number(args.longitude)
      }));
    }, CONTAINER_NAME$4.BAIDU);

    var chooseLocation$1 = normalizeChooseLocation(function (args) {
      return swan.chooseLocation(args);
    }, CONTAINER_NAME$4.BAIDU);

    var baiDuModule$8 = {
      getLocation: getLocation$5,
      openLocation: openLocation$1,
      chooseLocation: chooseLocation$1
    };

    var getLocation$2 = normalizeGetLocation(function (args) {
      return ks.getLocation(args);
    }, CONTAINER_NAME$4.KWAI);
    var getLocation$3 = getLocation$2;

    function _extends$s() { _extends$s = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$s.apply(this, arguments); }
    var openLocation = normalizeOpenLocation(function (args) {
      return ks.openLocation(_extends$s({}, args, {
        latitude: Number(args.latitude),
        longitude: Number(args.longitude)
      }));
    }, CONTAINER_NAME$4.KWAI);

    var chooseLocation = normalizeChooseLocation(function (args) {
      return ks.chooseLocation(args);
    }, CONTAINER_NAME$4.KWAI);

    var kuaiShouModule$6 = {
      getLocation: getLocation$3,
      openLocation: openLocation,
      chooseLocation: chooseLocation
    };

    var getLocation$1 = function getLocation(args) {
      if (isWeb$1) {
        return webModule$8.getLocation(args);
      } else if (isKuaiShouMiniProgram) {
        return kuaiShouModule$6.getLocation(args);
      } else if (isWeChatMiniProgram) {
        return weChatModule$8.getLocation(args);
      } else if (isByteDanceMicroApp) {
        return bytedanceModule$8.getLocation(args);
      } else if (isMiniApp) {
        return aliMiniAppModule$8.getLocation(args);
      } else if (isBaiduSmartProgram) {
        return baiDuModule$8.getLocation(args);
      } else {
        throw new Error('Uni API：getLocation暂不支持');
      }
    };

    var mini$6 = getLocation$1;

    var apiConfig$j = {
        web: {
            browser: getLocation$g,
            dingTalk: getLocation$f,
            dingTalkPC: getLocation$g,
            windvane: {
                cnStation: getLocation$h,
                cnNetCom: getLocation$h
            },
        },
        // @ts-ignore TODO TS类型处理，mini容器暂时不改动之前的逻辑
        mini: mini$6,
        panguMiniApp: getLocation$e,
    };
    /**
     * 获取地理位置，此 API 只返回经纬度，如需街道信息，请自行调用 mtop.taobao.wireless.lbs.regeo.getAddress 解析
     * API：https://yuque.antfin.com/cn-xt/arch/lwbvd0
     * @returns {Promise<{latitude: string; longitude: string}>} promise调用结果
     *
     * @example
     * import { getLocation } from '@alife/cn-uni-api';
     *
     * getLocation().then((res) => {
     *   console.log('success', res.latitude, res.longitude);
     * }).catch((error) => {
     *   console.log(error);
     * });
     * @author 敬文
     */
    var getLocation = extend(apiConfig$j, index$f);

    function getNetworkType$4(options, context) {
        var _a;
        var api = 'dd.device.connection.getNetworkType';
        var formatOutput = function (ret) { return ({
            networkType: (ret.result || '').toUpperCase(),
        }); };
        (_a = context === null || context === void 0 ? void 0 : context.DDCall) === null || _a === void 0 ? void 0 : _a.call(context, api, options, { formatOutput: formatOutput });
    }

    function getNetworkType$3(params) {
        // https://h5.alibaba-inc.com/api/WindVane-API.html#WVNetwork-getNetworkType
        var formatOutput = function (ret) {
            var type = "".concat(ret === null || ret === void 0 ? void 0 : ret.type);
            switch (type) {
                case 'WIFI':
                case '5G':
                case '4G':
                case '3G':
                case '2G':
                    break;
                case 'CELL':
                case 'UNKNOWN':
                default:
                    type = 'UNKNOWN';
                    break;
            }
            return { networkType: type };
        };
        WVCall$1('WVNetwork.getNetworkType', params, { formatOutput: formatOutput });
    }

    function getNetworkType$2(params) {
        // https://smallfish.antfin-inc.com/jsapi/getNetworkType.html
        var formatOutput = function (ret) {
            var type = "".concat(ret === null || ret === void 0 ? void 0 : ret.networkInfo);
            switch (type) {
                case 'WIFI':
                case '5G':
                case '4G':
                case '3G':
                case '2G':
                    break;
                case 'NOTREACHABLE':
                    type = 'NONE';
                    break;
                case 'UNKNOWN':
                case 'WWAN':
                default:
                    type = 'UNKNOWN';
                    break;
            }
            return { networkType: type };
        };
        NBCall$1('getNetworkType', params, { formatOutput: formatOutput });
    }

    // 纯web方式兜底
    function getNetworkType$1(params) {
        var _a, _b, _c;
        var type = (_a = navigator === null || navigator === void 0 ? void 0 : navigator.connection) === null || _a === void 0 ? void 0 : _a.effectiveType;
        if (type) {
            // slow-2g/2g/3g/4g
            if (type === 'slow-2g') {
                type = '2g';
            }
        }
        else {
            // bluetooth/cellular/ethernet/none/wifi/wimax/other/unknown
            type = ((_b = navigator === null || navigator === void 0 ? void 0 : navigator.connection) === null || _b === void 0 ? void 0 : _b.type) || 'none'; // not support yet
            if (!['wifi', 'none'].includes(type)) {
                type = 'unknown';
            }
        }
        type = type.toUpperCase();
        (_c = params === null || params === void 0 ? void 0 : params.success) === null || _c === void 0 ? void 0 : _c.call(params, { networkType: type });
    }

    var apiConfig$i = {
        web: {
            browser: getNetworkType$1,
            dingTalk: getNetworkType$4,
            windvane: getNetworkType$3,
            nebula: getNetworkType$2,
        },
    };
    /**
     * 是获取当前网络状态。
     * 小程序API：https://opendocs.alipay.com/mini/api/network-status
     * @returns {Promise<unknown>} promise调用结果
     *
     * @example
     * import { getNetworkType } from '@alife/cn-uni-api';
     *
     * getNetworkType()
     * .then((res) => {
     *   console.log('success', res);
     * })
     * .catch((error) => {
     *   console.log(error);
     * });
     * @author 敬文
     */
    var getNetworkType = extend(apiConfig$i, index$8);

    /** 各端统一的支付返回code */
    var PayResultCodeEnum;
    (function (PayResultCodeEnum) {
        /** '支付成功' */
        PayResultCodeEnum["Success"] = "9000";
        /** 正在处理中 */
        PayResultCodeEnum["Processing"] = "8000";
        /** 失败 */
        PayResultCodeEnum["Fail"] = "4000";
        /** 支付已取消 */
        PayResultCodeEnum["Cancel"] = "6001";
        /** 网络连接出错 */
        PayResultCodeEnum["NetWorkError"] = "6002";
        /** 用户点击忘记密码导致快捷界面退出 */
        PayResultCodeEnum["PasswordError"] = "99";
    })(PayResultCodeEnum || (PayResultCodeEnum = {}));

    var getCnResultCode = function (res) {
        var _a, _b;
        var data = res.data, param = res.param;
        return (_b = (_a = (data || param)) === null || _a === void 0 ? void 0 : _a.aplipayBusinessError) === null || _b === void 0 ? void 0 : _b.errorCode;
    };
    var addPayListener = function (callback) {
        // @ts-ignore: 菜鸟app独有的监听类型
        document.addEventListener('cnFinishPay', callback);
        return {
            remove: function () {
                // @ts-ignore: 菜鸟app独有的监听类型
                document.removeEventListener('cnFinishPay', callback);
            },
        };
    };
    function pay$5(params, context) {
        var resolve = params.success, rest = __rest(params, ["success"]);
        var formatInput = function (options) { return ({
            orderStr: options.payStr,
        }); };
        var manualProcessResSuccess = function (res) {
            /** 安卓部分机型直接返回支付结果 */
            if (getCnResultCode(res)) {
                resolve(__assign$1(__assign$1({}, res), { resultCode: getCnResultCode(res) }));
            }
            else {
                /** ios需要监听cnFinishPay的返回值 */
                var instance_1 = addPayListener(function (listenerRes) {
                    resolve(__assign$1(__assign$1({}, listenerRes), { resultCode: getCnResultCode(listenerRes) }));
                    instance_1.remove();
                });
            }
        };
        context === null || context === void 0 ? void 0 : context.WVCall('CNHybridAliPay.openAlipay', __assign$1(__assign$1({}, rest), { success: manualProcessResSuccess }), {
            formatInput: formatInput,
        });
    }

    function pay$4(params, context) {
        // https://page.cainiao.com/cn-yz/cnyz-book/_book/api/payment.html?spm=a2d5h.23431124.0.0
        var formatInput = function (options) { return ({
            orderInfo: options.payStr,
        }); };
        var formatOutput = function (result) { return (__assign$1(__assign$1({}, result), { resultCode: result.resultStatus })); };
        context === null || context === void 0 ? void 0 : context.WVCall('AliPayModule.payV2', params, {
            formatInput: formatInput,
            formatOutput: formatOutput,
        });
    }

    function pay$3(params, content) {
        var formatInput = function (options) { return ({
            url: options.payStr,
        }); };
        var formatOutput = function (result) { return (__assign$1(__assign$1({}, result), { resultCode: result.ResultStatus })); };
        // TODO 淘宝支付环境待测试
        content === null || content === void 0 ? void 0 : content.WVCall('TBWVPayPasswrdValidateHandler.checkPayPasswordAction', params, {
            formatInput: formatInput,
            formatOutput: formatOutput,
        });
    }

    function pay$2(params, context) {
        var formatInput = function (options) { return ({
            orderStr: options.payStr,
        }); };
        context === null || context === void 0 ? void 0 : context.NBCall('tradePay', params, { formatInput: formatInput });
    }

    function pay$1(params, context) {
        var _a;
        var formatOutput = function (result) { return (__assign$1(__assign$1({}, result), { resultCode: result.resultStatus || result.ResultStatus })); };
        // https://open.dingtalk.com/document/orgapp/payment-interface
        var api = 'dd.biz.alipay.pay';
        (_a = context.DDCall) === null || _a === void 0 ? void 0 : _a.call(context, api, params, {
            formatInput: function (input) {
                return { info: input.payStr }; // 订单信息
            },
            formatOutput: formatOutput,
        });
    }

    var apiConfig$h = {
        web: {
            windvane: {
                cn: pay$5,
                cnStation: pay$4,
                cnNetCom: pay$4,
                tb: pay$3,
            },
            nebula: pay$2,
            dingTalk: pay$1,
        },
    };
    var extendPay = extend(apiConfig$h);
    // errorCode=9000代表支付成功，errorCode=6001代表用户手动取消
    /**
     * 支付
     * pay返回参数不一致，各端统一promise返回，需要再判断一层。这部分暂时用户决定。
     * @[Experimental("实验性功能，线上环境请做好回归测试")]
     * @param payOption 支付参数
     * @returns
     */
    var pay = function (payOption) {
        if (typeof payOption === 'string') {
            return extendPay({ payStr: payOption });
        }
        return extendPay(payOption);
    };

    // 驿站JSBridge：https://page.cainiao.com/cn-yz/cnyz-book/_book/api/share.html
    function saveImage$i(params) {
        // ios下没有 TBSharedModule.saveMultiImage。
        // 所以目前根据端区分解决：https://code.alibaba-inc.com/cn-yz/m-post
        // TODO 推动驿站掌柜Native IOS和Android统一
        if (isIOS$2) {
            WVCall$1('TBSharedModule.saveImage', params, {
                formatInput: function (options) { return ({
                    image: options.url,
                }); },
            });
        }
        else {
            WVCall$1('TBSharedModule.saveMultiImage', params, {
                formatInput: function (options) { return ({
                    url: [options.url],
                }); },
            });
        }
    }

    function saveImage$h(params) {
        var formatInput = function (options) {
            var _a;
            return ({
                src: options.url,
                showActionSheet: (_a = options.showActionSheet) !== null && _a !== void 0 ? _a : false,
                cusHandleResult: true,
            });
        };
        NBCall$1('saveImage', params, { formatInput: formatInput });
    }

    // web方式兜底
    var saveImage$g = function (args) {
        var _a;
        var alink = document.createElement('a');
        alink.href = args === null || args === void 0 ? void 0 : args.url;
        alink.download = '图片';
        alink.click();
        (_a = args === null || args === void 0 ? void 0 : args.success) === null || _a === void 0 ? void 0 : _a.call(args, { success: true });
    };

    function saveImage$f(options, context) {
        var _a;
        (_a = context === null || context === void 0 ? void 0 : context.PanguMiniAppCall) === null || _a === void 0 ? void 0 : _a.call(context, 'saveImage', options);
    }

    /**
     * 钉钉下不支持保存图片，但预览图片功能中存在”保存图片“按钮
     * @param options
     * @param context
     */
    function saveImage$e(options, context) {
        var _a;
        var api = 'dd.biz.util.previewImage';
        (_a = context === null || context === void 0 ? void 0 : context.DDCall) === null || _a === void 0 ? void 0 : _a.call(context, api, options, {
            formatInput: function (o) { return ({
                urls: [o.url],
                current: o.url,
            }); },
        });
    }

    function isUndef$5(type) {
      return type === 'undefined';
    }

    var isDingdingMiniapp$5 = !isUndef$5(typeof dd) && dd !== null && !isUndef$5(typeof dd.alert);

    var CONTAINER_NAME$3 = {
      WECHAT: 'wechatMiniProgram',
      ALIPAY: 'aliMiniApp',
      BYTE: 'bytedanceMicroApp',
      WEB: 'web',
      BAIDU: 'baiduSmartProgram',
      KWAI: 'kuaishouMiniProgram'
    };

    function _extends$r() { _extends$r = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$r.apply(this, arguments); }

    function promisify$4(api) {
      return function (arg) {
        return new Promise(function (resolve, reject) {
          var promisifyArg = arg;
          api(_extends$r({}, promisifyArg, {
            success: function success(res) {
              if (promisifyArg && typeof promisifyArg.success === 'function') {
                promisifyArg.success(res);
              }

              resolve(res);
            },
            onSuccess: function onSuccess(res) {
              if (promisifyArg && typeof promisifyArg.onSuccess === 'function') {
                promisifyArg.onSuccess(res);
              }

              resolve(res);
            },
            fail: function fail(res) {
              if (promisifyArg && typeof promisifyArg.fail === 'function') {
                promisifyArg.fail(res);
              }

              reject(res);
            },
            onFail: function onFail(res) {
              if (promisifyArg && typeof promisifyArg.onFail === 'function') {
                promisifyArg.onFail(res);
              }

              reject(res);
            },
            complete: function complete(res) {
              if (promisifyArg && typeof promisifyArg.complete === 'function') {
                promisifyArg.complete(res);
              }
            },
            onComplete: function onComplete(res) {
              if (promisifyArg && typeof promisifyArg.onComplete === 'function') {
                promisifyArg.onComplete(res);
              }
            }
          }));
        });
      };
    }

    var _excluded$3 = ["_ext"];

    function _objectWithoutPropertiesLoose$3(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

    function _extends$q() { _extends$q = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$q.apply(this, arguments); }
    var styleIn$3 = function styleIn(options, baseName) {
      var _ref = options || {},
          _ref$_ext = _ref._ext,
          _ext = _ref$_ext === void 0 ? {} : _ref$_ext,
          rest = _objectWithoutPropertiesLoose$3(_ref, _excluded$3);

      return _extends$q({}, rest, _ext[baseName] || {});
    };

    function _extends$p() { _extends$p = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$p.apply(this, arguments); }
    var normalize$3 = {
      chooseImage: function chooseImage(api, containerName) {
        var formatResponse = function formatResponse(res) {
          return _extends$p({}, res, {
            tempFiles: res.tempFiles || res.files,
            tempFilePaths: res.tempFilePaths
          });
        };

        return function (args) {
          args = styleIn$3(args, containerName);
          return promisify$4(api)(_extends$p({}, args, {
            count: args.count || 1,
            success: function success(res) {
              args.success && args.success(formatResponse(res));
            },
            complete: function complete(res) {
              args.complete && args.complete(res);
            }
          })).then(formatResponse);
        };
      },
      compressImage: function compressImage(api, containerName) {
        var formatResponse = function formatResponse(res) {
          return {
            tempFilePath: res.tempFilePath || (res.filePaths || [])[0] || (res.apFilePaths || [])[0] || ''
          };
        };

        return function (args) {
          args = styleIn$3(args, containerName);
          return promisify$4(api)(_extends$p({}, args, {
            success: function success(res) {
              args.success && args.success(formatResponse(res));
            },
            complete: function complete(res) {
              args.complete && args.complete(res);
            }
          })).then(formatResponse);
        };
      },
      getImageInfo: function getImageInfo(api, containerName) {
        return function (args) {
          return promisify$4(api)(styleIn$3(args, containerName));
        };
      },
      previewImage: function previewImage(api, containerName) {
        return function (args) {
          return promisify$4(api)(styleIn$3(args, containerName));
        };
      },
      saveImage: function saveImage(api, containerName) {
        return function (args) {
          return promisify$4(api)(styleIn$3(args, containerName));
        };
      }
    };

    var chooseImage$g = normalize$3.chooseImage(function (args) {
      return isDingdingMiniapp$5 ? dd.chooseImage(args) : my.chooseImage(args);
    }, CONTAINER_NAME$3.ALIPAY);
    var chooseImage$h = chooseImage$g;

    var compressImage$a = normalize$3.compressImage(function (args) {
      if (isDingdingMiniapp$5) {
        args.filePaths = [args.src];
      } else {
        args.apFilePaths = [args.src];
      }

      args && typeof args.quality === 'number' && (args.compressLevel = args.quality);
      return isDingdingMiniapp$5 ? dd.compressImage(args) : my.compressImage(args);
    }, CONTAINER_NAME$3.ALIPAY);

    var getImageInfo$c = normalize$3.getImageInfo(function (args) {
      return isDingdingMiniapp$5 ? dd.getImageInfo(args) : my.getImageInfo(args);
    }, CONTAINER_NAME$3.ALIPAY);
    var getImageInfo$d = getImageInfo$c;

    var previewImage$e = normalize$3.previewImage(function (args) {
      return isDingdingMiniapp$5 ? dd.previewImage(args) : my.previewImage(args);
    }, CONTAINER_NAME$3.ALIPAY);
    var previewImage$f = previewImage$e;

    var saveImage$c = normalize$3.saveImage(function (args) {
      return isDingdingMiniapp$5 ? dd.saveImage(args) : my.saveImage(args);
    }, CONTAINER_NAME$3.ALIPAY);
    var saveImage$d = saveImage$c;

    var aliMiniAppModule$7 = {
      chooseImage: chooseImage$h,
      compressImage: compressImage$a,
      getImageInfo: getImageInfo$d,
      previewImage: previewImage$f,
      saveImage: saveImage$d
    };

    var constant$1 = createCommonjsModule(function (module, exports) {

    exports.__esModule = true;
    exports.CONTAINER_NAME = void 0;
    var CONTAINER_NAME = {
      WECHAT: 'wechatMiniProgram',
      ALIPAY: 'aliMiniApp',
      BYTE: 'bytedanceMicroApp',
      WEB: 'web',
      BAIDU: 'baiduSmartProgram',
      KWAI: 'kuaishouMiniProgram'
    };
    exports.CONTAINER_NAME = CONTAINER_NAME;
    });

    var promisify_2$1 = promisify$3;

    function _extends$o() { _extends$o = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$o.apply(this, arguments); }

    function promisify$3(api) {
      return function (arg) {
        return new Promise(function (resolve, reject) {
          var promisifyArg = arg;
          api(_extends$o({}, promisifyArg, {
            success: function success(res) {
              if (promisifyArg && typeof promisifyArg.success === 'function') {
                promisifyArg.success(res);
              }

              resolve(res);
            },
            onSuccess: function onSuccess(res) {
              if (promisifyArg && typeof promisifyArg.onSuccess === 'function') {
                promisifyArg.onSuccess(res);
              }

              resolve(res);
            },
            fail: function fail(res) {
              if (promisifyArg && typeof promisifyArg.fail === 'function') {
                promisifyArg.fail(res);
              }

              reject(res);
            },
            onFail: function onFail(res) {
              if (promisifyArg && typeof promisifyArg.onFail === 'function') {
                promisifyArg.onFail(res);
              }

              reject(res);
            },
            complete: function complete(res) {
              if (promisifyArg && typeof promisifyArg.complete === 'function') {
                promisifyArg.complete(res);
              }
            },
            onComplete: function onComplete(res) {
              if (promisifyArg && typeof promisifyArg.onComplete === 'function') {
                promisifyArg.onComplete(res);
              }
            }
          }));
        });
      };
    }

    var promisify_1$1 = /*#__PURE__*/Object.defineProperty({
    	promisify: promisify_2$1
    }, '__esModule', {value: true});

    var styleOptions$4 = createCommonjsModule(function (module, exports) {

    exports.__esModule = true;
    exports.styleIn = exports.styleOut = void 0;
    var _excluded = ["_ext"];

    function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

    function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

    var styleOut = function styleOut(output, originalInput, originalOutput) {
      return _extends({}, output, {
        _original: {
          input: _extends({}, originalInput),
          // 实际调用 api 方法时传入的参数. 对入参进行 format 之后的结果
          output: _extends({}, originalOutput) // 实际调用 api 方法时传入的参数. 返回值 format 之前的结果

        }
      });
    };

    exports.styleOut = styleOut;

    var styleIn = function styleIn(options, baseName) {
      var _ref = options || {},
          _ref$_ext = _ref._ext,
          _ext = _ref$_ext === void 0 ? {} : _ref$_ext,
          rest = _objectWithoutPropertiesLoose(_ref, _excluded);

      return _extends({}, rest, _ext[baseName] || {});
    };

    exports.styleIn = styleIn;
    });

    var common$1 = createCommonjsModule(function (module, exports) {

    exports.__esModule = true;
    exports.normalize = void 0;





    function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

    var normalize = {
      chooseVideo: function chooseVideo(api, containerName) {
        var formatResponse = function formatResponse(res) {
          return _extends({}, res, {
            tempFilePath: res.tempFilePath || res.filePath
          });
        };

        return function (args) {
          args = (0, styleOptions$4.styleIn)(args, containerName);
          return (0, promisify_1$1.promisify)(api)(_extends({}, args, {
            success: function success(res) {
              args.success && args.success(formatResponse(res));
            },
            complete: function complete(res) {
              args.complete && args.complete(res);
            }
          })).then(formatResponse);
        };
      },
      chooseMedia: function chooseMedia(api, containerName) {
        var formatResponse = function formatResponse(res) {
          return _extends({}, res, {
            tempFiles: (res.tempFiles || res.files).map(function (item) {
              return _extends({}, item, {
                tempFilePath: item.tempFilePath || item.path
              });
            })
          });
        };

        return function (args) {
          if (args === void 0) {
            args = {};
          }

          args = (0, styleOptions$4.styleIn)(_extends({
            count: 9,
            sizeType: ['original', 'compressed'],
            sourceType: ['camera', 'album'],
            mediaType: ['image', 'video'],
            maxDuration: 60
          }, args), containerName);
          return (0, promisify_1$1.promisify)(api)(_extends({}, args, {
            success: function success(res) {
              args.success && args.success(formatResponse(res));
            },
            fail: function fail(res) {
              args.fail && args.fail(res);
            },
            complete: function complete(res) {
              args.complete && args.complete(res);
            }
          })).then(formatResponse);
        };
      }
    };
    exports.normalize = normalize;
    });

    var chooseMedia_1 = createCommonjsModule(function (module, exports) {

    exports.__esModule = true;
    exports.default = void 0;





    function inputCreateAndAppend(multiple, accept) {
      var inputElement = document.createElement('INPUT');
      inputElement.name = 'file';
      inputElement.id = "input-" + Math.random() * 1e8;
      inputElement.type = 'file';
      multiple && inputElement.setAttribute('multiple', 'multiple');
      inputElement.style.display = 'none';
      accept && inputElement.setAttribute('accept', accept);
      document.body.appendChild(inputElement);
      return inputElement;
    }

    var chooseMedia = common$1.normalize.chooseMedia(function (args) {
      if (args === void 0) {
        args = {};
      }

      var _args = args,
          _args$count = _args.count,
          count = _args$count === void 0 ? 9 : _args$count,
          _args$success = _args.success,
          success = _args$success === void 0 ? function () {} : _args$success,
          _args$fail = _args.fail,
          fail = _args$fail === void 0 ? function () {} : _args$fail,
          _args$complete = _args.complete,
          complete = _args$complete === void 0 ? function () {} : _args$complete;

      try {
        var inputElement = inputCreateAndAppend(count > 1, args.accept);
        var files = [];
        inputElement.addEventListener('change', function (e) {
          files = e.target.files && Array.from(e.target.files).slice(0, count);
          var res = {
            tempFiles: files.map(function (file) {
              return {
                tempFilePath: window.URL.createObjectURL(file),
                size: file.size
              };
            }),
            files: files
          };
          success(res);
          complete(res);
          inputElement.remove && inputElement.remove();
        }, false);
        var MouseEvents = document.createEvent('MouseEvents');
        MouseEvents.initEvent('click', true, true);
        inputElement.dispatchEvent(MouseEvents);
      } catch (e) {
        fail(e);
        complete(e);
      }
    }, constant$1.CONTAINER_NAME.WEB);

    var _default = chooseMedia;
    exports.default = _default;
    });

    var chooseMedia = /*@__PURE__*/getDefaultExportFromCjs(chooseMedia_1);

    var chooseImage$e = normalize$3.chooseImage(function (args) {
      if (args === void 0) {
        args = {};
      }

      var _args = args,
          _args$count = _args.count,
          count = _args$count === void 0 ? 1 : _args$count,
          _args$success = _args.success,
          success = _args$success === void 0 ? function () {} : _args$success,
          _args$fail = _args.fail,
          fail = _args$fail === void 0 ? function () {} : _args$fail,
          _args$complete = _args.complete,
          complete = _args$complete === void 0 ? function () {} : _args$complete;
      chooseMedia({
        count: count,
        accept: 'image/*'
      }).then(function (res) {
        var result = {
          tempFilePaths: res.tempFiles.map(function (item) {
            return item.tempFilePath;
          }),
          tempFiles: res.tempFiles.map(function (item) {
            return {
              path: item.tempFilePath,
              size: item.size
            };
          }),
          files: res.files
        };
        success(result);
        complete(result);
      }).catch(function (e) {
        fail(e);
        complete(e);
      });
    }, CONTAINER_NAME$3.WEB);
    var chooseImage$f = chooseImage$e;

    var compressImage$9 = function compressImage() {
      throw new Error('Uni API: compressImage不支持');
    };

    var getImageInfo$a = normalize$3.getImageInfo(function (args) {
      var image = new Image();
      image.src = args.src;

      if (image.naturalWidth) {
        var res = {
          width: image.naturalWidth,
          height: image.naturalHeight,
          path: args.src
        };
        args.success(res);
        args.complete(res);
      } else {
        var setImageInfo = function setImageInfo() {
          var res = {
            width: image.width,
            height: image.height,
            path: args.src
          };
          args.success(res);
          args.complete(res);
        };

        if (image.complete) {
          setImageInfo();
        } else {
          var checkTimer = null;

          var clear = function clear() {
            clearInterval(checkTimer);
            checkTimer = null;
          };

          checkTimer = setInterval(function () {
            if (image.width > 0 || image.height > 0) {
              setImageInfo();
              clear();
            }
          }, 40);

          image.onload = function () {
            if (checkTimer) {
              setImageInfo();
              clear();
            }
          }; // eslint-disable-next-line no-multi-assign


          image.onabort = image.onerror = function (e) {
            args.fail(e);
            args.complete(e);
            clear();
          };
        }
      }
    }, CONTAINER_NAME$3.WEB);
    var getImageInfo$b = getImageInfo$a;

    var clsPrefix = '__universal_preview_image';
    var styles$1 = ("." + clsPrefix + " {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 9999;\n  text-align: center;\n  background: #000;\n  box-sizing: border-box;\n  outline: none;\n  overflow: hidden;\n  animation-duration: .3s;\n  animation-fill-mode: both;\n}\n." + clsPrefix + "_pageindex {\n  position: absolute;\n  top: 12px;\n  left: 0;\n  right: 0;\n  text-align: center;\n  color: #fff;\n  font-size: 16px;\n  z-index: 2;\n}\n." + clsPrefix + "_swiper {\n  position: relative;\n  width: 100%;\n  height: 100%;\n  z-index: 1;\n  display: flex;\n  align-items: center;\n  transition-property: transform;\n  box-sizing: content-box;\n}\n." + clsPrefix + "_item {\n  max-height: 70%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-shrink: 0;\n  width: 100%;\n  position: relative;\n  transition-property: transform;\n  overflow: hidden;\n}\n." + clsPrefix + "_img {\n  width: 100%;\n}\n@keyframes " + clsPrefix + "_fadeIn {\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n@keyframes " + clsPrefix + "_fadeOut {\n  0% {\n    opacity: 1;\n  }\n  100% {\n    opacity: 0;\n  }\n}").replace(/\n/g, '');
    var styleElement = null;
    var previewImage$c = normalize$3.previewImage(function (args) {
      var _ref = args || {},
          _ref$urls = _ref.urls,
          urls = _ref$urls === void 0 ? [] : _ref$urls;

      var _ref2 = args || {},
          _ref2$current = _ref2.current,
          current = _ref2$current === void 0 ? 0 : _ref2$current;

      if (Object.prototype.toString.call(urls) !== '[object Array]') {
        throw new Error('the arguments must contain urls that type is a Array');
      }

      if (urls.length <= 0) {
        throw new Error('the urls`s length is at least 1');
      }

      if (!Number.isSafeInteger(current)) {
        throw new Error('the current must be a safe integer');
      }

      current = Math.min(Math.max(current, 0), urls.length - 1);

      if (!styleElement) {
        // create a style tag for keyframes
        styleElement = document.createElement('style');
        styleElement.innerHTML = styles$1;
        document.body.appendChild(styleElement);
      }

      var containerEle = document.createElement('div');
      containerEle.className = clsPrefix;
      containerEle.style.animationName = clsPrefix + "_fadeIn";
      containerEle.addEventListener('click', function () {
        containerEle && (containerEle.style.animationName = clsPrefix + "_fadeOut");
        setTimeout(function () {
          containerEle && document.body.removeChild(containerEle);
          containerEle = null;
        }, 300);
      });
      var pageIndexEle = document.createElement('div');
      pageIndexEle.className = clsPrefix + "_pageindex";
      pageIndexEle.innerText = current + 1 + "/" + urls.length;
      containerEle.appendChild(pageIndexEle);
      var swiperEle = document.createElement('div');
      swiperEle.className = clsPrefix + "_swiper";
      var damp = 1;
      var clientWidth = document.documentElement.clientWidth;
      var startX = 0;
      swiperEle.addEventListener('touchstart', function (e) {
        if (e.touches.length > 1) {
          e.stopPropagation();
          e.preventDefault();
        }

        startX = e.targetTouches[0].pageX;
      });
      swiperEle.addEventListener('touchmove', function (e) {
        if (e.touches.length > 1) {
          e.stopPropagation();
          e.preventDefault();
        }

        var moveX = e.targetTouches[0].pageX - startX;
        swiperEle.style.transform = "translateX(" + (-clientWidth * current + moveX * damp) + "px)";
      });
      swiperEle.addEventListener('touchend', function (e) {
        var endX = e.changedTouches[0].pageX - startX;

        if (Math.abs(endX * damp) > clientWidth / 5) {
          current = endX < 0 ? Math.min(current + 1, urls.length - 1) : Math.max(current - 1, 0);
        }

        pageIndexEle.innerText = current + 1 + "/" + urls.length;
        var transitionDuration = 300;
        swiperEle.style.transitionDuration = transitionDuration + "ms";
        swiperEle.style.transform = "translateX(" + -clientWidth * current + "px)";
        setTimeout(function () {
          swiperEle.style.transitionDuration = '0ms';
        }, transitionDuration);
      });
      swiperEle.style.transform = "translateX(" + -clientWidth * current + "px)";
      containerEle.appendChild(swiperEle);
      urls.forEach(function (url) {
        var swiperItemEle = document.createElement('div');
        swiperItemEle.className = clsPrefix + "_item";
        swiperItemEle.addEventListener('click', function (e) {
          e.stopPropagation();
          containerEle && (containerEle.style.animationName = clsPrefix + "_fadeOut");
          setTimeout(function () {
            containerEle && document.body.removeChild(containerEle);
            containerEle = null;
          }, 300);
        });
        swiperEle.appendChild(swiperItemEle);
        var imageEle = document.createElement('img');
        imageEle.className = clsPrefix + "_img";
        imageEle.src = url;
        swiperItemEle.appendChild(imageEle);
        swiperItemEle.addEventListener('touchstart', function (e) {
          if (e.touches.length > 1) {
            e.stopPropagation();
            e.preventDefault();
            var point1 = e.touches[0];
            var point2 = e.touches[1];
            var xLen = Math.abs(point2.pageX - point1.pageX);
            var yLen = Math.abs(point2.pageY - point1.pageY);
            swiperItemEle.touchDistance = Math.sqrt(xLen * xLen + yLen * yLen);
          } else {
            swiperItemEle.touched = {
              x: e.touches[0].pageX,
              y: e.touches[0].pageY
            };
          }
        });
        swiperItemEle.addEventListener('touchmove', function (e) {
          if (e.touches.length > 1) {
            e.stopPropagation();
            e.preventDefault();
            var xLen = Math.abs(e.touches[0].pageX - e.touches[1].pageX);
            var yLen = Math.abs(e.touches[1].pageY - e.touches[1].pageY);
            var touchDistance = Math.sqrt(xLen * xLen + yLen * yLen);

            if (swiperItemEle.touchDistance) {
              var pinchScale = (swiperItemEle.previousPinchScale || 1) + (touchDistance - swiperItemEle.touchDistance) / swiperItemEle.touchDistance;
              var imageScale = Math.max(1, pinchScale);
              imageEle.style.transform = "scale(" + imageScale + ")";
              swiperItemEle.previousPinchScale = imageScale;
            }

            swiperItemEle.touchDistance = touchDistance;
          } else if (swiperItemEle.previousPinchScale > 1) {
            e.stopPropagation();
            var x = (swiperItemEle.preX || 0) + (e.touches[0].pageX - swiperItemEle.touched.x);
            var y = (swiperItemEle.preY || 0) + (e.touches[0].pageY - swiperItemEle.touched.y);
            imageEle.style.transform = "scale(" + swiperItemEle.previousPinchScale + ") translate(" + x + "px, " + y + "px)";
            swiperItemEle.preX = x;
            swiperItemEle.preY = y;
            swiperItemEle.touched = {
              x: e.touches[0].pageX,
              y: e.touches[0].pageY
            };
          }
        });
      });
      document.body.appendChild(containerEle);
    }, CONTAINER_NAME$3.WEB);
    var previewImage$d = previewImage$c;

    var saveImage$a = function saveImage() {
      throw new Error('Uni API: saveImage不支持');
    };

    var saveImage$b = saveImage$a;

    var webModule$7 = {
      chooseImage: chooseImage$f,
      compressImage: compressImage$9,
      getImageInfo: getImageInfo$b,
      previewImage: previewImage$d,
      saveImage: saveImage$b
    };

    var chooseImage$c = normalize$3.chooseImage(function (args) {
      return wx.chooseImage(args);
    }, CONTAINER_NAME$3.WECHAT);
    var chooseImage$d = chooseImage$c;

    var compressImage$8 = normalize$3.compressImage(function (args) {
      args && typeof args.quality === 'number' && (args.quality = args.quality * 33);
      return wx.compressImage(args);
    }, CONTAINER_NAME$3.WECHAT);

    var getImageInfo$8 = normalize$3.getImageInfo(function (args) {
      return wx.getImageInfo(args);
    }, CONTAINER_NAME$3.WECHAT);
    var getImageInfo$9 = getImageInfo$8;

    function _extends$n() { _extends$n = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$n.apply(this, arguments); }
    var previewImage$a = normalize$3.previewImage(function (args) {
      wx.previewImage(_extends$n({}, args, {
        current: typeof args.current === 'number' ? args.urls[args.current] : args.urls[0]
      }));
    }, CONTAINER_NAME$3.WECHAT);
    var previewImage$b = previewImage$a;

    function _extends$m() { _extends$m = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$m.apply(this, arguments); }
    var saveImage$8 = normalize$3.saveImage(function (args) {
      wx.saveImageToPhotosAlbum(_extends$m({}, args, {
        filePath: args.url
      }));
    }, CONTAINER_NAME$3.WECHAT);
    var saveImage$9 = saveImage$8;

    var weChatModule$7 = {
      chooseImage: chooseImage$d,
      compressImage: compressImage$8,
      getImageInfo: getImageInfo$9,
      previewImage: previewImage$b,
      saveImage: saveImage$9
    };

    var chooseImage$a = normalize$3.chooseImage(function (args) {
      return tt.chooseImage(args);
    }, CONTAINER_NAME$3.BYTE);
    var chooseImage$b = chooseImage$a;

    var compressImage$7 = normalize$3.compressImage(function (args) {
      args && typeof args.quality === 'number' && (args.quality = args.quality * 33);
      return tt.compressImage(args);
    }, CONTAINER_NAME$3.BYTE);

    var getImageInfo$6 = normalize$3.getImageInfo(function (args) {
      return tt.getImageInfo(args);
    }, CONTAINER_NAME$3.BYTE);
    var getImageInfo$7 = getImageInfo$6;

    function _extends$l() { _extends$l = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$l.apply(this, arguments); }
    var previewImage$8 = normalize$3.previewImage(function (args) {
      tt.previewImage(_extends$l({}, args, {
        current: typeof args.current === 'number' ? args.urls[args.current] : args.urls[0]
      }));
    }, CONTAINER_NAME$3.BYTE);
    var previewImage$9 = previewImage$8;

    function _extends$k() { _extends$k = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$k.apply(this, arguments); }
    var saveImage$6 = normalize$3.saveImage(function (args) {
      tt.saveImageToPhotosAlbum(_extends$k({}, args, {
        filePath: args.url
      }));
    }, CONTAINER_NAME$3.BYTE);
    var saveImage$7 = saveImage$6;

    var bytedanceModule$7 = {
      chooseImage: chooseImage$b,
      compressImage: compressImage$7,
      getImageInfo: getImageInfo$7,
      previewImage: previewImage$9,
      saveImage: saveImage$7
    };

    var chooseImage$8 = normalize$3.chooseImage(function (args) {
      return ks.chooseImage(args);
    }, CONTAINER_NAME$3.KWAI);
    var chooseImage$9 = chooseImage$8;

    var compressImage$6 = normalize$3.compressImage(function (args) {
      args && typeof args.quality === 'number' && (args.quality *= 33);
      return ks.compressImage(args);
    }, CONTAINER_NAME$3.KWAI);

    var getImageInfo$4 = normalize$3.getImageInfo(function (args) {
      return ks.getImageInfo(args);
    }, CONTAINER_NAME$3.KWAI);
    var getImageInfo$5 = getImageInfo$4;

    function _extends$j() { _extends$j = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$j.apply(this, arguments); }
    var previewImage$6 = normalize$3.previewImage(function (args) {
      ks.previewImage(_extends$j({}, args, {
        current: typeof args.current === 'number' ? args.urls[args.current] : args.urls[0]
      }));
    }, CONTAINER_NAME$3.KWAI);
    var previewImage$7 = previewImage$6;

    function _extends$i() { _extends$i = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$i.apply(this, arguments); }
    var saveImage$4 = normalize$3.saveImage(function (args) {
      ks.saveImageToPhotosAlbum(_extends$i({}, args, {
        filePath: args.url
      }));
    }, CONTAINER_NAME$3.KWAI);
    var saveImage$5 = saveImage$4;

    var kuaiShouModule$5 = {
      chooseImage: chooseImage$9,
      compressImage: compressImage$6,
      getImageInfo: getImageInfo$5,
      previewImage: previewImage$7,
      saveImage: saveImage$5
    };

    var chooseImage$6 = normalize$3.chooseImage(function (args) {
      return swan.chooseImage(args);
    }, CONTAINER_NAME$3.BAIDU);
    var chooseImage$7 = chooseImage$6;

    var compressImage$5 = normalize$3.compressImage(function (args) {
      args && typeof args.quality === 'number' && (args.quality *= 33);
      return swan.compressImage(args);
    }, CONTAINER_NAME$3.BAIDU);

    var getImageInfo$2 = normalize$3.getImageInfo(function (args) {
      return swan.getImageInfo(args);
    }, CONTAINER_NAME$3.BAIDU);
    var getImageInfo$3 = getImageInfo$2;

    function _extends$h() { _extends$h = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$h.apply(this, arguments); }
    var previewImage$4 = normalize$3.previewImage(function (args) {
      swan.previewImage(_extends$h({}, args, {
        current: typeof args.current === 'number' ? args.urls[args.current] : args.urls[0]
      }));
    }, CONTAINER_NAME$3.BAIDU);
    var previewImage$5 = previewImage$4;

    function _extends$g() { _extends$g = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$g.apply(this, arguments); }
    var saveImage$2 = normalize$3.saveImage(function (args) {
      swan.saveImageToPhotosAlbum(_extends$g({}, args, {
        filePath: args.url
      }));
    }, CONTAINER_NAME$3.BAIDU);
    var saveImage$3 = saveImage$2;

    var baiDuModule$7 = {
      chooseImage: chooseImage$7,
      compressImage: compressImage$5,
      getImageInfo: getImageInfo$3,
      previewImage: previewImage$5,
      saveImage: saveImage$3
    };

    var chooseImage$5 = function chooseImage(args) {
      if (isWeb$1) {
        return webModule$7.chooseImage(args);
      } else if (isKuaiShouMiniProgram) {
        return kuaiShouModule$5.chooseImage(args);
      } else if (isWeChatMiniProgram) {
        return weChatModule$7.chooseImage(args);
      } else if (isByteDanceMicroApp) {
        return bytedanceModule$7.chooseImage(args);
      } else if (isMiniApp) {
        return aliMiniAppModule$7.chooseImage(args);
      } else if (isBaiduSmartProgram) {
        return baiDuModule$7.chooseImage(args);
      } else {
        throw new Error('Uni API：chooseImage暂不支持');
      }
    };
    var compressImage$4 = function compressImage(args) {
      if (isWeb$1) {
        return webModule$7.compressImage();
      } else if (isKuaiShouMiniProgram) {
        return kuaiShouModule$5.compressImage(args);
      } else if (isWeChatMiniProgram) {
        return weChatModule$7.compressImage(args);
      } else if (isByteDanceMicroApp) {
        return bytedanceModule$7.compressImage(args);
      } else if (isMiniApp) {
        return aliMiniAppModule$7.compressImage(args);
      } else if (isBaiduSmartProgram) {
        return baiDuModule$7.compressImage(args);
      } else {
        throw new Error('Uni API：compressImage暂不支持');
      }
    };
    var getImageInfo$1 = function getImageInfo(args) {
      if (isWeb$1) {
        return webModule$7.getImageInfo(args);
      } else if (isKuaiShouMiniProgram) {
        return kuaiShouModule$5.getImageInfo(args);
      } else if (isWeChatMiniProgram) {
        return weChatModule$7.getImageInfo(args);
      } else if (isByteDanceMicroApp) {
        return bytedanceModule$7.getImageInfo(args);
      } else if (isMiniApp) {
        return aliMiniAppModule$7.getImageInfo(args);
      } else if (isBaiduSmartProgram) {
        return baiDuModule$7.getImageInfo(args);
      } else {
        throw new Error('Uni API：getImageInfo暂不支持');
      }
    };
    var previewImage$3 = function previewImage(args) {
      if (isWeb$1) {
        return webModule$7.previewImage(args);
      } else if (isKuaiShouMiniProgram) {
        return kuaiShouModule$5.previewImage(args);
      } else if (isWeChatMiniProgram) {
        return weChatModule$7.previewImage(args);
      } else if (isByteDanceMicroApp) {
        return bytedanceModule$7.previewImage(args);
      } else if (isMiniApp) {
        return aliMiniAppModule$7.previewImage(args);
      } else if (isBaiduSmartProgram) {
        return baiDuModule$7.previewImage(args);
      } else {
        throw new Error('Uni API：previewImage暂不支持');
      }
    };
    var saveImage$1 = function saveImage(args) {
      if (isWeb$1) {
        return webModule$7.saveImage();
      } else if (isKuaiShouMiniProgram) {
        return kuaiShouModule$5.saveImage(args);
      } else if (isWeChatMiniProgram) {
        return weChatModule$7.saveImage(args);
      } else if (isByteDanceMicroApp) {
        return bytedanceModule$7.saveImage(args);
      } else if (isMiniApp) {
        return aliMiniAppModule$7.saveImage(args);
      } else if (isBaiduSmartProgram) {
        return baiDuModule$7.saveImage(args);
      } else {
        throw new Error('Uni API：saveImage暂不支持');
      }
    };
    var image = {
      chooseImage: chooseImage$5,
      compressImage: compressImage$4,
      getImageInfo: getImageInfo$1,
      previewImage: previewImage$3,
      saveImage: saveImage$1
    };

    var mini$5 = saveImage$1;

    // api: https://uni-apis.alibaba-inc.com/doc/Media/saveimage
    var apiConfig$g = {
        web: {
            browser: saveImage$g,
            dingTalk: saveImage$e,
            dingTalkPC: saveImage$e,
            nebula: saveImage$h,
            windvane: {
                cnStation: saveImage$i,
                cnNetCom: saveImage$i,
            },
        },
        mini: mini$5,
        panguMiniApp: saveImage$f,
    };
    var extendSaveImage = extend(apiConfig$g, 
    /** baseSaveImage 支持windvane容器 */
    index$c);
    /**
     * 保存图片。API：https://yuque.antfin.com/cn-xt/arch/lwbvd0
     * @param  {!string|SaveImageIOptions} url 图片地址或者base64。（目前已知windvane容器支持base64）
     * @param  {?SaveImageParams} params 当第一个参数为string格式时，此参数有效。
     * @returns {Promise<unknown>} promise调用结果

     * @example 使用案例：
     * import { saveImage } from '@alife/cn-uni-api';
     *
     *  saveImage('https://gw.alicdn.com/imgextra/i4/O1CN01tmIVdW22WftYPPH1O_!!6000000007128-2-tps-135-133.png'）
     *  .then(() => {
     *    console.log('success');
     *  })
     *  .catch((error) => {
     *    console.log(error);
     *  });
     * @author 敬文
     */
    var saveImage = function (url, params) {
        if (typeof url === 'string') {
            return extendSaveImage(__assign$1(__assign$1({}, params), { url: url }));
        }
        return extendSaveImage(url);
    };

    function chooseImage$4(options, context) {
        var _a;
        (_a = context === null || context === void 0 ? void 0 : context.PanguMiniAppCall) === null || _a === void 0 ? void 0 : _a.call(context, 'chooseImage', options);
    }

    var mini$4 = chooseImage$5;

    // API: https://open.dingtalk.com/document/orgapp-client/obtain-current-geographic-location-information-single-positioning?spm=ding_open_doc.document.0.0.c97f4399SeHacV#topic-2025194
    function chooseImage$3(options, context) {
        var _a;
        var api = 'dd.biz.util.chooseImage'; // 该api需要钉钉鉴权：https://open.dingtalk.com/document/orgapp-client/jsapi-overview
        var formatOutput = function (ret) { return ({
            tempFilePaths: ret === null || ret === void 0 ? void 0 : ret.filePaths,
            tempFiles: ret === null || ret === void 0 ? void 0 : ret.files,
        }); };
        (_a = context === null || context === void 0 ? void 0 : context.DDCall) === null || _a === void 0 ? void 0 : _a.call(context, api, options, { formatOutput: formatOutput });
    }

    var apiConfig$f = {
        // @ts-ignore TODO TS类型处理，mini容器暂时不改动之前的逻辑
        mini: mini$4,
        panguMiniApp: chooseImage$4,
        dingTalk: chooseImage$3,
    };
    /**
     * 选择相册/拍照
     * 支持端：淘系App、钉钉。
     * 注意：该API在钉钉App权限高，需要自行前置dd.config鉴权，详见：https://open.dingtalk.com/document/isvapp/jsapi-authentication
     * @returns {Promise<unknown>} promise调用结果
     * @example 使用案例：
     * import { chooseImage } from '@alife/cn-uni-api'; // h5、小程序通用包
     *
     * chooseImage()
     *   .then((res) => {
     *     console.log('success');
     *   })
     *   .catch((error) => {
     *     console.log(error);
     *   });
     * @author 敬文
     */
    var chooseImage$2 = extend(apiConfig$f, 
    /** baseChooseImage 支持windvane容器、nebula容器 */
    index$u);

    function previewImage$2(params) {
        var formatInput = function (_a) {
            var urls = _a.urls, current = _a.current;
            return ({
                images: urls,
                index: Number(current || 0),
            });
        };
        WVCall$1('WVUIImagepreview.showImagepreview', params, { formatInput: formatInput });
    }

    function previewImage$1(options, context) {
        var _a;
        var api = 'dd.biz.util.previewImage';
        var formatInput = function (input) {
            var _a, _b;
            var current = (_a = input === null || input === void 0 ? void 0 : input.urls) === null || _a === void 0 ? void 0 : _a[0];
            if (input.current !== undefined) {
                current = (_b = input === null || input === void 0 ? void 0 : input.urls) === null || _b === void 0 ? void 0 : _b[Number(input.current)];
            }
            return { current: current };
        };
        (_a = context === null || context === void 0 ? void 0 : context.DDCall) === null || _a === void 0 ? void 0 : _a.call(context, api, options, { formatInput: formatInput });
    }

    var mini$3 = previewImage$3;

    var apiConfig$e = {
        web: {
            dingTalk: previewImage$1,
            windvane: {
                cn: previewImage$2,
                cnStation: previewImage$2,
                cnNetCom: previewImage$2,
            },
        },
        // @ts-ignore TODO TS类型处理，mini容器暂时不改动之前的逻辑
        mini: mini$3,
    };
    var extendPreviewImage = extend(apiConfig$e, index$1$1);
    /**
     * 预览图片
     * @param  {!string | string[] | PreviewImageIOptions} urls 预览的图片地址
     * @param  {?PreviewImageIOptions} params 当第一个参数为string 或 string[]格式时，此参数有效。
     * @returns {Promise<unknown>} promise调用结果

     * @example 使用案例：
     * import { previewImage } from '@alife/cn-uni-api';
     *
     *  previewImage('https://gw.alicdn.com/imgextra/i4/O1CN01tmIVdW22WftYPPH1O_!!6000000007128-2-tps-135-133.png'）
     *  .then(() => {
     *    console.log('success');
     *  })
     *  .catch((error) => {
     *    console.log(error);
     *  });
     * @author 敬文
     */
    var previewImage = function (urls, params) {
        if (isString(urls)) {
            return extendPreviewImage(__assign$1(__assign$1({}, params), { urls: [urls] }));
        }
        if (isArray(urls)) {
            return extendPreviewImage(__assign$1(__assign$1({}, params), { urls: urls }));
        }
        return extendPreviewImage(urls);
    };

    function compressImage$3(params, context) {
        var _a;
        // 钉钉h5微应用 ref: https://open.dingtalk.com/document/orgapp/compress-images
        var api = 'dd.biz.util.compressImage';
        (_a = context.DDCall) === null || _a === void 0 ? void 0 : _a.call(context, api, params);
    }

    function compressImage$2(options, context) {
        // 钉钉小程序 ref: https://open.dingtalk.com/document/orgapp/dd-compressimage
        context === null || context === void 0 ? void 0 : context.PanguMiniAppCall('compressImage', options);
    }

    // https://universal-api.js.org/packages/media/compress-image
    function compressImage$1(options) {
        var success = options.success, fail = options.fail, filePaths = options.filePaths, _a = options.compressLevel, compressLevel = _a === void 0 ? 0 : _a;
        // 压缩质量，范围0～3，1-低，2-中，3-高
        var quality = compressLevel > 0 && compressLevel <= 3 ? compressLevel - 1 : 0;
        compressImage$4({
            src: filePaths === null || filePaths === void 0 ? void 0 : filePaths[0],
            quality: quality,
        })
            .then(function (tempFilePath) { return success({ filePaths: [tempFilePath] }); })
            .catch(fail);
    }

    /**
     * 压缩图片
     * 支持端：钉钉、盘古小程序、小程序
     * @returns {Promise<unknown>} promise调用结果
     * @example 使用案例：
     * import { compressImage } from '@alife/cn-uni-api';
     *
     * compressImage({
     *    // 图片数组
     *    filePaths: ['链接1', '链接2']
     *    // 压缩程度
     *    compressLevel: 4
     * })
     *   .then((res) => {
     *     console.log('success', res);
     *   })
     *   .catch((error) => {
     *     console.log('fail', error);
     *   });
     * @author 余国平、敬文
     */
    var compressImage = extend({
        web: {
            dingTalk: compressImage$3,
        },
        mini: compressImage$1,
        panguMiniApp: compressImage$2,
    });

    /*! *****************************************************************************
    Copyright (c) Microsoft Corporation.

    Permission to use, copy, modify, and/or distribute this software for any
    purpose with or without fee is hereby granted.

    THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
    REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
    AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
    INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
    LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
    OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
    PERFORMANCE OF THIS SOFTWARE.
    ***************************************************************************** */

    var __assign = function() {
        __assign = Object.assign || function __assign(t) {
            for (var s, i = 1, n = arguments.length; i < n; i++) {
                s = arguments[i];
                for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
            }
            return t;
        };
        return __assign.apply(this, arguments);
    };

    function __read(o, n) {
        var m = typeof Symbol === "function" && o[Symbol.iterator];
        if (!m) return o;
        var i = m.call(o), r, ar = [], e;
        try {
            while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
        }
        catch (error) { e = { error: error }; }
        finally {
            try {
                if (r && !r.done && (m = i["return"])) m.call(i);
            }
            finally { if (e) throw e.error; }
        }
        return ar;
    }

    function __spread() {
        for (var ar = [], i = 0; i < arguments.length; i++)
            ar = ar.concat(__read(arguments[i]));
        return ar;
    }

    var _a;
    var isWeb = typeof window !== 'undefined' && 'onload' in window;
    typeof dd !== 'undefined' && !!dd && typeof dd.showtoast === 'function';
    var isMiniAli = typeof my !== 'undefined' && !!my && (typeof my.showToast === 'function' || typeof my.navigateTo === 'function');
    var isMiniTt = typeof tt !== 'undefined' && !!tt && typeof tt.showtoast === 'function';
    var isMiniWx = !isMiniTt &&
        typeof wx !== 'undefined' &&
        !!wx &&
        (typeof wx.login !== 'undefined' || typeof wx.miniProgram !== 'undefined');
    var isMini = isMiniAli || isMiniWx || isMiniTt;
    typeof WXEnvironment !== 'undefined' &&
        !!WXEnvironment &&
        WXEnvironment.platform !== 'Web';
    var aliUA = '';
    try {
        aliUA = navigator.userAgent || navigator.swuserAgent || '';
    }
    catch (error) {
        aliUA = '';
    }
    var isMiniweb = (isWeb && aliUA.indexOf('Triver') > -1) || aliUA.indexOf('miniProgram') > -1;
    var aliAppMatches = /.+AliApp\((\w+)\/((?:\d+\.)+\d+)\)/.exec(aliUA || '') || [];
    (_a = aliAppMatches[1]) === null || _a === void 0 ? void 0 : _a.toLocaleLowerCase();
    var isWindvane = /.+AliApp\((\w+)\/((?:\d+\.)+\d+)\).* .*(WindVane)(?:\/((?:\d+\.)+\d+))?.*/.test(aliUA || '');
    var isNebula = /.+AliApp\((\w+)\/((?:\d+\.)+\d+)\)/.test(aliUA || '') &&
        /.*(Nebula)(?:\/((?:\d+\.)+\d+))?.*/.test(aliUA || '');
    var isFliggy = /.+AliApp\((\w+)\/((?:\d+\.)+\d+)\) .*(AliTrip)(?:\/((?:\d+\.)+\d+))?.*/.test(aliUA || '');
    var isDingTalk = /.+AliApp\((DingTalk)\/((?:\d+\.)+\d+)?.*/.test(aliUA || '');
    var isDingTalkPC = /\s+DingTalk\(/i.test(aliUA);
    aliUA.indexOf('Android') > -1 || aliUA.indexOf('Adr') > -1;
    !!aliUA.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);

    function notSupport(_a) {
        var fail = _a.fail;
        fail({
            errCode: '1',
            errMsg: 'not support',
        });
    }
    function enhanceSuccess(success, _originalInput, formatOptions, formatErrorOptions) {
        if (success === void 0) { success = function (ret) { return ret; }; }
        if (formatOptions === void 0) { formatOptions = {}; }
        if (formatErrorOptions === void 0) { formatErrorOptions = {}; }
        var formatOutput = formatOptions.formatOutput, outputMap = formatOptions.outputMap;
        return function (ret) {
            var _a;
            if (ret && ret.error) {
                var onFail = enhanceFail(_originalInput && _originalInput.fail, formatErrorOptions);
                return onFail(ret);
            }
            var output = {};
            if (typeof formatOutput === 'function') {
                output = formatOutput(ret);
            }
            else if (outputMap) {
                (_a = Object.keys(outputMap)) === null || _a === void 0 ? void 0 : _a.forEach(function (key) {
                    output[key] = ret[outputMap[key]];
                });
            }
            output = __assign(__assign({}, ret), output);
            outputMap && delete outputMap.ret;
            outputMap && delete outputMap.status;
            success(__assign(__assign({}, output), { _original: {
                    input: _originalInput,
                    output: ret,
                } }));
        };
    }
    function enhanceFail(fail, formatOptions) {
        if (fail === void 0) { fail = function (e) { return e; }; }
        if (formatOptions === void 0) { formatOptions = {}; }
        return function (e) {
            var _a;
            var formatOutput = formatOptions.formatOutput, outputMap = formatOptions.outputMap;
            var output = {};
            if (typeof formatOutput === 'function') {
                output = formatOutput(e);
            }
            else if (outputMap) {
                (_a = Object.keys(outputMap)) === null || _a === void 0 ? void 0 : _a.forEach(function (key) {
                    output[key] = e[outputMap[key]];
                });
            }
            output = __assign(__assign({}, e), output);
            outputMap && delete outputMap.ret;
            outputMap && delete outputMap.status;
            return fail(__assign({ _originalErrInfo: e }, output));
        };
    }
    function apiCall(apiName, params, JSCall, formatOptions, errFormatOptions) {
        var _a;
        if (formatOptions === void 0) { formatOptions = {}; }
        if (errFormatOptions === void 0) { errFormatOptions = {}; }
        var success = params.success, fail = params.fail;
        var options = {};
        var formatInput = formatOptions.formatInput, inputMap = formatOptions.inputMap, formatOutput = formatOptions.formatOutput, outputMap = formatOptions.outputMap;
        if (typeof formatInput === 'function') {
            options = formatInput(params);
        }
        else if (inputMap) {
            (_a = Object.keys(inputMap)) === null || _a === void 0 ? void 0 : _a.forEach(function (key) {
                options[key] = params[inputMap[key]];
            });
        }
        options = __assign(__assign({}, params), options);
        var onSuccess = enhanceSuccess(success, options, {
            outputMap: outputMap,
            formatOutput: formatOutput,
        }, errFormatOptions);
        var onFail = enhanceFail(fail, errFormatOptions);
        apiName
            ? JSCall(apiName, options, onSuccess, onFail)
            : JSCall(__assign(__assign({}, options), { onSuccess: onSuccess, onFail: onFail }));
    }
    function promisifyApi(apiFn, plugins) {
        var promisify = function (apiFn) { return function (params) {
            if (params === void 0) { params = {}; }
            return new Promise(function (resolve, reject) {
                var success = function (e) {
                    if (typeof params.success === 'function') {
                        params.success(e);
                    }
                    else {
                        resolve(e);
                    }
                };
                var fail = function (e) {
                    typeof params.fail === 'function' && params.fail(e);
                    reject(e);
                };
                if (!params.onSuccess) {
                    params.onSuccess = success;
                }
                if (!params.onFail) {
                    params.onFail = fail;
                }
                apiFn(__assign(__assign({}, params), { success: success, fail: fail }));
            });
        }; };
        var api = promisify(apiFn);
        return api;
    }

    var ERR_USER_CANCEL = '11';
    var ERR_COMMON = '11';
    var ERR_MSG_CANCEL = 'cancel';
    var ERR_MSG_COMMON = 'call failed';

    var JSCall$1 = function (api, options, success, failure) {
        if (success === void 0) { success = function (r) { }; }
        if (failure === void 0) { failure = function (e) { }; }
        if (typeof options === 'function') {
            failure = success;
            success = options;
            options = {};
        }
        if (!__windvane__.call) {
            new Function(__windvane__.windVaneCoreJs())();
        }
        __windvane__.call(api, options, success, failure);
    };
    function WVCall(apiName, params, formatOptions, errFormatOptions) {
        if (formatOptions === void 0) { formatOptions = {}; }
        if (errFormatOptions === void 0) { errFormatOptions = {}; }
        apiCall(apiName, params, JSCall$1, formatOptions, errFormatOptions);
    }
    function chooseImage$1(params) {
        var formatInput = function (options) {
            var _a, _b;
            var mode = 'both';
            var sourceTypeInlcudeCamera = ((_a = options.sourceType) === null || _a === void 0 ? void 0 : _a.indexOf('camera')) > -1;
            var sourceTypeInlcudePhoto = ((_b = options.sourceType) === null || _b === void 0 ? void 0 : _b.indexOf('album')) > -1;
            if (sourceTypeInlcudeCamera || sourceTypeInlcudePhoto) {
                if (sourceTypeInlcudeCamera) {
                    mode = 'camera';
                }
                if (sourceTypeInlcudePhoto) {
                    mode = 'photo';
                }
            }
            return {
                type: '0',
                v: '2.0',
                mode: mode,
                mutipleSelection: options.multipleSelection || '0',
                bizCode: 'mtopupload',
                needLogin: false,
                maxSelect: options.count || 1,
            };
        };
        var formatOutput = function (ret) {
            var images = ret.images;
            return params.multipleSelection == '1'
                ? {
                    tempFilePaths: images.map(function (image) { return image.localPath; }),
                    tempFiles: images.map(function (image) {
                        return {
                            path: image.localPath,
                            previewURL: image.url,
                        };
                    }),
                }
                : {
                    tempFilePaths: [ret.localPath],
                    tempFiles: [
                        {
                            path: ret.localPath,
                            previewURL: ret.url,
                        },
                    ],
                };
        };
        var errFormatOutput = function (error) {
            var errorCode = error.status === 'RET_PHOTO_CANCEL' ? ERR_USER_CANCEL : ERR_COMMON;
            var errorMsg = error.msg === 'RET_PHOTO_CANCEL' ? ERR_MSG_CANCEL : ERR_MSG_COMMON;
            return {
                error: errorCode,
                errorMsg: errorMsg,
            };
        };
        return WVCall('WVCamera.takePhoto', params, {
            formatInput: formatInput,
            formatOutput: formatOutput,
        }, { formatOutput: errFormatOutput });
    }
    function chooseAndUploadImage$3(params) {
        chooseImage$1(__assign(__assign({}, params), { success: function (res) {
                var options = __assign(__assign({}, res), params);
                uploadImage$1(options);
            } }));
    }
    function uploadImage$1(params) {
        var files = params.tempFiles || params.files;
        if (files && files.length && files[0].path) {
            var urlList_1 = [];
            var originalRes_1 = [];
            files
                .reduce(function (promise, file) {
                return promise.then(function () {
                    return new Promise(function (resolve1, reject1) {
                        var options = {
                            path: file.path,
                            v: '2.0',
                            bizCode: params.bizCode || 'mtopupload',
                            needLogin: false,
                        };
                        var onSuccess = function (ret) {
                            urlList_1.push(ret.resourceURL);
                            originalRes_1.push(ret);
                            resolve1();
                        };
                        var onFail = function (e) {
                            reject1(e);
                        };
                        JSCall$1('WVCamera.confirmUploadPhoto', options, onSuccess, onFail);
                    });
                });
            }, Promise.resolve())
                .then(function () {
                var success = params.success;
                var onSuccess = enhanceSuccess(success, {});
                onSuccess({
                    urlList: urlList_1,
                    _original: { output: originalRes_1 },
                });
            })
                .catch(function (error) {
                var onFail = enhanceFail(params.fail);
                return onFail(error);
            });
        }
    }

    var readyCall = function (fn) {
        if (window.AlipayJSBridge) {
            fn();
        }
        else {
            var _once_1 = function () {
                fn();
                document.removeEventListener('AlipayJSBridgeReady', _once_1, false);
            };
            document.addEventListener('AlipayJSBridgeReady', _once_1, false);
        }
    };
    var call = function (api, options, success, failure) {
        if (typeof options === 'function') {
            failure = success;
            success = options;
            options = {};
        }
        readyCall(function () {
            AlipayJSBridge.call(api, options, success, failure);
        });
    };

    function NBCall(apiName, params, formatOptions, errFormatOptions) {
        if (formatOptions === void 0) { formatOptions = {}; }
        if (errFormatOptions === void 0) { errFormatOptions = {}; }
        apiCall(apiName, params, call, formatOptions, errFormatOptions);
    }
    function chooseImage(params) {
        var formatInput = function () {
            return {
                publicDomain: true,
            };
        };
        var formatOutput = function (ret) {
            var formattedData = {
                tempFilePaths: [],
                tempFiles: [],
            };
            var previewURLList = ret.apFilePathsV2 || ret.apFilePaths;
            previewURLList.forEach(function (previewURL, index) {
                if (ret.localIds) {
                    formattedData.tempFiles.push({
                        localId: ret.localIds[index],
                        previewURL: previewURL,
                    });
                    formattedData.tempFilePaths.push(previewURL);
                }
                if (ret.tempFilePaths) {
                    var tempFilePaths = ret.tempFilePaths;
                    if (typeof tempFilePaths === 'string') {
                        tempFilePaths = JSON.parse(tempFilePaths);
                    }
                    formattedData.tempFiles.push({
                        path: tempFilePaths[index],
                        previewURL: previewURL,
                    });
                    formattedData.tempFilePaths.push(tempFilePaths[index]);
                }
            });
            return formattedData;
        };
        NBCall('chooseImage', params, { formatInput: formatInput, formatOutput: formatOutput });
    }
    function chooseAndUploadImage$2(params) {
        chooseImage(__assign(__assign({}, params), { success: function (res) {
                var options = __assign(__assign({}, res), params);
                uploadImage(options);
            } }));
    }
    function uploadImage(params) {
        try {
            delete params.ex;
        }
        catch (error) { }
        var promises = [];
        var files = params.tempFiles || params.files;
        files.forEach(function (file) {
            promises.push(new Promise(function (resolve, reject) {
                var options = {
                    compress: 4,
                    business: params.business || 'NebulaBiz',
                    publicDomain: true,
                    dataType: '',
                    data: '',
                };
                if (file.path) {
                    options.dataType = 'fileURL';
                    options.data = file.path;
                }
                else if (file.dataURL) {
                    options.dataType = 'dataURL';
                    options.data = file.dataURL;
                }
                else if (file.localId) {
                    options.dataType = 'localID';
                    options.data = file.localId;
                }
                else ;
                var onSuccess = function (ret) {
                    if (ret.errorMessage) {
                        reject(ret);
                    }
                    else {
                        resolve(__assign(__assign(__assign({}, ret), ret.result), { _originalOutput: ret, _originalInput: options }));
                    }
                };
                var onFail = function (e) { return reject(e); };
                call('uploadImage', options, onSuccess, onFail);
            }));
        });
        var success = params.success, fail = params.fail;
        var onSuccess = typeof success === 'function' ? function (ret) { return success(ret); } : function (ret) { return ret; };
        Promise.all(promises)
            .then(function (results) {
            var res = [];
            var originalRes = [];
            results.forEach(function (item) {
                res.push(item.publicUrl);
                originalRes.push(item);
            });
            onSuccess(__assign(__assign({}, params), { urlList: res, originalRes: originalRes, _originalOutput: originalRes }));
        })
            .catch(function (error) {
            fail(error);
        });
    }

    var platform = '';
    try {
        platform = /\(i[^;]+;( U;)? CPU.+Mac OS X/i.test(navigator.userAgent)
            ? 'iOS'
            : 'Android';
    }
    catch (error) { }
    var JSCall = function () {
        var _a;
        var _b;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (typeof window !== 'undefined' &&
            !!window &&
            typeof ((_b = window === null || window === void 0 ? void 0 : window.FYBridge) === null || _b === void 0 ? void 0 : _b.call) === 'function') {
            return (_a = window.FYBridge).call.apply(_a, __spread(args));
        }
        function genID() {
            return ~~(Math.random() * 1000);
        }
        var cMap = {
            successCallback: 'suc_',
            callbackCommand: 'cmd_',
            failCallback: 'fail_',
        };
        function genCallback(api, type, fn, isKeep) {
            var cname = ("" + (isKeep ? 'e_handler_' : api + "_" + (cMap[type] || 'callback_')) + genID()).replace(/\//gi, '_');
            window[cname] = (function (cb, _cname) {
                return function () {
                    var rest = [];
                    for (var _i = 0; _i < arguments.length; _i++) {
                        rest[_i] = arguments[_i];
                    }
                    cb.apply(void 0, __spread(rest));
                    if (!isKeep) {
                        delete window[_cname];
                    }
                };
            })(fn, cname);
            return cname;
        }
        var FYBridge = window.FYBridge;
        if (!FYBridge) {
            var pushBack_1 = function (api, params, isKeep) {
                if (params === void 0) { params = {}; }
                var name = 'bridge';
                var action = "bridge://" + api;
                var isAbnormal = /:\/\//.test(api);
                if (isAbnormal) {
                    action = api;
                    var _arr = api.split('://');
                    name = _arr[0];
                    api = _arr[1];
                }
                for (var i in params) {
                    if (Object.prototype.hasOwnProperty.call(params, i)) {
                        if (typeof params[i] === 'function') {
                            params[i] = genCallback(api, i, params[i], isKeep);
                        }
                        var formattedKey = params.ignore2LowerCase
                            ? i
                            : i.replace(/([A-Z])/g, '_$1').toLowerCase();
                        if (i !== formattedKey) {
                            params[formattedKey] = params[i];
                            delete params[i];
                        }
                    }
                }
                if (platform === 'iOS') {
                    if (/\bWK\b/i.test(navigator.userAgent)) {
                        params._action_ = api;
                        webkit.messageHandlers[name].postMessage(params);
                    }
                    else {
                        alitripNativeCall(action, params);
                    }
                }
                else {
                    __JSContext__.alitripNativeCall(action, JSON.stringify(params));
                }
            };
            var call = function (api, options, success, failure) {
                if (typeof options === 'function') {
                    failure = success;
                    success = options;
                    options = {};
                }
                if (success) {
                    options.callbackCommand = options.successCallback = success;
                }
                if (failure) {
                    options.failCallback = failure;
                }
                if (options.clickHandler || options.clickCallback) {
                    pushBack_1(api, options, true);
                }
                else {
                    pushBack_1(api, options);
                }
            };
            FYBridge = { version: '1', call: call };
            Object.defineProperty(window, 'FYBridge', {
                enumerable: true,
                value: FYBridge,
            });
        }
        return FYBridge.call.apply(FYBridge, __spread(args));
    };
    function LXCall(apiName, params, formatOptions, errFormatOptions) {
        if (formatOptions === void 0) { formatOptions = {}; }
        if (errFormatOptions === void 0) { errFormatOptions = {}; }
        apiCall(apiName, params, JSCall, formatOptions, errFormatOptions);
    }
    function chooseAndUploadImage$1(params) {
        var formatInput = function (options) {
            var camera = (options.sourceType || []).indexOf('camera') > -1;
            var pickType = camera ? 1 : 0;
            return {
                pickType: pickType,
                maxSelect: options.count || 1,
            };
        };
        var outputMap = {
            urlList: 'imgUrls',
        };
        LXCall('take_photo', params, { formatInput: formatInput, outputMap: outputMap });
    }

    var chooseAndUploadImage$4;
    if (isWeb) {
        if (isWindvane) {
            chooseAndUploadImage$4 = chooseAndUploadImage$3;
        }
        else if (isNebula) {
            chooseAndUploadImage$4 = chooseAndUploadImage$2;
        }
        else if (isFliggy) {
            chooseAndUploadImage$4 = chooseAndUploadImage$1;
        }
        else if (isDingTalk) {
            chooseAndUploadImage$4 = notSupport;
        }
        else if (isDingTalkPC) {
            chooseAndUploadImage$4 = notSupport;
        }
    }
    else if (isMini) {
        if (isMiniAli) {
            chooseAndUploadImage$4 = notSupport;
        }
        else if (isMiniWx) {
            chooseAndUploadImage$4 = notSupport;
        }
        else if (isMiniTt) {
            chooseAndUploadImage$4 = notSupport;
        }
    }
    else if (isMiniweb) {
        chooseAndUploadImage$4 = notSupport;
    }
    if (!chooseAndUploadImage$4) {
        chooseAndUploadImage$4 = notSupport;
    }
    var index = promisifyApi(chooseAndUploadImage$4);

    var apiConfig$d = {};
    // 淘宝API：https://h5.alibaba-inc.com/api/WindVane-API.html#WVCamera-takePhoto
    // 支付宝API： https://smallfish.antfin-inc.com/jsapi/uploadImage.html
    /**
     * 选择相册并上传图片。
     * 注意：
     * 1. windvane容器。涉及到图片存储，要想图片不丢失，需要申请业务bizCode。bizCode不传默认是mtopupload，只用在本地测试，在线上使用出现问题概不负责。bizCode请求地址：https://code.alibaba-inc.com/picturecenter/wikipedia/blob/master/%E6%8E%A5%E5%85%A5%E6%96%87%E6%A1%A3.md
     * 2. 支付宝容器。同样涉及图片存储，使用business字段。默认值是：NebulaBiz。business申请地址：https://yuque.antfin.com/amm/apis/notice
     * 3. 踩坑：支付宝容器，开发环境调用会报“new jsapi permission deny”错误，只需要发布到支付宝支持的http域名白名单即可解决。
     * @returns {Promise<unknown>} promise调用结果
     * @example 使用案例：
     * import { chooseAndUploadImage } from '@alife/cn-uni-api'; // h5、小程序通用包
     *
     * chooseAndUploadImage({ bizCode: 'cnocean' })
     *   .then((res) => {
     *     console.log('success');
     *   })
     *   .catch((error) => {
     *     console.log(error);
     *   });
     * @author 敬文
     */
    var chooseAndUploadImage = extend(apiConfig$d, index);

    // 驿站JSBridge：https://page.cainiao.com/cn-yz/cnyz-book/_book/api/share.html?spm=a2d5h.23431112.0.0
    function saveVideo$1(params, context) {
        context === null || context === void 0 ? void 0 : context.WVCall('TBSharedModule.saveVideo', params);
    }

    var extendSaveVideo = extend({
        web: {
            windvane: {
                cnStation: saveVideo$1,
                cnNetCom: saveVideo$1,
            },
        },
    });
    /**
     * 保存视频。API：https://yuque.antfin.com/cn-xt/arch/lwbvd0
     * 目前支持：【驿站掌柜App】
     * @param {!string | SaveVideoIOptions} url 视频地址
     * @returns {Promise<unknown>} promise调用结果
     *
     * @example
     * import { saveVideo } from '@alife/cn-uni-api';
     *
     * saveVideo('http://xxx').then(() => {
     *   console.log('success');
     * }).catch((error) => {
     *   console.log(error);
     * });
     * @author 敬文
     */
    var saveVideo = function (url) {
        if (url && typeof url === 'object') {
            return extendSaveVideo(url);
        }
        return extendSaveVideo({ url: url });
    };

    function chooseVideo$1(options, context) {
        // 钉钉小程序 ref: https://open.dingtalk.com/document/orgapp/dd-choosevideo
        context === null || context === void 0 ? void 0 : context.PanguMiniAppCall('chooseVideo', options);
    }

    /**
     * 选择视频
     * 支持端：钉钉小程序
     * @returns {Promise<unknown>} promise调用结果
     * @example 使用案例：
     * import { chooseVideo } from '@alife/cn-uni-api'; //
     *
     * chooseVideo({
     *    sourceType: ['album', 'camera'],
     *    maxDuration: 60
     * })
     *   .then((res) => {
     *     console.log('success', res);
     *   })
     *   .catch((error) => {
     *     console.log('fail', error);
     *   });
     * @author 余国平
     */
    var chooseVideo = extend({
        panguMiniApp: chooseVideo$1,
    });

    function previewVideo$2(options, context) {
        var _a;
        var api = 'dd.biz.util.previewVideo';
        (_a = context.DDCall) === null || _a === void 0 ? void 0 : _a.call(context, api, options);
    }

    function previewVideo$1(options, context) {
        context === null || context === void 0 ? void 0 : context.PanguMiniAppCall('previewVideo', options);
    }

    /**
     * 播放视频
     * 支持端：菜鸟钉h5 菜鸟钉pc 钉钉小程序
     * @returns {Promise<unknown>} promise调用结果
     * @example 使用案例：
     * import { previewVideo } from '@alife/cn-uni-api'; //
     *
     * previewVideo({
     *    url: '链接',
     *    fileName: '文件名',
     *    thumbnail: '视频缩略图'
     * })
     *   .then((res) => {
     *     console.log('success', res);
     *   })
     *   .catch((error) => {
     *     console.log('fail', error);
     *   });
     * @author 余国平
     */
    var previewVideo = extend({
        web: {
            dingTalk: previewVideo$2,
            dingTalkPC: previewVideo$2,
            panguMiniApp: previewVideo$1,
        },
    });

    function makeVideoChat$2(options, context) {
        var _a;
        // 该api需要钉钉鉴权：https://open.dingtalk.com/document/orgapp/initiate-video-conference
        var api = 'dd.biz.conference.videoConfCall';
        (_a = context === null || context === void 0 ? void 0 : context.DDCall) === null || _a === void 0 ? void 0 : _a.call(context, api, options);
    }

    function makeVideoChat$1(options, context) {
        var _a;
        (_a = context === null || context === void 0 ? void 0 : context.PanguMiniAppCall) === null || _a === void 0 ? void 0 : _a.call(context, 'makeVideoChat', options);
    }

    /**
     * 视频通话
     * @example
     * import { makeVideoChat } from '@alife/cn-uni-api';
     *
     * makeVideoChat({
     *    // ...
     * })
     *  .then(console.log)
     *  .catch(console.log)
     *
     * @author 余国平
     */
    var makeVideoChat = extend({
        web: {
            dingTalk: makeVideoChat$2,
            dingTalkPC: makeVideoChat$2,
        },
        panguMiniApp: makeVideoChat$1,
    });

    function uploadFile$2(params, context) {
        var _a, _b;
        // 菜鸟钉 h5 ref: https://open.dingtalk.com/document/orgapp/upload-objects-jsapi
        if (params.fileType !== 'image') {
            (_a = params === null || params === void 0 ? void 0 : params.fail) === null || _a === void 0 ? void 0 : _a.call(params, {
                errMsg: 'Only supports images',
            });
            return;
        }
        var api = 'dd.biz.util.uploadFile';
        (_b = context.DDCall) === null || _b === void 0 ? void 0 : _b.call(context, api, params, {
            formatInput: function (input) {
                var fileName = input.fileName, other = __rest(input, ["fileName"]);
                return __assign$1(__assign$1({}, other), { name: fileName });
            },
        });
    }

    function uploadFile$1(options, context) {
        // 钉钉小程序 ref: https://open.dingtalk.com/document/orgapp/dd-upload-objects
        context === null || context === void 0 ? void 0 : context.PanguMiniAppCall('uploadFile', options);
    }

    /**
     * 上传图片
     * 支持端：菜鸟钉h5(图片) 钉钉小程序(图片、视频、音频)
     * @returns {Promise<unknown>} promise调用结果
     * @example 使用案例：
     * import { uploadFile } from '@alife/cn-uni-api'; //
     *
     * uploadFile({
     *    url: '链接'
     *    fileName: '文件名',
     *    filePath: '文件路径',
     *    fileType: '文件类型'
     * })
     *   .then((res) => {
     *     console.log('success', res);
     *   })
     *   .catch((error) => {
     *     console.log('fail', error);
     *   });
     * @author 余国平
     */
    var uploadFile = extend({
        web: {
            dingTalk: uploadFile$2,
        },
        panguMiniApp: uploadFile$1,
    });

    function showToast$9(options, context) {
        var _a;
        var api = 'dd.device.notification.toast';
        var formatInput = function (input) {
            var duration = input.duration, content = input.content;
            var getDuration = function () {
                if (duration) {
                    return duration > 100 ? duration / 1000 : duration;
                }
                return 2;
            };
            return {
                icon: '',
                text: content,
                duration: getDuration(),
                delay: 0,
            };
        };
        (_a = context === null || context === void 0 ? void 0 : context.DDCall) === null || _a === void 0 ? void 0 : _a.call(context, api, options, { formatInput: formatInput });
    }

    function showToast$8(options, context) {
        var formatInput = function (_a) {
            var content = _a.content, _b = _a.duration, duration = _b === void 0 ? 2000 : _b;
            return ({
                content: content,
                timeInSeconds: duration / 1000, // Toast 的持续时间：菜鸟App以s为单位
            });
        };
        context.WVCall('CNHybridToast.showToast', options, { formatInput: formatInput });
    }

    function _extends$f() { _extends$f = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$f.apply(this, arguments); }

    function promisify$2(api) {
      return function (arg) {
        return new Promise(function (resolve, reject) {
          var promisifyArg = arg;
          api(_extends$f({}, promisifyArg, {
            success: function success(res) {
              if (promisifyArg && typeof promisifyArg.success === 'function') {
                promisifyArg.success(res);
              }

              resolve(res);
            },
            onSuccess: function onSuccess(res) {
              if (promisifyArg && typeof promisifyArg.onSuccess === 'function') {
                promisifyArg.onSuccess(res);
              }

              resolve(res);
            },
            fail: function fail(res) {
              if (promisifyArg && typeof promisifyArg.fail === 'function') {
                promisifyArg.fail(res);
              }

              reject(res);
            },
            onFail: function onFail(res) {
              if (promisifyArg && typeof promisifyArg.onFail === 'function') {
                promisifyArg.onFail(res);
              }

              reject(res);
            },
            complete: function complete(res) {
              if (promisifyArg && typeof promisifyArg.complete === 'function') {
                promisifyArg.complete(res);
              }
            },
            onComplete: function onComplete(res) {
              if (promisifyArg && typeof promisifyArg.onComplete === 'function') {
                promisifyArg.onComplete(res);
              }
            }
          }));
        });
      };
    }

    function _extends$e() { _extends$e = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$e.apply(this, arguments); }

    var SHORT_DELAY = 2000; // 2 seconds

    function styleOptions$3(options) {
      var DEFAULT_REQUEST_OPTIONS = {
        content: '',
        type: 'none',
        duration: SHORT_DELAY
      };

      if (typeof options === 'string') {
        return _extends$e({}, DEFAULT_REQUEST_OPTIONS, {
          content: options
        });
      } else {
        return _extends$e({}, DEFAULT_REQUEST_OPTIONS, options);
      }
    }
    function normalize$2(api) {
      return function (options) {
        var afterOptions = styleOptions$3(options);
        return promisify$2(api)(afterOptions);
      };
    }

    function isUndef$4(type) {
      return type === 'undefined';
    }

    var isDingdingMiniapp$4 = !isUndef$4(typeof dd) && dd !== null && !isUndef$4(typeof dd.alert);

    var show$6 = normalize$2(function (options) {
      var type = options.type,
          content = options.content,
          duration = options.duration,
          _success = options.success,
          _fail = options.fail,
          _complete = options.complete;
      var showToast = isDingdingMiniapp$4 ? dd.showToast : my.showToast;
      showToast({
        type: type,
        content: content,
        duration: duration,
        success: function success() {
          _success && _success();
        },
        fail: function fail(res) {
          _fail && _fail(res);
        },
        complete: function complete(res) {
          _complete && _complete(res);
        }
      });
    });
    var showToast$7 = show$6;

    var hide$5 = normalize$2(function (options) {
      var hideToast = isDingdingMiniapp$4 ? dd.hideToast : my.hideToast;
      hideToast(options);
    });
    var hideToast$7 = hide$5;

    var aliMiniAppModule$6 = {
      show: showToast$7,
      hide: hideToast$7,
      showToast: showToast$7,
      hideToast: hideToast$7
    };

    var show$5 = normalize$2(function (options) {
      var type = options.type,
          content = options.content,
          duration = options.duration,
          _success = options.success,
          _fail = options.fail,
          _complete = options.complete;
      var iconMap = {
        success: 'success',
        fail: 'error',
        none: 'none',
        loading: 'loading'
      };
      wx.showToast({
        icon: iconMap[type] || '',
        title: content,
        duration: duration,
        success: function success() {
          _success && _success();
        },
        fail: function fail(res) {
          _fail && _fail(res);
        },
        complete: function complete(res) {
          _complete && _complete(res);
        }
      });
    });
    var showToast$6 = show$5;

    var hide$4 = normalize$2(function (options) {
      wx.hideToast(options);
    });
    var hideToast$6 = hide$4;

    var weChatModule$6 = {
      show: showToast$6,
      hide: hideToast$6,
      showToast: showToast$6,
      hideToast: hideToast$6
    };

    var show$4 = normalize$2(function (options) {
      var type = options.type,
          content = options.content,
          duration = options.duration,
          _success = options.success,
          _fail = options.fail,
          _complete = options.complete;
      var iconMap = {
        success: 'success',
        fail: 'fail',
        none: 'none',
        loading: 'loading'
      };
      tt.showToast({
        icon: iconMap[type] || 'none',
        title: content,
        duration: duration,
        success: function success() {
          _success && _success();
        },
        fail: function fail(res) {
          _fail && _fail(res);
        },
        complete: function complete(res) {
          _complete && _complete(res);
        }
      });
    });
    var showToast$5 = show$4;

    var hide$3 = normalize$2(function (options) {
      tt.hideToast(options);
    });
    var hideToast$5 = hide$3;

    var bytedanceModule$6 = {
      show: showToast$5,
      hide: hideToast$5,
      showToast: showToast$5,
      hideToast: hideToast$5
    };

    /* eslint-disable guard-for-in */
    var styles = {
      container: {
        backgroundColor: 'rgba(0, 0, 0, 0.6)',
        boxSizing: 'border-box',
        maxWidth: '80%',
        color: '#ffffff',
        padding: '8px 16px',
        position: 'fixed',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        left: '50%',
        bottom: '50%',
        fontSize: '16px',
        lineHeight: '32px',
        fontWeight: '600',
        borderRadius: '4px',
        textAlign: 'center',
        transition: 'all 0.4s ease-in-out',
        webkitTransition: 'all 0.4s ease-in-out',
        transform: 'translateX(-50%)',
        webkitTransform: 'translateX(-50%)',
        zIndex: 9999
      },
      icon: {
        marginBottom: '5px',
        width: '45px',
        height: '45px'
      }
    };

    function showToastWindow(message, iconUrl) {
      if (!window._uni_toast_status.toastWin) {
        window._uni_toast_status.toastIcon = null;
        window._uni_toast_status.toastWin = document.createElement('div');

        window._uni_toast_status.toastWin.setAttribute('role', 'alert'); // support for ARIA, add tabindex for focus
        // https://developer.mozilla.org/zh-CN/docs/Web/HTML/Global_attributes/tabindex


        window._uni_toast_status.toastWin.setAttribute('tabindex', '-1');

        for (var key in styles.container) {
          window._uni_toast_status.toastWin.style[key] = styles.container[key];
        }

        window._uni_toast_status.toastContent = document.createElement('div');

        window._uni_toast_status.toastWin.appendChild(window._uni_toast_status.toastContent);

        document.body.appendChild(window._uni_toast_status.toastWin);
      } // 创建icon


      if (window._uni_toast_status.toastIcon && !iconUrl) {
        window._uni_toast_status.toastWin.removeChild(window._uni_toast_status.toastIcon);

        window._uni_toast_status.toastIcon = null;
      } else if (window._uni_toast_status.toastIcon && iconUrl) {
        window._uni_toast_status.toastIcon.setAttribute('src', iconUrl);
      } else if (!window._uni_toast_status.toastIcon && iconUrl) {
        window._uni_toast_status.toastIcon = document.createElement('img');

        window._uni_toast_status.toastIcon.setAttribute('src', iconUrl);

        for (var _key in styles.icon) {
          window._uni_toast_status.toastIcon.style[_key] = styles.icon[_key];
        }

        window._uni_toast_status.toastWin.insertBefore(window._uni_toast_status.toastIcon, window._uni_toast_status.toastContent);
      }

      window._uni_toast_status.toastContent.textContent = message;
      window._uni_toast_status.toastWin.style.transform = 'translateX(-50%)';
      window._uni_toast_status.toastWin.style.webkitTransform = 'translateX(-50%)';
    }

    function hideToastWindow() {
      setTimeout(function () {
        if (window._uni_toast_status.toastWin && window._uni_toast_status.toastWin.style) {
          window._uni_toast_status.toastWin.style.transform = 'translateX(-50%) scale(0.8)';
          window._uni_toast_status.toastWin.style.webkitTransform = 'translateX(-50%) scale(0.8)';
        }
      }, 0);
    }

    var innerToast = {
      hideTimer: null,
      show: function show() {
        // All messages had been toasted already, so remove the toast window,
        if (!window._uni_toast_status.queue.length) {
          if (window._uni_toast_status.toastWin) {
            // eslint-disable-next-line
            window._uni_toast_status.toastWin.parentNode.removeChild(window._uni_toast_status.toastWin);
          }

          window._uni_toast_status.toastWin = null;
          return;
        } // the previous toast is not ended yet.


        if (window._uni_toast_status.isProcessing) return;
        window._uni_toast_status.isProcessing = true;

        var toastInfo = window._uni_toast_status.queue.shift();

        try {
          showToastWindow(toastInfo.content, toastInfo.icon);
        } catch (e) {
          toastInfo.fail && toastInfo.fail(e);
          toastInfo.complete && toastInfo.complete(e);
        }

        innerToast.hideTimer = setTimeout(function () {
          toastInfo.success && toastInfo.success();
          toastInfo.complete && toastInfo.complete();
          innerToast.switchToNext();
        }, toastInfo.duration);
      },
      push: function push(options) {
        window._uni_toast_status.queue.push(options);

        innerToast.show();
      },
      // Switch to next message
      // This function will hide current, and call `show()` to display next
      // If queue is empty, DOM will be clear in `show()`
      switchToNext: function switchToNext() {
        hideToastWindow();
        window._uni_toast_status.isProcessing = false;
        setTimeout(function () {
          return innerToast.show();
        }, 500);

        if (innerToast.hideTimer) {
          clearTimeout(innerToast.hideTimer);
          innerToast.hideTimer = null;
        }
      }
    };
    var show$3 = normalize$2(function (options) {
      window._uni_toast_inner_toast = innerToast;
      window._uni_toast_status = window._uni_toast_status || {
        queue: [],
        isProcessing: false,
        toastWin: '',
        toastContent: '',
        toastIcon: ''
      };
      var type = options.type,
          content = options.content,
          duration = options.duration,
          _success = options.success,
          _fail = options.fail,
          _complete = options.complete;
      var iconMap = {
        success: 'https://gw.alicdn.com/imgextra/i1/O1CN01h684sE1Td4mwYyChK_!!6000000002404-2-tps-200-200.png',
        fail: 'https://gw.alicdn.com/imgextra/i1/O1CN01yOywus1et4ORJzafk_!!6000000003928-2-tps-200-200.png',
        none: ''
      };
      innerToast.push({
        content: content,
        duration: duration,
        icon: iconMap[type] || '',
        success: function success() {
          _success && _success();
        },
        fail: function fail(res) {
          _fail && _fail(res);
        },
        complete: function complete(res) {
          _complete && _complete(res);
        }
      });
    });
    var showToast$4 = show$3;

    var hide$2 = normalize$2(function (options) {
      var success = options.success,
          fail = options.fail,
          complete = options.complete; // remove all queued messages

      try {
        if (!window._uni_toast_status) {
          success && success();
          complete && complete();
          return;
        }

        window._uni_toast_status.queue = [];

        window._uni_toast_inner_toast.switchToNext();

        success && success();
        complete && complete();
      } catch (e) {
        fail && fail(e);
        complete && complete(e);
      }
    });
    var hideToast$4 = hide$2;

    var webModule$6 = {
      show: showToast$4,
      hide: hideToast$4,
      showToast: showToast$4,
      hideToast: hideToast$4
    };

    var show$2 = normalize$2(function (options) {
      var type = options.type,
          content = options.content,
          duration = options.duration,
          _success = options.success,
          _fail = options.fail,
          _complete = options.complete;
      var iconMap = {
        success: 'success',
        loading: 'loading',
        none: 'none'
      }; // 快手image 不起作用。。

      ks.showToast({
        icon: iconMap[type] || 'none',
        title: content,
        duration: duration,
        success: function success() {
          _success && _success();
        },
        fail: function fail(res) {
          _fail && _fail(res);
        },
        complete: function complete(res) {
          _complete && _complete(res);
        }
      });
    });
    var showToast$3 = show$2;

    var hide$1 = normalize$2(function (options) {
      ks.hideToast(options);
    });
    var hideToast$3 = hide$1;

    var kuaiShouModule$4 = {
      show: showToast$3,
      hide: hideToast$3,
      showToast: showToast$3,
      hideToast: hideToast$3
    };

    var show$1 = normalize$2(function (options) {
      var type = options.type,
          content = options.content,
          duration = options.duration,
          _success = options.success,
          _fail = options.fail,
          _complete = options.complete;
      var iconMap = {
        success: 'success',
        loading: 'loading',
        none: 'none'
      };

      if (type === 'fail') {
        swan.showToast({
          image: 'https://gw.alicdn.com/imgextra/i2/O1CN01XzxlKk1GL8IyXoqEa_!!6000000000605-2-tps-200-200.png',
          title: content,
          duration: duration,
          success: function success() {
            _success && _success();
          },
          fail: function fail(res) {
            _fail && _fail(res);
          },
          complete: function complete(res) {
            _complete && _complete(res);
          }
        });
      } else {
        swan.showToast({
          icon: iconMap[type] || 'none',
          title: content,
          duration: duration,
          success: function success() {
            _success && _success();
          },
          fail: function fail(res) {
            _fail && _fail(res);
          },
          complete: function complete(res) {
            _complete && _complete(res);
          }
        });
      }
    });
    var showToast$2 = show$1;

    var hide = normalize$2(function (options) {
      swan.hideToast(options);
    });
    var hideToast$2 = hide;

    var baiDuModule$6 = {
      show: showToast$2,
      hide: hideToast$2,
      showToast: showToast$2,
      hideToast: hideToast$2
    };

    var show = function show(options) {
      if (isWeb$1) {
        return webModule$6.show(options);
      } else if (isKuaiShouMiniProgram) {
        return kuaiShouModule$4.show(options);
      } else if (isWeChatMiniProgram) {
        return weChatModule$6.show(options);
      } else if (isByteDanceMicroApp) {
        return bytedanceModule$6.show(options);
      } else if (isMiniApp) {
        return aliMiniAppModule$6.show(options);
      } else if (isBaiduSmartProgram) {
        return baiDuModule$6.show(options);
      } else {
        throw new Error('Uni API：Toast暂不支持');
      }
    };
    var hideToast$1 = function hideToast(options) {
      if (isWeb$1) {
        return webModule$6.hideToast(options);
      } else if (isKuaiShouMiniProgram) {
        return kuaiShouModule$4.hideToast(options);
      } else if (isWeChatMiniProgram) {
        return weChatModule$6.hideToast(options);
      } else if (isByteDanceMicroApp) {
        return bytedanceModule$6.hideToast(options);
      } else if (isMiniApp) {
        return aliMiniAppModule$6.hideToast(options);
      } else if (isBaiduSmartProgram) {
        return baiDuModule$6.hideToast(options);
      } else {
        throw new Error('Uni API：Toast暂不支持');
      }
    };

    var ali1688 = show;

    function showToast$1(options, context) {
        var _a;
        (_a = context === null || context === void 0 ? void 0 : context.PanguMiniAppCall) === null || _a === void 0 ? void 0 : _a.call(context, 'showToast', options);
    }

    var mini$2 = show;

    var extendShowToast = extend({
        web: {
            dingTalk: showToast$9,
            dingTalkPC: showToast$9,
            windvane: {
                cn: showToast$8,
                ali1688: ali1688,
            },
        },
        mini: mini$2,
        panguMiniApp: showToast$1,
    }, 
    /** baseShowToast 支持windvane容器、nebula容器、小程序容器 */
    index$a);
    /**
     * toast 提示
     * API：https://yuque.antfin.com/cn-xt/htc47g/tzr9pt
     * @param  {string|ShowToastIOptions} [data] toast文案
     * @returns {Promise<unknown>} promise调用结果
     * @example 使用案例：
     * import { showToast } from '@alife/cn-uni-api'; // h5、小程序通用包
     *
     * showToast({
     *  content: '提示内容',
     *  duration: 2000,
     * })
     *   .then(() => {
     *     console.log('success');
     *   })
     *   .catch((error) => {
     *     console.log(error);
     *   });
     * @author 敬文
     */
    var showToast = function (data) {
        if (typeof data === 'string') {
            return extendShowToast({ content: data, duration: 2000 });
        }
        return extendShowToast(__assign$1({ duration: 2000 }, data));
    };

    var mini$1 = hideToast$1;

    /**
     * 隐藏 toast
     * API：https://yuque.antfin.com/cn-xt/htc47g/tzr9pt
     * @returns {Promise<unknown>} promise调用结果
     * @example 使用案例：
     * import { hideToast } from '@alife/cn-uni-api'; // h5、小程序通用包
     *
     * hideToast()
     *   .then(() => {
     *     console.log('success');
     *   })
     *   .catch((error) => {
     *     console.log(error);
     *   });
     * @author 敬文
     */
    var hideToast = extend({
        mini: mini$1,
    }, 
    /** baseHideToast 支持windvane容器、nebula容器、小程序容器 */
    index$7);

    function showLoading$3(params) {
        // 菜鸟APP Hybrid ref：https://alidocs.dingtalk.com/i/nodes/Mk5evdR04jBV59vnPj1dVQL3x2OlParn
        // TODO api命名 菜鸟App客户端变动中，持续跟进
        WVCall$1('CNHybridLoading.showLoading', params);
    }

    function showLoading$2(options, context) {
        var _a;
        var api = 'dd.device.notification.showPreloader';
        var formatInput = function () { return ({ text: '', showIcon: true }); };
        (_a = context === null || context === void 0 ? void 0 : context.DDCall) === null || _a === void 0 ? void 0 : _a.call(context, api, options, {
            formatInput: formatInput,
        });
    }

    function showLoading$1(options, context) {
        var _a;
        (_a = context === null || context === void 0 ? void 0 : context.PanguMiniAppCall) === null || _a === void 0 ? void 0 : _a.call(context, 'showLoading', options);
    }

    /**
     * 展示 Loading 提示
     * API：https://yuque.antfin.com/cn-xt/htc47g/tzr9pt
     * @param  {ShowLoadingIOptions} [data]
     * @returns {Promise<unknown>} promise调用结果
     * @example 使用案例：
     * import { showLoading } from '@alife/cn-uni-api';
     *
     * showLoading()
     *   .then(() => {
     *     console.log('success');
     *   })
     *   .catch((error) => {
     *     console.log(error);
     *   });
     * @author 敬文
     */
    var showLoading = extend({
        web: {
            dingTalk: showLoading$2,
            windvane: {
                cn: showLoading$3,
            },
        },
        panguMiniApp: showLoading$1,
    }, 
    /** baseShowLoading 支持windvane容器、nebula容器、小程序容器 */
    index$D);

    function hideLoading$3(params) {
        // 菜鸟APP Hybrid ref：https://alidocs.dingtalk.com/i/nodes/Mk5evdR04jBV59vnPj1dVQL3x2OlParn
        WVCall$1('CNHybridLoading.hideLoading', params);
    }

    function hideLoading$2(options, context) {
        var _a;
        var api = 'dd.device.notification.hidePreloader';
        (_a = context === null || context === void 0 ? void 0 : context.DDCall) === null || _a === void 0 ? void 0 : _a.call(context, api, options);
    }

    function hideLoading$1(options, context) {
        var _a;
        (_a = context === null || context === void 0 ? void 0 : context.PanguMiniAppCall) === null || _a === void 0 ? void 0 : _a.call(context, 'hideLoading', options);
    }

    var apiConfig$c = {
        web: {
            dingTalk: hideLoading$2,
            windvane: {
                cn: hideLoading$3,
            },
            panguMiniApp: hideLoading$1,
        },
    };
    /**
     * 取消 Loading 提示
     * API：https://yuque.antfin.com/cn-xt/htc47g/tzr9pt
     * @param  {HideLoadingIOptions} [data]
     * @returns {Promise<unknown>} promise调用结果
     * @example 使用案例：
     * import { hideLoading } from '@alife/cn-uni-api'; // h5、小程序通用包
     *
     * hideLoading()
     *   .then(() => {
     *     console.log('success');
     *   })
     *   .catch((error) => {
     *     console.log(error);
     *   });
     * @author 敬文
     */
    var hideLoading = extend(apiConfig$c, 
    /** baseHideLoading 支持windvane容器、nebula容器、小程序容器 */
    index$t);

    function alert$2(options, context) {
        var _a;
        var api = 'dd.device.notification.alert';
        var formatInput = function (input) {
            var title = input.title, content = input.content, buttonText = input.buttonText;
            return {
                title: title,
                message: content,
                buttonName: buttonText,
            };
        };
        (_a = context === null || context === void 0 ? void 0 : context.DDCall) === null || _a === void 0 ? void 0 : _a.call(context, api, options, { formatInput: formatInput });
    }

    function alert$1(options, context) {
        var _a;
        (_a = context === null || context === void 0 ? void 0 : context.PanguMiniAppCall) === null || _a === void 0 ? void 0 : _a.call(context, 'alert', options);
    }

    /**
     * alert 提示
     * API：https://yuque.antfin.com/cn-xt/htc47g/tzr9pt
     * @returns {Promise<unknown>} promise调用结果
     * @example 使用案例：
     * import { alert } from '@alife/cn-uni-api'; // h5、小程序通用包
     *
     * alert({ title: '标题', content: '内容', buttonText = '按钮文案'})
     *   .then(() => {
     *     console.log('success');
     *   })
     *   .catch((error) => {
     *     console.log(error);
     *   });
     * @author 敬文
     */
    var alert = extend({
        web: {
            dingTalk: alert$2,
            dingTalkPC: alert$2,
            panguMiniApp: alert$1,
        },
    }, 
    /** baseAlert 支持windvane容器、nebula容器、小程序容器 */
    index$3);

    function confirm$2(options, context) {
        var _a;
        var api = 'dd.device.notification.confirm';
        var formatInput = function (input) {
            var _a = input !== null && input !== void 0 ? input : {}, _b = _a.content, content = _b === void 0 ? '' : _b, _c = _a.confirmButtonText, confirmButtonText = _c === void 0 ? '确定' : _c, _d = _a.cancelButtonText, cancelButtonText = _d === void 0 ? '取消' : _d;
            return {
                message: content,
                buttonLabels: [confirmButtonText, cancelButtonText],
            };
        };
        var formatOutput = function (ret) { return ({
            confirm: ret.buttonIndex === 0,
        }); };
        (_a = context === null || context === void 0 ? void 0 : context.DDCall) === null || _a === void 0 ? void 0 : _a.call(context, api, options, { formatInput: formatInput, formatOutput: formatOutput });
    }

    function confirm$1(options, context) {
        var _a;
        (_a = context === null || context === void 0 ? void 0 : context.PanguMiniAppCall) === null || _a === void 0 ? void 0 : _a.call(context, 'confirm', options);
    }

    /**
     * confirm 提示
     * API：https://yuque.antfin.com/cn-xt/htc47g/tzr9pt
     * @returns {Promise<unknown>} promise调用结果
     * @example 使用案例：
     * import { confirm } from '@alife/cn-uni-api'; // h5、小程序通用包
     *
     * confirm({ title: '标题', content: '内容', confirmButtonText = '确认', cancelButtonText: '取消'})
     *   .then((res) => {
     *     console.log(res.confirm ? 'confirm' : 'cancel');
     *   })
     *   .catch((error) => {
     *     console.log(error);
     *   });
     * @author 敬文
     */
    var confirm = extend({
        web: {
            dingTalk: confirm$2,
            dingTalkPC: confirm$2,
        },
        panguMiniApp: confirm$1,
    }, 
    /** baseConfirm 支持windvane容器、nebula容器、小程序容器 */
    index$I);

    function showActionSheet$1(options, context) {
        var _a;
        var api = 'dd.device.notification.actionSheet';
        var formatInput = function (input) {
            var _a = input.items, items = _a === void 0 ? [] : _a, cancelButtonText = input.cancelButtonText;
            return {
                cancelButton: cancelButtonText || '取消',
                otherButtons: items,
            };
        };
        var formatOutput = function (ret) { return ({
            index: ret === null || ret === void 0 ? void 0 : ret.buttonIndex,
        }); };
        (_a = context === null || context === void 0 ? void 0 : context.DDCall) === null || _a === void 0 ? void 0 : _a.call(context, api, options, {
            formatInput: formatInput,
            formatOutput: formatOutput,
        });
    }

    /**
     * ActionSheet 选择框
     * API：https://yuque.antfin.com/cn-xt/htc47g/tzr9pt
     * @returns {Promise<unknown>} promise调用结果
     * @example 使用案例：
     * import { showActionSheet } from '@alife/cn-uni-api'; // h5、小程序通用包
     *
     * showActionSheet({ title: '标题', item: ['内容1', '内容2', '内容3'] })
     *   .then((res) => {
     *     console.log(res.index, '选中项');
     *   })
     *   .catch((error) => {
     *     console.log(error);
     *   });
     * @author 敬文
     */
    var showActionSheet = extend({
        web: {
            dingTalk: showActionSheet$1,
        },
    }, 
    /** baseShowActionSheet 支持windvane容器、nebula容器、小程序容器 */
    index$L);

    function setNaviBarRightItem$3(params) {
        // 菜鸟APP Hybrid ref：https://alidocs.dingtalk.com/i/nodes/Mk5evdR04jBV59vnPj1dVQL3x2OlParn
        var formatInput = function (options) { return ({
            buttonText: options === null || options === void 0 ? void 0 : options.title,
            imageURL: options === null || options === void 0 ? void 0 : options.iconBase64,
            showButton: true,
            imagePosition: 'right',
            // onClick: options?.onClick, // 菜鸟不支持直接onClick回调
        }); };
        WVCall$1('CNHybridNavigationBar.setRightBarButton', params, { formatInput: formatInput });
    }

    function setNaviBarRightItem$2(params) {
        // https://page.cainiao.com/cn-yz/cnyz-book/_book/api/titlrbar.html?spm=a2d5h.23431124.0.0
        var formatInput = function (options) { return ({
            text: options === null || options === void 0 ? void 0 : options.title,
            imgUrl: options === null || options === void 0 ? void 0 : options.iconBase64,
            callback: options === null || options === void 0 ? void 0 : options.onClick,
        }); };
        WVCall$1('TitlebarModule.setFarRightButton', params, { formatInput: formatInput });
    }

    function setNaviBarRightItem$1(options, context) {
        var _a;
        var api = 'dd.biz.navigation.setRight';
        var formatInput = function (input) { return ({
            show: true,
            control: true,
            text: input.title,
            onSuccess: function (e) {
                var onClick = (input === null || input === void 0 ? void 0 : input.onClick) || function () { };
                onClick(e);
            },
        }); };
        (_a = context === null || context === void 0 ? void 0 : context.DDCall) === null || _a === void 0 ? void 0 : _a.call(context, api, options, { formatInput: formatInput });
    }

    // api: https://uni-apis.alibaba-inc.com/doc/UI/setnavibarrightitem
    var apiConfig$b = {
        web: {
            dingTalk: setNaviBarRightItem$1,
            windvane: {
                cn: setNaviBarRightItem$3,
                cnStation: setNaviBarRightItem$2,
                cnNetCom: setNaviBarRightItem$2,
            },
        },
    };
    /**
     * 设置导航栏右侧项
     * @example 使用案例：
     * import { setNaviBarRightItem } from '@alife/cn-uni-api';
     *  setNaviBarRightItem({
     *    title: '分享',
     *    onClick: () => {},
     *  })
     *    .then(() => {
     *      console.log('success');
     *    })
     *    .catch((error) => {
     *      console.log(error);
     *    });
     * @author 敬文
     */
    var setNaviBarRightItem = extend(apiConfig$b, index$x);

    function clearNaviBarRightItem$3(params) {
        // 菜鸟APP Hybrid ref：https://alidocs.dingtalk.com/i/nodes/Mk5evdR04jBV59vnPj1dVQL3x2OlParn
        var formatInput = function () { return ({
            buttonText: null,
            showButton: false,
            imagePosition: 'right',
        }); };
        WVCall$1('CNHybridNavigationBar.setRightBarButton', params, { formatInput: formatInput });
    }

    function clearNaviBarRightItem$2(params) {
        // https://page.cainiao.com/cn-yz/cnyz-book/_book/api/titlrbar.html?spm=a2d5h.23431124.0.0
        var formatInput = function () { return ({
            text: '',
            imgUrl: '',
            callback: null,
        }); };
        WVCall$1('TitlebarModule.setFarRightButton', params, { formatInput: formatInput });
    }

    function clearNaviBarRightItem$1(options, context) {
        var api = 'dd.biz.navigation.setRight';
        var formatInput = function () { return ({
            control: false,
            text: '分享',
        }); };
        context.DDCall(api, options, { formatInput: formatInput });
    }

    // api: https://uni-apis.alibaba-inc.com/doc/UI/clearnavibarrightitem
    var apiConfig$a = {
        web: {
            dingTalk: clearNaviBarRightItem$1,
            windvane: {
                cn: clearNaviBarRightItem$3,
                cnStation: clearNaviBarRightItem$2,
                cnNetCom: clearNaviBarRightItem$2
            },
        },
    };
    var clearNaviBarRightItem = extend(apiConfig$a, index$g);

    function setNavigationBarTitle$i(params) {
        var _a;
        if (document) {
            document.title = (_a = params === null || params === void 0 ? void 0 : params.title) !== null && _a !== void 0 ? _a : '';
        }
        var formatInput = function (options) { return ({
            title: options === null || options === void 0 ? void 0 : options.title,
        }); };
        // https://alidocs.dingtalk.com/i/nodes/Mk5evdR04jBV59vnPj1dVQL3x2OlParn
        WVCall$1('CNHybridNavigationBar.setTitle', params, { formatInput: formatInput });
    }

    function setNavigationBarTitle$h(params) {
        var _a;
        if (document) {
            document.title = (_a = params === null || params === void 0 ? void 0 : params.title) !== null && _a !== void 0 ? _a : '';
        }
        // https://page.cainiao.com/cn-yz/cnyz-book/_book/api/titlrbar.html?spm=a2d5h.23431112.0.0
        WVCall$1('TitlebarModule.setTitle', params, {
            formatInput: function (options) { return ({
                text: options === null || options === void 0 ? void 0 : options.title,
            }); },
        });
    }

    function setNavigationBarTitle$g(options, context) {
        var _a;
        var api = 'dd.biz.navigation.setTitle';
        (_a = context === null || context === void 0 ? void 0 : context.DDCall) === null || _a === void 0 ? void 0 : _a.call(context, api, options);
    }

    function setNavigationBarTitle$f(params) {
        var _a;
        if (document) {
            document.title = (_a = params === null || params === void 0 ? void 0 : params.title) !== null && _a !== void 0 ? _a : '';
        }
    }

    function setNavigationBarTitle$e(options, context) {
        var _a;
        (_a = context === null || context === void 0 ? void 0 : context.PanguMiniAppCall) === null || _a === void 0 ? void 0 : _a.call(context, 'setNavigationBar', options);
    }

    function isUndef$3(type) {
      return type === 'undefined';
    }

    var isDingdingMiniapp$3 = !isUndef$3(typeof dd) && dd !== null && !isUndef$3(typeof dd.alert);

    function _extends$d() { _extends$d = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$d.apply(this, arguments); }

    function promisify$1(api) {
      return function (arg) {
        return new Promise(function (resolve, reject) {
          var promisifyArg = arg;
          api(_extends$d({}, promisifyArg, {
            success: function success(res) {
              if (promisifyArg && typeof promisifyArg.success === 'function') {
                promisifyArg.success(res);
              }

              resolve(res);
            },
            onSuccess: function onSuccess(res) {
              if (promisifyArg && typeof promisifyArg.onSuccess === 'function') {
                promisifyArg.onSuccess(res);
              }

              resolve(res);
            },
            fail: function fail(res) {
              if (promisifyArg && typeof promisifyArg.fail === 'function') {
                promisifyArg.fail(res);
              }

              reject(res);
            },
            onFail: function onFail(res) {
              if (promisifyArg && typeof promisifyArg.onFail === 'function') {
                promisifyArg.onFail(res);
              }

              reject(res);
            },
            complete: function complete(res) {
              if (promisifyArg && typeof promisifyArg.complete === 'function') {
                promisifyArg.complete(res);
              }
            },
            onComplete: function onComplete(res) {
              if (promisifyArg && typeof promisifyArg.onComplete === 'function') {
                promisifyArg.onComplete(res);
              }
            }
          }));
        });
      };
    }

    var _excluded$2 = ["_ext"];

    function _objectWithoutPropertiesLoose$2(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

    function _extends$c() { _extends$c = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$c.apply(this, arguments); }
    var styleIn$2 = function styleIn(options, baseName) {
      var _ref = options || {},
          _ref$_ext = _ref._ext,
          _ext = _ref$_ext === void 0 ? {} : _ref$_ext,
          rest = _objectWithoutPropertiesLoose$2(_ref, _excluded$2);

      return _extends$c({}, rest, _ext[baseName] || {});
    };

    function _extends$b() { _extends$b = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$b.apply(this, arguments); }

    var styleOptions$2 = function styleOptions(options, containerName) {
      var afterOptions = _extends$b({}, options);

      if (!afterOptions.frontColor) {
        afterOptions.frontColor = '#000000';
      }

      return afterOptions;
    };
    /**
     * setNavigationBarTitle api
     * @param api
     * @param containerName
     * @returns
     */


    function normalizeSetNavigationBarTitle(api, containerName) {
      return function (args) {
        return promisify$1(api)(styleIn$2(args, containerName));
      };
    }
    /**
     * setNavigationBarColor api
     * @param api
     * @param containerName
     * @returns
     */

    function normalizeSetNavigationBarColor(api, containerName) {
      return function (args) {
        return promisify$1(api)(styleOptions$2(styleIn$2(args, containerName)));
      };
    } // export function normalizeGetMenuButtonBoundingClientRect(api: (args) => any, containerName: string) {
    //   return (args?) => {
    //     return promisify(api)(args);
    //   };
    // }

    var CONTAINER_NAME$2 = {
      WECHAT: 'wechatMiniProgram',
      ALIPAY: 'aliMiniApp',
      BYTE: 'bytedanceMicroApp',
      WEB: 'web',
      BAIDU: 'baiduSmartProgram',
      KWAI: 'kuaishouMiniProgram'
    };

    var setNavigationBarColor$4 = normalizeSetNavigationBarColor(function (args) {
      return isDingdingMiniapp$3 ? dd.setNavigationBar(args) : my.setNavigationBar(args);
    }, CONTAINER_NAME$2.ALIPAY);

    var setNavigationBarTitle$c = normalizeSetNavigationBarTitle(function (args) {
      return isDingdingMiniapp$3 ? dd.setNavigationBar(args) : my.setNavigationBar(args);
    }, CONTAINER_NAME$2.ALIPAY);
    var setNavigationBarTitle$d = setNavigationBarTitle$c;

    var aliMiniAppModule$5 = {
      setNavigationBarColor: setNavigationBarColor$4,
      setNavigationBarTitle: setNavigationBarTitle$d
    };

    /**
     * 动态设置当前页面的标题
     */

    var setNavigationBarTitle$a = normalizeSetNavigationBarTitle(function (_ref) {
      var title = _ref.title,
          _ref$success = _ref.success,
          success = _ref$success === void 0 ? function () {} : _ref$success,
          _ref$fail = _ref.fail,
          fail = _ref$fail === void 0 ? function () {} : _ref$fail,
          _ref$complete = _ref.complete,
          complete = _ref$complete === void 0 ? function () {} : _ref$complete;

      try {
        document.title = title;
        success();
        complete();
      } catch (error) {
        fail();
        complete();
      }
    }, CONTAINER_NAME$2.WEB);
    var setNavigationBarTitle$b = setNavigationBarTitle$a;

    var webModule$5 = {
      setNavigationBarTitle: setNavigationBarTitle$b
    };

    var setNavigationBarColor$3 = normalizeSetNavigationBarColor(function (args) {
      wx.setNavigationBarColor(args);
    }, CONTAINER_NAME$2.WECHAT);

    var setNavigationBarTitle$8 = normalizeSetNavigationBarTitle(function (args) {
      return wx.setNavigationBarTitle(args);
    }, CONTAINER_NAME$2.WECHAT);
    var setNavigationBarTitle$9 = setNavigationBarTitle$8;

    // import { normalizeSetNavigationBarColor } from '../common';
    // import { CONTAINER_NAME } from '@utils/constant';
    // const getMenuButtonBoundingClientRect = normalizeSetNavigationBarColor((args) => {
    //   wx.setNavigationBarColor(args);
    // }, CONTAINER_NAME.WECHAT);
    // export default getMenuButtonBoundingClientRect;
    var getMenuButtonBoundingClientRect$3 = (function () {
      return wx.getMenuButtonBoundingClientRect();
    });

    var weChatModule$5 = {
      setNavigationBarColor: setNavigationBarColor$3,
      setNavigationBarTitle: setNavigationBarTitle$9,
      getMenuButtonBoundingClientRect: getMenuButtonBoundingClientRect$3
    };

    var setNavigationBarColor$2 = normalizeSetNavigationBarColor(function (args) {
      tt.setNavigationBarColor(args);
    }, CONTAINER_NAME$2.BYTE);

    var setNavigationBarTitle$6 = normalizeSetNavigationBarTitle(function (args) {
      return tt.setNavigationBarTitle(args);
    }, CONTAINER_NAME$2.BYTE);
    var setNavigationBarTitle$7 = setNavigationBarTitle$6;

    var getMenuButtonBoundingClientRect$2 = (function () {
      return tt.getMenuButtonBoundingClientRect();
    });

    var bytedanceModule$5 = {
      setNavigationBarColor: setNavigationBarColor$2,
      setNavigationBarTitle: setNavigationBarTitle$7,
      getMenuButtonBoundingClientRect: getMenuButtonBoundingClientRect$2
    };

    var setNavigationBarColor$1 = normalizeSetNavigationBarColor(function (args) {
      ks.setNavigationBarColor(args);
    }, CONTAINER_NAME$2.KWAI);

    var setNavigationBarTitle$4 = normalizeSetNavigationBarTitle(function (args) {
      return ks.setNavigationBarTitle(args);
    }, CONTAINER_NAME$2.KWAI);
    var setNavigationBarTitle$5 = setNavigationBarTitle$4;

    var getMenuButtonBoundingClientRect$1 = (function () {
      return ks.getMenuButtonBoundingClientRect();
    });

    var kuaiShouModule$3 = {
      setNavigationBarColor: setNavigationBarColor$1,
      setNavigationBarTitle: setNavigationBarTitle$5,
      getMenuButtonBoundingClientRect: getMenuButtonBoundingClientRect$1
    };

    var setNavigationBarColor = normalizeSetNavigationBarColor(function (args) {
      swan.setNavigationBarColor(args);
    }, CONTAINER_NAME$2.BAIDU);

    var setNavigationBarTitle$2 = normalizeSetNavigationBarTitle(function (args) {
      return swan.setNavigationBarTitle(args);
    }, CONTAINER_NAME$2.BAIDU);
    var setNavigationBarTitle$3 = setNavigationBarTitle$2;

    var getMenuButtonBoundingClientRect = (function () {
      return swan.getMenuButtonBoundingClientRect();
    });

    var baiDuModule$5 = {
      setNavigationBarColor: setNavigationBarColor,
      setNavigationBarTitle: setNavigationBarTitle$3,
      getMenuButtonBoundingClientRect: getMenuButtonBoundingClientRect
    };

    var setNavigationBarTitle$1 = function setNavigationBarTitle(args) {
      if (isWeb$1) {
        return webModule$5.setNavigationBarTitle(args);
      } else if (isKuaiShouMiniProgram) {
        return kuaiShouModule$3.setNavigationBarTitle(args);
      } else if (isWeChatMiniProgram) {
        return weChatModule$5.setNavigationBarTitle(args);
      } else if (isByteDanceMicroApp) {
        return bytedanceModule$5.setNavigationBarTitle(args);
      } else if (isMiniApp) {
        return aliMiniAppModule$5.setNavigationBarTitle(args);
      } else if (isBaiduSmartProgram) {
        return baiDuModule$5.setNavigationBarTitle(args);
      } else {
        throw new Error('Uni API：setNavigationBarTitle暂不支持');
      }
    };

    var mini = setNavigationBarTitle$1;

    var apiConfig$9 = {
        web: {
            browser: setNavigationBarTitle$f,
            dingTalk: setNavigationBarTitle$g,
            dingTalkPC: setNavigationBarTitle$g,
            windvane: {
                cn: setNavigationBarTitle$i,
                cnStation: setNavigationBarTitle$h,
                cnNetCom: setNavigationBarTitle$h,
            },
        },
        mini: mini,
        panguMiniApp: setNavigationBarTitle$e,
    };
    // @uni库里，使用setNavigationBarTitle作为统一命名。
    var extendSetNavigationBarTitle = extend(apiConfig$9, index$r);
    /**
     * 设置导航栏标题。API：https://yuque.antfin.com/cn-xt/arch/lwbvd0
     * @param title
     * @param params
     * @example 使用案例：
     * import { setNavigationBarTitle } from '@alife/cn-uni-api';
     *  setNavigationBarTitle('测试标题')
     *    .then(() => {
     *      console.log('success');
     *    })
     *    .catch((error) => {
     *      console.log(error);
     *    });
     * @author 敬文
     */
    var setNavigationBarTitle = function (title, params) {
        if (typeof title === 'string') {
            return extendSetNavigationBarTitle(__assign$1(__assign$1({}, params), { title: title }));
        }
        return extendSetNavigationBarTitle(title);
    };

    function showTitle$2(params) {
        var formatInput = function () { return ({
            fullScreenV2: 'NO',
            fullScreen: 'NO', // 传值为YES时，当前H5容器全屏，其他值则不全屏
        }); };
        // https://alidocs.dingtalk.com/i/nodes/Mk5evdR04jBV59vnPj1dVQL3x2OlParn
        WVCall$1('CNHybridH5ParamUtil.handleH5Param', params, { formatInput: formatInput });
    }

    function showTitle$1(params) {
        var formatInput = function () { return ({
            visibility: 0, // 0-显示 1-不显示 2-不显示但仍占位
        }); };
        // https://page.cainiao.com/cn-yz/cnyz-book/_book/api/titlrbar.html?spm=a2d5h.23431112.0.0
        WVCall$1('TitlebarModule.setVisibility', params, { formatInput: formatInput });
    }

    var apiConfig$8 = {
        web: {
            windvane: {
                cn: showTitle$2,
                cnStation: showTitle$1,
                cnNetCom: showTitle$1,
            },
        },
    };
    /**
     * 显示titleBar
     * API：https://yuque.antfin.com/cn-xt/htc47g/tzr9pt
     * @returns {Promise<unknown>} promise调用结果
     * @example 使用案例：
     * import { showTitle } from '@alife/cn-uni-api'; // h5、小程序通用包
     *
     * showTitle()
     *   .then(() => {
     *     console.log('success');
     *   })
     *   .catch((error) => {
     *     console.log(error);
     *   });
     * @author 敬文
     */
    var showTitle = extend(apiConfig$8, index$i);

    function hideTitle$2(params) {
        var formatInput = function () { return ({
            fullScreenV2: 'YES',
            fullScreen: 'YES', // 传值为YES时，当前H5容器全屏，其他值则不全屏
        }); };
        // https://alidocs.dingtalk.com/i/nodes/Mk5evdR04jBV59vnPj1dVQL3x2OlParn
        WVCall$1('CNHybridH5ParamUtil.handleH5Param', params, { formatInput: formatInput });
    }

    function hideTitle$1(params) {
        var formatInput = function () { return ({
            visibility: 1, // 0-显示 1-不显示 2-不显示但仍占位
        }); };
        // https://page.cainiao.com/cn-yz/cnyz-book/_book/api/titlrbar.html?spm=a2d5h.23431112.0.0
        WVCall$1('TitlebarModule.setVisibility', params, { formatInput: formatInput });
    }

    var apiConfig$7 = {
        web: {
            windvane: {
                cn: hideTitle$2,
                cnStation: hideTitle$1,
                cnNetCom: hideTitle$1,
            },
        },
    };
    /**
     * 隐藏titleBar
     * API：https://yuque.antfin.com/cn-xt/htc47g/tzr9pt
     * @returns {Promise<unknown>} promise调用结果
     * @example 使用案例：
     * import { hideTitle } from '@alife/cn-uni-api'; // h5、小程序通用包
     *
     * hideTitle()
     *   .then(() => {
     *     console.log('success');
     *   })
     *   .catch((error) => {
     *     console.log(error);
     *   });
     * @author 敬文
     */
    var hideTitle = extend(apiConfig$7, index$e);

    var apiConfig$6 = {};
    /**
     * 设置 WebView 的背景颜色
     * API：https://yuque.antfin.com/cn-xt/htc47g/tzr9pt
     * @returns {Promise<unknown>} promise调用结果
     * @example 使用案例：
     * import { setBackgroundColor } from '@alife/cn-uni-api'; // h5、小程序通用包
     *
     * setBackgroundColor({ backgroundColor: "#005BE5" })
     *   .then(() => {
     *     console.log('success');
     *   })
     *   .catch((error) => {
     *     console.log(error);
     *   });
     * @author 敬文
     */
    var setBackgroundColor = extend(apiConfig$6, 
    /** baseSetBackgroundColor 支持windvane容器、nebula容器 */
    index$M);

    function getStorage$1(options, context) {
        var _a;
        (_a = context === null || context === void 0 ? void 0 : context.PanguMiniAppCall) === null || _a === void 0 ? void 0 : _a.call(context, 'getStorage', options);
    }

    var extendGetStorage = extend({
        panguMiniApp: getStorage$1,
    }, index$H);
    /**
     * 获取缓存。API：https://yuque.antfin.com/cn-xt/arch/lwbvd0
     * 当没有值时，默认返回空对象{}。因为这里遵循uni-api规范，保持一致。
     * @returns {Promise<unknown>} promise调用结果
     *
     * @example
     * import { getStorage } from '@alife/cn-uni-api';
     *
     * getStorage('your-key').then((res) => {
     *   console.log('success', res);
     * }).catch((error) => {
     *   console.log(error);
     * });
     * @author 敬文
     */
    var getStorage = function (key, params) {
        if (typeof key === 'string') {
            return extendGetStorage(__assign$1(__assign$1({}, params), { key: key }));
        }
        return extendGetStorage(key);
    };

    function setStorage$2(options, context) {
        var _a;
        (_a = context === null || context === void 0 ? void 0 : context.PanguMiniAppCall) === null || _a === void 0 ? void 0 : _a.call(context, 'setStorage', options);
    }

    var apiConfig$5 = {
        web: {
            panguMiniApp: setStorage$2,
        },
    };
    /**
     * 设置缓存。API：https://yuque.antfin.com/cn-xt/arch/lwbvd0
     * @returns {Promise<unknown>} promise调用结果
     *
     * @example
     * import { setStorage } from '@alife/cn-uni-api';
     *
     * setStorage({key: 'your-key', value:{}})
     * .then((res) => {
     *   console.log('success', res);
     * })
     * .catch((error) => {
     *   console.log(error);
     * });
     * @author 敬文
     */
    var setStorage$1 = extend(apiConfig$5, index$b);

    function setStorage(options, context) {
        var _a;
        (_a = context === null || context === void 0 ? void 0 : context.PanguMiniAppCall) === null || _a === void 0 ? void 0 : _a.call(context, 'removeStorage', options);
    }

    var apiConfig$4 = {
        web: {
            panguMiniApp: setStorage,
        },
    };
    var extendRemoveStorage = extend(apiConfig$4, index$y);
    /**
     * 设置缓存。API：https://yuque.antfin.com/cn-xt/arch/lwbvd0
     * @returns {Promise<unknown>} promise调用结果
     *
     * @example
     * import { removeStorage } from '@alife/cn-uni-api';
     *
     * removeStorage('your-key')
     * .then((res) => {
     *   console.log('success', res);
     * })
     * .catch((error) => {
     *   console.log(error);
     * });
     * @author 敬文
     */
    var removeStorage = function (key, params) {
        if (typeof key === 'string') {
            return extendRemoveStorage(__assign$1(__assign$1({}, params), { key: key }));
        }
        return extendRemoveStorage(key);
    };

    /**
     * 监听页面回退事件。
     * 支持【菜鸟、淘宝、支付宝】
     * 注意: 该事件需要和navigateBack API配合触发。
     * @example 使用案例：
     * useEffect(() => {
     *  const callback = () => {}
     *  const cancelGlobalResume = onGlobalResume(callback);
     *
     *  return () => cancelGlobalResume();
    }, [])
     * @param cb resume事件回调函数
     * @returns 返回取消全局的global事件
     */
    var onGlobalResume = function (cb) {
        var handleResume = function (e) {
            var data = getResumeCallBackData(e);
            cb(data); // 未想到更好方式屏蔽as，此处as作为参数。
        };
        var eventName = 'WV.Event.APP.Active';
        if (isWebAp) {
            eventName = 'resume';
        }
        else if (isWebCn) {
            eventName = 'pageResume';
        }
        document.addEventListener(eventName, handleResume, false);
        return function () { return document.removeEventListener(eventName, handleResume, false); };
    };

    /**
     * 该方法会彻底拦截掉容器左上角的默认回退。
     */
    function onBackCatcher$3(cb) {
        var handler = function () {
            if (typeof cb !== 'function') {
                return;
            }
            cb();
        };
        JSCall$3('CNHybridNavigator.registerNativeGoBackCatcher', {}, function () {
            document.addEventListener('cnBack', handler, false);
        });
        return function () { return JSCall$3('CNHybridNavigator.unregisterNativeGoBackCatcher', {}); };
    }

    function onBackCatcher$2(cb) {
        /**
         * 拦截手淘 WebView 的 Back 事件: http://h5.alibaba-inc.com/api/TaobaoClient-API.html#%E6%8B%A6%E6%88%AA%E6%89%8B%E6%B7%98-WebView-%E7%9A%84-Back-%E4%BA%8B%E4%BB%B6
         * 手淘导航栏的左上角的返回按钮，或 Android 系统的返回按钮，都可以令当前页面回退到上一历史，或者关闭当前 WebView（如果不存在可以回退的历史）。
         * WindVane 在手淘中提供了拦截 Native Back 的机制，使得 JS 可以控制这一返回过程.
         * 例如可以通过调用 WebAppInterface.pop 这一 API 跳过历史记录直接关闭 WebView。
         * 要拦截 Native Back，首先要在页面中调用 JSBridge WebAppInterface.enableHookNativeBack，开启拦截 Native Back 的功能。
         * 然后在页面中实现一个控制方法 _windvane_backControl，每次 Native Back 时都会调用该方法。
         * 如果方法返回 'true'，就会停止客户端的返回逻辑，并通过 wvBackClickEvent 事件通知 JS。如果返回其它值，则会继续客户端的返回逻辑（不拦截）。
         * @returns
         */
        JSCall$3('WebAppInterface.enableHookNativeBack', {});
        // eslint-disable-next-line no-underscore-dangle
        window._windvane_backControl = function () {
            // 返回 'true' 即可拦截手淘的 Native Back
            return 'true';
        };
        var handler = function () {
            if (typeof cb !== 'function') {
                return;
            }
            cb();
        };
        document.addEventListener('wvBackClickEvent', handler, false);
        return function () {
            // eslint-disable-next-line no-underscore-dangle
            window._windvane_backControl = function () {
                return 'false';
            };
            document.removeEventListener('wvBackClickEvent', handler, false);
        };
    }

    // back: https://smallfish.antfin-inc.com/jsapi/back.html
    // 注意：iOS端侧滑返回，由于手势操作具有可中途撤销的特性，无法触发back事件。
    function onBackCatcher$1(cb) {
        var handler = function (e) {
            e.preventDefault(); // 首先屏蔽默认行为，然后调用页面跳转API进行手动控制
            if (typeof cb !== 'function') {
                return;
            }
            cb();
        };
        document.addEventListener('back', handler, false);
        return function () { return document.removeEventListener('back', handler, false); };
    }

    /**
     * 原生容器，默认返回时的拦截和回调监听
     * 注意该方法只能拦截原生容器（Android/IOS）返回，navigateBack无法拦截。
     * @param cb 拦截返回回调函数
     * @returns 返回取消对用户返回的拦截
     * @example 使用案例：
     * import { onBackCatcher } from '@alife/cn-uni-api';
     *
     * useEffect(() => {
     *  const callback = () => {}
     *  const cancelBackCatcher = onBackCatcher(callback);
     *
     *  return () => cancelBackCatcher();
     * }, [])
     */
    var onBackCatcher = function (cb) {
        if (isWebCn) {
            return onBackCatcher$3(cb);
        }
        if (isWebAp) {
            return onBackCatcher$1(cb);
        }
        if (isWebTb) {
            return onBackCatcher$2(cb);
        }
        console.warn('onBackCatcher API is not support this env');
        return function () { };
    };

    var getApp$7 = (function () {
      return getApp();
    });

    var getCurrentPages$6 = (function () {
      return getCurrentPages();
    });

    var getLaunchOptionsSync$6 = (function () {
      return my.getLaunchOptionsSync();
    });

    function isUndef$2(type) {
      return type === 'undefined';
    }

    var isDingdingMiniapp$2 = !isUndef$2(typeof dd) && dd !== null && !isUndef$2(typeof dd.alert);

    var onError$6 = (function (cb) {
      return isDingdingMiniapp$2 ? dd.onError(cb) : my.onError(cb);
    });

    var offError$5 = (function (cb) {
      return isDingdingMiniapp$2 ? dd.offError(cb) : my.offError(cb);
    });

    var onUnhandledRejection$6 = (function (cb) {
      return isDingdingMiniapp$2 ? dd.onUnhandledRejection(cb) : my.onUnhandledRejection(cb);
    });

    var offUnhandledRejection$5 = (function (cb) {
      return isDingdingMiniapp$2 ? dd.offUnhandledRejection(cb) : my.offUnhandledRejection(cb);
    });

    var aliMiniAppModule$4 = {
      getApp: getApp$7,
      getCurrentPages: getCurrentPages$6,
      getLaunchOptionsSync: getLaunchOptionsSync$6,
      onError: onError$6,
      offError: offError$5,
      onUnhandledRejection: onUnhandledRejection$6,
      offUnhandledRejection: offUnhandledRejection$5
    };

    var getApp$6 = (function () {
      return getApp();
    });

    var getCurrentPages$5 = (function () {
      return getCurrentPages();
    });

    var getLaunchOptionsSync$5 = (function () {
      return wx.getLaunchOptionsSync();
    });

    var onError$5 = (function (cb) {
      return wx.onError(cb);
    });

    var offError$4 = (function (cb) {
      return wx.offError(cb);
    });

    var onUnhandledRejection$5 = (function (cb) {
      return wx.onUnhandledRejection(cb);
    });

    var offUnhandledRejection$4 = (function (cb) {
      return wx.offUnhandledRejection(cb);
    });

    var weChatModule$4 = {
      getApp: getApp$6,
      getCurrentPages: getCurrentPages$5,
      getLaunchOptionsSync: getLaunchOptionsSync$5,
      onError: onError$5,
      offError: offError$4,
      onUnhandledRejection: onUnhandledRejection$5,
      offUnhandledRejection: offUnhandledRejection$4
    };

    var getApp$5 = (function () {
      return getApp();
    });

    var getCurrentPages$4 = (function () {
      return getCurrentPages();
    });

    var getLaunchOptionsSync$4 = (function () {
      return tt.getLaunchOptionsSync();
    });

    var onError$4 = (function (cb) {
      return tt.onError(cb);
    });

    var offError$3 = (function (cb) {
      return tt.offError(cb);
    });

    var onUnhandledRejection$4 = (function (cb) {
      return tt.onUnhandledRejection(cb);
    });

    var offUnhandledRejection$3 = (function (cb) {
      return tt.offUnhandledRejection(cb);
    });

    var bytedanceModule$4 = {
      getApp: getApp$5,
      getCurrentPages: getCurrentPages$4,
      getLaunchOptionsSync: getLaunchOptionsSync$4,
      onError: onError$4,
      offError: offError$3,
      onUnhandledRejection: onUnhandledRejection$4,
      offUnhandledRejection: offUnhandledRejection$3
    };

    var getApp$4 = (function () {
      return window;
    });

    var getCurrentPages$3 = (function () {
      var query = {};
      var hash = {};
      window.location.hash.replace(/#.*?\?/, '').split('&').forEach(function (i) {
        hash[i.split('=')[0]] = i.split('=')[1];
      });
      window.location.search.replace('?', '').split('&').forEach(function (i) {
        query[i.split('=')[0]] = i.split('=')[1];
      });
      return [{
        pageId: "" + window.location.pathname + window.location.hash + "-1",
        query: query,
        hash: hash
      }];
    });

    var getLaunchOptionsSync$3 = (function () {
      return {
        path: window.location.pathname,
        query: {}
      };
    });

    var onError$3 = (function (cb) {
      return window.addEventListener('error', cb);
    });

    var offError$2 = (function (cb) {
      return window.removeEventListener('error', cb);
    });

    var onUnhandledRejection$3 = (function (cb) {
      return window.addEventListener('unhandledrejection', cb);
    });

    var offUnhandledRejection$2 = (function (cb) {
      return window.removeEventListener('unhandledrejection', cb);
    });

    var webModule$4 = {
      getApp: getApp$4,
      getCurrentPages: getCurrentPages$3,
      getLaunchOptionsSync: getLaunchOptionsSync$3,
      onError: onError$3,
      offError: offError$2,
      onUnhandledRejection: onUnhandledRejection$3,
      offUnhandledRejection: offUnhandledRejection$2
    };

    var getApp$3 = (function () {
      return getApp();
    });

    var getCurrentPages$2 = (function () {
      return getCurrentPages();
    });

    var getLaunchOptionsSync$2 = (function () {
      return ks.getLaunchOptionsSync();
    });

    var onError$2 = (function (cb) {
      return ks.onError(cb);
    });

    var offError$1 = (function (cb) {
      return ks.offError(cb);
    });

    var onUnhandledRejection$2 = (function (cb) {
      return ks.onUnhandledRejection(cb);
    });

    var offUnhandledRejection$1 = (function (cb) {
      return ks.offUnhandledRejection(cb);
    });

    var kuaiShouModule$2 = {
      getApp: getApp$3,
      getCurrentPages: getCurrentPages$2,
      getLaunchOptionsSync: getLaunchOptionsSync$2,
      onError: onError$2,
      offError: offError$1,
      onUnhandledRejection: onUnhandledRejection$2,
      offUnhandledRejection: offUnhandledRejection$1
    };

    var getApp$2 = (function () {
      return getApp();
    });

    var getCurrentPages$1 = (function () {
      return getCurrentPages();
    });

    // export default () => swan.getLaunchOptionsSync();
    var getLaunchOptionsSync$1 = (function () {});

    var onError$1 = (function (cb) {
      return swan.onError(cb);
    });

    var offError = (function (cb) {
      return swan.offError(cb);
    });

    var onUnhandledRejection$1 = (function (cb) {// return swan.onUnhandledRejection(cb);
    });

    var offUnhandledRejection = (function (cb) {// return swan.offUnhandledRejection(cb);
    });

    var baiDuModule$4 = {
      getApp: getApp$2,
      getCurrentPages: getCurrentPages$1,
      getLaunchOptionsSync: getLaunchOptionsSync$1,
      onError: onError$1,
      offError: offError,
      onUnhandledRejection: onUnhandledRejection$1,
      offUnhandledRejection: offUnhandledRejection
    };

    var getApp$1 = function getApp() {
      if (isWeb$1) {
        return webModule$4.getApp();
      } else if (isKuaiShouMiniProgram) {
        return kuaiShouModule$2.getApp();
      } else if (isWeChatMiniProgram) {
        return weChatModule$4.getApp();
      } else if (isByteDanceMicroApp) {
        return bytedanceModule$4.getApp();
      } else if (isMiniApp) {
        return aliMiniAppModule$4.getApp();
      } else if (isBaiduSmartProgram) {
        return baiDuModule$4.getApp();
      } else {
        throw new Error('@uni：application.getApp 暂不支持');
      }
    };
    var getLaunchOptionsSync = function getLaunchOptionsSync() {
      if (isWeb$1) {
        return webModule$4.getLaunchOptionsSync();
      } else if (isKuaiShouMiniProgram) {
        return kuaiShouModule$2.getLaunchOptionsSync();
      } else if (isWeChatMiniProgram) {
        return weChatModule$4.getLaunchOptionsSync();
      } else if (isByteDanceMicroApp) {
        return bytedanceModule$4.getLaunchOptionsSync();
      } else if (isMiniApp) {
        return aliMiniAppModule$4.getLaunchOptionsSync();
      } else {
        throw new Error('@uni：application.getLaunchOptionsSync 暂不支持');
      }
    };
    var onError = function onError(options) {
      if (isWeb$1) {
        return webModule$4.onError(options);
      } else if (isKuaiShouMiniProgram) {
        throw new Error('@uni：onError 暂不支持');
      } else if (isWeChatMiniProgram) {
        return weChatModule$4.onError(options);
      } else if (isByteDanceMicroApp) {
        return bytedanceModule$4.onError(options);
      } else if (isMiniApp) {
        return aliMiniAppModule$4.onError(options);
      } else if (isBaiduSmartProgram) {
        return baiDuModule$4.onError(options);
      } else {
        throw new Error('@uni：onError 暂不支持');
      }
    };
    var onUnhandledRejection = function onUnhandledRejection(options) {
      if (isWeb$1) {
        return webModule$4.onUnhandledRejection(options);
      } else if (isKuaiShouMiniProgram) {
        return kuaiShouModule$2.onUnhandledRejection(options);
      } else if (isWeChatMiniProgram) {
        return weChatModule$4.onUnhandledRejection(options);
      } else if (isByteDanceMicroApp) {
        return bytedanceModule$4.onUnhandledRejection(options);
      } else if (isMiniApp) {
        return aliMiniAppModule$4.onUnhandledRejection(options);
      } else {
        throw new Error('@uni：onUnhandledRejection 暂不支持');
      }
    };

    var apiConfig$3 = {
        web: image.getImageInfo,
        mini: image.getImageInfo,
    };
    var getImageInfo = extend(apiConfig$3);

    var promisify_2 = promisify;
    function _extends$a() { _extends$a = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$a.apply(this, arguments); }
    function promisify(api) {
      return function (arg) {
        return new Promise(function (resolve, reject) {
          var promisifyArg = arg;
          api(_extends$a({}, promisifyArg, {
            success: function success(res) {
              if (promisifyArg && typeof promisifyArg.success === 'function') {
                promisifyArg.success(res);
              }
              resolve(res);
            },
            onSuccess: function onSuccess(res) {
              if (promisifyArg && typeof promisifyArg.onSuccess === 'function') {
                promisifyArg.onSuccess(res);
              }
              resolve(res);
            },
            fail: function fail(res) {
              if (promisifyArg && typeof promisifyArg.fail === 'function') {
                promisifyArg.fail(res);
              }
              reject(res);
            },
            onFail: function onFail(res) {
              if (promisifyArg && typeof promisifyArg.onFail === 'function') {
                promisifyArg.onFail(res);
              }
              reject(res);
            },
            complete: function complete(res) {
              if (promisifyArg && typeof promisifyArg.complete === 'function') {
                promisifyArg.complete(res);
              }
            },
            onComplete: function onComplete(res) {
              if (promisifyArg && typeof promisifyArg.onComplete === 'function') {
                promisifyArg.onComplete(res);
              }
            }
          }));
        });
      };
    }

    var promisify_1 = /*#__PURE__*/Object.defineProperty({
    	promisify: promisify_2
    }, '__esModule', {value: true});

    var styleOptions$1 = createCommonjsModule(function (module, exports) {

    exports.__esModule = true;
    exports.styleOut = exports.styleIn = void 0;
    var _excluded = ["_ext"];
    function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
    function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
    var styleOut = function styleOut(output, originalInput, originalOutput) {
      return _extends({}, output, {
        _original: {
          input: _extends({}, originalInput),
          // 实际调用 api 方法时传入的参数. 对入参进行 format 之后的结果
          output: _extends({}, originalOutput) // 实际调用 api 方法时传入的参数. 返回值 format 之前的结果
        }
      });
    };
    exports.styleOut = styleOut;
    var styleIn = function styleIn(options, baseName) {
      var _ref = options || {},
        _ref$_ext = _ref._ext,
        _ext = _ref$_ext === void 0 ? {} : _ref$_ext,
        rest = _objectWithoutPropertiesLoose(_ref, _excluded);
      return _extends({}, rest, _ext[baseName] || {});
    };
    exports.styleIn = styleIn;
    });

    var common = createCommonjsModule(function (module, exports) {

    exports.__esModule = true;
    exports.formatSystemInfoAsync = exports.formatSystemInfo = exports.formatResult = void 0;


    function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
    var formatLanguage = function formatLanguage(language) {
      var fl = 'en';
      switch (language.toLowerCase()) {
        case 'zh_cn':
        case 'zh-hans':
        case 'zh-cn':
        case 'chinese':
          fl = 'zh_CN';
          break;
        case 'zh_tw':
        case 'zh-hant':
        case 'zh-hk':
          fl = 'zh_TW';
          break;
        case 'en':
        case 'english':
        case 'en-us':
          fl = 'en';
          break;
        default:
          fl = 'en';
      }
      return fl;
    };
    var formatSystemInfo = function formatSystemInfo(api) {
      return function () {
        var res = api();
        return formatResult(res);
      };
    };
    exports.formatSystemInfo = formatSystemInfo;
    var formatResult = function formatResult(data) {
      var defaultData = {
        pixelRatio: 1,
        screenWidth: 0,
        screenHeight: 0,
        windowWidth: 0,
        windowHeight: 0,
        language: '',
        version: '',
        platform: ''
      };
      return _extends({}, defaultData, data, {
        language: data.language ? formatLanguage(data.language) : ''
      });
    };
    exports.formatResult = formatResult;
    var formatSystemInfoAsync = function formatSystemInfoAsync(api, containerName) {
      return function (options) {
        var _options = (0, styleOptions$1.styleIn)(options, containerName);
        var afterOptions = _extends({}, _options, {
          success: function success(res) {
            _options.success && _options.success(formatResult(res));
          },
          complete: function complete(res) {
            _options.complete && _options.complete(res.pixelRatio ? formatResult(res) : res);
          }
        });
        return (0, promisify_1.promisify)(api)(afterOptions).then(formatResult);
      };
    };
    exports.formatSystemInfoAsync = formatSystemInfoAsync;
    });

    var constant = createCommonjsModule(function (module, exports) {

    exports.__esModule = true;
    exports.JSONP_SIGN = exports.CONTAINER_NAME = void 0;
    var CONTAINER_NAME = {
      WECHAT: 'wechatMiniProgram',
      ALIPAY: 'aliMiniApp',
      BYTE: 'bytedanceMicroApp',
      WEB: 'web',
      BAIDU: 'baiduSmartProgram',
      KWAI: 'kuaishouMiniProgram'
    };
    exports.CONTAINER_NAME = CONTAINER_NAME;
    var JSONP_SIGN = '__uni_jsonp_handler_sign__';
    exports.JSONP_SIGN = JSONP_SIGN;
    });

    var getInfo_1$5 = createCommonjsModule(function (module, exports) {

    exports.__esModule = true;
    exports.default = void 0;


    function getPlatform() {
      var _navigator = navigator,
        platform = _navigator.platform;
      if (platform) {
        var _navigator2, _navigator2$userAgent, _navigator3, _navigator3$userAgent;
        if (/(iphone|ipod|ipad)/.test((_navigator2 = navigator) == null ? void 0 : (_navigator2$userAgent = _navigator2.userAgent) == null ? void 0 : _navigator2$userAgent.toLowerCase())) return 'iOS';
        if (/android/.test((_navigator3 = navigator) == null ? void 0 : (_navigator3$userAgent = _navigator3.userAgent) == null ? void 0 : _navigator3$userAgent.toLowerCase())) return 'Android';
        return platform;
      }
      return '';
    }
    var getInfoSync = (0, common.formatSystemInfo)(function () {
      return {
        pixelRatio: window.devicePixelRatio,
        screenWidth: window.document.documentElement.clientWidth,
        screenHeight: window.document.documentElement.clientHeight,
        windowWidth: window.innerWidth,
        windowHeight: window.innerHeight,
        language: navigator.language,
        version: navigator.appVersion,
        platform: getPlatform() || ''
      };
    });
    var getInfo = (0, common.formatSystemInfoAsync)(function (options) {
      var success = options.success,
        fail = options.fail,
        complete = options.complete;
      try {
        var res = getInfoSync();
        success && success(res);
        complete && complete(res);
      } catch (e) {
        fail && fail(e);
        complete && complete(e);
      }
    }, constant.CONTAINER_NAME.WEB);
    var _default = getInfo;
    exports.default = _default;
    });

    var getInfoSync_1$5 = createCommonjsModule(function (module, exports) {

    exports.__esModule = true;
    exports.default = void 0;

    function getPlatform() {
      var _navigator = navigator,
        platform = _navigator.platform;
      if (platform) {
        var _navigator2, _navigator2$userAgent, _navigator3, _navigator3$userAgent;
        if (/(iphone|ipod|ipad)/.test((_navigator2 = navigator) == null ? void 0 : (_navigator2$userAgent = _navigator2.userAgent) == null ? void 0 : _navigator2$userAgent.toLowerCase())) return 'iOS';
        if (/android/.test((_navigator3 = navigator) == null ? void 0 : (_navigator3$userAgent = _navigator3.userAgent) == null ? void 0 : _navigator3$userAgent.toLowerCase())) return 'Android';
        return platform;
      }
      return '';
    }
    var getInfoSync = (0, common.formatSystemInfo)(function () {
      return {
        pixelRatio: window.devicePixelRatio,
        screenWidth: window.document.documentElement.clientWidth,
        screenHeight: window.document.documentElement.clientHeight,
        windowWidth: window.innerWidth,
        windowHeight: window.innerHeight,
        language: navigator.language,
        version: navigator.appVersion,
        platform: getPlatform()
      };
    });
    var _default = getInfoSync;
    exports.default = _default;
    });

    var web = createCommonjsModule(function (module, exports) {

    exports.__esModule = true;
    exports.default = void 0;
    var _getInfo = _interopRequireDefault(getInfo_1$5);
    exports.getInfo = _getInfo.default;
    var _getInfoSync = _interopRequireDefault(getInfoSync_1$5);
    exports.getInfoSync = _getInfoSync.default;
    function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
    var _default = {
      getInfo: _getInfo.default,
      getInfoSync: _getInfoSync.default
    };
    exports.default = _default;
    });

    var miniappEnvApp = createCommonjsModule(function (module, exports) {

    exports.__esModule = true;
    exports.isDingdingMiniapp = void 0;
    function isUndef(type) {
      return type === 'undefined';
    }
    var isDingdingMiniapp = !isUndef(typeof dd) && dd !== null && !isUndef(typeof dd.alert);
    exports.isDingdingMiniapp = isDingdingMiniapp;
    });

    var getInfo_1$4 = createCommonjsModule(function (module, exports) {

    exports.__esModule = true;
    exports.default = void 0;



    var getInfo = (0, common.formatSystemInfoAsync)(function (options) {
      var _success = options.success,
        _fail = options.fail,
        _complete = options.complete;
      var _getInfo = miniappEnvApp.isDingdingMiniapp ? dd.getSystemInfo : my.getSystemInfo;
      _getInfo({
        success: function success(res) {
          _success && _success(res);
        },
        fail: function fail(res) {
          _fail && _fail(res);
        },
        complete: function complete(res) {
          _complete && _complete(res);
        }
      });
    }, constant.CONTAINER_NAME.ALIPAY);
    var _default = getInfo;
    exports.default = _default;
    });

    var getInfoSync_1$4 = createCommonjsModule(function (module, exports) {

    exports.__esModule = true;
    exports.default = void 0;


    var getInfoSync = (0, common.formatSystemInfo)(function () {
      return miniappEnvApp.isDingdingMiniapp ? dd.getSystemInfoSync() : my.getSystemInfoSync();
    });
    var _default = getInfoSync;
    exports.default = _default;
    });

    var aliMiniapp = createCommonjsModule(function (module, exports) {

    exports.__esModule = true;
    exports.default = void 0;
    var _getInfo = _interopRequireDefault(getInfo_1$4);
    exports.getInfo = _getInfo.default;
    var _getInfoSync = _interopRequireDefault(getInfoSync_1$4);
    exports.getInfoSync = _getInfoSync.default;
    function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
    var _default = {
      getInfo: _getInfo.default,
      getInfoSync: _getInfoSync.default
    };
    exports.default = _default;
    });

    var getInfo_1$3 = createCommonjsModule(function (module, exports) {

    exports.__esModule = true;
    exports.default = void 0;


    var getInfo = (0, common.formatSystemInfoAsync)(function (options) {
      var _success = options.success,
        _fail = options.fail,
        _complete = options.complete;
      wx.getSystemInfo({
        success: function success(res) {
          _success && _success(res);
        },
        fail: function fail(res) {
          _fail && _fail(res);
        },
        complete: function complete(res) {
          _complete && _complete(res);
        }
      });
    }, constant.CONTAINER_NAME.WECHAT);
    var _default = getInfo;
    exports.default = _default;
    });

    var getInfoSync_1$3 = createCommonjsModule(function (module, exports) {

    exports.__esModule = true;
    exports.default = void 0;

    var getInfoSync = (0, common.formatSystemInfo)(function () {
      return wx.getSystemInfoSync();
    });
    var _default = getInfoSync;
    exports.default = _default;
    });

    var wechatMiniprogram = createCommonjsModule(function (module, exports) {

    exports.__esModule = true;
    exports.default = void 0;
    var _getInfo = _interopRequireDefault(getInfo_1$3);
    exports.getInfo = _getInfo.default;
    var _getInfoSync = _interopRequireDefault(getInfoSync_1$3);
    exports.getInfoSync = _getInfoSync.default;
    function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
    var _default = {
      getInfo: _getInfo.default,
      getInfoSync: _getInfoSync.default
    };
    exports.default = _default;
    });

    var getInfo_1$2 = createCommonjsModule(function (module, exports) {

    exports.__esModule = true;
    exports.default = void 0;


    var getInfo = (0, common.formatSystemInfoAsync)(function (options) {
      var _success = options.success,
        _fail = options.fail,
        _complete = options.complete;
      tt.getSystemInfo({
        success: function success(res) {
          _success && _success(res);
        },
        fail: function fail(res) {
          _fail && _fail(res);
        },
        complete: function complete(res) {
          _complete && _complete(res);
        }
      });
    }, constant.CONTAINER_NAME.BYTE);
    var _default = getInfo;
    exports.default = _default;
    });

    var getInfoSync_1$2 = createCommonjsModule(function (module, exports) {

    exports.__esModule = true;
    exports.default = void 0;

    var getInfoSync = (0, common.formatSystemInfo)(function () {
      return tt.getSystemInfoSync();
    });
    var _default = getInfoSync;
    exports.default = _default;
    });

    var bytedanceMicroapp = createCommonjsModule(function (module, exports) {

    exports.__esModule = true;
    exports.default = void 0;
    var _getInfo = _interopRequireDefault(getInfo_1$2);
    exports.getInfo = _getInfo.default;
    var _getInfoSync = _interopRequireDefault(getInfoSync_1$2);
    exports.getInfoSync = _getInfoSync.default;
    function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
    var _default = {
      getInfo: _getInfo.default,
      getInfoSync: _getInfoSync.default
    };
    exports.default = _default;
    });

    var getInfo_1$1 = createCommonjsModule(function (module, exports) {

    exports.__esModule = true;
    exports.default = void 0;


    var getInfo = (0, common.formatSystemInfoAsync)(function (options) {
      var _success = options.success,
        _fail = options.fail,
        _complete = options.complete;
      ks.getSystemInfo({
        success: function success(res) {
          _success && _success(res);
        },
        fail: function fail(res) {
          _fail && _fail(res);
        },
        complete: function complete(res) {
          _complete && _complete(res);
        }
      });
    }, constant.CONTAINER_NAME.KWAI);
    var _default = getInfo;
    exports.default = _default;
    });

    var getInfoSync_1$1 = createCommonjsModule(function (module, exports) {

    exports.__esModule = true;
    exports.default = void 0;

    var getInfoSync = (0, common.formatSystemInfo)(function () {
      return ks.getSystemInfoSync();
    });
    var _default = getInfoSync;
    exports.default = _default;
    });

    var kuaishouMiniprogram = createCommonjsModule(function (module, exports) {

    exports.__esModule = true;
    exports.default = void 0;
    var _getInfo = _interopRequireDefault(getInfo_1$1);
    exports.getInfo = _getInfo.default;
    var _getInfoSync = _interopRequireDefault(getInfoSync_1$1);
    exports.getInfoSync = _getInfoSync.default;
    function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
    var _default = {
      getInfo: _getInfo.default,
      getInfoSync: _getInfoSync.default
    };
    exports.default = _default;
    });

    var getInfo_1 = createCommonjsModule(function (module, exports) {

    exports.__esModule = true;
    exports.default = void 0;


    var getInfo = (0, common.formatSystemInfoAsync)(function (options) {
      var _success = options.success,
        _fail = options.fail,
        _complete = options.complete;
      swan.getSystemInfo({
        success: function success(res) {
          _success && _success(res);
        },
        fail: function fail(res) {
          _fail && _fail(res);
        },
        complete: function complete(res) {
          _complete && _complete(res);
        }
      });
    }, constant.CONTAINER_NAME.BAIDU);
    var _default = getInfo;
    exports.default = _default;
    });

    var getInfoSync_1 = createCommonjsModule(function (module, exports) {

    exports.__esModule = true;
    exports.default = void 0;

    var getInfoSync = (0, common.formatSystemInfo)(function () {
      return swan.getSystemInfoSync();
    });
    var _default = getInfoSync;
    exports.default = _default;
    });

    var baiduSmartprogram = createCommonjsModule(function (module, exports) {

    exports.__esModule = true;
    exports.default = void 0;
    var _getInfo = _interopRequireDefault(getInfo_1);
    exports.getInfo = _getInfo.default;
    var _getInfoSync = _interopRequireDefault(getInfoSync_1);
    exports.getInfoSync = _getInfoSync.default;
    function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
    var _default = {
      getInfo: _getInfo.default,
      getInfoSync: _getInfoSync.default
    };
    exports.default = _default;
    });

    var _env = /*@__PURE__*/getAugmentedNamespace(es);

    var lib = createCommonjsModule(function (module, exports) {

    exports.__esModule = true;
    exports.getInfoSync = exports.getInfo = exports.default = void 0;

    var webModule = _interopRequireWildcard(web);
    var aliMiniAppModule = _interopRequireWildcard(aliMiniapp);
    var weChatModule = _interopRequireWildcard(wechatMiniprogram);
    var bytedanceModule = _interopRequireWildcard(bytedanceMicroapp);
    var kuaiShouModule = _interopRequireWildcard(kuaishouMiniprogram);
    var baiDuModule = _interopRequireWildcard(baiduSmartprogram);
    function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
    function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
    var getInfoSync = function getInfoSync() {
      if (_env.isWeb) {
        return webModule.getInfoSync();
      } else if (_env.isKuaiShouMiniProgram) {
        return kuaiShouModule.getInfoSync();
      } else if (_env.isWeChatMiniProgram) {
        return weChatModule.getInfoSync();
      } else if (_env.isByteDanceMicroApp) {
        return bytedanceModule.getInfoSync();
      } else if (_env.isMiniApp) {
        return aliMiniAppModule.getInfoSync();
      } else if (_env.isBaiduSmartProgram) {
        return baiDuModule.getInfoSync();
      } else {
        throw new Error('Uni API：getInfoSync暂不支持');
      }
    };
    exports.getInfoSync = getInfoSync;
    var getInfo = function getInfo(options) {
      if (_env.isWeb) {
        return webModule.getInfo(options);
      } else if (_env.isKuaiShouMiniProgram) {
        return kuaiShouModule.getInfo(options);
      } else if (_env.isWeChatMiniProgram) {
        return weChatModule.getInfo(options);
      } else if (_env.isByteDanceMicroApp) {
        return bytedanceModule.getInfo(options);
      } else if (_env.isMiniApp) {
        return aliMiniAppModule.getInfo(options);
      } else if (_env.isBaiduSmartProgram) {
        return baiDuModule.getInfo(options);
      } else {
        throw new Error('Uni API：getInfo暂不支持');
      }
    };
    exports.getInfo = getInfo;
    var _default = {
      getInfoSync: getInfoSync,
      getInfo: getInfo
    };
    exports.default = _default;
    });

    var systemInfo = /*@__PURE__*/getDefaultExportFromCjs(lib);

    var apiConfig$2 = {
        web: systemInfo.getInfo,
        mini: systemInfo.getInfo,
    };
    var getInfo = extend(apiConfig$2);

    var getScrollOffset$6 = function getScrollOffset(selector) {
      return new Promise(function (resolve) {
        my.createSelectorQuery().selectAll(selector).scrollOffset().exec(function (ret) {
          resolve(ret[0] ? ret[0].map(function (i) {
            return {
              scrollLeft: i.scrollLeft,
              scrollTop: i.scrollTop
            };
          }) : []);
        });
      });
    };

    var styleBoundingClientRectResponse = function styleBoundingClientRectResponse(data) {
      return data ? data.map(function (res) {
        return {
          left: isNone(res.left) ? '' : res.left,
          right: isNone(res.right) ? '' : res.right,
          top: isNone(res.top) ? '' : res.top,
          bottom: isNone(res.bottom) ? '' : res.bottom,
          width: res.width,
          height: res.height
        };
      }) : [];
    };
    var normalize$1 = {
      getBoundingClientRect: function getBoundingClientRect(api) {
        return function () {
          return api.apply(void 0, arguments).then(styleBoundingClientRectResponse);
        };
      }
    };

    var isNone = function isNone(val) {
      return typeof val === 'undefined' || !val && val !== 0;
    };

    var getBoundingClientRect$7 = normalize$1.getBoundingClientRect(function (selector) {
      return new Promise(function (resolve) {
        my.createSelectorQuery().selectAll(selector).boundingClientRect().exec(function (ret) {
          resolve(ret[0]);
        });
      });
    });

    var aliMiniAppModule$3 = {
      getScrollOffset: getScrollOffset$6,
      getBoundingClientRect: getBoundingClientRect$7
    };

    var getScrollOffset$5 = function getScrollOffset(selector, context) {
      if (context === void 0) {
        context = wx;
      }

      return new Promise(function (resolve) {
        // const ele: any = document.querySelector(selector);
        // if (!ele || !ele._internal) {
        //   console.warn('element not found', selector);
        //   resolve([]);
        // }
        var createSelectorQuery = context.createSelectorQuery || wx.createSelectorQuery;
        createSelectorQuery().selectAll(selector).scrollOffset().exec(function (ret) {
          resolve(ret[0] ? ret[0].map(function (i) {
            return {
              scrollLeft: i.scrollLeft,
              scrollTop: i.scrollTop
            };
          }) : []);
        });
      });
    };

    var getBoundingClientRect$6 = normalize$1.getBoundingClientRect(function (selector, context) {
      if (context === void 0) {
        context = wx;
      }

      return new Promise(function (resolve) {
        var createSelectorQuery = context.createSelectorQuery || wx.createSelectorQuery;
        createSelectorQuery().selectAll(selector).boundingClientRect().exec(function (ret) {
          resolve(ret[0]);
        });
      });
    });

    var weChatModule$3 = {
      getScrollOffset: getScrollOffset$5,
      getBoundingClientRect: getBoundingClientRect$6
    };

    var getScrollOffset$4 = function getScrollOffset(selector, context) {
      if (context === void 0) {
        context = tt;
      }

      return new Promise(function (resolve) {
        context.createSelectorQuery = context.createSelectorQuery || tt.createSelectorQuery;
        context.createSelectorQuery().selectAll(selector).scrollOffset().exec(function (ret) {
          resolve(ret[0] ? ret[0].map(function (i) {
            return {
              scrollLeft: i.scrollLeft,
              scrollTop: i.scrollTop
            };
          }) : []);
        });
      });
    };

    var getBoundingClientRect$5 = normalize$1.getBoundingClientRect(function (selector, context) {
      if (context === void 0) {
        context = tt;
      }

      return new Promise(function (resolve) {
        context.createSelectorQuery = context.createSelectorQuery || tt.createSelectorQuery;
        context.createSelectorQuery().selectAll(selector).boundingClientRect().exec(function (ret) {
          resolve(ret[0]);
        });
      });
    });

    var bytedanceModule$3 = {
      getScrollOffset: getScrollOffset$4,
      getBoundingClientRect: getBoundingClientRect$5
    };

    var getScrollOffset$3 = function getScrollOffset(selector, context) {
      if (context === void 0) {
        context = ks;
      }

      return new Promise(function (resolve) {
        context.createSelectorQuery = context.createSelectorQuery || ks.createSelectorQuery;
        context.createSelectorQuery().selectAll(selector).scrollOffset().exec(function (ret) {
          resolve(ret[0] ? ret[0].map(function (i) {
            return {
              scrollLeft: i.scrollLeft,
              scrollTop: i.scrollTop
            };
          }) : []);
        });
      });
    };

    var getBoundingClientRect$4 = normalize$1.getBoundingClientRect(function (selector, context) {
      if (context === void 0) {
        context = ks;
      }

      return new Promise(function (resolve) {
        context.createSelectorQuery = context.createSelectorQuery || ks.createSelectorQuery;
        context.createSelectorQuery().selectAll(selector).boundingClientRect().exec(function (ret) {
          resolve(ret[0]);
        });
      });
    });

    var kuaiShouModule$1 = {
      getScrollOffset: getScrollOffset$3,
      getBoundingClientRect: getBoundingClientRect$4
    };

    var getScrollOffset$2 = function getScrollOffset(selector, context) {
      if (context === void 0) {
        context = swan;
      }

      return new Promise(function (resolve) {
        context.createSelectorQuery = context.createSelectorQuery || swan.createSelectorQuery;
        context.createSelectorQuery().selectAll(selector).scrollOffset().exec(function (ret) {
          resolve(ret[0] ? ret[0].map(function (i) {
            return {
              scrollLeft: i.scrollLeft,
              scrollTop: i.scrollTop
            };
          }) : []);
        });
      });
    };

    var getBoundingClientRect$3 = normalize$1.getBoundingClientRect(function (selector, context) {
      if (context === void 0) {
        context = swan;
      }

      return new Promise(function (resolve) {
        context.createSelectorQuery = context.createSelectorQuery || swan.createSelectorQuery;
        context.createSelectorQuery().selectAll(selector).boundingClientRect().exec(function (ret) {
          resolve(ret[0]);
        });
      });
    });

    var baiDuModule$3 = {
      getScrollOffset: getScrollOffset$2,
      getBoundingClientRect: getBoundingClientRect$3
    };

    var getScrollOffset$1 = function getScrollOffset(selector) {
      return new Promise(function (resolve) {
        var el = document.querySelectorAll(selector);
        resolve(el.length === 0 ? [] : [].map.call(el, function (node) {
          return {
            scrollTop: node.scrollTop,
            scrollLeft: node.scrollLeft
          };
        }));
      });
    };

    var getBoundingClientRect$2 = normalize$1.getBoundingClientRect(function (selector) {
      return new Promise(function (resolve) {
        var el = document.querySelectorAll(selector);
        resolve(el.length === 0 ? [] : [].map.call(el, function (node) {
          return node.getBoundingClientRect();
        }));
      });
    });

    var webModule$3 = {
      getScrollOffset: getScrollOffset$1,
      getBoundingClientRect: getBoundingClientRect$2
    };

    var getScrollOffset = function getScrollOffset(selector, context) {
      if (isWeb$1) {
        return webModule$3.getScrollOffset(selector);
      } else if (isKuaiShouMiniProgram) {
        return kuaiShouModule$1.getScrollOffset(selector, context);
      } else if (isWeChatMiniProgram) {
        return weChatModule$3.getScrollOffset(selector, context);
      } else if (isByteDanceMicroApp) {
        return bytedanceModule$3.getScrollOffset(selector, context);
      } else if (isMiniApp) {
        return aliMiniAppModule$3.getScrollOffset(selector);
      } else if (isBaiduSmartProgram) {
        return baiDuModule$3.getScrollOffset(selector, context);
      } else {
        throw new Error('Uni API：element暂不支持');
      }
    };
    var getBoundingClientRect$1 = function getBoundingClientRect(selector, context) {
      if (isWeb$1) {
        return webModule$3.getBoundingClientRect(selector);
      } else if (isKuaiShouMiniProgram) {
        return kuaiShouModule$1.getBoundingClientRect(selector, context);
      } else if (isWeChatMiniProgram) {
        return weChatModule$3.getBoundingClientRect(selector, context);
      } else if (isByteDanceMicroApp) {
        return bytedanceModule$3.getBoundingClientRect(selector, context);
      } else if (isMiniApp) {
        return aliMiniAppModule$3.getBoundingClientRect(selector);
      } else if (isBaiduSmartProgram) {
        return baiDuModule$3.getBoundingClientRect(selector, context);
      } else {
        throw new Error('Uni API：element暂不支持');
      }
    };
    var element = {
      getScrollOffset: getScrollOffset,
      getBoundingClientRect: getBoundingClientRect$1
    };

    var fn = function (_a) {
        var selector = _a.selector, success = _a.success, fail = _a.fail;
        element.getBoundingClientRect(selector).then(success).catch(fail);
    };
    var apiConfig$1 = {
        web: fn,
        mini: fn,
    };
    var getBoundingClientRect = extend(apiConfig$1);

    function isUndef$1(type) {
      return type === 'undefined';
    }

    var isDingdingMiniapp$1 = !isUndef$1(typeof dd) && dd !== null && !isUndef$1(typeof dd.alert);

    var aliMiniAppModule$2 = (function () {
      var _dd, _my;

      return isDingdingMiniapp$1 ? (_dd = dd).createIntersectionObserver.apply(_dd, arguments) : (_my = my).createIntersectionObserver.apply(_my, arguments);
    });

    function buildMarginStr(margins) {
      return (Number(margins.top) || 0) + "px " + (Number(margins.right) || 0) + "px " + (Number(margins.bottom) || 0) + "px " + (Number(margins.left) || 0) + "px";
    }

    function IntersectionObservers(options) {
      this.thresholds = options && options.thresholds ? options.thresholds : [0];
      this.initialRatio = options && options.initialRatio ? options.initialRatio : 0;
      this.selectAll = options && options.selectAll ? options.selectAll : false;

      this.callBack = function () {};

      this.observers = [];
    }

    function relative(root, self, margins) {
      var options = {
        root: root,
        rootMargin: margins ? buildMarginStr(margins) : '0px',
        threshold: self.thresholds
      };
      self.observers.push(new IntersectionObserver(function () {
        self.callBack.apply(self, arguments);
      }, options));
    }

    IntersectionObservers.prototype.relativeTo = function (selector, margins) {
      relative(document.querySelector(selector), this, margins);
      return this;
    };

    IntersectionObservers.prototype.relativeToViewport = function (margins) {
      relative(null, this, margins);
      return this;
    };

    IntersectionObservers.prototype.observe = function (targetSelector, callback) {
      var _this = this;

      if (this.selectAll) {
        var targets = document.querySelectorAll(targetSelector);
        targets.forEach(function (target) {
          return _this.observers.forEach(function (observer) {
            return observer.observe(target);
          });
        });
      } else {
        var target = document.querySelector(targetSelector);
        this.observers.forEach(function (observer) {
          return observer.observe(target);
        });
      }

      this.callBack = function (entries, observer) {
        entries.forEach(function (entry) {
          callback && typeof callback === 'function' && callback({
            boundingClientRect: entry.boundingClientRect,
            intersectionRatio: entry.intersectionRatio,
            intersectionRect: entry.intersectionRect,
            relativeRect: entry.rootBounds,
            time: entry.time
          });
        });
      };

      return this;
    };

    IntersectionObservers.prototype.disconnect = function (targetSelector, callback) {
      this.callBack = function () {};

      this.observers = [];
      this.observers.forEach(function (observer) {
        observer.disconnect();
      });
      return this;
    };

    var createIntersectionObserver$2 = function createIntersectionObserver(options, component) {
      return new IntersectionObservers(options);
    };

    var webModule$2 = createIntersectionObserver$2;

    var weChatModule$2 = (function (options, context) {
      if (context === void 0) {
        context = wx;
      }

      if (options && options.selectAll != undefined) {
        options.observeAll = options.selectAll;
      } // 防止传入自定义组件的this没有createIntersectionObserver


      return context === wx || !context.createIntersectionObserver ? context.createIntersectionObserver(null, options) : context.createIntersectionObserver(options);
    });

    var bytedanceModule$2 = (function (options, context) {
      if (context === void 0) {
        context = tt;
      }

      if (options && options.selectAll != undefined) {
        options.observeAll = options.selectAll;
      } // 防止传入自定义组件的this没有createIntersectionObserver


      return context === tt || !context.createIntersectionObserver ? context.createIntersectionObserver(null, options) : context.createIntersectionObserver(options);
    });

    var baiDuModule$2 = (function (options, context) {
      if (context === void 0) {
        context = swan;
      }

      // 防止传入自定义组件的this没有createIntersectionObserver
      return context === swan || !context.createIntersectionObserver ? context.createIntersectionObserver(null, options) : context.createIntersectionObserver(options);
    });

    var createIntersectionObserver = function createIntersectionObserver() {
      if (isWeb$1) {
        return webModule$2.apply(void 0, arguments);
      } else if (isKuaiShouMiniProgram) {
        throw new Error('Uni API：IntersectionObserver暂不支持');
      } else if (isWeChatMiniProgram) {
        return weChatModule$2.apply(void 0, arguments);
      } else if (isByteDanceMicroApp) {
        return bytedanceModule$2.apply(void 0, arguments);
      } else if (isMiniApp) {
        return aliMiniAppModule$2.apply(void 0, arguments);
      } else if (isBaiduSmartProgram) {
        return baiDuModule$2.apply(void 0, arguments);
      } else {
        throw new Error('Uni API：IntersectionObserver暂不支持');
      }
    };

    var createIntersectionObserver$1 = createIntersectionObserver;

    var CONTAINER_NAME$1 = {
      WECHAT: 'wechatMiniProgram',
      ALIPAY: 'aliMiniApp',
      BYTE: 'bytedanceMicroApp',
      WEB: 'web',
      BAIDU: 'baiduSmartProgram',
      KWAI: 'kuaishouMiniProgram'
    };

    var _excluded$1 = ["_ext"];

    function _objectWithoutPropertiesLoose$1(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

    function _extends$9() { _extends$9 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$9.apply(this, arguments); }
    var styleIn$1 = function styleIn(options, baseName) {
      var _ref = options || {},
          _ref$_ext = _ref._ext,
          _ext = _ref$_ext === void 0 ? {} : _ref$_ext,
          rest = _objectWithoutPropertiesLoose$1(_ref, _excluded$1);

      return _extends$9({}, rest, _ext[baseName] || {});
    };

    function _extends$8() { _extends$8 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$8.apply(this, arguments); }

    /**
     * merge default options
     * @param containerName
     * @param options
     */
    function getMergedOptions(containerName, options) {
      var mergedOptions = styleIn$1(_extends$8({
        duration: 400,
        timingFunction: 'linear',
        delay: 0,
        transformOrigin: '50% 50% 0'
      }, options), containerName); // set the min duration to 16ms to avoid some problems

      if (mergedOptions.duration < 16) {
        mergedOptions.duration = 16;
      }

      return mergedOptions;
    }
    /**
     * parse value of transform
     * @param value
     */

    function parseTransform(value) {
      value = String(value || '');
      var pos = 0;

      var isValidWord = function isValidWord(code) {
        if (code >= 65 && code <= 90) return true; // A-Z

        if (code >= 97 && code <= 122) return true; // a-z

        if (code >= 48 && code <= 57) return true; // 0-9

        if (code === 45 || code === 46) return true; // `-` or `.`

        return false;
      };

      var skipSpace = function skipSpace() {
        while (pos < value.length) {
          var code = value.charCodeAt(pos);

          if (code === 32 || code === 160) {
            // ` `
            pos++;
          } else if (code === 13 || code === 10 || code === 8232 || code === 8233) {
            // new line
            if (code === 13 && value.charCodeAt(pos + 1) === 10) {
              // CRLF
              pos++;
            }

            pos++;
          } else if (code > 8 && code < 14) {
            // other space
            pos++;
          } else {
            break;
          }
        }
      };

      var eat = function eat(_char) {
        if (value[pos] === _char) {
          pos++;
          return true;
        }

        return false;
      };

      var parseAtom = function parseAtom() {
        var name = '';
        var args = [];
        var isReadArgs = false;
        var isExpectWord = true;

        while (pos < value.length) {
          skipSpace();
          var code = value.charCodeAt(pos);

          if (isExpectWord) {
            if (!isValidWord(code)) break;
            var chunkStart = pos;

            while (pos < value.length && isValidWord(code)) {
              code = value.charCodeAt(++pos);
            }

            var str = value.slice(chunkStart, pos);

            if (isReadArgs) {
              args.push(str);
              isExpectWord = false;
            } else {
              name = str;
              skipSpace();
              if (!eat('(')) break;
              isReadArgs = true;
              isExpectWord = true;
            }
          } else if (code === 44) {
            // `,`
            isExpectWord = true;
            pos++;
          } else {
            break;
          }
        }

        if (isExpectWord || !eat(')')) return null;
        if (!name || args.length === 0) return null;
        return {
          name: name,
          args: args
        };
      };

      var hasInvalid = false;

      var getValidArg = function getValidArg(val, unit) {
        if (unit === void 0) {
          unit = '';
        }

        var match = new RegExp("^(-?\\d*(\\.\\d+)?)" + unit + "$", 'i').exec(val);

        if (match && match[1]) {
          return Number(match[1]);
        } else {
          hasInvalid = true;
        }
      };

      var result = {};

      while (pos < value.length) {
        var res = parseAtom();
        skipSpace();
        if (!res) return {};
        var args = res.args;

        if (['rotate', 'rotateX', 'rotateY', 'rotateZ', 'skew', 'skewX', 'skewY'].includes(res.name)) {
          args = args.map(function (arg) {
            return getValidArg(arg, 'deg');
          });
        } else if (['translate', 'translateX', 'translateY', 'translateZ', 'translate3d'].includes(res.name)) {
          args = args.map(function (arg) {
            return getValidArg(arg, 'px');
          });
        } else if (['scale', 'scale3d', 'scaleX', 'scaleY', 'scaleZ', 'matrix', 'matrix3d'].includes(res.name)) {
          args = args.map(function (arg) {
            return getValidArg(arg, '');
          });
        } else if (res.name === 'rotate3d') {
          args = [].concat(args.slice(0, 3).map(function (arg) {
            return getValidArg(arg, '');
          }), args.slice(3, 4).map(function (arg) {
            return getValidArg(arg, 'deg');
          }));
        } else {
          return {};
        }

        if (hasInvalid) return {};
        result[res.name] = args;
      }

      return result;
    }
    /**
     * normalize createTransition method
     * @param animation
     * @param options
     */

    function normalizeCreateTransition(animation, options) {
      var _ref = options || {},
          _ref$from = _ref.from,
          from = _ref$from === void 0 ? {} : _ref$from,
          _ref$to = _ref.to,
          to = _ref$to === void 0 ? {} : _ref$to,
          animationOptions = _ref.options;

      var applyTransform = function applyTransform(opts) {
        Object.keys(opts).forEach(function (key) {
          var value = opts[key];

          if (key === 'transform') {
            applyTransform(parseTransform(value));
          } else if (typeof animation[key] === 'function') {
            if (Array.isArray(value)) {
              animation[key].apply(animation, value);
            } else {
              animation[key](value);
            }
          }
        });
      }; // from


      applyTransform(from);
      animation.step(_extends$8({}, animationOptions, {
        duration: 16,
        delay: 0
      })); // to

      applyTransform(to);
      animation.step(animationOptions);
      return animation;
    }

    function _extends$7() { _extends$7 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7.apply(this, arguments); }

    function createAnimation$5(options) {
      var animation = my.createAnimation(getMergedOptions(CONTAINER_NAME$1.ALIPAY, options)); // override

      var _step = animation.step.bind(animation);

      var _export = animation.export.bind(animation);

      animation.step = function (opts) {
        opts = getMergedOptions(CONTAINER_NAME$1.ALIPAY, _extends$7({}, options, opts));
        return _step(opts);
      };

      animation.export = function () {
        return _export();
      };

      return animation;
    }

    function createTransition$5(options) {
      var animation = createAnimation$5();
      return normalizeCreateTransition(animation, options);
    }

    var aliMiniAppModule$1 = {
      createAnimation: createAnimation$5,
      createTransition: createTransition$5
    };

    function _extends$6() { _extends$6 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6.apply(this, arguments); }
    var ANIMATION_RUNNING = '__UNI_API_ANIMATION_RUNNING__';
    var ANIMATION_CANCEL = '__UNI_API_ANIMATION_CANCEL__';
    var ANIMATION_ORIGINAL_STYLE = '__UNI_API_ANIMATION_ORIGINAL_STYLE__';
    /**
     * normalize unit
     * @param value
     * @param unit
     * @param force
     */

    function normalizeUnit(value, unit, force) {
      if (force === void 0) {
        force = false;
      }

      if (force || typeof value === 'number') {
        return "" + value + unit;
      }

      return value;
    }
    /**
     * handle animation actions queue
     * @param actions
     * @param fn
     * @param onFinish
     */


    function handleActionsQueue(actions, fn, onFinish) {
      actions = actions.slice();
      var action = actions.shift();

      if (action) {
        fn(action, function () {
          return handleActionsQueue(actions, fn, onFinish);
        });
      } else if (onFinish) {
        onFinish();
      }
    }
    /**
     * apply animation for web-side
     * @param actions
     * @param dom
     */


    function applyWebAnimation(actions, dom) {
      // If `dom` is not HTML Node, ignore
      if (!(dom && dom.nodeType === 1)) {
        return;
      } // clear the last animation


      if (dom[ANIMATION_RUNNING]) {
        (dom[ANIMATION_CANCEL] || []).forEach(function (t) {
          return clearTimeout(t);
        });
      } else {
        // cache original style
        dom[ANIMATION_ORIGINAL_STYLE] = {
          transitionProperty: dom.style.transitionProperty,
          transitionDuration: dom.style.transitionDuration,
          transitionDelay: dom.style.transitionDelay,
          transitionTimingFunction: dom.style.transitionTimingFunction,
          transformOrigin: dom.style.transformOrigin
        };
      }

      dom[ANIMATION_RUNNING] = true;
      dom[ANIMATION_CANCEL] = [];
      /**
       * Apply animation action, return the current cost time
       * @param action
       */

      var applyAction = function applyAction(action) {
        var _action$option = action.option,
            transition = _action$option.transition,
            transformOrigin = _action$option.transformOrigin;
        var transform = [];
        action.animates.forEach(function (animate) {
          if (animate.type === 'style') {
            var _animate$args = animate.args,
                property = _animate$args[0],
                value = _animate$args[1];
            dom.style[property] = value;
          } else {
            transform.push(animate.type + "(" + animate.args.join(',') + ")");
          }
        });

        if (transform.length > 0) {
          dom.style.transform = transform.join(' ');
        }

        dom.style.transitionProperty = 'all';
        dom.style.transitionDuration = transition.duration + "ms";
        dom.style.transitionDelay = transition.delay + "ms";
        dom.style.transitionTimingFunction = transition.timingFunction;
        dom.style.transformOrigin = transformOrigin;
        var cost = transition.delay + transition.duration;
        return isNaN(cost) ? 0 : cost;
      };

      var saveCancel = function saveCancel(timer) {
        dom[ANIMATION_CANCEL] = dom[ANIMATION_CANCEL] || [];
        dom[ANIMATION_CANCEL].push(timer);
      };

      var delay = 0;
      handleActionsQueue(actions, function (action, callback) {
        saveCancel(setTimeout(function () {
          delay = applyAction(action);
          callback();
        }, delay));
      }, function () {
        saveCancel( // Restore the style at the end of the animation
        setTimeout(function () {
          Object.assign(dom.style, dom[ANIMATION_ORIGINAL_STYLE] || {});
          dom[ANIMATION_RUNNING] = null;
          dom[ANIMATION_CANCEL] = null;
          dom[ANIMATION_ORIGINAL_STYLE] = null;
        }, delay));
      });
    }

    var AnimationImpl = /*#__PURE__*/function () {
      function AnimationImpl(options) {
        this.options = void 0;
        this.actions = void 0;
        this.currentTransform = void 0;
        this.currentStepAnimates = void 0;
        this.options = getMergedOptions(CONTAINER_NAME$1.WEB, options);
        this.actions = [];
        this.currentTransform = {};
        this.currentStepAnimates = [];
      }

      var _proto = AnimationImpl.prototype;

      _proto.export = function _export(dom) {
        var actions = this.actions.slice();
        applyWebAnimation(actions, dom);
        this.actions = [];
        return {
          actions: actions
        };
      };

      _proto.step = function step(options) {
        var _this = this;

        options = getMergedOptions(CONTAINER_NAME$1.WEB, _extends$6({}, this.options, options));
        this.currentStepAnimates.forEach(function (animate) {
          var key = animate.type;

          if (key === 'style') {
            key += "." + animate.args[0];
          }

          _this.currentTransform[key] = animate;
        });
        var animates = [];
        Object.keys(this.currentTransform).forEach(function (key) {
          animates.push(_this.currentTransform[key]);
        });
        this.actions.push({
          animates: animates,
          option: {
            transformOrigin: options.transformOrigin,
            transition: {
              delay: options.delay,
              duration: options.duration,
              timingFunction: options.timingFunction
            }
          }
        });
        this.currentStepAnimates = [];
        return this;
      };

      _proto.opacity = function opacity(value) {
        this.currentStepAnimates.push({
          type: 'style',
          args: ['opacity', value]
        });
        return this;
      };

      _proto.backgroundColor = function backgroundColor(value) {
        this.currentStepAnimates.push({
          type: 'style',
          args: ['background-color', value]
        });
        return this;
      };

      _proto.width = function width(value) {
        this.currentStepAnimates.push({
          type: 'style',
          args: ['width', normalizeUnit(value, 'px')]
        });
        return this;
      };

      _proto.height = function height(value) {
        this.currentStepAnimates.push({
          type: 'style',
          args: ['height', normalizeUnit(value, 'px')]
        });
        return this;
      };

      _proto.left = function left(value) {
        this.currentStepAnimates.push({
          type: 'style',
          args: ['left', normalizeUnit(value, 'px')]
        });
        return this;
      };

      _proto.right = function right(value) {
        this.currentStepAnimates.push({
          type: 'style',
          args: ['right', normalizeUnit(value, 'px')]
        });
        return this;
      };

      _proto.top = function top(value) {
        this.currentStepAnimates.push({
          type: 'style',
          args: ['top', normalizeUnit(value, 'px')]
        });
        return this;
      };

      _proto.bottom = function bottom(value) {
        this.currentStepAnimates.push({
          type: 'style',
          args: ['bottom', normalizeUnit(value, 'px')]
        });
        return this;
      };

      _proto.rotate = function rotate(angle) {
        if (angle === void 0) {
          angle = 0;
        }

        this.currentStepAnimates.push({
          type: 'rotate',
          args: [normalizeUnit(angle, 'deg', true)]
        });
        return this;
      };

      _proto.rotate3d = function rotate3d(x, y, z, angle) {
        if (x === void 0) {
          x = 0;
        }

        if (y === void 0) {
          y = 0;
        }

        if (z === void 0) {
          z = 0;
        }

        if (angle === void 0) {
          angle = 0;
        }

        this.currentStepAnimates.push({
          type: 'rotate3d',
          args: [x, y, z, normalizeUnit(angle, 'deg', true)]
        });
        return this;
      };

      _proto.rotateX = function rotateX(angle) {
        if (angle === void 0) {
          angle = 0;
        }

        this.currentStepAnimates.push({
          type: 'rotateX',
          args: [normalizeUnit(angle, 'deg', true)]
        });
        return this;
      };

      _proto.rotateY = function rotateY(angle) {
        if (angle === void 0) {
          angle = 0;
        }

        this.currentStepAnimates.push({
          type: 'rotateY',
          args: [normalizeUnit(angle, 'deg', true)]
        });
        return this;
      };

      _proto.rotateZ = function rotateZ(angle) {
        if (angle === void 0) {
          angle = 0;
        }

        this.currentStepAnimates.push({
          type: 'rotateZ',
          args: [normalizeUnit(angle, 'deg', true)]
        });
        return this;
      };

      _proto.scale = function scale(sx, sy) {
        if (sx === undefined) sx = 1;
        if (sy === undefined) sy = sx;
        this.currentStepAnimates.push({
          type: 'scale',
          args: [sx, sy]
        });
        return this;
      };

      _proto.scale3d = function scale3d(sx, sy, sz) {
        if (sx === void 0) {
          sx = 1;
        }

        if (sy === void 0) {
          sy = 1;
        }

        if (sz === void 0) {
          sz = 1;
        }

        this.currentStepAnimates.push({
          type: 'scale3d',
          args: [sx, sy, sz]
        });
        return this;
      };

      _proto.scaleX = function scaleX(scale) {
        if (scale === void 0) {
          scale = 1;
        }

        this.currentStepAnimates.push({
          type: 'scaleX',
          args: [scale]
        });
        return this;
      };

      _proto.scaleY = function scaleY(scale) {
        if (scale === void 0) {
          scale = 1;
        }

        this.currentStepAnimates.push({
          type: 'scaleY',
          args: [scale]
        });
        return this;
      };

      _proto.scaleZ = function scaleZ(scale) {
        if (scale === void 0) {
          scale = 1;
        }

        this.currentStepAnimates.push({
          type: 'scaleZ',
          args: [scale]
        });
        return this;
      };

      _proto.translate = function translate(tx, ty) {
        if (tx === void 0) {
          tx = 0;
        }

        if (ty === void 0) {
          ty = 0;
        }

        this.currentStepAnimates.push({
          type: 'translate',
          args: [normalizeUnit(tx, 'px', true), normalizeUnit(ty, 'px', true)]
        });
        return this;
      };

      _proto.translate3d = function translate3d(tx, ty, tz) {
        if (tx === void 0) {
          tx = 0;
        }

        if (ty === void 0) {
          ty = 0;
        }

        if (tz === void 0) {
          tz = 0;
        }

        this.currentStepAnimates.push({
          type: 'translate3d',
          args: [normalizeUnit(tx, 'px', true), normalizeUnit(ty, 'px', true), normalizeUnit(tz, 'px', true)]
        });
        return this;
      };

      _proto.translateX = function translateX(translation) {
        if (translation === void 0) {
          translation = 0;
        }

        this.currentStepAnimates.push({
          type: 'translateX',
          args: [normalizeUnit(translation, 'px', true)]
        });
        return this;
      };

      _proto.translateY = function translateY(translation) {
        if (translation === void 0) {
          translation = 0;
        }

        this.currentStepAnimates.push({
          type: 'translateY',
          args: [normalizeUnit(translation, 'px', true)]
        });
        return this;
      };

      _proto.translateZ = function translateZ(translation) {
        if (translation === void 0) {
          translation = 0;
        }

        this.currentStepAnimates.push({
          type: 'translateZ',
          args: [normalizeUnit(translation, 'px', true)]
        });
        return this;
      };

      _proto.skew = function skew(ax, ay) {
        if (ax === void 0) {
          ax = 0;
        }

        if (ay === void 0) {
          ay = 0;
        }

        this.currentStepAnimates.push({
          type: 'skew',
          args: [normalizeUnit(ax, 'deg', true), normalizeUnit(ay, 'deg', true)]
        });
        return this;
      };

      _proto.skewX = function skewX(angle) {
        if (angle === void 0) {
          angle = 0;
        }

        this.currentStepAnimates.push({
          type: 'skewX',
          args: [normalizeUnit(angle, 'deg', true)]
        });
        return this;
      };

      _proto.skewY = function skewY(angle) {
        if (angle === void 0) {
          angle = 0;
        }

        this.currentStepAnimates.push({
          type: 'skewY',
          args: [normalizeUnit(angle, 'deg', true)]
        });
        return this;
      };

      _proto.matrix = function matrix(a, b, c, d, tx, ty) {
        if (a === void 0) {
          a = 1;
        }

        if (b === void 0) {
          b = 0;
        }

        if (c === void 0) {
          c = 0;
        }

        if (d === void 0) {
          d = 1;
        }

        if (tx === void 0) {
          tx = 0;
        }

        if (ty === void 0) {
          ty = 0;
        }

        this.currentStepAnimates.push({
          type: 'matrix',
          args: [a, b, c, d, tx, ty]
        });
        return this;
      };

      _proto.matrix3d = function matrix3d(a1, b1, c1, d1, a2, b2, c2, d2, a3, b3, c3, d3, a4, b4, c4, d4) {
        if (a1 === void 0) {
          a1 = 1;
        }

        if (b1 === void 0) {
          b1 = 0;
        }

        if (c1 === void 0) {
          c1 = 0;
        }

        if (d1 === void 0) {
          d1 = 0;
        }

        if (a2 === void 0) {
          a2 = 0;
        }

        if (b2 === void 0) {
          b2 = 1;
        }

        if (c2 === void 0) {
          c2 = 0;
        }

        if (d2 === void 0) {
          d2 = 0;
        }

        if (a3 === void 0) {
          a3 = 0;
        }

        if (b3 === void 0) {
          b3 = 0;
        }

        if (c3 === void 0) {
          c3 = 1;
        }

        if (d3 === void 0) {
          d3 = 0;
        }

        if (a4 === void 0) {
          a4 = 0;
        }

        if (b4 === void 0) {
          b4 = 0;
        }

        if (c4 === void 0) {
          c4 = 0;
        }

        if (d4 === void 0) {
          d4 = 1;
        }

        this.currentStepAnimates.push({
          type: 'matrix3d',
          args: [a1, b1, c1, d1, a2, b2, c2, d2, a3, b3, c3, d3, a4, b4, c4, d4]
        });
        return this;
      };

      return AnimationImpl;
    }();

    function createAnimation$4(options) {
      return new AnimationImpl(options);
    }

    function createTransition$4(options) {
      var animation = createAnimation$4();
      return normalizeCreateTransition(animation, options);
    }

    var webModule$1 = {
      createAnimation: createAnimation$4,
      createTransition: createTransition$4
    };

    function _extends$5() { _extends$5 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5.apply(this, arguments); }

    function createAnimation$3(options) {
      var animation = wx.createAnimation(getMergedOptions(CONTAINER_NAME$1.WECHAT, options)); // override

      var _step = animation.step.bind(animation);

      var _export = animation.export.bind(animation);

      animation.step = function (opts) {
        opts = getMergedOptions(CONTAINER_NAME$1.WECHAT, _extends$5({}, options, opts));
        return _step(opts);
      };

      animation.export = function () {
        return _export();
      };

      return animation;
    }

    function createTransition$3(options) {
      var animation = createAnimation$3();
      return normalizeCreateTransition(animation, options);
    }

    var weChatModule$1 = {
      createAnimation: createAnimation$3,
      createTransition: createTransition$3
    };

    function _extends$4() { _extends$4 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4.apply(this, arguments); }

    function createAnimation$2(options) {
      var animation = tt.createAnimation(getMergedOptions(CONTAINER_NAME$1.BYTE, options)); // override

      var _step = animation.step.bind(animation);

      var _export = animation.export.bind(animation);

      animation.step = function (opts) {
        opts = getMergedOptions(CONTAINER_NAME$1.BYTE, _extends$4({}, options, opts));
        return _step(opts);
      };

      animation.export = function () {
        return _export();
      };

      return animation;
    }

    function createTransition$2(options) {
      var animation = createAnimation$2();
      return normalizeCreateTransition(animation, options);
    }

    var bytedanceModule$1 = {
      createAnimation: createAnimation$2,
      createTransition: createTransition$2
    };

    function _extends$3() { _extends$3 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3.apply(this, arguments); }

    function createAnimation$1(options) {
      var animation = swan.createAnimation(getMergedOptions(CONTAINER_NAME$1.BAIDU, options)); // override

      var _step = animation.step.bind(animation);

      var _export = animation.export.bind(animation);

      animation.step = function (opts) {
        opts = getMergedOptions(CONTAINER_NAME$1.BAIDU, _extends$3({}, options, opts));
        return _step(opts);
      };

      animation.export = function () {
        return _export();
      };

      return animation;
    }

    function createTransition$1(options) {
      var animation = createAnimation$1();
      return normalizeCreateTransition(animation, options);
    }

    var baiDuModule$1 = {
      createAnimation: createAnimation$1,
      createTransition: createTransition$1
    };

    function createAnimation(options) {
      if (isWeb$1) {
        return webModule$1.createAnimation(options);
      } else if (isKuaiShouMiniProgram) {
        throw new Error('@uni/apis：createAnimation 暂不支持');
      } else if (isWeChatMiniProgram) {
        return weChatModule$1.createAnimation(options);
      } else if (isByteDanceMicroApp) {
        return bytedanceModule$1.createAnimation(options);
      } else if (isMiniApp) {
        return aliMiniAppModule$1.createAnimation(options);
      } else if (isBaiduSmartProgram) {
        return baiDuModule$1.createAnimation(options);
      } else {
        throw new Error('@uni/apis：createAnimation 暂不支持');
      }
    }
    function createTransition(options) {
      if (isWeb$1) {
        return webModule$1.createTransition(options);
      } else if (isKuaiShouMiniProgram) {
        throw new Error('@uni/apis：createAnimation 暂不支持');
      } else if (isWeChatMiniProgram) {
        return weChatModule$1.createTransition(options);
      } else if (isByteDanceMicroApp) {
        return bytedanceModule$1.createTransition(options);
      } else if (isMiniApp) {
        return aliMiniAppModule$1.createTransition(options);
      } else if (isBaiduSmartProgram) {
        return baiDuModule$1.createTransition(options);
      } else {
        throw new Error('@uni/apis：createTransition 暂不支持');
      }
    }

    /**
     *  Common
     */
    var ERROR_REQUEST_ABORT = {
      code: 0,
      message: 'Request Abort'
    };
    var ERROR_REQUEST_TIMEOUT = {
      code: 1,
      message: 'Request timeout'
    };
    var ERROR_REQUEST_JSONP = function ERROR_REQUEST_JSONP(url) {
      return {
        code: 1,
        message: "JSONP error : request " + url + " error"
      };
    };

    var _excluded = ["_ext"];

    function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

    function _extends$2() { _extends$2 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2.apply(this, arguments); }
    var styleIn = function styleIn(options, baseName) {
      var _ref = options || {},
          _ref$_ext = _ref._ext,
          _ext = _ref$_ext === void 0 ? {} : _ref$_ext,
          rest = _objectWithoutPropertiesLoose(_ref, _excluded);

      return _extends$2({}, rest, _ext[baseName] || {});
    };

    var CONTAINER_NAME = {
      WECHAT: 'wechatMiniProgram',
      ALIPAY: 'aliMiniApp',
      BYTE: 'bytedanceMicroApp',
      WEB: 'web',
      BAIDU: 'baiduSmartProgram',
      KWAI: 'kuaishouMiniProgram'
    };
    var JSONP_SIGN = '__uni_jsonp_handler_sign__';

    function _extends$1() { _extends$1 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1.apply(this, arguments); }
    function stringifyQS(qs) {
      if (!qs) {
        return '';
      }

      var str = [];

      for (var key in qs) {
        if (qs[key]) {
          str.push(key + "=" + encodeURIComponent(String(qs[key])));
        }
      }

      return str.join('&');
    }
    function applyParamToURL(param, url) {
      if (!param) {
        return url;
      }

      return "" + url + (url.indexOf('?') === -1 ? '?' : '&') + stringifyQS(param);
    }
    function object2json(obj) {
      try {
        return JSON.stringify(obj);
      } catch (e) {
        return obj || '';
      }
    }
    function isObject(obj) {
      return typeof obj === 'object' && obj !== null;
    }
    function normalizeHeaders(obj) {
      if (!isObject(obj)) {
        return obj;
      }

      var keyList = ['Accept', 'Content-Type'];
      keyList.forEach(function (key) {
        for (var headerKey in obj) {
          if (Object.prototype.hasOwnProperty.call(obj, headerKey)) {
            if (headerKey.toUpperCase() === key.toUpperCase() && headerKey !== key) {
              obj[key] = obj[headerKey];
              delete obj[headerKey];
            }
          }
        }
      });
      return obj;
    }
    var validateStatus = function validateStatus(status) {
      return status >= 200 && status < 300 || status === 304;
    };
    function checkIsApplyDataToURL(headers) {
      if (!headers || !headers['Content-Type']) {
        return false;
      }

      return String(headers['Content-Type']).toLowerCase().indexOf('application/x-www-form-urlencoded') > -1;
    }
    var EMPTY_OBJECT = {};
    function isPlainObject(obj) {
      return EMPTY_OBJECT.toString.call(obj) === '[object Object]';
    }
    function styleOptions(options, containerName) {
      var _options$method;

      var DEFAULT_TIMEOUT = 20000;
      var DEFAULT_REQUEST_OPTIONS = {
        url: '',
        headers: {
          'Content-Type': 'application/json'
        },
        method: 'GET',
        jsonpCallbackProp: 'callback',
        jsonpCallback: "__uni_jsonp_handler_" + new Date().getTime(),
        timeout: DEFAULT_TIMEOUT,
        dataType: 'json'
      };
      var isJsonp = (options == null ? void 0 : (_options$method = options.method) == null ? void 0 : _options$method.toUpperCase()) === 'JSONP';

      if (isJsonp && containerName === CONTAINER_NAME.WEB) {
        window[JSONP_SIGN] = typeof window[JSONP_SIGN] !== 'undefined' ? window[JSONP_SIGN] + 1 : 0;
        DEFAULT_REQUEST_OPTIONS.jsonpCallback = DEFAULT_REQUEST_OPTIONS.jsonpCallback + "_" + window[JSONP_SIGN];
      }

      var jsonpCallback = options.jsonpCallback || DEFAULT_REQUEST_OPTIONS.jsonpCallback;

      var adapterResponse = function adapterResponse(res) {
        var _res$errMsg;

        if (res.errMsg && (res == null ? void 0 : (_res$errMsg = res.errMsg) == null ? void 0 : _res$errMsg.indexOf('request:fail')) !== -1 || res.error) {
          return _extends$1({}, res, {
            error: res.error || res.status || res.statusCode,
            errorMessage: res.errorMessage || res.errMsg || '',
            status: res.statusCode || res.status,
            headers: res.header || res.headers || {}
          });
        }

        var afterRes = _extends$1({}, res, {
          errorMessage: res.errorMessage || res.errMsg || '',
          status: res.statusCode || res.status,
          headers: res.header || res.headers || {}
        });

        if (isJsonp && containerName !== CONTAINER_NAME.WEB) {
          try {
            var _reg$exec;

            var reg = new RegExp(jsonpCallback + "\\(([\\s\\S]*)\\);?$", 'gm');
            var content = (_reg$exec = reg.exec(res == null ? void 0 : res.data)) == null ? void 0 : _reg$exec[1];
            var data = content ? JSON.parse(content) : '';
            return _extends$1({}, afterRes, {
              data: data
            });
          } catch (e) {
            return {
              error: 14,
              data: res,
              errorMessage: 'JSONP 解码失败'
            };
          }
        }

        return afterRes;
      };

      var afterOptions = _extends$1({}, DEFAULT_REQUEST_OPTIONS, options, {
        method: (options.method || 'GET').toUpperCase(),
        headers: _extends$1({}, DEFAULT_REQUEST_OPTIONS.headers, normalizeHeaders(options.headers || {})),
        success: function success(res) {
          var _validateStatus = options.validateStatus || validateStatus;

          var _res = adapterResponse(res);

          if (!_validateStatus(_res.status)) {
            options.fail && options.fail(_res);
          } else {
            options.success && options.success(_res);
          }
        },
        fail: function fail(res) {
          options.fail && options.fail(adapterResponse(res));
        },
        complete: function complete(res) {
          options.complete && options.complete(adapterResponse(res));
        }
      });

      if (isJsonp) {
        var _extends2;

        afterOptions = _extends$1({}, afterOptions, {
          method: 'GET',
          isJsonp: isJsonp,
          dataType: 'text',
          data: _extends$1({}, options.data, (_extends2 = {}, _extends2[options.jsonpCallbackProp || DEFAULT_REQUEST_OPTIONS.jsonpCallbackProp] = jsonpCallback, _extends2))
        });
      }

      return afterOptions;
    }
    function normalize(api, containerName) {
      return function (options) {
        var afterOptions = styleOptions(styleIn(options, containerName), containerName);
        return api(afterOptions);
      };
    }

    function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

    function requestXHR(options) {
      options.headers = _extends({
        Accept: 'application/json, text/plain, */*'
      }, options.headers);

      var _jsonpCallbackProp$js = _extends({
        jsonpCallbackProp: 'callback',
        jsonpCallback: "__uni_jsonp_handler_" + new Date().getTime(),
        withCredentials: true,
        method: 'GET',
        validateStatus: function validateStatus(status) {
          return status >= 200 && status < 300 || status === 304;
        }
      }, options),
          validateStatus = _jsonpCallbackProp$js.validateStatus,
          url = _jsonpCallbackProp$js.url,
          method = _jsonpCallbackProp$js.method,
          isJsonp = _jsonpCallbackProp$js.isJsonp,
          withCredentials = _jsonpCallbackProp$js.withCredentials,
          headers = _jsonpCallbackProp$js.headers,
          data = _jsonpCallbackProp$js.data,
          timeout = _jsonpCallbackProp$js.timeout,
          jsonpCallback = _jsonpCallbackProp$js.jsonpCallback,
          dataType = _jsonpCallbackProp$js.dataType,
          success = _jsonpCallbackProp$js.success,
          fail = _jsonpCallbackProp$js.fail,
          complete = _jsonpCallbackProp$js.complete;

      var timer;

      function noop() {}

      if (isJsonp) {
        var script;
        var target = document.getElementsByTagName('script')[0] || document.head;

        var _clean = function _clean() {
          if (script.parentNode) {
            script.parentNode.removeChild(script);
          }

          window[jsonpCallback] = noop;
          timer && clearTimeout(timer);
        };

        if (timeout) {
          timer = setTimeout(function () {
            _clean();

            fail && fail(ERROR_REQUEST_TIMEOUT);
            complete && complete(ERROR_REQUEST_TIMEOUT);
          }, timeout);
        }

        window[jsonpCallback] = function (data) {
          _clean();

          success && success({
            data: data,
            status: 200,
            headers: {}
          });
          complete && complete({
            data: data,
            status: 200,
            headers: {}
          });
        };

        var scriptUrl = "" + applyParamToURL(data, url);
        script = document.createElement('script');
        script.setAttribute('src', scriptUrl);
        target.parentNode.insertBefore(script, target);

        script.onerror = function () {
          fail && fail(ERROR_REQUEST_JSONP);

          _clean();
        };

        return {
          abort: function abort() {}
        };
      }

      var requestData;
      var xhr = new XMLHttpRequest();

      var clean = function clean() {
        clearTimeout(timer);
      };

      timer = window.setTimeout(function () {
        clean();
        fail && fail(ERROR_REQUEST_TIMEOUT);
        complete && complete(ERROR_REQUEST_TIMEOUT); // reject(ERROR_REQUEST_TIMEOUT);

        xhr.abort();
      }, timeout);

      xhr.onreadystatechange = function () {
        if (!xhr || xhr.readyState !== 4) {
          return;
        }

        clean();

        if (!validateStatus(xhr.status)) {
          // TODO Detailed error message
          fail && fail({
            code: ERROR_REQUEST_ABORT.code,
            message: "" + JSON.stringify({
              status: xhr.status
            })
          });
          complete && complete({
            code: ERROR_REQUEST_ABORT.code,
            message: "" + JSON.stringify({
              status: xhr.status
            })
          });
          return;
        }

        var headers = xhr.getAllResponseHeaders();
        var arr = headers.trim().split(/[\r\n]+/);
        var headerMap = {};
        arr.forEach(function (line) {
          var parts = line.split(': ');
          var header = parts.shift();
          var value = parts.join(': ');
          headerMap[header] = value;
        });
        success && success({
          data: xhr.response,
          status: xhr.status,
          headers: headerMap
        });
        complete && complete({
          data: xhr.response,
          status: xhr.status,
          headers: headerMap
        });
      };

      xhr.responseType = dataType || '';

      if (method === 'GET' || checkIsApplyDataToURL(headers)) {
        xhr.open(method, applyParamToURL(data, url), true);
      } else {
        xhr.open(method, url, true);
      }

      xhr.withCredentials = withCredentials;

      if (headers) {
        for (var key in headers || []) {
          if (Object.prototype.hasOwnProperty.call(headers, key)) {
            xhr.setRequestHeader(key, String(headers[key]));
          }
        }
      }

      if (method === 'GET') {
        requestData = null;
      } else {
        requestData = data;
      }

      if (isObject(requestData) && isPlainObject(requestData)) {
        requestData = object2json(requestData);
      }

      xhr.send(requestData);
      return {
        abort: function abort() {}
      };
    }

    var webModule = normalize(requestXHR, CONTAINER_NAME.WEB);

    function isUndef(type) {
      return type === 'undefined';
    }

    var isDingdingMiniapp = !isUndef(typeof dd) && dd !== null && !isUndef(typeof dd.alert);

    function request$5(options) {
      var url = options.url,
          method = options.method,
          data = options.data,
          dataType = options.dataType,
          headers = options.headers,
          timeout = options.timeout,
          _success = options.success,
          _fail = options.fail,
          _complete = options.complete;
      var httpRequest = isDingdingMiniapp ? dd.httpRequest : my.request;
      var _data = data;

      if (isDingdingMiniapp && method === 'POST' && headers['Content-Type'] === 'application/json' && typeof data !== 'string') {
        _data = JSON.stringify(data);
      }

      return httpRequest({
        url: url,
        headers: headers,
        method: method,
        data: _data,
        timeout: timeout,
        dataType: dataType,
        success: function success(res) {
          _success && _success(res);
        },
        fail: function fail(res) {
          _fail && _fail(res);
        },
        complete: function complete(res) {
          _complete && _complete(res);
        }
      });
    }

    var aliMiniAppModule = normalize(request$5, CONTAINER_NAME.ALIPAY);

    function request$4(options) {
      var url = options.url,
          method = options.method,
          data = options.data,
          dataType = options.dataType,
          headers = options.headers,
          timeout = options.timeout,
          _success = options.success,
          _fail = options.fail,
          _complete = options.complete;
      return wx.request({
        url: url,
        header: headers,
        method: method,
        data: data,
        timeout: timeout,
        dataType: dataType,
        success: function success(res) {
          _success && _success(res);
        },
        fail: function fail(res) {
          _fail && _fail(res);
        },
        complete: function complete(res) {
          _complete && _complete(res);
        }
      });
    }

    var weChatModule = normalize(request$4, CONTAINER_NAME.WECHAT);

    function request$3(options) {
      var url = options.url,
          method = options.method,
          data = options.data,
          dataType = options.dataType,
          headers = options.headers,
          timeout = options.timeout,
          _success = options.success,
          _fail = options.fail,
          _complete = options.complete;
      return tt.request({
        url: url,
        header: headers,
        method: method,
        data: data,
        timeout: timeout,
        dataType: dataType,
        success: function success(res) {
          _success && _success(res);
        },
        fail: function fail(res) {
          _fail && _fail(res);
        },
        complete: function complete(res) {
          _complete && _complete(res);
        }
      });
    }

    var bytedanceModule = normalize(request$3, CONTAINER_NAME.BYTE);

    function request$2(options) {
      var url = options.url,
          method = options.method,
          data = options.data,
          dataType = options.dataType,
          headers = options.headers,
          timeout = options.timeout,
          _success = options.success,
          _fail = options.fail,
          _complete = options.complete;
      return swan.request({
        url: url,
        header: headers,
        method: method,
        data: data,
        timeout: timeout,
        dataType: dataType,
        success: function success(res) {
          _success && _success(res);
        },
        fail: function fail(res) {
          _fail && _fail(res);
        },
        complete: function complete(res) {
          _complete && _complete(res);
        }
      });
    }

    var baiDuModule = normalize(request$2, CONTAINER_NAME.WECHAT);

    function request$1(options) {
      var url = options.url,
          method = options.method,
          data = options.data,
          dataType = options.dataType,
          headers = options.headers,
          timeout = options.timeout,
          _success = options.success,
          _fail = options.fail,
          _complete = options.complete;
      return ks.request({
        url: url,
        header: headers,
        method: method,
        data: data,
        timeout: timeout,
        dataType: dataType,
        success: function success(res) {
          _success && _success(res);
        },
        fail: function fail(res) {
          _fail && _fail(res);
        },
        complete: function complete(res) {
          _complete && _complete(res);
        }
      });
    }

    var kuaiShouModule = normalize(request$1, CONTAINER_NAME.WECHAT);

    var uniRequest = (function (options) {
      if (isWeb$1) {
        return webModule(options);
      } else if (isKuaiShouMiniProgram) {
        return kuaiShouModule(options);
      } else if (isWeChatMiniProgram) {
        return weChatModule(options);
      } else if (isByteDanceMicroApp) {
        return bytedanceModule(options);
      } else if (isMiniApp) {
        return aliMiniAppModule(options);
      } else if (isBaiduSmartProgram) {
        return baiDuModule(options);
      } else {
        throw new Error('Uni API：request暂不支持');
      }
    });

    var apiConfig = {
        // XMLHttpRequest: https://github.com/raxjs/universal-api/blob/master/src/packages/network/request/src/web/index.ts
        web: uniRequest,
        // my.request: https://github.com/raxjs/universal-api/blob/master/src/packages/network/request/src/ali-miniapp/index.ts
        mini: uniRequest,
    };
    /**
     * 用于发起网络请求
     * https://universal-api.js.org/packages/network/request
     */
    var request = extend(apiConfig);

    var nebula$1 = (function (options) {
        var success = options.success, fail = options.fail, _a = options.overtime, overtime = _a === void 0 ? 3000 : _a;
        document.addEventListener('AlipayJSBridgeReady', function () {
            return success({
                data: window.AlipayJSBridge,
            });
        }, false);
        // 超时阈值设置，3s暂时根据经验
        setTimeout(function () {
            return fail({
                errMsg: 'jsbridgeReady API is timeout',
            });
        }, overtime);
    });

    /**
     * jsbridge准备工作完成。支持【nebula容器(支付宝App)】
     * @example
     * import { jsbridgeReady } from '@alife/cn-uni-api';
     *
     * jsbridgeReady()
     *  .then(res => res)
     *  .catch(err => err)
     *
     * @author 敬文
     */
    var jsbridgeReady = extend({
        web: {
            nebula: nebula$1,
        },
    });

    /**
     * @description windvane promise
     * @param moduleName 模块名称
     * @param apiName 方法名
     * @param params 其他参数
     * @param overtime windVane响应超时时间, 默认5s超时, 需要禁用可传null
     */
    var promiseWindVane = function (moduleName, apiName, params, extraParams) {
        if (extraParams === void 0) { extraParams = { overtime: 5000 }; }
        return new Promise(function (resolve) {
            if (!isWindvane$1) {
                resolve({ success: false, message: 'no windvane found' });
                return;
            }
            /**
             * 增加超时
             * 防止有些客户端 windVane 方法无响应
             */
            var timer = 0;
            if (extraParams === null || extraParams === void 0 ? void 0 : extraParams.overtime) {
                timer = window.setTimeout(function () {
                    resolve({ success: false, message: 'promiseWindVane timeout' });
                }, extraParams === null || extraParams === void 0 ? void 0 : extraParams.overtime);
            }
            try {
                JSCall$3("".concat(moduleName, ".").concat(apiName), params, function (res) {
                    clearTimeout(timer);
                    resolve({ success: true, data: res.data, originalData: res });
                }, function (e) {
                    clearTimeout(timer);
                    resolve({ success: false, message: e.message, originalData: e });
                });
            }
            catch (e) {
                clearTimeout(timer);
                resolve({
                    success: false,
                    message: e instanceof Error ? e.message : 'expectation failed',
                });
            }
        });
    };

    /**
     * @description nebula promise
     * @param apiName 方法名
     * @param params 其他参数
     */
    var promiseNebule = function (apiName, params) {
        return new Promise(function (resolve) {
            if (!isNebula$1) {
                resolve({ success: false, data: null, message: 'no nebula found' });
            }
            try {
                call$1(apiName, params, function (res) {
                    resolve({ success: true, data: res });
                }, function (e) {
                    resolve({ success: false, message: e.message });
                });
            }
            catch (e) {
                resolve({
                    success: false,
                    message: e instanceof Error ? e.message : 'expectation failed',
                });
            }
        });
    };

    /**
     * @description dingTalk promise
     * @param api 方法名。如'biz.util.share'
     * @param params 参数
     */
    var promiseDingTalk = function (api, params) {
        return new Promise(function (resolve) {
            var excuteDingTalkBridge = function () {
                try {
                    JSCall$4(api, params, function (res) {
                        resolve({ success: true, data: res });
                    }, function (e) {
                        resolve({ success: false, message: e === null || e === void 0 ? void 0 : e.message });
                    });
                }
                catch (e) {
                    resolve({
                        success: false,
                        message: e instanceof Error ? e.message : 'expectation failed',
                    });
                }
            };
            if (!env.isDingTalk) {
                resolve({ success: false, message: 'not dingTalk app' });
                return;
            }
            if (typeof dd === 'undefined') {
                loadScripts(BRIDGE_DEPEND_LIBS.dingTalk)
                    .then(function () {
                    excuteDingTalkBridge();
                })
                    .catch(function () {
                    resolve({ success: false, message: 'dd lib script not download' });
                });
                return;
            }
            excuteDingTalkBridge();
        });
    };

    var resolvedJsbridge = function (promise) {
        return promise
            .then(function (res) {
            return Promise.resolve({
                success: true,
                data: res,
            });
        })
            .catch(function (err) {
            return Promise.resolve({
                success: false,
                data: err,
            });
        });
    };

    /**
     * 方便的对外工具函数。
     * 类似node utils.promisify，有需要则使用。包含：
     * 1. 底层web容器调用：promiseWindvane、promiseNebula
     * 2. resolvedJsbridge。把promise的reject，转换为 promise 的resolve { success: false }形态
     */
    var utils = {
        /**
         * windvane容器 call。等同于window.Windvane.call() 的Promise版。
         * @see https://h5.alibaba-inc.com/api/WindVane-API.html
         *
         * @example 使用案例：
         * import { promiseWindvane } from '@alife/cn-uni-api'; // h5、小程序通用包
         *
         * const res = await utils.promiseWindvane('Base', 'copyToClipboard', {})
         * if (res.success) {
         *  console.log('success', res.data);
         * } else {
         *  console.log('fail');
         * }
         *
         * @author 敬文
         */
        promiseWindVane: promiseWindVane,
        /**
         * nebula容器 call。等同于window.AlipayJSBridge.call() 的Promise版。
         * @see https://smallfish.antfin-inc.com/jsapi/chooseImage.html
         *
         * @example 使用案例：
         * import { promiseNebule } from '@alife/cn-uni-api'; // h5、小程序通用包
         *
         * const res = await utils.promiseNebule('copyToClipboard', {})
         * if (res.success) {
         *  console.log('success', res.data);
         * } else {
         *  console.log('fail');
         * }
         *
         * @author 敬文
         */
        promiseNebule: promiseNebule,
        /**
         * 钉钉容器 call。等同于window.dd.call() 的Promise版。
         * API会自动按需引入钉钉官方jssdk，无需用户手动引入。
         * @see https://open.dingtalk.com/document/orgapp-client/jsapi-overview
         *
         * @example 使用案例：
         * import { promiseDingTalk } from '@alife/cn-uni-api'; // h5、小程序通用包
         *
         * const res = await utils.promiseDingTalk('biz.util.share', { url: 'http://xxx' })
         * if (res.success) {
         *  console.log('success', res.data);
         * } else {
         *  console.log('fail');
         * }
         *
         * @author 敬文
         */
        promiseDingTalk: promiseDingTalk,
        /**
         * 把promise的reject，转换为 promise 的resolve { success: false }形态。
         *
         * @example 使用案例：
         * import { utils, showToast } from '@alife/cn-uni-api'; // h5、小程序通用包
         *
         * const promise = showToast({ duration: 1000 });
         * const res = await utils.resolvedJsbridge(promise);
         * if (res.success) {
         *  console.log('success', res.data);
         * } else {
         *  console.log('fail');
         * }
         *
         * @author 敬文
         */
        resolvedJsbridge: resolvedJsbridge,
    };

    // 执行
    var hideNubelaBack = extend({
        web: {
            nebula: function (options, context) {
                context === null || context === void 0 ? void 0 : context.NBCall('hideTransBack', options);
            },
        },
    });
    var nebula = (function (options) { return __awaiter(void 0, void 0, void 0, function () {
        var success, fail, promise, res;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    success = options.success, fail = options.fail;
                    promise = jsbridgeReady();
                    return [4 /*yield*/, utils.resolvedJsbridge(promise)];
                case 1:
                    res = _a.sent();
                    if (res.success) {
                        hideNubelaBack().then(success).catch(fail);
                    }
                    else {
                        fail({ errMsg: 'jsbridgeReady 执行失败' });
                    }
                    return [2 /*return*/];
            }
        });
    }); });

    /**
     * 隐藏全屏状态下的箭头。支持【nebula容器(支付宝App)】
     *
     * @example
     * import { hideBack } from '@alife/cn-uni-api';
     *
     * hideBack()
     *  .then(res => res)
     *  .catch(err => err);
     *
     * @author 敬文
     */
    var hideBack = extend({
        web: {
            nebula: nebula,
        },
    });

    var dingTalk = (function (options, context) {
        var api = 'dd.biz.chat.openSingleChat';
        context.DDCall(api, options);
    });

    /**
     * 打开与某个用户的单聊会话。支持【钉钉App】
     * 钉钉SDK：https://open.dingtalk.com/document/orgapp-client/open-a-one-on-one-chat-session-with-a-user
     *
     * @example
     * import { openSingleChat } from '@alife/cn-uni-api';
     *
     * openSingleChat({ corpId: 'xxx', userId: 'xxx' })
     *  .then(res => res)
     *  .catch(err => err);
     *
     * @author 敬文
     */
    var openSingleChat = extend({
        web: {
            dingTalk: dingTalk,
        },
    });

    /**
     * 获取菜鸟App业务版本。"ORIGINAL", "CAMPUS", "HOMETOWN"  分别对应 大众版、校园版 、家乡版
     * SDK: https://alidocs.dingtalk.com/i/nodes/Mk5evdR04jBV59vnPj1dVQL3x2OlParn
     * @example
     * import { getAppBaseInfo } from '@alife/cn-uni-api';
     *
     * getAppBaseInfo()
     * .then(res => res.cnVersionName === 'CAMPUS')
     * .catch((err) => console.error(err))
     *
     * @author 敬文
     */
    var getAppBaseInfo = extend({
        web: {
            windvane: {
                cn: function (options, context) {
                    var _a;
                    // 菜鸟APP Hybrid ref：https://alidocs.dingtalk.com/i/nodes/Mk5evdR04jBV59vnPj1dVQL3x2OlParn
                    // TODO getAppBaseInfo做成1个通用的能力,目前菜鸟Hybrid只找到这1个 JSBridge，以后再扩展更多字段。
                    (_a = context === null || context === void 0 ? void 0 : context.WVCall) === null || _a === void 0 ? void 0 : _a.call(context, 'CNHybridGGHomeVersionManage.currentVersion', options, {
                        formatOutput: function (ret) {
                            var _a;
                            return ({
                                cnVersionName: (_a = ret === null || ret === void 0 ? void 0 : ret.data) === null || _a === void 0 ? void 0 : _a.version,
                            });
                        },
                    });
                },
            },
        },
    });

    var isAndroid$1 = env.isAndroid, isIOS$1 = env.isIOS, version$1 = env.version;
    /**
     * 当前菜鸟App版本，是否支持播放穿山甲视频。
     * 经常用的场景：不支持播放的情况下，提前隐藏播放按钮，避免不支持的环境播放视频。
     */
    var cnIsSupportPlayAdVersion = function () {
        return (isAndroid$1 && (version$1 === null || version$1 === void 0 ? void 0 : version$1.gte('6.9.0'))) || (isIOS$1 && (version$1 === null || version$1 === void 0 ? void 0 : version$1.gte('6.9.3')));
    };
    // 执行广告视频
    var showAd = extend({
        web: {
            windvane: {
                cn: function (options, context) {
                    context === null || context === void 0 ? void 0 : context.WVCall('CNHybridRewardedVideoAd.showAd', __assign$1({ orientation: 1 }, options));
                },
            },
        },
    });
    var cn$1 = (function (options) {
        var success = options.success, fail = options.fail;
        if (!cnIsSupportPlayAdVersion()) {
            fail({
                errMsg: '当前菜鸟App版本，不支持cnPreloadAdVideo API',
            });
            return;
        }
        showAd(options)
            .then(function (res) {
            var _a;
            var isPlaySuccess = (_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.isValid;
            if (isPlaySuccess) {
                success();
            }
            else {
                fail({ errMsg: '客户端播放失败' });
            }
        })
            .catch(fail);
    });

    /**
     * 播放穿山甲视频。支持【菜鸟App】
     * Promise.then表明完整播放完视频（比如30s视频）；Promise.catch表明视频未播放完
     * 菜鸟SDK: https://yuque.antfin.com/nbwireless/unifiedhybridsdk/pf235x
     *
     * @example
     * import { playAdVideo } from '@alife/cn-uni-api';
     *
     * playAdVideo({slotId: '945901829'})
     * .then(res => res)
     * .catch((err) => console.error(err))
     *
     * @author 敬文
     */
    var playAdVideo = extend({
        web: {
            windvane: {
                // 菜鸟App
                cn: cn$1,
            },
        },
    });

    var isAndroid = env.isAndroid, isIOS = env.isIOS, version = env.version;
    /**
     * 当前菜鸟App版本，是否支持预加载穿山甲视频
     */
    var cnIsSupportPreloadAdVersion = function () {
        return (isAndroid && (version === null || version === void 0 ? void 0 : version.gte('7.7.0.0'))) || isIOS;
    };
    // 执行预加载广告视频
    var preloadAd = extend({
        web: {
            windvane: {
                cn: function (options, context) {
                    context === null || context === void 0 ? void 0 : context.WVCall('CNHybridRewardedVideoAd.preloadAd', __assign$1({ orientation: 1, onlyWifiReload: true }, options));
                },
            },
        },
    });
    var cn = (function (options) {
        var success = options.success, fail = options.fail;
        if (!cnIsSupportPreloadAdVersion()) {
            fail({
                errMsg: '当前菜鸟App版本，不支持preloadAdVideo API',
            });
            return;
        }
        preloadAd(options).then(success).catch(fail);
    });

    /**
     * 预加载广告视频（穿山甲）。支持【菜鸟App】
     * 菜鸟SDK: https://yuque.antfin.com/nbwireless/unifiedhybridsdk/pf235x
     *
     * @example
     * import { preloadAdVideo } from '@alife/cn-uni-api';
     *
     * preloadAdVideo({slotId: '945901829'})
     * .then(res => res)
     * .catch((err) => console.error(err))
     *
     * @author 敬文
     */
    var preloadAdVideo = extend({
        web: {
            windvane: {
                // 菜鸟App
                cn: cn,
            },
        },
    });

    /**
     * 是否开启系统push
     */
    var cnGetPushEnabled = function () { return __awaiter(void 0, void 0, void 0, function () {
        var res;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0: return [4 /*yield*/, promiseWindVane('CNHybridPushNotifPermissionAlert', 'pushAlertEnabled')];
                case 1:
                    res = _c.sent();
                    if (res.success) {
                        return [2 /*return*/, (_b = (_a = res.data) === null || _a === void 0 ? void 0 : _a.enabled) !== null && _b !== void 0 ? _b : false];
                    }
                    return [2 /*return*/, false];
            }
        });
    }); };
    // alert弹窗询问
    var cnAlertAndPushSystem = function (options) {
        return promiseWindVane('CNHybridPushNotifPermissionAlert', 'showAlert', __assign$1({}, options));
    };
    // 菜鸟app激活监听
    var onCnAppActive = function (cb) {
        var handleResume = function () {
            cb();
        };
        var eventName = 'WV.Event.APP.Active';
        document.addEventListener(eventName, handleResume, false);
        return function () { return document.removeEventListener(eventName, handleResume, false); };
    };

    // 菜鸟APP Hybrid ref：https://alidocs.dingtalk.com/i/nodes/Mk5evdR04jBV59vnPj1dVQL3x2OlParn
    function openSystemPush$1(options) {
        return __awaiter(this, void 0, void 0, function () {
            var success, fail, _a, _b, _c, cn, hasOpenSystemPush, doAlertPush;
            var _this = this;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        success = options.success, fail = options.fail, _a = options._ext, _b = _a === void 0 ? {} : _a, _c = _b.cn, cn = _c === void 0 ? {} : _c;
                        return [4 /*yield*/, cnGetPushEnabled()];
                    case 1:
                        hasOpenSystemPush = _d.sent();
                        if (hasOpenSystemPush) {
                            success();
                            return [2 /*return*/];
                        }
                        doAlertPush = function () { return __awaiter(_this, void 0, void 0, function () {
                            var data;
                            var _this = this;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, cnAlertAndPushSystem(__assign$1({ needAlert: true, tipText: '您是否同意开启系统通知？', ignoreTiredPeriod: true, channel: 'cn-uni-api' }, cn))];
                                    case 1:
                                        data = _a.sent();
                                        if (!data.success) {
                                            fail({ errMsg: data === null || data === void 0 ? void 0 : data.message });
                                            return [2 /*return*/];
                                        }
                                        // app激活监听
                                        onCnAppActive(function () { return __awaiter(_this, void 0, void 0, function () {
                                            var isSystemPushOpen;
                                            return __generator(this, function (_a) {
                                                switch (_a.label) {
                                                    case 0: return [4 /*yield*/, cnGetPushEnabled()];
                                                    case 1:
                                                        isSystemPushOpen = _a.sent();
                                                        if (isSystemPushOpen) {
                                                            success();
                                                        }
                                                        else {
                                                            fail({ errMsg: '未开启系统通知' });
                                                        }
                                                        return [2 /*return*/];
                                                }
                                            });
                                        }); });
                                        return [2 /*return*/];
                                }
                            });
                        }); };
                        doAlertPush();
                        return [2 /*return*/];
                }
            });
        });
    }

    /**
     * 开启系统通知。支持【菜鸟App】
     * SDK: https://alidocs.dingtalk.com/i/nodes/Mk5evdR04jBV59vnPj1dVQL3x2OlParn
     * @example
     * import { openSystemPush } from '@alife/cn-uni-api';
     *
     * openSystemPush()
     *  .then((res) => {
          doSomeMtop();
     *  });
     *  .catch(err => Toast.show('开启提醒失败'))
     *
     * @author 敬文
     */
    var openSystemPush = extend({
        web: {
            windvane: {
                cn: openSystemPush$1,
            },
        },
    });

    var isTruthy = function (obj) { return obj !== undefined && obj !== null; };
    var isFalsy = function (obj) { return !isTruthy(obj); };
    var transformObjectToQueryString = function (target, encoded) {
        if (encoded === void 0) { encoded = true; }
        if (isFalsy(target)) {
            return '';
        }
        if (typeof target === 'string') {
            return target;
        }
        return Object.keys(target)
            .map(function (key) {
            if (isFalsy(target === null || target === void 0 ? void 0 : target[key])) {
                return '';
            }
            var value = encoded ? encodeURIComponent(target === null || target === void 0 ? void 0 : target[key]) : target === null || target === void 0 ? void 0 : target[key];
            return "".concat(key, "=").concat(value);
        })
            .filter(Boolean)
            .join('&');
    };
    var handleAmapApp = function (param) {
        var distance;
        try {
            var d = param.distance;
            if (typeof d === 'string') {
                d = d.replace('km', '');
            }
            d = Number(d);
            if (Number.isNaN(d)) {
                d = 10;
            }
            distance = d;
        }
        catch (e) {
            distance = 10;
        }
        var type = distance > 1 ? 0 : 2;
        var address = param.addressDetail || param.stationName || '';
        var longitude = param.longitude || '';
        var latitude = param.latitude || '';
        var url = transformObjectToQueryString({
            sid: 'BGVIS1',
            slat: '',
            slon: '',
            sname: '',
            did: 'BGVIS2',
            dlat: latitude,
            dlon: longitude,
            dname: address,
            dev: 0,
            t: type,
        });
        var navUrl = '';
        if (env.isIOS) {
            navUrl = "iosamap://path?sourceApplication=applicationName&".concat(url);
        }
        else {
            navUrl = "androidamap://route/plan/?".concat(url);
        }
        return navUrl;
    };
    function openAmapApp$2(options) {
        var navUrl = handleAmapApp(options);
        navigateTo({
            url: navUrl,
            success: options.success,
            fail: options.fail,
            complete: options.complete,
        });
    }

    function openAmapApp$1(options) {
        var navUrl = handleAmapApp(options);
        navigateTo({
            url: "tp-dd://callApp?url=".concat(encodeURIComponent(navUrl)),
            success: options.success,
            fail: options.fail,
            complete: options.complete,
        });
    }

    /**
     * 打开高德地图
     * 支持端：菜鸟钉h5 菜鸟钉pc 钉钉小程序 浏览器 等
     * @returns {Promise<unknown>} promise调用结果
     * @example 使用案例：
     * import { openAmapApp } from '@alife/cn-uni-api'; //
     *
     * openAmapApp({
     *   addressDetail: '北京',
     *   latitude: '39.916527',
     *   longitude: '116.397128',
     *   distance: '10km'
     * })
     *   .then(() => {
     *     console.log('success');
     *   })
     *   .catch((error) => {
     *     console.log(error);
     *   });
     * @author 余国平
     */
    var openAmapApp = extend({
        web: openAmapApp$2,
        panguMiniApp: openAmapApp$1,
    });

    /**
     * 插件管理器。统一管理跨端插件
     * @example
     * import { pluginManager } from '@alife/cn-uni-api';
     *
     * // 插件定义
     * const panguPlugin: UniApiPlugin = {
     *  api1: {
     *    xn: (options) => {},
     *    cn: (options) => {}
     *  },
     *  api2: {
     *    xn: (options) => {},
     *    cn: (options) => {}
     *  },
     * };
     *
     * // 插件加载
     * pluginManager.addPlugin(panguPlugin);
     * // 插件使用
     * pluginManager.api1({});
     */
    var pluginManager = {
        addPlugin: function (plugin) {
            var _this = this;
            if (!plugin.$i) {
                Object.keys(plugin).forEach(function (apiName) {
                    return _this.$registerApi(apiName, plugin[apiName]);
                });
                // @ts-ignore 只注册1次
                plugin.$i = true;
            }
        },
        $registerApi: function (key, value) {
            // plugin有效性检测
            if (!key) {
                console.error('【@alife/cn-uni-api】插件注册无效', value);
                return;
            }
            var apiFunc = isFunction(value) ? value : extend(value);
            // @ts-ignore 直接挂载到this上面。
            this[key] = apiFunc;
        },
    };

    /**
     * Adapter加载机制
     * @example
     *
     * import * as CnUniApi from '@alife/cn-uni-api';
     *
     * CnUniApi.loadAdapter(require('@alife/adapter-xiniao-to-cnuniapi')
     *
     * @param adapter
     * @returns
     */
    var loadAdapter = function (adapter, userAgentId) {
        if (userAgentId === void 0) { userAgentId = 'web'; }
        // @ts-ignore this改写
        var cnUniApi = this;
        function addClient(appClient, clientName) {
            Object.keys(appClient).forEach(function (apiFunctionName) {
                var _a;
                var clientFn = appClient[apiFunctionName];
                var orignalFn = cnUniApi[apiFunctionName];
                cnUniApi[apiFunctionName] = extend((_a = {}, _a[clientName] = clientFn, _a), orignalFn);
            });
        }
        addClient(adapter, userAgentId);
        return cnUniApi;
    };

    // 完全继承自uni-api。uni-api文档：https://uni-apis.alibaba-inc.com/doc/UI/showtoast
    var VERSION = '2.13.1';

    exports.VERSION = VERSION;
    exports.alert = alert;
    exports.back = back;
    exports.callPhone = callPhone;
    exports.chooseAndUploadImage = chooseAndUploadImage;
    exports.chooseCity = index$B;
    exports.chooseImage = chooseImage$2;
    exports.choosePhoneContact = choosePhoneContact;
    exports.chooseVideo = chooseVideo;
    exports.clearNaviBarRightItem = clearNaviBarRightItem;
    exports.clearStorage = index$9;
    exports.clearStorageSync = clearStorageSync$1;
    exports.compressImage = compressImage;
    exports.configuration = configuration;
    exports.confirm = confirm;
    exports.createAnimation = createAnimation;
    exports.createIntersectionObserver = createIntersectionObserver$1;
    exports.createTransition = createTransition;
    exports.datePicker = index$A;
    exports.env = env;
    exports.extend = extend;
    exports.getApp = getApp$1;
    exports.getAppBaseInfo = getAppBaseInfo;
    exports.getBoundingClientRect = getBoundingClientRect;
    exports.getClipboard = getClipboard;
    exports.getDeviceId = index$n;
    exports.getImageInfo = getImageInfo;
    exports.getInfo = getInfo;
    exports.getInfoSync = lib.getInfoSync;
    exports.getLaunchOptionsSync = getLaunchOptionsSync;
    exports.getLocation = getLocation;
    exports.getNetworkType = getNetworkType;
    exports.getOrientation = index$2;
    exports.getStatusBarHeight = index$J;
    exports.getStorage = getStorage;
    exports.getStorageSync = getStorageSync$1;
    exports.hideBack = hideBack;
    exports.hideLoading = hideLoading;
    exports.hideNavigationBarLoading = index$m;
    exports.hideTitle = hideTitle;
    exports.hideToast = hideToast;
    exports.isAppInstalled = isAppInstalled;
    exports.jsbridgeReady = jsbridgeReady;
    exports.loadAdapter = loadAdapter;
    exports.makeVideoChat = makeVideoChat;
    exports.navigateBack = navigateBack;
    exports.navigateTo = navigateTo;
    exports.onBackCatcher = onBackCatcher;
    exports.onError = onError;
    exports.onGlobalResume = onGlobalResume;
    exports.onUnhandledRejection = onUnhandledRejection;
    exports.openAmapApp = openAmapApp;
    exports.openInBrowser = openInBrowser;
    exports.openOtherApp = openOtherApp;
    exports.openSingleChat = openSingleChat;
    exports.openSystemPush = openSystemPush;
    exports.pauseAudio = index$d;
    exports.pay = pay;
    exports.playAdVideo = playAdVideo;
    exports.playAudio = index$6;
    exports.pluginManager = pluginManager;
    exports.preloadAdVideo = preloadAdVideo;
    exports.previewImage = previewImage;
    exports.previewVideo = previewVideo;
    exports.redirectTo = redirectTo;
    exports.removeStorage = removeStorage;
    exports.removeStorageSync = removeStorageSync$1;
    exports.request = request;
    exports.resumeAudio = index$k;
    exports.saveImage = saveImage;
    exports.saveVideo = saveVideo;
    exports.scan = scan;
    exports.setBackgroundColor = setBackgroundColor;
    exports.setClipboard = setClipboard;
    exports.setNaviBarRightItem = setNaviBarRightItem;
    exports.setNavigationBar = index$r;
    exports.setNavigationBarTitle = setNavigationBarTitle;
    exports.setOrientation = index$j;
    exports.setStorage = setStorage$1;
    exports.setStorageSync = setStorageSync$1;
    exports.showActionSheet = showActionSheet;
    exports.showLoading = showLoading;
    exports.showNavigationBarLoading = index$w;
    exports.showSharePanel = showSharePanel;
    exports.showTitle = showTitle;
    exports.showToast = showToast;
    exports.snapshot = snapshot;
    exports.stopAudio = index$K;
    exports.uploadFile = uploadFile;
    exports.uploadImage = index$C;
    exports.utils = utils;
    exports.vibrate = vibrate;
    exports.vibrateLong = index$p;
    exports.vibrateShort = index$h;

    Object.defineProperty(exports, '__esModule', { value: true });

}));
